/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types, prettier/prettier */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AccountNumber: { input: any; output: any; }
  BigInt: { input: any; output: any; }
  Byte: { input: any; output: any; }
  CountryCode: { input: any; output: any; }
  Cuid: { input: any; output: any; }
  Currency: { input: any; output: any; }
  DID: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  DateTimeISO: { input: any; output: any; }
  DeweyDecimal: { input: any; output: any; }
  Duration: { input: any; output: any; }
  EmailAddress: { input: string; output: string; }
  GUID: { input: any; output: any; }
  HSL: { input: any; output: any; }
  HSLA: { input: any; output: any; }
  HexColorCode: { input: any; output: any; }
  Hexadecimal: { input: any; output: any; }
  IBAN: { input: any; output: any; }
  IP: { input: any; output: any; }
  IPCPatent: { input: any; output: any; }
  IPv4: { input: any; output: any; }
  IPv6: { input: any; output: any; }
  ISBN: { input: any; output: any; }
  ISO8601Duration: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  JWT: { input: any; output: any; }
  LCCSubclass: { input: any; output: any; }
  Latitude: { input: number; output: number; }
  LocalDate: { input: any; output: any; }
  LocalDateTime: { input: any; output: any; }
  LocalEndTime: { input: any; output: any; }
  LocalTime: { input: any; output: any; }
  Locale: { input: any; output: any; }
  Long: { input: any; output: any; }
  Longitude: { input: number; output: number; }
  MAC: { input: any; output: any; }
  NegativeFloat: { input: number; output: number; }
  NegativeInt: { input: number; output: number; }
  NonEmptyString: { input: string; output: string; }
  NonNegativeFloat: { input: number; output: number; }
  NonNegativeInt: { input: number; output: number; }
  NonPositiveFloat: { input: number; output: number; }
  NonPositiveInt: { input: number; output: number; }
  ObjectID: { input: any; output: any; }
  PhoneNumber: { input: string; output: string; }
  Port: { input: any; output: any; }
  PositiveFloat: { input: number; output: number; }
  PositiveInt: { input: number; output: number; }
  PostalCode: { input: string; output: string; }
  RGB: { input: any; output: any; }
  RGBA: { input: any; output: any; }
  RoutingNumber: { input: any; output: any; }
  SESSN: { input: any; output: any; }
  SafeInt: { input: any; output: any; }
  SemVer: { input: any; output: any; }
  Time: { input: any; output: any; }
  TimeZone: { input: string; output: string; }
  Timestamp: { input: number; output: number; }
  URL: { input: string; output: string; }
  USCurrency: { input: any; output: any; }
  UUID: { input: any; output: any; }
  UnsignedFloat: { input: number; output: number; }
  UnsignedInt: { input: number; output: number; }
  UtcOffset: { input: any; output: any; }
  Void: { input: any; output: any; }
};

export type AcceptPaymentRequestInput = {
  payment_method_id?: InputMaybe<Scalars['String']['input']>;
  tips?: InputMaybe<PaymentItemRequestInput>;
};

export type AccountOnboardLinkInput = {
  refreshUrl: Scalars['String']['input'];
  returnUrl: Scalars['String']['input'];
};

export type ActivitiesQueryResponse = {
  __typename?: 'ActivitiesQueryResponse';
  canFetchMore: Scalars['Boolean']['output'];
  results: Array<Activity>;
};

export type Activity = {
  __typename?: 'Activity';
  attachments: Array<Attachment>;
  content: Scalars['String']['output'];
  foreign_entity_type: EntityType;
  foreign_id: Scalars['String']['output'];
  id: Scalars['String']['output'];
  object: Scalars['String']['output'];
  own_reactions?: Maybe<OwnReactions>;
  reaction_counts?: Maybe<ReactionCounts>;
  time: Scalars['String']['output'];
  verb: Scalars['String']['output'];
};

/** A type that describes an add-on */
export type AddOn = {
  __typename?: 'AddOn';
  apply_to_all_listings?: Maybe<Scalars['Boolean']['output']>;
  category: Scalars['String']['output'];
  category_id?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['Timestamp']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  deposit_amount?: Maybe<Scalars['Float']['output']>;
  deposit_percentage?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Scalars['String']['output']>>;
  is_enabled: Scalars['Boolean']['output'];
  is_hidden_from_outfitters?: Maybe<Scalars['Boolean']['output']>;
  is_hidden_from_sportsmen?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  listings: Array<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  offer_period: AddOnOfferPeriod;
  /** Unused field. Built for potential cases with size variations for trophies. For now new add-ons will be created for each size variation. */
  options?: Maybe<Array<AddOnOption>>;
  outfitter: Outfitter;
  price_by_day?: Maybe<PriceByDay>;
  price_by_guest?: Maybe<PriceByGuest>;
  species?: Maybe<Species>;
  /** Unused field. Built for future references to Stripe products. */
  stripe_product_id?: Maybe<Scalars['String']['output']>;
  sub_label?: Maybe<Scalars['String']['output']>;
  unit_price: Scalars['Float']['output'];
  unit_price_label?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Timestamp']['output'];
};

export enum AddOnCategory {
  GunRental = 'GUN_RENTAL',
  MealUpgrade = 'MEAL_UPGRADE',
  Other = 'OTHER',
  Trophy = 'TROPHY'
}

export enum AddOnOfferPeriod {
  After = 'AFTER',
  Before = 'BEFORE',
  During = 'DURING'
}

export type AddOnOption = {
  __typename?: 'AddOnOption';
  created_at?: Maybe<Scalars['Timestamp']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  deposit_amount?: Maybe<Scalars['Float']['output']>;
  deposit_percentage?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  stripe_product_id?: Maybe<Scalars['String']['output']>;
  unit_price: Scalars['Float']['output'];
  updated_at?: Maybe<Scalars['Timestamp']['output']>;
};

export type AddPackageToQuoteInput = {
  add_ons?: InputMaybe<Array<QuoteAddOnInput>>;
  number_of_guests: Scalars['PositiveInt']['input'];
  pricing_package_id: Scalars['ID']['input'];
};

export type AdditionalBookingPaymentSummaryInput = {
  amount: Scalars['Float']['input'];
  external_payment_type?: InputMaybe<ExternalPaymentType>;
  payment_method_id?: InputMaybe<Scalars['String']['input']>;
};

export type AdditionalPaymentSummary = {
  __typename?: 'AdditionalPaymentSummary';
  line_items: Array<LineItem>;
  prices: Array<QuotePrice>;
  total: Scalars['Int']['output'];
};

export type AdditionalPaymentSummaryInput = {
  add_ons?: InputMaybe<Array<PaymentRequestAddOnInput>>;
  items?: InputMaybe<Array<PaymentItemRequestInput>>;
  should_include_taxes?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A type that describes an address */
export type Address = {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  street_a: Scalars['String']['output'];
  street_b?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  street_a: Scalars['String']['input'];
  street_b?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export enum AiAgent {
  Availability = 'AVAILABILITY',
  ListingDescription = 'LISTING_DESCRIPTION',
  OutfitterAbout = 'OUTFITTER_ABOUT'
}

export type AlgoliaOutfitterClient = {
  __typename?: 'AlgoliaOutfitterClient';
  date_added?: Maybe<Scalars['Timestamp']['output']>;
  gross_revenue?: Maybe<Scalars['PositiveInt']['output']>;
  last_booking_date?: Maybe<Scalars['Timestamp']['output']>;
  notes: Array<Note>;
  number_of_prior_bookings?: Maybe<Scalars['PositiveInt']['output']>;
  objectID: Scalars['String']['output'];
  outfitter_id: Scalars['String']['output'];
  resolved_user: OutfitterClientUser;
};

/** A type that describes an amenity */
export type Amenity = {
  __typename?: 'Amenity';
  category: AmenityCategory;
  created_at: Scalars['Timestamp']['output'];
  description: Scalars['String']['output'];
  icon_url: Scalars['URL']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export enum AmenityCategory {
  Basic = 'BASIC',
  Features = 'FEATURES',
  Include = 'INCLUDE'
}

export type Attachment = {
  __typename?: 'Attachment';
  type: MediaType;
  url: Scalars['String']['output'];
};

export type AttachmentInput = {
  type: MediaType;
  url: Scalars['String']['input'];
};

export type Attribution = {
  __typename?: 'Attribution';
  deal_attribution?: Maybe<Scalars['String']['output']>;
  internal_source?: Maybe<BookingInternalSource>;
  internal_source_entity_id?: Maybe<Scalars['ID']['output']>;
  internal_source_entity_type?: Maybe<BookingInternalSourceEntityType>;
  utm_campaign?: Maybe<Scalars['String']['output']>;
  utm_content?: Maybe<Scalars['String']['output']>;
  utm_medium?: Maybe<Scalars['String']['output']>;
  utm_source?: Maybe<Scalars['String']['output']>;
  utm_term?: Maybe<Scalars['String']['output']>;
};

export type AttributionInput = {
  client_name?: InputMaybe<Scalars['String']['input']>;
  client_version?: InputMaybe<Scalars['String']['input']>;
  deal_attribution?: InputMaybe<Scalars['String']['input']>;
  internal_source?: InputMaybe<BookingInternalSource>;
  internal_source_entity_id?: InputMaybe<Scalars['ID']['input']>;
  internal_source_entity_type?: InputMaybe<BookingInternalSourceEntityType>;
  utm_campaign?: InputMaybe<Scalars['String']['input']>;
  utm_content?: InputMaybe<Scalars['String']['input']>;
  utm_medium?: InputMaybe<Scalars['String']['input']>;
  utm_source?: InputMaybe<Scalars['String']['input']>;
  utm_term?: InputMaybe<Scalars['String']['input']>;
};

export enum AtvCategory {
  SideBySide = 'SIDE_BY_SIDE',
  Sport = 'SPORT',
  Utility = 'UTILITY',
  Youth = 'YOUTH'
}

export type AtvInput = {
  category: AtvCategory;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
};

export type AtvProps = {
  __typename?: 'AtvProps';
  category: AtvCategory;
  manufacturer?: Maybe<Scalars['String']['output']>;
};

/** A type that describes an available date with slots amount */
export type Availability = {
  __typename?: 'Availability';
  available_slots: Scalars['NonNegativeInt']['output'];
  booked_slots: Scalars['NonNegativeInt']['output'];
  date: Scalars['Timestamp']['output'];
  total_slots: Scalars['NonNegativeInt']['output'];
};

export type AvailabilityInfo = {
  __typename?: 'AvailabilityInfo';
  available_slots: Scalars['NonNegativeInt']['output'];
  booked_slots: Scalars['NonNegativeInt']['output'];
  threshold: AvailabilityThreshold;
  total_slots: Scalars['NonNegativeInt']['output'];
};

export type AvailabilityInput = {
  booked_slots: Scalars['NonNegativeInt']['input'];
  date: Scalars['Timestamp']['input'];
  total_slots: Scalars['NonNegativeInt']['input'];
};

export type AvailabilityRangeInput = {
  end_date: Scalars['Timestamp']['input'];
  is_available: Scalars['Boolean']['input'];
  start_date: Scalars['Timestamp']['input'];
  total_slots?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export enum AvailabilityThreshold {
  High = 'HIGH',
  Low = 'LOW',
  None = 'NONE'
}

export type AvailabilityUpdateInput = {
  booked_slots?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  end_date: Scalars['Timestamp']['input'];
  is_available: Scalars['Boolean']['input'];
  resource_id: Scalars['ID']['input'];
  resource_type: Scalars['String']['input'];
  start_date: Scalars['Timestamp']['input'];
  total_slots?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type AvailableDatesForCalendarEventResourcesInput = {
  calendar_event_id: Scalars['ID']['input'];
  end_date: Scalars['Timestamp']['input'];
  number_of_guests: Scalars['NonNegativeInt']['input'];
  start_date: Scalars['Timestamp']['input'];
};

export type Banner = {
  __typename?: 'Banner';
  content_default: BannerContent;
  content_mobile?: Maybe<BannerContent>;
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  is_admin: Scalars['Boolean']['output'];
  is_archived: Scalars['Boolean']['output'];
  order: Scalars['PositiveInt']['output'];
  page_keys: Array<BannerPageKey>;
  updated_at: Scalars['Timestamp']['output'];
};

export type BannerContent = {
  __typename?: 'BannerContent';
  body?: Maybe<Scalars['String']['output']>;
  color_mode: ColorMode;
  ctas: Array<CallToAction>;
  image?: Maybe<Media>;
  title_lines: Array<Scalars['String']['output']>;
};

export type BannerContentInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  color_mode: ColorMode;
  ctas: Array<CallToActionInput>;
  image?: InputMaybe<MediaInput>;
  title_lines: Array<Scalars['String']['input']>;
};

export enum BannerPageKey {
  DashboardHomepage = 'DashboardHomepage',
  WebsiteHomepage = 'WebsiteHomepage'
}

export type BaseEvent = {
  created_at: Scalars['Timestamp']['output'];
  event_type: EventType;
  id: Scalars['ID']['output'];
  updated_at: Scalars['Timestamp']['output'];
  user_id?: Maybe<Scalars['ID']['output']>;
};

export enum BedType {
  AirMattress = 'AIR_MATTRESS',
  BunkBed = 'BUNK_BED',
  Couch = 'COUCH',
  FloorMattress = 'FLOOR_MATTRESS',
  FullBed = 'FULL_BED',
  Hammock = 'HAMMOCK',
  KingBed = 'KING_BED',
  Other = 'OTHER',
  QueenBed = 'QUEEN_BED',
  SleepingBag = 'SLEEPING_BAG',
  Sofa = 'SOFA',
  SofaBed = 'SOFA_BED',
  TwinBed = 'TWIN_BED'
}

export enum BlindCategory {
  Box = 'BOX',
  Layout = 'LAYOUT',
  PopUp = 'POP_UP'
}

export type BlindInput = {
  category: BlindCategory;
};

export type BlindProps = {
  __typename?: 'BlindProps';
  category: BlindCategory;
};

export enum BoatCategory {
  DriftBoat = 'DRIFT_BOAT',
  ManPoweredBoat = 'MAN_POWERED_BOAT',
  MotorBoat = 'MOTOR_BOAT',
  SailBoat = 'SAIL_BOAT'
}

export type BoatInput = {
  boat_manufacturer?: InputMaybe<Scalars['String']['input']>;
  boat_type?: InputMaybe<Scalars['String']['input']>;
  category: BoatCategory;
  length?: InputMaybe<Scalars['Int']['input']>;
};

export type BoatProps = {
  __typename?: 'BoatProps';
  boat_manufacturer?: Maybe<Scalars['String']['output']>;
  boat_type?: Maybe<Scalars['String']['output']>;
  category: BoatCategory;
  length?: Maybe<Scalars['Int']['output']>;
};

/** A type that describes a booking */
export type Booking = {
  __typename?: 'Booking';
  add_ons?: Maybe<Array<QuoteAddOn>>;
  allows_editing?: Maybe<Scalars['Boolean']['output']>;
  attribution?: Maybe<Attribution>;
  booking_invite?: Maybe<BookingInvite>;
  can_be_reviewed?: Maybe<Scalars['Boolean']['output']>;
  can_request_additional_payments: Scalars['Boolean']['output'];
  cancellation_reason?: Maybe<BookingCancellationReason>;
  check_in_time: Scalars['Timestamp']['output'];
  check_out_time: Scalars['Timestamp']['output'];
  color?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<Coupon>;
  created_at: Scalars['Timestamp']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  dates: Array<Scalars['Timestamp']['output']>;
  denial_reasons?: Maybe<Array<DenialReason>>;
  discount?: Maybe<Scalars['Float']['output']>;
  edits_history?: Maybe<Array<EditLogEntry>>;
  end_date: Scalars['Timestamp']['output'];
  group_pay_share?: Maybe<GroupPayShare>;
  guides: Array<TeamMember>;
  has_additional_booking_payments?: Maybe<Scalars['Boolean']['output']>;
  has_lodging: Scalars['Boolean']['output'];
  has_remaining_payments?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  invoice_id?: Maybe<Scalars['String']['output']>;
  is_archived: Scalars['Boolean']['output'];
  is_demo?: Maybe<Scalars['Boolean']['output']>;
  is_offsite?: Maybe<Scalars['Boolean']['output']>;
  is_returning_customer?: Maybe<Scalars['Boolean']['output']>;
  items: Array<QuoteItem>;
  itinerary?: Maybe<TripItinerary>;
  liability_waivers?: Maybe<Array<OutfitterDocument>>;
  listing: Listing;
  listing_id: Scalars['ID']['output'];
  message_to_outfitter?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  outfitter: Outfitter;
  packages: Array<QuotePackage>;
  paymentRequests: Array<PaymentRequest>;
  payment_plan_type?: Maybe<PaymentPlanType>;
  payment_summary: BookingPaymentSummary;
  payments: Array<Payment>;
  /** @deprecated Use packages instead */
  pricing_package?: Maybe<PricingPackage>;
  quote?: Maybe<Quote>;
  rates?: Maybe<Rates>;
  review_form_url?: Maybe<Scalars['String']['output']>;
  service_fee: Scalars['Float']['output'];
  should_allow_external_payment?: Maybe<Scalars['Boolean']['output']>;
  start_date: Scalars['Timestamp']['output'];
  state_tax: Scalars['Float']['output'];
  status: BookingStatus;
  sub_total: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  trip_insurance?: Maybe<BookingTripInsurance>;
  updated_at: Scalars['Timestamp']['output'];
  user: User;
  was_guest_checkout?: Maybe<Scalars['Boolean']['output']>;
  what_to_expect_documents?: Maybe<Array<OutfitterDocument>>;
  widget_source?: Maybe<Scalars['String']['output']>;
};

export type BookingCancellationInfo = {
  __typename?: 'BookingCancellationInfo';
  members: Array<BookingCancellationMemberInfo>;
  reasons: Array<DenialReason>;
};

export type BookingCancellationMemberInfo = {
  __typename?: 'BookingCancellationMemberInfo';
  amount_paid: Scalars['NonNegativeInt']['output'];
  deposit_amount: Scalars['NonNegativeInt']['output'];
  is_auto_refund_allowed: Scalars['Boolean']['output'];
  member_id: Scalars['ID']['output'];
  member_name: Scalars['String']['output'];
  payment_plan_type?: Maybe<PaymentPlanType>;
};

export type BookingCancellationReason = {
  __typename?: 'BookingCancellationReason';
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
};

export enum BookingInternalSource {
  Dashboard = 'Dashboard',
  GuideTech = 'GuideTech',
  MallardBay = 'MallardBay',
  SendQuote = 'SendQuote',
  SendQuoteMarketplace = 'SendQuoteMarketplace'
}

export enum BookingInternalSourceEntityType {
  BookingInvites = 'BookingInvites',
  Listings = 'Listings',
  PricingPackages = 'PricingPackages',
  Widgets = 'Widgets'
}

export type BookingInvite = {
  __typename?: 'BookingInvite';
  /** @deprecated Use packages instead */
  add_ons?: Maybe<Array<QuoteAddOn>>;
  attribution?: Maybe<Attribution>;
  booked_redirect_url?: Maybe<Scalars['String']['output']>;
  can_send_invoice: Scalars['Boolean']['output'];
  coupon?: Maybe<Coupon>;
  created_at: Scalars['Timestamp']['output'];
  /** @deprecated Need to remove once all FEs are updated */
  created_bookings: Array<Booking>;
  dates?: Maybe<Array<Scalars['Timestamp']['output']>>;
  editable_fields: BookingInviteEditableFields;
  hubspot_deal_owner_email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoice_id?: Maybe<Scalars['String']['output']>;
  invoice_note?: Maybe<Scalars['String']['output']>;
  is_active: Scalars['Boolean']['output'];
  is_archived: Scalars['Boolean']['output'];
  itinerary?: Maybe<TripItinerary>;
  join_url: Scalars['String']['output'];
  listing: Listing;
  note?: Maybe<Scalars['String']['output']>;
  outfitter: Outfitter;
  packages: Array<BookingInvitePackage>;
  /** @deprecated Use packages instead */
  pricing_package?: Maybe<PricingPackage>;
  quote_request_id?: Maybe<Scalars['ID']['output']>;
  should_allow_external_payment?: Maybe<Scalars['Boolean']['output']>;
  sportsman_email?: Maybe<Scalars['String']['output']>;
  sportsman_name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use packages instead */
  total_guests?: Maybe<Scalars['PositiveInt']['output']>;
  updated_at: Scalars['Timestamp']['output'];
  user?: Maybe<BookingInviteUser>;
};

export type BookingInviteEditableFields = {
  __typename?: 'BookingInviteEditableFields';
  add_ons: Scalars['Boolean']['output'];
  coupon: Scalars['Boolean']['output'];
  dates: Scalars['Boolean']['output'];
  pricing_package: Scalars['Boolean']['output'];
  total_guests: Scalars['Boolean']['output'];
};

export type BookingInviteEditableFieldsInput = {
  add_ons: Scalars['Boolean']['input'];
  coupon: Scalars['Boolean']['input'];
  dates: Scalars['Boolean']['input'];
  pricing_package: Scalars['Boolean']['input'];
  total_guests: Scalars['Boolean']['input'];
};

export type BookingInviteFilters = {
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  quote_request_id?: InputMaybe<Scalars['ID']['input']>;
};

export type BookingInvitePackage = {
  __typename?: 'BookingInvitePackage';
  add_ons?: Maybe<Array<QuoteAddOn>>;
  editable_fields: BookingInviteEditableFields;
  id: Scalars['ID']['output'];
  pricing_package?: Maybe<PricingPackage>;
  total_guests?: Maybe<Scalars['PositiveInt']['output']>;
};

export type BookingInvitePackageInput = {
  add_ons?: InputMaybe<Array<QuoteAddOnInput>>;
  editable_fields: BookingInviteEditableFieldsInput;
  id?: InputMaybe<Scalars['ID']['input']>;
  pricing_package?: InputMaybe<Scalars['ID']['input']>;
  total_guests?: InputMaybe<Scalars['PositiveInt']['input']>;
};

export type BookingInviteUser = {
  __typename?: 'BookingInviteUser';
  email?: Maybe<Scalars['EmailAddress']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['PhoneNumber']['output']>;
};

export type BookingInvitesResults = {
  __typename?: 'BookingInvitesResults';
  count: Scalars['Int']['output'];
  data: Array<BookingInvite>;
  pages: Scalars['Int']['output'];
};

export type BookingPaymentSummary = {
  __typename?: 'BookingPaymentSummary';
  line_items: Array<LineItem>;
  member_summaries: Array<MemberPaymentSummary>;
  member_total?: Maybe<Scalars['PositiveInt']['output']>;
  totals: Array<QuotePrice>;
};

export type BookingQuoteTripInsuranceQuote = {
  __typename?: 'BookingQuoteTripInsuranceQuote';
  cost: Scalars['PositiveInt']['output'];
  insurable_amount?: Maybe<Scalars['PositiveInt']['output']>;
  is_accepted?: Maybe<Scalars['Boolean']['output']>;
  policy_attributes?: Maybe<TripInsurancePolicyAttribute>;
  product: TripInsuranceProduct;
  quote_id: Scalars['String']['output'];
  taxes_and_fees?: Maybe<Array<TripInsuranceTaxesAndFees>>;
  zip_code?: Maybe<Scalars['String']['output']>;
};

export type BookingReferral = {
  __typename?: 'BookingReferral';
  booking?: Maybe<Booking>;
  booking_invite_id?: Maybe<Scalars['ID']['output']>;
  created_at: Scalars['Timestamp']['output'];
  decline_reason?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fee_amount: Scalars['NonNegativeInt']['output'];
  fee_fixed: Scalars['NonNegativeInt']['output'];
  fee_rate: Scalars['NonNegativeInt']['output'];
  id: Scalars['ID']['output'];
  is_by_admin: Scalars['Boolean']['output'];
  original_outfitter?: Maybe<Outfitter>;
  recipient_outfitter: Outfitter;
  sportsman_email?: Maybe<Scalars['EmailAddress']['output']>;
  sportsman_name?: Maybe<Scalars['String']['output']>;
  status: BookingReferralStatus;
  transfer_date?: Maybe<Scalars['Timestamp']['output']>;
  updated_at: Scalars['Timestamp']['output'];
  was_fee_transferred: Scalars['Boolean']['output'];
};

export enum BookingReferralStatus {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

export type BookingResults = {
  __typename?: 'BookingResults';
  count: Scalars['Int']['output'];
  data: Array<Booking>;
  pages: Scalars['Int']['output'];
};

export type BookingSearchResults = {
  __typename?: 'BookingSearchResults';
  results: Array<Booking>;
  total: Scalars['NonNegativeInt']['output'];
};

export type BookingStartedEvent = BaseEvent & {
  __typename?: 'BookingStartedEvent';
  created_at: Scalars['Timestamp']['output'];
  event_type: EventType;
  id: Scalars['ID']['output'];
  metadata: BookingStartedEventMetadata;
  updated_at: Scalars['Timestamp']['output'];
  user_id?: Maybe<Scalars['ID']['output']>;
};

export type BookingStartedEventMetadata = {
  __typename?: 'BookingStartedEventMetadata';
  listing_id: Scalars['ID']['output'];
  outfitter_id: Scalars['ID']['output'];
  pricing_package_ids: Array<Scalars['ID']['output']>;
};

export enum BookingStatus {
  Approved = 'APPROVED',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Denied = 'DENIED',
  Requested = 'REQUESTED'
}

export type BookingTripInsurance = {
  __typename?: 'BookingTripInsurance';
  errors?: Maybe<Array<TripInsuranceError>>;
  insurable_amount: Scalars['PositiveInt']['output'];
  insurance_policy_number?: Maybe<Scalars['String']['output']>;
  insurance_quote_id: Scalars['String']['output'];
  is_accepted?: Maybe<Scalars['Boolean']['output']>;
  status: BookingTripInsuranceStatus;
  zip_code: Scalars['String']['output'];
};

export type BookingTripInsuranceInput = {
  insurance_quote_id: Scalars['String']['input'];
  zip_code: Scalars['String']['input'];
};

export enum BookingTripInsuranceStatus {
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  PendingApproval = 'PENDING_APPROVAL'
}

export type CalendarEvent = {
  __typename?: 'CalendarEvent';
  base_color: Scalars['String']['output'];
  calculated_colors: CalendarEventCalculatedColors;
  created_at: Scalars['Timestamp']['output'];
  dates: Array<CalendarEventDate>;
  description?: Maybe<Scalars['String']['output']>;
  details_items: Array<CalendarEventDetailsItem>;
  end_date: Scalars['Timestamp']['output'];
  formatted_date_range: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_archived: Scalars['Boolean']['output'];
  is_single_use_resources: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  number_of_guests: Scalars['NonNegativeInt']['output'];
  outfitter_id: Scalars['ID']['output'];
  resources: Array<MinimalResource>;
  source: Scalars['String']['output'];
  source_id: Scalars['String']['output'];
  source_type: CalendarEventSourceType;
  start_date: Scalars['Timestamp']['output'];
  status: EventStatus;
  subtitle: Scalars['String']['output'];
  time_zone: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type CalendarEventCalculatedColors = {
  __typename?: 'CalendarEventCalculatedColors';
  dark: CalendarEventColors;
  light: CalendarEventColors;
};

export type CalendarEventColors = {
  __typename?: 'CalendarEventColors';
  background: Scalars['String']['output'];
  border: Scalars['String']['output'];
  highlighted: Scalars['String']['output'];
  not_highlighted: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type CalendarEventDate = {
  __typename?: 'CalendarEventDate';
  date: Scalars['Timestamp']['output'];
  is_highlighted: Scalars['Boolean']['output'];
};

export type CalendarEventDetailsItem = {
  __typename?: 'CalendarEventDetailsItem';
  is_bold: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
};

export type CalendarEventFilters = {
  from_date?: InputMaybe<Scalars['Timestamp']['input']>;
  to_date?: InputMaybe<Scalars['Timestamp']['input']>;
};

export enum CalendarEventSourceType {
  Booking = 'BOOKING',
  CalendarImport = 'CALENDAR_IMPORT'
}

export type CalendarSubscription = {
  __typename?: 'CalendarSubscription';
  created_at: Scalars['Timestamp']['output'];
  filename: Scalars['String']['output'];
  google_calendar_url: Scalars['URL']['output'];
  id: Scalars['ID']['output'];
  is_archived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  outlook_calendar_url: Scalars['URL']['output'];
  resources: Array<MinimalResource>;
  updated_at: Scalars['Timestamp']['output'];
  url: Scalars['URL']['output'];
  user: User;
  webcal_url: Scalars['URL']['output'];
};

export type CalendarSubscriptionsResults = {
  __typename?: 'CalendarSubscriptionsResults';
  count: Scalars['Int']['output'];
  data: Array<CalendarSubscription>;
  pages: Scalars['Int']['output'];
};

export type CallToAction = {
  __typename?: 'CallToAction';
  image?: Maybe<Media>;
  label: Scalars['String']['output'];
  url_android?: Maybe<Scalars['URL']['output']>;
  url_default: Scalars['URL']['output'];
  url_ios?: Maybe<Scalars['URL']['output']>;
};

export type CallToActionInput = {
  image?: InputMaybe<MediaInput>;
  label: Scalars['String']['input'];
  url_android?: InputMaybe<Scalars['URL']['input']>;
  url_default: Scalars['URL']['input'];
  url_ios?: InputMaybe<Scalars['URL']['input']>;
};

export type CancelBookingReasonInput = {
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
};

export type CancelBookingRefundInput = {
  amount: Scalars['NonNegativeInt']['input'];
  member_id: Scalars['String']['input'];
};

export type CancellationPolicy = {
  __typename?: 'CancellationPolicy';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_custom: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  ai_agent?: Maybe<AiAgent>;
  ai_suggestion_id?: Maybe<Scalars['ID']['output']>;
  channel_id: Scalars['ID']['output'];
  content: Scalars['String']['output'];
  created_at: Scalars['Timestamp']['output'];
  has_ai_suggestion_been_applied: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  is_ai: Scalars['Boolean']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type ChatMessagesResults = {
  __typename?: 'ChatMessagesResults';
  count: Scalars['Int']['output'];
  data: Array<ChatMessage>;
  pages: Scalars['Int']['output'];
};

export type CheckInConfig = {
  __typename?: 'CheckInConfig';
  check_in_minutes?: Maybe<Scalars['NonNegativeInt']['output']>;
  check_out_minutes?: Maybe<Scalars['NonNegativeInt']['output']>;
  days_after_check_out?: Maybe<Scalars['NonNegativeInt']['output']>;
  days_before_check_in?: Maybe<Scalars['NonNegativeInt']['output']>;
  is_check_in_off?: Maybe<Scalars['Boolean']['output']>;
  is_check_out_off?: Maybe<Scalars['Boolean']['output']>;
  non_lodging_check_in_minutes?: Maybe<Scalars['NonNegativeInt']['output']>;
  non_lodging_check_out_minutes?: Maybe<Scalars['NonNegativeInt']['output']>;
  non_lodging_days_after_check_out?: Maybe<Scalars['NonNegativeInt']['output']>;
  non_lodging_days_before_check_in?: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type CheckInConfigInput = {
  check_in_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  check_out_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  days_after_check_out?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  days_before_check_in?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  is_check_in_off?: InputMaybe<Scalars['Boolean']['input']>;
  is_check_out_off?: InputMaybe<Scalars['Boolean']['input']>;
  non_lodging_check_in_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  non_lodging_check_out_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  non_lodging_days_after_check_out?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  non_lodging_days_before_check_in?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export enum ColorMode {
  Dark = 'Dark',
  Light = 'Light'
}

/** A type that describes a coupon */
export type Coupon = {
  __typename?: 'Coupon';
  amount_off?: Maybe<Scalars['Float']['output']>;
  created_at: Scalars['Timestamp']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  custom_code: Scalars['ID']['output'];
  duration: CouponDuration;
  duration_in_months?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  max_redemptions?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  outfitter?: Maybe<Outfitter>;
  percent_off?: Maybe<Scalars['Float']['output']>;
  redeem_by?: Maybe<Scalars['Timestamp']['output']>;
  updated_at: Scalars['Timestamp']['output'];
};

export enum CouponDuration {
  Forever = 'forever',
  Once = 'once',
  Repeating = 'repeating'
}

export type CreateAddOnInput = {
  apply_to_all_listings?: InputMaybe<Scalars['Boolean']['input']>;
  category: Scalars['String']['input'];
  category_id?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  deposit_amount?: InputMaybe<Scalars['Float']['input']>;
  deposit_percentage?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  is_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_hidden_from_outfitters?: InputMaybe<Scalars['Boolean']['input']>;
  is_hidden_from_sportsmen?: InputMaybe<Scalars['Boolean']['input']>;
  listings?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  offer_period: AddOnOfferPeriod;
  outfitter: Scalars['ID']['input'];
  price_by_day?: InputMaybe<PriceByDay>;
  price_by_guest?: InputMaybe<PriceByGuest>;
  species?: InputMaybe<Scalars['ID']['input']>;
  stripe_product_id?: InputMaybe<Scalars['String']['input']>;
  unit_price: Scalars['Float']['input'];
};

export type CreateAddOnOptionInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  deposit_amount?: InputMaybe<Scalars['Float']['input']>;
  deposit_percentage?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  stripe_product_id?: InputMaybe<Scalars['String']['input']>;
  unit_price: Scalars['Float']['input'];
};

export type CreateAdditionalBookingPaymentInput = {
  amount: Scalars['Float']['input'];
  date?: InputMaybe<Scalars['Timestamp']['input']>;
  external_payment_reference_id?: InputMaybe<Scalars['String']['input']>;
  external_payment_type?: InputMaybe<ExternalPaymentType>;
  group_pay_member_id?: InputMaybe<Scalars['String']['input']>;
  has_payment_been_received?: InputMaybe<Scalars['Boolean']['input']>;
  note: Scalars['String']['input'];
  payment_method_id?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateAmenityInput = {
  category: Scalars['String']['input'];
  description: Scalars['String']['input'];
  icon_url: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateBannerInput = {
  content_default: BannerContentInput;
  content_mobile?: InputMaybe<BannerContentInput>;
  is_admin: Scalars['Boolean']['input'];
  order: Scalars['PositiveInt']['input'];
  page_keys: Array<BannerPageKey>;
};

export type CreateBookingInput = {
  /** @deprecated check_in_time is now inferred from start_date */
  check_in_time?: InputMaybe<Scalars['Timestamp']['input']>;
  group_pay_share?: InputMaybe<Scalars['ID']['input']>;
  internal_source?: InputMaybe<BookingInternalSource>;
  internal_source_entity_id?: InputMaybe<Scalars['ID']['input']>;
  internal_source_entity_type?: InputMaybe<BookingInternalSourceEntityType>;
  is_external_payment_method?: InputMaybe<Scalars['Boolean']['input']>;
  message_to_outfitter?: InputMaybe<Scalars['String']['input']>;
  payment_method?: InputMaybe<Scalars['ID']['input']>;
  payment_plan_type: PaymentPlanType;
  payment_processor_type?: InputMaybe<PaymentProcessorType>;
  quote_id: Scalars['ID']['input'];
  widget_source?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBookingInviteInput = {
  /** @deprecated Use packages instead */
  add_ons?: InputMaybe<Array<QuoteAddOnInput>>;
  attribution?: InputMaybe<AttributionInput>;
  coupon?: InputMaybe<Scalars['ID']['input']>;
  dates?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  editable_fields: BookingInviteEditableFieldsInput;
  hubspot_deal_owner_email?: InputMaybe<Scalars['String']['input']>;
  invoice_note?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  listing: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  outfitter: Scalars['ID']['input'];
  packages?: InputMaybe<Array<BookingInvitePackageInput>>;
  /** @deprecated Use packages instead */
  pricing_package?: InputMaybe<Scalars['ID']['input']>;
  quote_request_id?: InputMaybe<Scalars['ID']['input']>;
  should_allow_external_payment?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use userInput instead */
  sportsman_email?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use userInput instead */
  sportsman_name?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use packages instead */
  total_guests?: InputMaybe<Scalars['PositiveInt']['input']>;
};

export type CreateBookingReferralsInput = {
  booking?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  is_by_admin: Scalars['Boolean']['input'];
  original_outfitter?: InputMaybe<Scalars['String']['input']>;
  recipient_outfitter_ids: Array<Scalars['String']['input']>;
  sportsman_email?: InputMaybe<Scalars['EmailAddress']['input']>;
  sportsman_name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBookingStartedEventInput = {
  internal_source?: InputMaybe<BookingInternalSource>;
  internal_source_entity_id?: InputMaybe<Scalars['ID']['input']>;
  internal_source_entity_type?: InputMaybe<BookingInternalSourceEntityType>;
  listing_id: Scalars['ID']['input'];
  pricing_package_ids: Array<Scalars['ID']['input']>;
};

export type CreateCalendarSubscriptionInput = {
  name: Scalars['String']['input'];
  resources: Array<MinimalResourceInput>;
};

export type CreateCouponInput = {
  amount_off?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  custom_code: Scalars['ID']['input'];
  duration: CouponDuration;
  duration_in_months?: InputMaybe<Scalars['Int']['input']>;
  max_redemptions?: InputMaybe<Scalars['Int']['input']>;
  outfitter?: InputMaybe<Scalars['ID']['input']>;
  percent_off?: InputMaybe<Scalars['Float']['input']>;
  redeem_by?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type CreateGenericEventInput = {
  event_type: Scalars['String']['input'];
  metadata: Scalars['JSONObject']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateGroupPayInput = {
  members: Array<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type CreateGroupPayMemberInput = {
  email: Scalars['EmailAddress']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
};

export type CreateGroupPayShareInput = {
  group_pay: Scalars['ID']['input'];
  shares: Array<CreateSlotShareInput>;
};

export type CreateLeadInput = {
  address?: InputMaybe<AddressInput>;
  email: Scalars['EmailAddress']['input'];
  first_name?: InputMaybe<Scalars['String']['input']>;
  group_size?: InputMaybe<Scalars['PositiveInt']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  phone_number: Scalars['PhoneNumber']['input'];
  quality?: InputMaybe<LeadQuality>;
  referral_source?: InputMaybe<ReferralSource>;
  status?: InputMaybe<LeadStatus>;
  trip_amount?: InputMaybe<Scalars['PositiveInt']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLicenseInfoInput = {
  country: Scalars['String']['input'];
  fishing_info_url?: InputMaybe<Scalars['String']['input']>;
  general_info_url?: InputMaybe<Scalars['String']['input']>;
  hunting_info_url?: InputMaybe<Scalars['String']['input']>;
  online_portal_url?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
};

export type CreateListingInput = {
  admin_note?: InputMaybe<Scalars['String']['input']>;
  amenities?: InputMaybe<Array<Scalars['ID']['input']>>;
  booking_instructions?: InputMaybe<Scalars['String']['input']>;
  check_in_config?: InputMaybe<CheckInConfigInput>;
  check_in_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  check_out_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  deposit_percentage?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<ListingDuration>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  guides?: InputMaybe<Array<Scalars['ID']['input']>>;
  license_info?: InputMaybe<Scalars['ID']['input']>;
  license_required?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<AddressInput>;
  lodging?: InputMaybe<Scalars['ID']['input']>;
  lodgings?: InputMaybe<Array<Scalars['ID']['input']>>;
  max_guest?: InputMaybe<Scalars['PositiveInt']['input']>;
  min_guest?: InputMaybe<Scalars['PositiveInt']['input']>;
  outfitter: Scalars['ID']['input'];
  photos?: InputMaybe<Array<MediaInput>>;
  pricing?: InputMaybe<PricingInput>;
  pricing_packages?: InputMaybe<Array<Scalars['ID']['input']>>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  rule?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Array<Scalars['ID']['input']>>;
  time_of_day?: InputMaybe<ListingTimeOfDay>;
  time_zone?: InputMaybe<Scalars['TimeZone']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ListingType>;
};

export type CreateListingNoteInput = {
  content: Scalars['String']['input'];
  date: Scalars['Timestamp']['input'];
};

export type CreateListingVisitedEventInput = {
  listing_id: Scalars['ID']['input'];
};

export type CreateLodgingInput = {
  /** @deprecated Beds have been replaced by capacity */
  beds?: InputMaybe<Array<LodgingBedInput>>;
  capacity?: InputMaybe<Scalars['PositiveInt']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<MediaInput>>;
  is_single_use?: InputMaybe<Scalars['Boolean']['input']>;
  listings?: InputMaybe<Array<Scalars['ID']['input']>>;
  location?: InputMaybe<AddressInput>;
  name: Scalars['String']['input'];
  outfitter: Scalars['ID']['input'];
  type: LodgingType;
};

export type CreateNewsfeedEventInput = {
  activity_id: Scalars['String']['input'];
  entity_id: Scalars['ID']['input'];
  entity_type: EntityType;
};

export type CreateNoteInput = {
  content: Scalars['String']['input'];
};

export type CreateOffsiteBookingInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  custom_booking_fee?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  end_date: Scalars['Timestamp']['input'];
  items?: InputMaybe<Array<QuoteItemInput>>;
  listing: Scalars['ID']['input'];
  /** @deprecated This field is no longer used */
  should_adjust_availability?: InputMaybe<Scalars['Boolean']['input']>;
  start_date: Scalars['Timestamp']['input'];
  total: Scalars['Float']['input'];
  user: CreateUserInput;
};

export type CreateOutfitterDocumentInput = {
  document?: InputMaybe<MediaInput>;
  external_url?: InputMaybe<Scalars['String']['input']>;
  listing_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  outfitter_id: Scalars['String']['input'];
  pricing_package_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  type: OutfitterDocumentType;
};

export type CreateOutfitterInput = {
  about: Scalars['String']['input'];
  admin_note?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<MediaInput>;
  cancellation_policy?: InputMaybe<OutfitterCancellationPolicyInput>;
  check_in_config?: InputMaybe<CheckInConfigInput>;
  contacts?: InputMaybe<Array<OutfitterContactInput>>;
  currency?: InputMaybe<Scalars['String']['input']>;
  default_check_in_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  default_check_out_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  gmb_id?: InputMaybe<Scalars['String']['input']>;
  hubspot_company_id?: InputMaybe<Scalars['String']['input']>;
  is_guide_tech?: InputMaybe<Scalars['Boolean']['input']>;
  is_hidden_from_marketplace?: InputMaybe<Scalars['Boolean']['input']>;
  is_processing_fee_payed_by_sportsman?: InputMaybe<Scalars['Boolean']['input']>;
  land_size?: InputMaybe<Scalars['PositiveInt']['input']>;
  licensed?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<AddressInput>;
  lodging_instructions?: InputMaybe<Scalars['String']['input']>;
  lodging_rules?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  other_info?: InputMaybe<OutfitterOtherInfoInput>;
  owner?: InputMaybe<Scalars['ID']['input']>;
  photos?: InputMaybe<Array<MediaInput>>;
  primary_contact_email?: InputMaybe<Scalars['EmailAddress']['input']>;
  referral_fee_fixed?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  referral_fee_rate?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  species?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<OutfitterStatus>;
  tax_rate?: InputMaybe<Scalars['Float']['input']>;
  time_zone?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  video?: InputMaybe<VideoInput>;
  website?: InputMaybe<Scalars['String']['input']>;
  years_in_operation?: InputMaybe<Scalars['PositiveInt']['input']>;
};

export type CreateOutfitterPostInput = {
  attachments: Array<AttachmentInput>;
  content: Scalars['String']['input'];
  listing_ids: Array<Scalars['ID']['input']>;
};

export type CreatePaymentRequestInput = {
  add_ons?: InputMaybe<Array<PaymentRequestAddOnInput>>;
  items: Array<PaymentItemRequestInput>;
  payment_method_id?: InputMaybe<Scalars['String']['input']>;
  should_allow_external_payment?: InputMaybe<Scalars['Boolean']['input']>;
  should_include_taxes?: InputMaybe<Scalars['Boolean']['input']>;
  type: PaymentRequestType;
};

export type CreatePricingPackageInput = {
  check_in_config?: InputMaybe<CheckInConfigInput>;
  days_included: Scalars['NonNegativeInt']['input'];
  gear_rentals: Array<Scalars['ID']['input']>;
  guests_included: Scalars['NonNegativeInt']['input'];
  included_lodging_id?: InputMaybe<Scalars['ID']['input']>;
  included_resource_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_hidden_from_outfitters?: InputMaybe<Scalars['Boolean']['input']>;
  is_hidden_from_sportsmen?: InputMaybe<Scalars['Boolean']['input']>;
  is_lodging_only?: InputMaybe<Scalars['Boolean']['input']>;
  lodging_included: Scalars['Boolean']['input'];
  max_guests?: InputMaybe<Scalars['PositiveInt']['input']>;
  meal_upgrades: Array<Scalars['ID']['input']>;
  min_guests?: InputMaybe<Scalars['PositiveInt']['input']>;
  name: Scalars['String']['input'];
  other_add_ons: Array<Scalars['ID']['input']>;
  price: Scalars['Float']['input'];
  price_by_day: PriceByDay;
  price_by_guest: PriceByGuest;
  trophies: Array<Scalars['ID']['input']>;
};

export type CreateQuickPayPaymentInput = {
  amount: Scalars['PositiveInt']['input'];
  customer?: InputMaybe<PaymentCustomerInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  outfitter_id: Scalars['ID']['input'];
  should_include_taxes?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateQuoteInput = {
  add_ons?: InputMaybe<Array<QuoteAddOnInput>>;
  booking_invite?: InputMaybe<Scalars['ID']['input']>;
  coupon?: InputMaybe<Scalars['ID']['input']>;
  dates: Array<Scalars['Timestamp']['input']>;
  internal_source?: InputMaybe<BookingInternalSource>;
  internal_source_entity_id?: InputMaybe<Scalars['ID']['input']>;
  internal_source_entity_type?: InputMaybe<BookingInternalSourceEntityType>;
  packages?: InputMaybe<Array<AddPackageToQuoteInput>>;
  pricing_package?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Use packages instead */
  total_guests?: InputMaybe<Scalars['PositiveInt']['input']>;
};

export type CreateRefundInput = {
  amount: Scalars['PositiveInt']['input'];
  approved_by_name: Scalars['String']['input'];
  is_outfitter_responsible_for_refund: Scalars['Boolean']['input'];
  payment_id: Scalars['ID']['input'];
  stripe_reason?: InputMaybe<StripeRefundReason>;
  user_reason: Scalars['String']['input'];
};

export type CreateResourceInput = {
  atv_props?: InputMaybe<AtvInput>;
  blind_props?: InputMaybe<BlindInput>;
  boat_props?: InputMaybe<BoatInput>;
  capacity: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  gear_props?: InputMaybe<GearInput>;
  images?: InputMaybe<Array<MediaInput>>;
  is_single_use?: InputMaybe<Scalars['Boolean']['input']>;
  listings?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  outfitter_id: Scalars['String']['input'];
  type: ResourceType;
  vehicle_props?: InputMaybe<VehicleInput>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateReviewFormInput = {
  main_subject_type: ReviewSubjectType;
  name: Scalars['String']['input'];
  owner_type: ReviewOwnerType;
  questions?: InputMaybe<Array<ReviewFormQuestionInput>>;
  sub_owner_type?: InputMaybe<ReviewOwnerType>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateReviewInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  photos?: InputMaybe<Array<MediaInput>>;
  rating?: InputMaybe<Scalars['PositiveInt']['input']>;
};

export type CreateSetupIntentOnBehalfOfInput = {
  userId: Scalars['ID']['input'];
};

export type CreateSlotShareInput = {
  member: Scalars['ID']['input'];
  slots: Scalars['PositiveInt']['input'];
  total: Scalars['NonNegativeInt']['input'];
};

export type CreateSpeciesCategoryInput = {
  image?: InputMaybe<MediaInput>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
};

export type CreateSpeciesInput = {
  category?: InputMaybe<SpeciesCategoryInput>;
  image?: InputMaybe<MediaInput>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  type: SpeciesType;
};

export type CreateTeamMemberInput = {
  email: Scalars['EmailAddress']['input'];
  name: Scalars['String']['input'];
  role: TeamMemberRole;
};

export type CreateTransactionInput = {
  payment_processor_transaction_id: Scalars['ID']['input'];
  payment_processor_type: Scalars['String']['input'];
};

export type CreateUserInput = {
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  bookings?: InputMaybe<Array<Scalars['ID']['input']>>;
  date_of_birth?: InputMaybe<Scalars['PositiveInt']['input']>;
  email: Scalars['EmailAddress']['input'];
  favorite_game?: InputMaybe<Array<Scalars['String']['input']>>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  is_guest?: InputMaybe<Scalars['Boolean']['input']>;
  is_guest_conversion_disabled?: InputMaybe<Scalars['Boolean']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
  stripe_connected_account_id?: InputMaybe<Scalars['String']['input']>;
  stripe_user_id?: InputMaybe<Scalars['String']['input']>;
  years_of_experience?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type CreateWidgetInput = {
  button_color?: InputMaybe<Scalars['String']['input']>;
  button_text?: InputMaybe<Scalars['String']['input']>;
  google_analytics_id?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_external?: InputMaybe<Scalars['Boolean']['input']>;
  listing_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  outfitter: Scalars['ID']['input'];
  pixel_id?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  text_color?: InputMaybe<Scalars['String']['input']>;
  trigger_type: WidgetTriggerType;
  widget_name: Scalars['String']['input'];
};

export type CreateWishlistInput = {
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  listings?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  user: Scalars['ID']['input'];
};

export type CursorPaginationInfo = {
  __typename?: 'CursorPaginationInfo';
  first_cursor?: Maybe<Scalars['ID']['output']>;
  has_more: Scalars['Boolean']['output'];
  last_cursor?: Maybe<Scalars['ID']['output']>;
};

export type CursorPaginationOptions = {
  ending_before?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['PositiveInt']['input']>;
  starting_after?: InputMaybe<Scalars['ID']['input']>;
};

export type DayBalanceDueConfig = {
  __typename?: 'DayBalanceDueConfig';
  day: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
};

export type DayBalanceDueConfigInput = {
  day: Scalars['Int']['input'];
  month: Scalars['Int']['input'];
};

export type DealAttributionOption = {
  __typename?: 'DealAttributionOption';
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type DenialReason = {
  __typename?: 'DenialReason';
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type DenialReasonInput = {
  content: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type Disqualification = {
  __typename?: 'Disqualification';
  created_at?: Maybe<Scalars['Timestamp']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  is_disqualified?: Maybe<Scalars['Boolean']['output']>;
  reason?: Maybe<Array<DisqualifiedReason>>;
};

export type DisqualificationInput = {
  created_by: Scalars['String']['input'];
  is_disqualified: Scalars['Boolean']['input'];
  reason?: InputMaybe<Array<DisqualifiedReason>>;
};

export enum DisqualifiedReason {
  AskedToBeRemoved = 'ASKED_TO_BE_REMOVED',
  BadEmail = 'BAD_EMAIL',
  BadNumber = 'BAD_NUMBER',
  Other = 'OTHER',
  Spam = 'SPAM'
}

export type DraftQuote = QuoteInterface & {
  __typename?: 'DraftQuote';
  add_ons?: Maybe<Array<QuoteAddOn>>;
  attribution?: Maybe<Attribution>;
  booking_invite?: Maybe<BookingInvite>;
  coupon?: Maybe<Coupon>;
  currency?: Maybe<Scalars['String']['output']>;
  dates: Array<Scalars['Timestamp']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  items: Array<QuoteItem>;
  itinerary?: Maybe<TripItinerary>;
  listing: Listing;
  lodging_included?: Maybe<Scalars['Boolean']['output']>;
  packages: Array<QuotePackage>;
  payment_plans: Array<QuotePaymentPlan>;
  payment_summary?: Maybe<PaymentSummary>;
  prices: Array<QuotePrice>;
  /** @deprecated Use packages instead */
  pricing_package?: Maybe<PricingPackage>;
  total: Scalars['Float']['output'];
  trip_insurance?: Maybe<BookingQuoteTripInsuranceQuote>;
};

export type EditLogEntry = {
  __typename?: 'EditLogEntry';
  edited_at: Scalars['Timestamp']['output'];
  edited_by: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

export type EnabledOutfitterIntegrations = {
  __typename?: 'EnabledOutfitterIntegrations';
  does_quick_books_need_reconnection?: Maybe<Scalars['Boolean']['output']>;
  is_quick_books_enabled?: Maybe<Scalars['Boolean']['output']>;
};

export enum EntityIntegrationSettingsEntityType {
  AddOn = 'ADD_ON',
  Listing = 'LISTING',
  PricingPackage = 'PRICING_PACKAGE'
}

export enum EntityType {
  AddOn = 'add_on',
  Booking = 'booking',
  BookingInvite = 'booking_invite',
  BookingReferral = 'booking_referral',
  CalendarEvent = 'calendar_event',
  GroupPayShare = 'group_pay_share',
  Listing = 'listing',
  Lodging = 'lodging',
  Onboarding = 'onboarding',
  Outfitter = 'outfitter',
  OutfitterDocument = 'outfitter_document',
  Payment = 'payment',
  PaymentRequest = 'payment_request',
  PricingPackage = 'pricing_package',
  QuoteRequest = 'quote_request',
  Resource = 'resource',
  StripeCharge = 'stripe_charge',
  StripeCustomer = 'stripe_customer',
  TeamMember = 'team_member',
  User = 'user'
}

export type EntityUserInput = {
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
};

export enum EventStatus {
  Approved = 'APPROVED',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Denied = 'DENIED',
  Requested = 'REQUESTED'
}

export enum EventType {
  BookingRequested = 'BOOKING_REQUESTED',
  BookingStarted = 'BOOKING_STARTED',
  ListingVisited = 'LISTING_VISITED',
  NewsfeedPostInteractedWith = 'NEWSFEED_POST_INTERACTED_WITH',
  NewsfeedPostOpened = 'NEWSFEED_POST_OPENED'
}

export type ExportDataInput = {
  from_date?: InputMaybe<Scalars['Timestamp']['input']>;
  outfitter_id: Scalars['ID']['input'];
  to_date?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ExternalPaymentInfoInput = {
  date: Scalars['Timestamp']['input'];
  external_payment_reference_id?: InputMaybe<Scalars['String']['input']>;
  external_payment_type: ExternalPaymentType;
};

export enum ExternalPaymentType {
  Cash = 'CASH',
  Check = 'CHECK',
  Other = 'OTHER'
}

export type FeatureAccess = {
  __typename?: 'FeatureAccess';
  features: Array<FeatureAccessSetting>;
};

export type FeatureAccessInput = {
  feature_key: FeatureKey;
  limit?: InputMaybe<Scalars['PositiveInt']['input']>;
};

export type FeatureAccessSetting = {
  __typename?: 'FeatureAccessSetting';
  current_count?: Maybe<Scalars['NonNegativeInt']['output']>;
  feature_key: FeatureKey;
  limit?: Maybe<Scalars['PositiveInt']['output']>;
};

export enum FeatureKey {
  AdditionalBookingPayments = 'ADDITIONAL_BOOKING_PAYMENTS',
  AdditionalPaymentRequests = 'ADDITIONAL_PAYMENT_REQUESTS',
  AssignGuideToBookings = 'ASSIGN_GUIDE_TO_BOOKINGS',
  BookingInvites = 'BOOKING_INVITES',
  ClientList = 'CLIENT_LIST',
  Coupons = 'COUPONS',
  EditBookingDates = 'EDIT_BOOKING_DATES',
  Leads = 'LEADS',
  Marketplace = 'MARKETPLACE',
  Messaging = 'MESSAGING',
  OffPlatformBookings = 'OFF_PLATFORM_BOOKINGS',
  QuickBooks = 'QUICK_BOOKS',
  QuickPay = 'QUICK_PAY',
  ReceiveReferrals = 'RECEIVE_REFERRALS',
  ReportingBasic = 'REPORTING_BASIC',
  ReportingBusinessPerformance = 'REPORTING_BUSINESS_PERFORMANCE',
  ReportingPayments = 'REPORTING_PAYMENTS',
  ReportingPayouts = 'REPORTING_PAYOUTS',
  ReportingUnpaidBalances = 'REPORTING_UNPAID_BALANCES',
  SendReferrals = 'SEND_REFERRALS',
  TeamMembers = 'TEAM_MEMBERS',
  ViewBookingsInCalendar = 'VIEW_BOOKINGS_IN_CALENDAR'
}

export enum FeedGroup {
  Listing = 'listing',
  Timeline = 'timeline',
  User = 'user'
}

export type GearInput = {
  other?: InputMaybe<Scalars['String']['input']>;
};

export type GearProps = {
  __typename?: 'GearProps';
  other?: Maybe<Scalars['String']['output']>;
};

export type GenericAvailabilityEntry = {
  __typename?: 'GenericAvailabilityEntry';
  available_slots: Scalars['NonNegativeInt']['output'];
  booked_slots: Scalars['NonNegativeInt']['output'];
  created_at: Scalars['Timestamp']['output'];
  date: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  is_ai_suggestion?: Maybe<Scalars['Boolean']['output']>;
  is_available: Scalars['Boolean']['output'];
  resource_id: Scalars['ID']['output'];
  resource_type: Scalars['String']['output'];
  total_slots: Scalars['NonNegativeInt']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type GenericEvent = {
  __typename?: 'GenericEvent';
  created_at: Scalars['Timestamp']['output'];
  event_type: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  metadata: Scalars['JSONObject']['output'];
  updated_at: Scalars['Timestamp']['output'];
  user_id?: Maybe<Scalars['ID']['output']>;
};

export type GenericSearchSuggestionGroup = {
  __typename?: 'GenericSearchSuggestionGroup';
  items: Array<GenericSearchSuggestionItem>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type GenericSearchSuggestionItem = {
  __typename?: 'GenericSearchSuggestionItem';
  cta_url?: Maybe<Scalars['String']['output']>;
  icon_url?: Maybe<Scalars['String']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type GetGenericAvailabilityInput = {
  ai_suggestion_id?: InputMaybe<Scalars['ID']['input']>;
  end_date: Scalars['Timestamp']['input'];
  resource_id: Scalars['ID']['input'];
  resource_type: Scalars['String']['input'];
  start_date: Scalars['Timestamp']['input'];
};

export type GroupPay = {
  __typename?: 'GroupPay';
  created_at: Scalars['Timestamp']['output'];
  host: User;
  id: Scalars['ID']['output'];
  members: Array<Maybe<GroupPayMember>>;
  name: Scalars['String']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type GroupPayMember = {
  __typename?: 'GroupPayMember';
  created_at: Scalars['Timestamp']['output'];
  email: Scalars['EmailAddress']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['PhoneNumber']['output']>;
  stripe_user_id: Scalars['String']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type GroupPayShare = {
  __typename?: 'GroupPayShare';
  booking?: Maybe<Booking>;
  created_at: Scalars['Timestamp']['output'];
  created_by: User;
  group_pay: GroupPay;
  id: Scalars['ID']['output'];
  join_url?: Maybe<Scalars['URL']['output']>;
  last_payment_due_date?: Maybe<Scalars['Timestamp']['output']>;
  remaining_slots?: Maybe<Scalars['NonNegativeInt']['output']>;
  shares: Array<SlotShare>;
  updated_at: Scalars['Timestamp']['output'];
};

export type GuestUserInput = {
  email: Scalars['EmailAddress']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  phone: Scalars['PhoneNumber']['input'];
};

export type HubspotCompanySearchResult = {
  __typename?: 'HubspotCompanySearchResult';
  companies: Array<HubspotCompanySearchResultItem>;
  total: Scalars['Int']['output'];
};

export type HubspotCompanySearchResultItem = {
  __typename?: 'HubspotCompanySearchResultItem';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type IdAndName = {
  __typename?: 'IdAndName';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ImpersonationDetails = {
  __typename?: 'ImpersonationDetails';
  acts_as_user_id?: Maybe<Scalars['String']['output']>;
  is_impersonated: Scalars['Boolean']['output'];
  original_user_id?: Maybe<Scalars['ID']['output']>;
};

export type InitiateConnectionResult = {
  __typename?: 'InitiateConnectionResult';
  auth_uri: Scalars['String']['output'];
};

export type JoinGroupPayInput = {
  bookingId: Scalars['ID']['input'];
  insuranceQuoteId?: InputMaybe<Scalars['ID']['input']>;
  invitationId: Scalars['ID']['input'];
  isExternalPaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  shouldAcceptTripInsurance?: InputMaybe<Scalars['Boolean']['input']>;
  slots: Scalars['PositiveInt']['input'];
  sportsmanZipCode?: InputMaybe<Scalars['String']['input']>;
};

export type JoinGroupPayShareInput = {
  bookingId: Scalars['ID']['input'];
  invitationId: Scalars['ID']['input'];
  isExternalPaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
  memberId: Scalars['ID']['input'];
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  slots: Scalars['PositiveInt']['input'];
};

export type Lead = {
  __typename?: 'Lead';
  address?: Maybe<Address>;
  available_at?: Maybe<Scalars['Timestamp']['output']>;
  client_id?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['Timestamp']['output'];
  disqualification?: Maybe<Disqualification>;
  email?: Maybe<Scalars['EmailAddress']['output']>;
  gross_sales?: Maybe<Scalars['Int']['output']>;
  group_size?: Maybe<Scalars['PositiveInt']['output']>;
  id: Scalars['ID']['output'];
  last_booking_date?: Maybe<Scalars['Timestamp']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Array<Note>>;
  number_of_comments?: Maybe<Scalars['Int']['output']>;
  outfitter_id: Scalars['String']['output'];
  phone_number?: Maybe<Scalars['PhoneNumber']['output']>;
  prior_bookings?: Maybe<Scalars['Int']['output']>;
  quality?: Maybe<LeadQuality>;
  referral_source?: Maybe<ReferralSource>;
  schedule_new_lead_at?: Maybe<Scalars['Timestamp']['output']>;
  status?: Maybe<LeadStatus>;
  trip_amount?: Maybe<Scalars['PositiveInt']['output']>;
  updated_at: Scalars['Timestamp']['output'];
  user: PublicUser;
  user_id?: Maybe<Scalars['String']['output']>;
};

export enum LeadQuality {
  Cold = 'COLD',
  Hot = 'HOT',
  Warm = 'WARM'
}

export enum LeadStatus {
  Booked = 'BOOKED',
  Contacted = 'CONTACTED',
  Disqualified = 'DISQUALIFIED',
  Lost = 'LOST',
  New = 'NEW',
  Quoted = 'QUOTED'
}

/** A type that describes hunting & fishing license info of a state */
export type LicenseInfo = {
  __typename?: 'LicenseInfo';
  country: Scalars['String']['output'];
  created_at: Scalars['Timestamp']['output'];
  fishing_info_url?: Maybe<Scalars['String']['output']>;
  general_info_url?: Maybe<Scalars['String']['output']>;
  hunting_info_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  online_portal_url?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type LineItem = {
  __typename?: 'LineItem';
  details_label?: Maybe<Scalars['String']['output']>;
  details_value?: Maybe<Scalars['String']['output']>;
  display_value: Scalars['String']['output'];
  key?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  section_key?: Maybe<Scalars['String']['output']>;
  sub_items?: Maybe<Array<SubItem>>;
  total: Scalars['Int']['output'];
};

/** A type that describes a listing */
export type Listing = {
  __typename?: 'Listing';
  admin_note?: Maybe<Scalars['String']['output']>;
  amenities: Array<Amenity>;
  availability_info?: Maybe<AvailabilityInfo>;
  booking_fee_fixed?: Maybe<Scalars['Float']['output']>;
  booking_fee_rate?: Maybe<Scalars['Float']['output']>;
  booking_instructions?: Maybe<Scalars['String']['output']>;
  booking_reviews_aggregation?: Maybe<ReviewAggregation>;
  check_in_config?: Maybe<CheckInConfig>;
  check_in_minutes?: Maybe<Scalars['NonNegativeInt']['output']>;
  check_out_minutes?: Maybe<Scalars['NonNegativeInt']['output']>;
  color: Scalars['String']['output'];
  cover_image?: Maybe<Scalars['URL']['output']>;
  created_at: Scalars['Timestamp']['output'];
  deposit_percentage: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<ListingDuration>;
  featured?: Maybe<Scalars['Boolean']['output']>;
  guides?: Maybe<Array<TeamMember>>;
  id: Scalars['ID']['output'];
  is_archived: Scalars['Boolean']['output'];
  is_demo?: Maybe<Scalars['Boolean']['output']>;
  is_hidden_from_marketplace?: Maybe<Scalars['Boolean']['output']>;
  is_unavailable?: Maybe<Scalars['Boolean']['output']>;
  liability_waivers?: Maybe<Array<OutfitterDocument>>;
  license_info?: Maybe<LicenseInfo>;
  license_required?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Address>;
  lodging?: Maybe<Lodging>;
  lodgings: Array<Lodging>;
  lowest_pricing_package?: Maybe<PricingPackage>;
  max_guest?: Maybe<Scalars['PositiveInt']['output']>;
  min_guest?: Maybe<Scalars['PositiveInt']['output']>;
  next_availability?: Maybe<GenericAvailabilityEntry>;
  notes: Array<ListingNote>;
  order?: Maybe<Scalars['PositiveInt']['output']>;
  outfitter: Outfitter;
  payment_fee_settings?: Maybe<PaymentFeeSettings>;
  photos: Array<Media>;
  /** @deprecated No longer supported */
  pricing?: Maybe<Pricing>;
  pricing_packages: Array<PricingPackage>;
  published?: Maybe<Scalars['Boolean']['output']>;
  rule?: Maybe<Scalars['String']['output']>;
  should_allow_quote_requests?: Maybe<Scalars['Boolean']['output']>;
  species: Array<Species>;
  tax_rate?: Maybe<Scalars['Float']['output']>;
  time_of_day?: Maybe<ListingTimeOfDay>;
  time_zone?: Maybe<Scalars['TimeZone']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ListingType>;
  updated_at: Scalars['Timestamp']['output'];
  what_to_expect_documents?: Maybe<Array<OutfitterDocument>>;
};

export enum ListingDuration {
  MultiDay = 'MULTI_DAY',
  SingleDay = 'SINGLE_DAY'
}

export type ListingNote = {
  __typename?: 'ListingNote';
  content: Scalars['String']['output'];
  created_at: Scalars['Timestamp']['output'];
  date: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  listing_id: Scalars['ID']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type ListingProgress = {
  __typename?: 'ListingProgress';
  is_add_ons_complete: Scalars['Boolean']['output'];
  is_amenities_complete: Scalars['Boolean']['output'];
  is_availability_complete: Scalars['Boolean']['output'];
  is_basic_info_complete: Scalars['Boolean']['output'];
  is_description_complete: Scalars['Boolean']['output'];
  is_guides_complete: Scalars['Boolean']['output'];
  is_listing_complete: Scalars['Boolean']['output'];
  is_location_complete: Scalars['Boolean']['output'];
  is_lodging_complete: Scalars['Boolean']['output'];
  is_photos_complete: Scalars['Boolean']['output'];
  is_post_trip_payments_complete: Scalars['Boolean']['output'];
  is_pricing_complete: Scalars['Boolean']['output'];
  is_species_complete: Scalars['Boolean']['output'];
};

export type ListingSearchResults = {
  __typename?: 'ListingSearchResults';
  results: Array<Listing>;
  total: Scalars['NonNegativeInt']['output'];
};

export enum ListingTimeOfDay {
  Afternoon = 'AFTERNOON',
  AllDay = 'ALL_DAY',
  Evening = 'EVENING',
  Morning = 'MORNING'
}

export enum ListingType {
  BlastCast = 'BLAST_CAST',
  Fishing = 'FISHING',
  Hunting = 'HUNTING',
  LodgingOnly = 'LODGING_ONLY'
}

export type ListingVisitedEvent = BaseEvent & {
  __typename?: 'ListingVisitedEvent';
  created_at: Scalars['Timestamp']['output'];
  event_type: EventType;
  id: Scalars['ID']['output'];
  metadata: ListingVisitedEventMetadata;
  updated_at: Scalars['Timestamp']['output'];
  user_id?: Maybe<Scalars['ID']['output']>;
};

export type ListingVisitedEventMetadata = {
  __typename?: 'ListingVisitedEventMetadata';
  has_availability: Scalars['Boolean']['output'];
  listing_id: Scalars['ID']['output'];
  outfitter_id: Scalars['ID']['output'];
};

/** A type that describes a lodging room or space */
export type Lodging = {
  __typename?: 'Lodging';
  /** @deprecated Beds have been replaced by capacity */
  beds: Array<LodgingBed>;
  /** @deprecated Beds have been replaced by capacity */
  beds_icons: Array<Scalars['URL']['output']>;
  /** @deprecated Beds have been replaced by capacity */
  beds_summary: Scalars['String']['output'];
  capacity: Scalars['PositiveInt']['output'];
  cover_image: Scalars['URL']['output'];
  created_at: Scalars['Timestamp']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Media>>;
  is_archived: Scalars['Boolean']['output'];
  is_single_use?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Address>;
  name: Scalars['String']['output'];
  outfitter: Outfitter;
  type: LodgingType;
  type_name: Scalars['String']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type LodgingBed = {
  __typename?: 'LodgingBed';
  bed_type_name: Scalars['String']['output'];
  count: Scalars['NonNegativeInt']['output'];
  type: BedType;
};

export type LodgingBedInput = {
  count: Scalars['NonNegativeInt']['input'];
  type: BedType;
};

export enum LodgingType {
  Bedroom = 'BEDROOM',
  CommonArea = 'COMMON_AREA',
  LivingRoom = 'LIVING_ROOM',
  Lodge = 'LODGE',
  Other = 'OTHER',
  Tent = 'TENT'
}

export type Media = {
  __typename?: 'Media';
  description?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  mime_type?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type MediaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  file_name?: InputMaybe<Scalars['String']['input']>;
  mime_type?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export enum MediaType {
  Image = 'image',
  Video = 'video'
}

export type MemberPaymentSummary = {
  __typename?: 'MemberPaymentSummary';
  member_id: Scalars['ID']['output'];
  member_name: Scalars['String']['output'];
  prices: Array<QuotePrice>;
  totals: Array<QuotePrice>;
};

/** A type that describes a metric */
export type Metric = {
  __typename?: 'Metric';
  created_at: Scalars['Timestamp']['output'];
  date_timestamp: Scalars['Timestamp']['output'];
  delta: MetricDelta;
  description: Scalars['String']['output'];
  formatted_value: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  metric_bucket: MetricBucket;
  metric_key: Scalars['String']['output'];
  outfitter_id: Scalars['ID']['output'];
  updated_at: Scalars['Timestamp']['output'];
  user_id?: Maybe<Scalars['String']['output']>;
  value: Scalars['Float']['output'];
};

export enum MetricBucket {
  Month = 'MONTH',
  Total = 'TOTAL',
  Year = 'YEAR'
}

export type MetricByOutfitterAndKeysParams = {
  end_date: Scalars['Timestamp']['input'];
  metric_bucket: MetricBucket;
  metric_keys: Array<Scalars['String']['input']>;
  outfitter_id: Scalars['ID']['input'];
  start_date: Scalars['Timestamp']['input'];
};

export enum MetricChangeType {
  Bad = 'BAD',
  Good = 'GOOD',
  Neutral = 'NEUTRAL'
}

export type MetricDelta = {
  __typename?: 'MetricDelta';
  change: Scalars['String']['output'];
  change_type: MetricChangeType;
};

export enum MetricKey {
  BookingCountNewCustomerBookingDate = 'BOOKING_COUNT_NEW_CUSTOMER_BOOKING_DATE',
  BookingCountNewCustomerTripDate = 'BOOKING_COUNT_NEW_CUSTOMER_TRIP_DATE',
  BookingCountOffsiteBookingDate = 'BOOKING_COUNT_OFFSITE_BOOKING_DATE',
  BookingCountOffsiteTripDate = 'BOOKING_COUNT_OFFSITE_TRIP_DATE',
  BookingCountOnlineBookingDate = 'BOOKING_COUNT_ONLINE_BOOKING_DATE',
  BookingCountOnlineTripDate = 'BOOKING_COUNT_ONLINE_TRIP_DATE',
  BookingCountReturningCustomerBookingDate = 'BOOKING_COUNT_RETURNING_CUSTOMER_BOOKING_DATE',
  BookingCountReturningCustomerTripDate = 'BOOKING_COUNT_RETURNING_CUSTOMER_TRIP_DATE',
  BookingCountSendQuoteBookingDate = 'BOOKING_COUNT_SEND_QUOTE_BOOKING_DATE',
  BookingCountSendQuoteTripDate = 'BOOKING_COUNT_SEND_QUOTE_TRIP_DATE',
  BookingCountTotalBookingDate = 'BOOKING_COUNT_TOTAL_BOOKING_DATE',
  BookingCountTotalTripDate = 'BOOKING_COUNT_TOTAL_TRIP_DATE',
  BookingCountTotalUserBooking = 'BOOKING_COUNT_TOTAL_USER_BOOKING',
  BookingCountWebsiteBookingDate = 'BOOKING_COUNT_WEBSITE_BOOKING_DATE',
  BookingCountWebsiteTripDate = 'BOOKING_COUNT_WEBSITE_TRIP_DATE',
  BookingCountWidgetBookingDate = 'BOOKING_COUNT_WIDGET_BOOKING_DATE',
  BookingCountWidgetTripDate = 'BOOKING_COUNT_WIDGET_TRIP_DATE',
  FailedPaymentsNetRevenue = 'FAILED_PAYMENTS_NET_REVENUE',
  FailedPaymentsTotal = 'FAILED_PAYMENTS_TOTAL',
  FailedPaymentsTotalOnCompletedTrips = 'FAILED_PAYMENTS_TOTAL_ON_COMPLETED_TRIPS',
  GrossRevenueNewCustomerBookingDate = 'GROSS_REVENUE_NEW_CUSTOMER_BOOKING_DATE',
  GrossRevenueNewCustomerTripDate = 'GROSS_REVENUE_NEW_CUSTOMER_TRIP_DATE',
  GrossRevenueOffsiteBookingDate = 'GROSS_REVENUE_OFFSITE_BOOKING_DATE',
  GrossRevenueOffsiteTripDate = 'GROSS_REVENUE_OFFSITE_TRIP_DATE',
  GrossRevenueOnlineBookingDate = 'GROSS_REVENUE_ONLINE_BOOKING_DATE',
  GrossRevenueOnlineTripDate = 'GROSS_REVENUE_ONLINE_TRIP_DATE',
  GrossRevenueReturningCustomerBookingDate = 'GROSS_REVENUE_RETURNING_CUSTOMER_BOOKING_DATE',
  GrossRevenueReturningCustomerTripDate = 'GROSS_REVENUE_RETURNING_CUSTOMER_TRIP_DATE',
  GrossRevenueSendQuoteBookingDate = 'GROSS_REVENUE_SEND_QUOTE_BOOKING_DATE',
  GrossRevenueSendQuoteTripDate = 'GROSS_REVENUE_SEND_QUOTE_TRIP_DATE',
  GrossRevenueTotalBookingDate = 'GROSS_REVENUE_TOTAL_BOOKING_DATE',
  GrossRevenueTotalTripDate = 'GROSS_REVENUE_TOTAL_TRIP_DATE',
  GrossRevenueTotalUserBooking = 'GROSS_REVENUE_TOTAL_USER_BOOKING',
  GrossRevenueWebsiteBookingDate = 'GROSS_REVENUE_WEBSITE_BOOKING_DATE',
  GrossRevenueWebsiteTripDate = 'GROSS_REVENUE_WEBSITE_TRIP_DATE',
  GrossRevenueWidgetBookingDate = 'GROSS_REVENUE_WIDGET_BOOKING_DATE',
  GrossRevenueWidgetTripDate = 'GROSS_REVENUE_WIDGET_TRIP_DATE',
  PendingPaymentsNetRevenue = 'PENDING_PAYMENTS_NET_REVENUE',
  PendingPaymentsTotal = 'PENDING_PAYMENTS_TOTAL',
  SuccessAchPaymentsCount = 'SUCCESS_ACH_PAYMENTS_COUNT',
  SuccessAchPaymentsNetRevenue = 'SUCCESS_ACH_PAYMENTS_NET_REVENUE',
  SuccessCardPaymentsCount = 'SUCCESS_CARD_PAYMENTS_COUNT',
  SuccessCardPaymentsNetRevenue = 'SUCCESS_CARD_PAYMENTS_NET_REVENUE',
  SuccessCashPaymentsCount = 'SUCCESS_CASH_PAYMENTS_COUNT',
  SuccessCashPaymentsNetRevenue = 'SUCCESS_CASH_PAYMENTS_NET_REVENUE',
  SuccessCheckPaymentsCount = 'SUCCESS_CHECK_PAYMENTS_COUNT',
  SuccessCheckPaymentsNetRevenue = 'SUCCESS_CHECK_PAYMENTS_NET_REVENUE',
  SuccessOtherPaymentsCount = 'SUCCESS_OTHER_PAYMENTS_COUNT',
  SuccessOtherPaymentsNetRevenue = 'SUCCESS_OTHER_PAYMENTS_NET_REVENUE',
  SuccessPaymentsNetRevenue = 'SUCCESS_PAYMENTS_NET_REVENUE'
}

export type MetricParams = {
  end_date?: InputMaybe<Scalars['Timestamp']['input']>;
  metric_bucket: MetricBucket;
  metric_key: Scalars['String']['input'];
  outfitter_id: Scalars['ID']['input'];
  start_date?: InputMaybe<Scalars['Timestamp']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export type MinimalResource = {
  __typename?: 'MinimalResource';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: ResourceType;
};

export type MinimalResourceInput = {
  id: Scalars['ID']['input'];
  type: ResourceType;
};

export type MoveBookingInput = {
  dates: Array<Scalars['Timestamp']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  _empty?: Maybe<Scalars['Void']['output']>;
  acceptAvailabilityAiSuggestion: Array<GenericAvailabilityEntry>;
  acceptBooking: Booking;
  acceptBookingReferral: BookingReferral;
  acceptPaymentRequest: PaymentRequest;
  acceptTeamMemberInvitation: TeamMember;
  addPackageToQuote: Quote;
  applyQuoteCoupon: Quote;
  archiveBanner: Banner;
  archiveBooking: Booking;
  archiveBookingInvite: BookingInvite;
  archiveCalendarSubscription: CalendarSubscription;
  archiveOnboarding?: Maybe<Scalars['Void']['output']>;
  archiveOutfitterDocument?: Maybe<Scalars['Void']['output']>;
  archiveQuoteRequest: QuoteRequest;
  archiveSyncedCalendar: SyncedCalendar;
  cancelBooking: Booking;
  cancelBookingReferral: BookingReferral;
  cancelPayment: Payment;
  cancelPaymentRequest: PaymentRequest;
  cancelRefund: Refund;
  changeUserPassword: Scalars['Boolean']['output'];
  confirmOfflinePaymentRequest: PaymentRequest;
  convertGuestToUser?: Maybe<Scalars['Void']['output']>;
  createAddOn: AddOn;
  createAdditionalBookingPayment: Payment;
  createAmenity: Amenity;
  createBanner: Banner;
  createBooking: Booking;
  createBookingAsOutfitter: Booking;
  createBookingInvite: BookingInvite;
  createBookingReferrals: Array<BookingReferral>;
  createBookingStartedEvent: BookingStartedEvent;
  createBookingTripInsurancePolicy: Booking;
  createCalendarSubscription: CalendarSubscription;
  createChatChannelWithOutfitter?: Maybe<Scalars['String']['output']>;
  createChatChannelWithSportsman?: Maybe<Scalars['String']['output']>;
  createCoupon: Coupon;
  createDraftOnboarding: Onboarding;
  createGenericEvent: GenericEvent;
  createGroupPayMemberSetupIntent: StripeSetupIntent;
  createGuestUser: User;
  createLead: Lead;
  createListing: Listing;
  createListingVisitedEvent: ListingVisitedEvent;
  createLodging: Lodging;
  createNewsfeedPostInteractedWithEvent: NewsfeedEvent;
  createNewsfeedPostOpenedEvent: NewsfeedEvent;
  createNote: Note;
  createNoteForListing: ListingNote;
  createOnboarding: Onboarding;
  /** @deprecated Use createOnboarding instead */
  createOnboardingForLegacyOutfitter: Onboarding;
  createOutfitter: Outfitter;
  createOutfitterDocument: OutfitterDocument;
  createOutfitterFeedPost?: Maybe<Scalars['Void']['output']>;
  createOutfitterFromHubspotCompany: Outfitter;
  createPaymentIntentForQuickPay: StripePaymentIntent;
  createPaymentRequest: PaymentRequest;
  createPricingPackage: PricingPackage;
  createQuickPayPayment: Payment;
  createQuote: Quote;
  createQuoteRequest: QuoteRequest;
  createRefund: Refund;
  createResource: Resource;
  createSetupIntent: StripeSetupIntent;
  createSetupIntentOnBehalfOf: StripeSetupIntent;
  createSpecies: Species;
  createSyncedCalendar: SyncedCalendar;
  createTeamMember: TeamMember;
  createUser: User;
  createUserFromAuth0: User;
  createWidget: Widget;
  createWishlist: Wishlist;
  declineBooking: Booking;
  declineBookingReferral: BookingReferral;
  deleteLead: Lead;
  deleteListing: Listing;
  deleteLodging?: Maybe<Scalars['Void']['output']>;
  deleteNote?: Maybe<Scalars['Void']['output']>;
  deleteNoteForListing?: Maybe<Scalars['Void']['output']>;
  deletePaymentFeeSettings?: Maybe<Scalars['Void']['output']>;
  deletePaymentMethod: Array<PaymentBlock>;
  deleteResource?: Maybe<Scalars['Void']['output']>;
  deleteSpecies: Species;
  deleteTeamMember?: Maybe<Scalars['Void']['output']>;
  deleteUser: User;
  disableQuotePaymentGroup: Quote;
  duplicateBookingInvite: BookingInvite;
  duplicateListing: Listing;
  enableQuotePaymentGroup: Quote;
  initiateQuickBooksConnection: InitiateConnectionResult;
  initiateTransferToOutfiterForPayment?: Maybe<Payment>;
  joinGroupPay: GroupPayShare;
  logInAsGuestUser: Scalars['String']['output'];
  markPaymentAsNotNeedingRefund: Payment;
  markPaymentAsPaidOffline: Payment;
  markPaymentAsRefunded: Payment;
  processTerminalPaymentIntent: PaymentRequest;
  reactToActivity: Activity;
  reassignOutfitterOwner: Outfitter;
  removeAddOn?: Maybe<Scalars['Void']['output']>;
  removeCoupon?: Maybe<Scalars['Void']['output']>;
  removeListing: Listing;
  removeOffsiteBooking?: Maybe<Scalars['Void']['output']>;
  removeOutfitter: Outfitter;
  removePackageFromQuote: Quote;
  removePricingPackage?: Maybe<Scalars['Void']['output']>;
  removeQuoteCoupon: Quote;
  removeReaction: Activity;
  removeWidget?: Maybe<Scalars['Void']['output']>;
  removeWishlist?: Maybe<Scalars['Void']['output']>;
  retryPayment: Payment;
  sendChatMessageToAi?: Maybe<Scalars['Void']['output']>;
  sendInvoice?: Maybe<Scalars['Void']['output']>;
  setDefaultPaymentMethod: Array<PaymentBlock>;
  setRemainingPaymentIsArchived: RemainingPayment;
  startImpersonation?: Maybe<Scalars['Void']['output']>;
  stopImpersonation?: Maybe<Scalars['Void']['output']>;
  submitReviewForm?: Maybe<Scalars['Void']['output']>;
  suspendOutfitter: Outfitter;
  updateAddOn: AddOn;
  updateAmenity: Amenity;
  updateAvailability?: Maybe<Scalars['Void']['output']>;
  updateBooking: Booking;
  updateBookingAttribution: Booking;
  updateBookingDatesGuestsAndAddons: Booking;
  updateBookingInvite: BookingInvite;
  updateCalendarEvent: CalendarEvent;
  updateCalendarSubscription: CalendarSubscription;
  updateFeedPost: Activity;
  updateGroupPayMember: GroupPayMember;
  updateLead: Lead;
  updateLicenseInfo: LicenseInfo;
  updateListing: Listing;
  updateListingLodgings: Listing;
  updateListingRates: Listing;
  updateListingsOrder: Array<Listing>;
  updateLodging: Lodging;
  updateNote: Note;
  updateNoteForListing: ListingNote;
  updateOnboarding: Onboarding;
  updateOutfitter: Outfitter;
  updateOutfitterDocument: OutfitterDocument;
  updateOutfitterFeatureAccessSettings?: Maybe<Scalars['Void']['output']>;
  updateOutfitterFees: Outfitter;
  updateOutfitterFeesAsOutfitterOwner: Outfitter;
  updateOutfitterSubscription?: Maybe<Scalars['Void']['output']>;
  updatePackageOnQuote: Quote;
  updatePayment: Payment;
  updatePaymentDueDate: Payment;
  updatePaymentMethodOnPayment: Payment;
  updatePricingPackage: PricingPackage;
  updatePricingPackagesOrder: Array<PricingPackage>;
  updateQuickBooksClassMapping: QuickBooksListingClassMapping;
  updateQuickBooksItemMapping: QuickBooksItemMapping;
  updateResource: Resource;
  updateSelfOnboardingStep: Outfitter;
  updateSpecies: Species;
  updateSyncedCalendar: SyncedCalendar;
  updateTeamMember: TeamMember;
  updateUser: User;
  updateWidget: Widget;
  updateWishlist: Wishlist;
  upsertOutfitterIntegrationSettings: OutfitterIntegrationSettings;
  upsertPaymentFeeSettings: PaymentFeeSettings;
  upsertPaymentSettings: PaymentSettings;
  verifyMicroDeposits: Scalars['Boolean']['output'];
};


export type MutationAcceptAvailabilityAiSuggestionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAcceptBookingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAcceptBookingReferralArgs = {
  referralId: Scalars['ID']['input'];
};


export type MutationAcceptPaymentRequestArgs = {
  data: AcceptPaymentRequestInput;
  id: Scalars['ID']['input'];
  isExternalPaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationAcceptTeamMemberInvitationArgs = {
  invitationId: Scalars['ID']['input'];
  teamMemberId: Scalars['ID']['input'];
};


export type MutationAddPackageToQuoteArgs = {
  data: AddPackageToQuoteInput;
  quoteId: Scalars['ID']['input'];
};


export type MutationApplyQuoteCouponArgs = {
  couponCode: Scalars['String']['input'];
  quoteId: Scalars['ID']['input'];
};


export type MutationArchiveBannerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveBookingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveBookingInviteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveCalendarSubscriptionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveOnboardingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveOutfitterDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveQuoteRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveSyncedCalendarArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelBookingArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<CancelBookingReasonInput>;
  refunds?: InputMaybe<Array<CancelBookingRefundInput>>;
};


export type MutationCancelBookingReferralArgs = {
  referralId: Scalars['ID']['input'];
};


export type MutationCancelPaymentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelPaymentRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelRefundArgs = {
  refundId: Scalars['ID']['input'];
};


export type MutationChangeUserPasswordArgs = {
  newPassword: Scalars['String']['input'];
};


export type MutationConfirmOfflinePaymentRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationConvertGuestToUserArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};


export type MutationCreateAddOnArgs = {
  data: CreateAddOnInput;
};


export type MutationCreateAdditionalBookingPaymentArgs = {
  bookingId: Scalars['ID']['input'];
  data: CreateAdditionalBookingPaymentInput;
};


export type MutationCreateAmenityArgs = {
  data: CreateAmenityInput;
};


export type MutationCreateBannerArgs = {
  data: CreateBannerInput;
};


export type MutationCreateBookingArgs = {
  data: CreateBookingInput;
};


export type MutationCreateBookingAsOutfitterArgs = {
  bookingInput: CreateBookingInput;
  isMallardBayProcessingPayment: Scalars['Boolean']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  shouldSendSportsmanConfirmationNotification?: InputMaybe<Scalars['Boolean']['input']>;
  sportsmanId?: InputMaybe<Scalars['ID']['input']>;
  userInput: CreateUserInput;
};


export type MutationCreateBookingInviteArgs = {
  data: CreateBookingInviteInput;
  isInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  referralId?: InputMaybe<Scalars['String']['input']>;
  userInput?: InputMaybe<EntityUserInput>;
};


export type MutationCreateBookingReferralsArgs = {
  data: CreateBookingReferralsInput;
};


export type MutationCreateBookingStartedEventArgs = {
  data: CreateBookingStartedEventInput;
};


export type MutationCreateBookingTripInsurancePolicyArgs = {
  data: TripInsurancePolicyInput;
};


export type MutationCreateCalendarSubscriptionArgs = {
  data: CreateCalendarSubscriptionInput;
  userId: Scalars['ID']['input'];
};


export type MutationCreateChatChannelWithOutfitterArgs = {
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  outfitterId: Scalars['ID']['input'];
};


export type MutationCreateChatChannelWithSportsmanArgs = {
  outfitterId?: InputMaybe<Scalars['ID']['input']>;
  sportsmanId: Scalars['ID']['input'];
};


export type MutationCreateCouponArgs = {
  data: CreateCouponInput;
};


export type MutationCreateGenericEventArgs = {
  data: CreateGenericEventInput;
};


export type MutationCreateGroupPayMemberSetupIntentArgs = {
  memberId: Scalars['ID']['input'];
};


export type MutationCreateGuestUserArgs = {
  data: CreateUserInput;
};


export type MutationCreateLeadArgs = {
  data: CreateLeadInput;
  outfitter_id: Scalars['String']['input'];
};


export type MutationCreateListingArgs = {
  data: CreateListingInput;
};


export type MutationCreateListingVisitedEventArgs = {
  data: CreateListingVisitedEventInput;
};


export type MutationCreateLodgingArgs = {
  data: CreateLodgingInput;
};


export type MutationCreateNewsfeedPostInteractedWithEventArgs = {
  data: CreateNewsfeedEventInput;
};


export type MutationCreateNewsfeedPostOpenedEventArgs = {
  data: CreateNewsfeedEventInput;
};


export type MutationCreateNoteArgs = {
  data: CreateNoteInput;
  entityId: Scalars['String']['input'];
  entityType: NotesEntityType;
};


export type MutationCreateNoteForListingArgs = {
  data: CreateListingNoteInput;
  listingId: Scalars['ID']['input'];
};


export type MutationCreateOnboardingArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type MutationCreateOnboardingForLegacyOutfitterArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type MutationCreateOutfitterArgs = {
  data: CreateOutfitterInput;
};


export type MutationCreateOutfitterDocumentArgs = {
  data: CreateOutfitterDocumentInput;
};


export type MutationCreateOutfitterFeedPostArgs = {
  data: CreateOutfitterPostInput;
  outfitterId: Scalars['ID']['input'];
};


export type MutationCreateOutfitterFromHubspotCompanyArgs = {
  companyId: Scalars['String']['input'];
};


export type MutationCreatePaymentIntentForQuickPayArgs = {
  paymentId: Scalars['ID']['input'];
};


export type MutationCreatePaymentRequestArgs = {
  booking: Scalars['ID']['input'];
  data: CreatePaymentRequestInput;
  isMallardBayProcessingPayment?: InputMaybe<Scalars['Boolean']['input']>;
  paymentData?: InputMaybe<ExternalPaymentInfoInput>;
};


export type MutationCreatePricingPackageArgs = {
  data: CreatePricingPackageInput;
  listing: Scalars['ID']['input'];
};


export type MutationCreateQuickPayPaymentArgs = {
  data: CreateQuickPayPaymentInput;
};


export type MutationCreateQuoteArgs = {
  data: CreateQuoteInput;
};


export type MutationCreateQuoteRequestArgs = {
  data: QuoteRequestInput;
};


export type MutationCreateRefundArgs = {
  data: CreateRefundInput;
};


export type MutationCreateResourceArgs = {
  data: CreateResourceInput;
};


export type MutationCreateSetupIntentArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateSetupIntentOnBehalfOfArgs = {
  data: CreateSetupIntentOnBehalfOfInput;
};


export type MutationCreateSpeciesArgs = {
  data: CreateSpeciesInput;
};


export type MutationCreateSyncedCalendarArgs = {
  data: SyncedCalendarInput;
};


export type MutationCreateTeamMemberArgs = {
  data: CreateTeamMemberInput;
  outfitterId: Scalars['ID']['input'];
};


export type MutationCreateUserArgs = {
  data: CreateUserInput;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateUserFromAuth0Args = {
  data: CreateUserInput;
};


export type MutationCreateWidgetArgs = {
  data: CreateWidgetInput;
};


export type MutationCreateWishlistArgs = {
  data: CreateWishlistInput;
};


export type MutationDeclineBookingArgs = {
  denialReasons?: InputMaybe<Array<DenialReasonInput>>;
  id: Scalars['ID']['input'];
};


export type MutationDeclineBookingReferralArgs = {
  reason: Scalars['String']['input'];
  referralId: Scalars['ID']['input'];
};


export type MutationDeleteLeadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteListingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLodgingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteNoteArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteNoteForListingArgs = {
  listingId: Scalars['ID']['input'];
  noteId: Scalars['ID']['input'];
};


export type MutationDeletePaymentFeeSettingsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePaymentMethodArgs = {
  groupPayMemberId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteResourceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSpeciesArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTeamMemberArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDisableQuotePaymentGroupArgs = {
  quoteId: Scalars['ID']['input'];
};


export type MutationDuplicateBookingInviteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDuplicateListingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEnableQuotePaymentGroupArgs = {
  hostSlots: Scalars['PositiveInt']['input'];
  quoteId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationInitiateQuickBooksConnectionArgs = {
  connectionData: QuickBooksConnectionInput;
};


export type MutationInitiateTransferToOutfiterForPaymentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationJoinGroupPayArgs = {
  input: JoinGroupPayInput;
};


export type MutationLogInAsGuestUserArgs = {
  data: GuestUserInput;
};


export type MutationMarkPaymentAsNotNeedingRefundArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkPaymentAsPaidOfflineArgs = {
  id: Scalars['ID']['input'];
  paymentData: ExternalPaymentInfoInput;
};


export type MutationMarkPaymentAsRefundedArgs = {
  id: Scalars['ID']['input'];
};


export type MutationProcessTerminalPaymentIntentArgs = {
  paymentIntentId: Scalars['String']['input'];
};


export type MutationReactToActivityArgs = {
  activityId: Scalars['String']['input'];
  reactionType: ReactionType;
};


export type MutationReassignOutfitterOwnerArgs = {
  outfitterId: Scalars['ID']['input'];
  ownerId: Scalars['ID']['input'];
};


export type MutationRemoveAddOnArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveCouponArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveListingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveOffsiteBookingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveOutfitterArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemovePackageFromQuoteArgs = {
  packageId: Scalars['ID']['input'];
  quoteId: Scalars['ID']['input'];
};


export type MutationRemovePricingPackageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveQuoteCouponArgs = {
  quoteId: Scalars['ID']['input'];
};


export type MutationRemoveReactionArgs = {
  reactionId: Scalars['String']['input'];
};


export type MutationRemoveWidgetArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveWishlistArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRetryPaymentArgs = {
  data: RetryPaymentInput;
  id: Scalars['ID']['input'];
};


export type MutationSendChatMessageToAiArgs = {
  aiAgent: AiAgent;
  message: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationSendInvoiceArgs = {
  entityId: Scalars['ID']['input'];
  entityType: EntityType;
};


export type MutationSetDefaultPaymentMethodArgs = {
  id: Scalars['String']['input'];
};


export type MutationSetRemainingPaymentIsArchivedArgs = {
  id: Scalars['ID']['input'];
  is_archived: Scalars['Boolean']['input'];
};


export type MutationStartImpersonationArgs = {
  actsAsUserId: Scalars['ID']['input'];
};


export type MutationSubmitReviewFormArgs = {
  data: SubmitReviewFormInput;
};


export type MutationSuspendOutfitterArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpdateAddOnArgs = {
  data: UpdateAddOnInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateAmenityArgs = {
  data: UpdateAmenityInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateAvailabilityArgs = {
  data: AvailabilityUpdateInput;
};


export type MutationUpdateBookingArgs = {
  data: UpdateBookingInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateBookingAttributionArgs = {
  data: AttributionInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateBookingDatesGuestsAndAddonsArgs = {
  data: UpdateBookingDatesGuestsAndAddonsInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateBookingInviteArgs = {
  data: UpdateBookingInviteInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateCalendarEventArgs = {
  data: UpdateCalendarEventInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateCalendarSubscriptionArgs = {
  data: UpdateCalendarSubscriptionInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateFeedPostArgs = {
  data: UpdatePostInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateGroupPayMemberArgs = {
  id: Scalars['ID']['input'];
  input: UpdateGroupPayMemberInput;
};


export type MutationUpdateLeadArgs = {
  data: UpdateLeadInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateLicenseInfoArgs = {
  data: UpdateLicenseInfoInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateListingArgs = {
  aiSuggestionId?: InputMaybe<Scalars['ID']['input']>;
  data: UpdateListingInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateListingLodgingsArgs = {
  listingId: Scalars['ID']['input'];
  lodgingIds: Array<Scalars['ID']['input']>;
};


export type MutationUpdateListingRatesArgs = {
  data: UpdateListingRatesInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateListingsOrderArgs = {
  orderedIds: Array<Scalars['ID']['input']>;
};


export type MutationUpdateLodgingArgs = {
  data: UpdateLodgingInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateNoteArgs = {
  data: UpdateNoteInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateNoteForListingArgs = {
  data: UpdateListingNoteInput;
  listingId: Scalars['ID']['input'];
  noteId: Scalars['ID']['input'];
};


export type MutationUpdateOnboardingArgs = {
  data: UpdateOnboardingInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateOutfitterArgs = {
  aiSuggestionId?: InputMaybe<Scalars['ID']['input']>;
  data: UpdateOutfitterInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateOutfitterDocumentArgs = {
  data: UpdateOutfitterDocumentInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateOutfitterFeatureAccessSettingsArgs = {
  features: Array<FeatureAccessInput>;
  outfitterId: Scalars['ID']['input'];
};


export type MutationUpdateOutfitterFeesArgs = {
  data: UpdateOutfitterFeesInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateOutfitterFeesAsOutfitterOwnerArgs = {
  data: UpdateOutfitterFeesAsOutfitterOwnerInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateOutfitterSubscriptionArgs = {
  data: UpdateOutfitterSubscriptionInput;
};


export type MutationUpdatePackageOnQuoteArgs = {
  data: UpdatePackageOnQuoteInput;
  packageId: Scalars['ID']['input'];
  quoteId: Scalars['ID']['input'];
};


export type MutationUpdatePaymentArgs = {
  data: UpdatePaymentInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdatePaymentDueDateArgs = {
  date: Scalars['Timestamp']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUpdatePaymentMethodOnPaymentArgs = {
  id: Scalars['ID']['input'];
  paymentMethodId: Scalars['String']['input'];
};


export type MutationUpdatePricingPackageArgs = {
  data: UpdatePricingPackageInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdatePricingPackagesOrderArgs = {
  orderedIds: Array<Scalars['ID']['input']>;
};


export type MutationUpdateQuickBooksClassMappingArgs = {
  data: QuickBooksClassMappingInput;
  outfitterId: Scalars['ID']['input'];
};


export type MutationUpdateQuickBooksItemMappingArgs = {
  data: QuickBooksItemMappingInput;
  outfitterId: Scalars['ID']['input'];
};


export type MutationUpdateResourceArgs = {
  data: UpdateResourceInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateSelfOnboardingStepArgs = {
  id: Scalars['ID']['input'];
  step: SelfOnboardingStepType;
};


export type MutationUpdateSpeciesArgs = {
  data: UpdateSpeciesInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateSyncedCalendarArgs = {
  data: SyncedCalendarUpdateInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateTeamMemberArgs = {
  data: UpdateTeamMemberInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUserArgs = {
  data: UpdateUserInput;
};


export type MutationUpdateWidgetArgs = {
  data: UpdateWidgetInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateWishlistArgs = {
  data: UpdateWishlistInput;
  id: Scalars['ID']['input'];
};


export type MutationUpsertOutfitterIntegrationSettingsArgs = {
  data: UpsertOutfitterIntegrationSettingsInput;
  outfitterId: Scalars['ID']['input'];
};


export type MutationUpsertPaymentFeeSettingsArgs = {
  data: UpsertPaymentFeeSettingsInput;
};


export type MutationUpsertPaymentSettingsArgs = {
  data: UpsertPaymentSettingsInput;
};


export type MutationVerifyMicroDepositsArgs = {
  amount1?: InputMaybe<Scalars['Float']['input']>;
  amount2?: InputMaybe<Scalars['Float']['input']>;
  descriptorCode?: InputMaybe<Scalars['String']['input']>;
  paymentId?: InputMaybe<Scalars['ID']['input']>;
  setupIntentId?: InputMaybe<Scalars['String']['input']>;
};

export type MyBookingReferralsByBookingIdResponse = {
  __typename?: 'MyBookingReferralsByBookingIdResponse';
  receivedBookingReferrals: Array<BookingReferral>;
  sentBookingReferrals: Array<BookingReferral>;
};

export type NewsfeedEvent = BaseEvent & {
  __typename?: 'NewsfeedEvent';
  created_at: Scalars['Timestamp']['output'];
  event_type: EventType;
  id: Scalars['ID']['output'];
  metadata: NewsfeedEventMetadata;
  updated_at: Scalars['Timestamp']['output'];
  user_id?: Maybe<Scalars['ID']['output']>;
};

export type NewsfeedEventMetadata = {
  __typename?: 'NewsfeedEventMetadata';
  activity_id: Scalars['String']['output'];
  entity_id: Scalars['ID']['output'];
  entity_type: EntityType;
};

export type Note = {
  __typename?: 'Note';
  content: Scalars['String']['output'];
  created_at: Scalars['Timestamp']['output'];
  entity_id: Scalars['String']['output'];
  entity_type: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  updated_at: Scalars['Timestamp']['output'];
  user?: Maybe<PublicUser>;
};

export enum NotesEntityType {
  ClientDetails = 'CLIENT_DETAILS',
  Lead = 'LEAD'
}

export enum NotificationType {
  BookingCanceled = 'booking_canceled',
  BookingConfirmedSportsman = 'booking_confirmed_sportsman',
  BookingInviteInvoice = 'booking_invite_invoice',
  BookingReceipt = 'booking_receipt',
  BookingRequestedSportsman = 'booking_requested_sportsman',
  BookingStartsSoonWithFailedPayments = 'booking_starts_soon_with_failed_payments',
  BookingUpdated = 'booking_updated',
  FailedPaymentOutfitter = 'failed_payment_outfitter',
  FailedPaymentSportsman = 'failed_payment_sportsman',
  LeadCreated = 'lead_created',
  OnboardingPaymentLink = 'onboarding_payment_link',
  OnboardingSignUpInvite = 'onboarding_sign_up_invite',
  PaymentMethodsWaitingForVerification = 'payment_methods_waiting_for_verification',
  PaymentRequestCreated = 'payment_request_created',
  PaymentRequestReceipt = 'payment_request_receipt',
  PaymentRequestReminder = 'payment_request_reminder',
  PaymentRequestUrgentReminder = 'payment_request_urgent_reminder',
  PurchaseBookingInsurance = 'purchase_booking_insurance',
  PurchaseGroupPayShareInsurance = 'purchase_group_pay_share_insurance',
  QuoteRequestCreated = 'quote_request_created',
  ReferralAccepted = 'referral_accepted',
  ReferralCreated = 'referral_created',
  ReferralDeclined = 'referral_declined',
  ReferralNoLongerAvailable = 'referral_no_longer_available',
  RefundCreated = 'refund_created'
}

export type Onboarding = {
  __typename?: 'Onboarding';
  add_ons: Array<Scalars['String']['output']>;
  created_at: Scalars['Timestamp']['output'];
  email?: Maybe<Scalars['String']['output']>;
  errors: Array<PaymentError>;
  hubspot_company_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_archived: Scalars['Boolean']['output'];
  is_currently_free_tier?: Maybe<Scalars['Boolean']['output']>;
  is_draft: Scalars['Boolean']['output'];
  is_legacy?: Maybe<Scalars['Boolean']['output']>;
  is_self_initiated?: Maybe<Scalars['Boolean']['output']>;
  outfitter?: Maybe<Outfitter>;
  payment_link_id?: Maybe<Scalars['String']['output']>;
  payment_link_url?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  promo_codes: Array<Scalars['String']['output']>;
  status: OnboardingStatus;
  subscription_tier_name?: Maybe<Scalars['String']['output']>;
  subscriptions: Array<Scalars['String']['output']>;
  team_member?: Maybe<TeamMember>;
  updated_at: Scalars['Timestamp']['output'];
};

export type OnboardingFilters = {
  status?: InputMaybe<OnboardingStatus>;
};

export type OnboardingPaymentSummaryInput = {
  add_ons: Array<Scalars['String']['input']>;
  products: Array<Scalars['String']['input']>;
  promo_codes: Array<Scalars['String']['input']>;
};

export type OnboardingQueryResults = {
  __typename?: 'OnboardingQueryResults';
  results: Array<Onboarding>;
  total: Scalars['NonNegativeInt']['output'];
};

export enum OnboardingStatus {
  Initiated = 'INITIATED',
  ReadyForOutfitterPayment = 'READY_FOR_OUTFITTER_PAYMENT',
  Subscribed = 'SUBSCRIBED'
}

export type OnboardingStatusInfo = {
  __typename?: 'OnboardingStatusInfo';
  email?: Maybe<Scalars['String']['output']>;
  has_account: Scalars['Boolean']['output'];
  status: OnboardingStatus;
};

export type OnboardingSubscriptionOptions = {
  __typename?: 'OnboardingSubscriptionOptions';
  add_ons: Array<IdAndName>;
  products: Array<IdAndName>;
  promo_codes: Array<IdAndName>;
};

/** A type that describes an outfitter */
export type Outfitter = {
  __typename?: 'Outfitter';
  about: Scalars['String']['output'];
  admin_note?: Maybe<Scalars['String']['output']>;
  ads_score?: Maybe<Scalars['PositiveInt']['output']>;
  /** @deprecated Use Payment Settings instead */
  allow_deposit?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use Payment Settings instead */
  amount_deposit?: Maybe<Scalars['Float']['output']>;
  avatar?: Maybe<Media>;
  booking_fee_fixed: Scalars['Float']['output'];
  booking_fee_rate: Scalars['Float']['output'];
  booking_reviews_aggregation?: Maybe<ReviewAggregation>;
  cancellation_policy: OutfitterCancellationPolicy;
  check_in_config?: Maybe<CheckInConfig>;
  contacts?: Maybe<Array<OutfitterContact>>;
  coupons?: Maybe<Array<Coupon>>;
  cover_image?: Maybe<Scalars['URL']['output']>;
  created_at: Scalars['Timestamp']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  current_self_onboard_step?: Maybe<SelfOnboardingStepType>;
  /** @deprecated Use Payment Settings instead */
  date_before_trip_balance_due?: Maybe<Scalars['Timestamp']['output']>;
  /** @deprecated Use Payment Settings instead */
  days_before_trip_balance_due: Scalars['PositiveInt']['output'];
  default_check_in_minutes?: Maybe<Scalars['NonNegativeInt']['output']>;
  default_check_out_minutes?: Maybe<Scalars['NonNegativeInt']['output']>;
  enabled_integrations: EnabledOutfitterIntegrations;
  feature_access: FeatureAccess;
  feature_set_id?: Maybe<Scalars['String']['output']>;
  featured: Scalars['Boolean']['output'];
  gmb_id?: Maybe<Scalars['String']['output']>;
  guides: Array<TeamMember>;
  hubspot_company_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_ach_enabled?: Maybe<Scalars['Boolean']['output']>;
  is_archived: Scalars['Boolean']['output'];
  is_demo?: Maybe<Scalars['Boolean']['output']>;
  is_free_tier_subscription: Scalars['Boolean']['output'];
  is_guide_tech?: Maybe<Scalars['Boolean']['output']>;
  is_hidden_from_marketplace?: Maybe<Scalars['Boolean']['output']>;
  is_legacy_subscription: Scalars['Boolean']['output'];
  is_processing_fee_payed_by_sportsman?: Maybe<Scalars['Boolean']['output']>;
  is_self_onboarded?: Maybe<Scalars['Boolean']['output']>;
  is_stripe_terminal_enabled?: Maybe<Scalars['Boolean']['output']>;
  land_size?: Maybe<Scalars['PositiveInt']['output']>;
  licensed: Scalars['Boolean']['output'];
  listings: Array<Listing>;
  listings_count: Scalars['NonNegativeInt']['output'];
  location?: Maybe<Address>;
  lodging_instructions?: Maybe<Scalars['String']['output']>;
  lodging_rules?: Maybe<Scalars['String']['output']>;
  lodgings: Array<Lodging>;
  max_booking_fee: Scalars['Float']['output'];
  my_roles: Array<TeamMember>;
  name: Scalars['String']['output'];
  other_info?: Maybe<OutfitterOtherInfo>;
  /** @deprecated Use Payment Fee Settings instead. */
  outfitter_fee_fixed: Scalars['Float']['output'];
  /** @deprecated Use Payment Fee Settings instead. */
  outfitter_fee_rate: Scalars['Float']['output'];
  owner: User;
  payment_fee_settings?: Maybe<PaymentFeeSettings>;
  /** @deprecated Use Payment Settings instead */
  percent_deposit?: Maybe<Scalars['Float']['output']>;
  photos: Array<Media>;
  primary_contact_email?: Maybe<Scalars['EmailAddress']['output']>;
  processing_fee_ach_fixed: Scalars['Float']['output'];
  processing_fee_ach_max: Scalars['NonNegativeInt']['output'];
  processing_fee_ach_rate: Scalars['Float']['output'];
  processing_fee_fixed: Scalars['Float']['output'];
  processing_fee_rate: Scalars['Float']['output'];
  ranking_score?: Maybe<Scalars['NonNegativeInt']['output']>;
  referral_fee_fixed: Scalars['NonNegativeInt']['output'];
  referral_fee_rate: Scalars['NonNegativeInt']['output'];
  resources: Array<Resource>;
  slug: Scalars['String']['output'];
  species: Array<Species>;
  /** @deprecated Use Payment Settings instead */
  statement_descriptor?: Maybe<Scalars['String']['output']>;
  status: OutfitterStatus;
  stripe_location_id?: Maybe<Scalars['String']['output']>;
  stripe_subscription_id?: Maybe<Scalars['String']['output']>;
  subscription_tier_name?: Maybe<Scalars['String']['output']>;
  tax_rate: Scalars['Float']['output'];
  time_zone?: Maybe<Scalars['TimeZone']['output']>;
  updated_at: Scalars['Timestamp']['output'];
  verified: Scalars['Boolean']['output'];
  video?: Maybe<Video>;
  website?: Maybe<Scalars['String']['output']>;
  years_in_operation: Scalars['PositiveInt']['output'];
};

export type OutfitterCancellationPolicy = {
  __typename?: 'OutfitterCancellationPolicy';
  description: Scalars['String']['output'];
  policy_id: Scalars['String']['output'];
};

export type OutfitterCancellationPolicyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  policy_id: Scalars['String']['input'];
};

export type OutfitterClient = {
  __typename?: 'OutfitterClient';
  date_added?: Maybe<Scalars['Timestamp']['output']>;
  gross_revenue?: Maybe<Scalars['NonNegativeInt']['output']>;
  id: Scalars['ID']['output'];
  last_booking_date?: Maybe<Scalars['Timestamp']['output']>;
  notes: Array<Note>;
  number_of_prior_bookings?: Maybe<Scalars['NonNegativeInt']['output']>;
  outfitter_id: Scalars['ID']['output'];
  user: OutfitterClientUser;
};

export type OutfitterClientUser = {
  __typename?: 'OutfitterClientUser';
  avatar_url?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['EmailAddress']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['PhoneNumber']['output']>;
};

export type OutfitterContact = {
  __typename?: 'OutfitterContact';
  email?: Maybe<Scalars['EmailAddress']['output']>;
  facebook?: Maybe<Scalars['String']['output']>;
  instagram?: Maybe<Scalars['String']['output']>;
  is_primary_contact?: Maybe<Scalars['Boolean']['output']>;
  linkedin?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['PhoneNumber']['output']>;
  snapchat?: Maybe<Scalars['String']['output']>;
  tiktok?: Maybe<Scalars['String']['output']>;
  title: OutfitterContactTitle;
  twitter?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  youtube?: Maybe<Scalars['String']['output']>;
};

export type OutfitterContactInput = {
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  is_primary_contact?: InputMaybe<Scalars['Boolean']['input']>;
  linkedin?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
  snapchat?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  title: OutfitterContactTitle;
  twitter?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export enum OutfitterContactTitle {
  Guide = 'Guide',
  Manager = 'Manager',
  Marketing = 'Marketing',
  Other = 'Other',
  Owner = 'Owner',
  Sales = 'Sales',
  Secretary = 'Secretary'
}

export type OutfitterDocument = {
  __typename?: 'OutfitterDocument';
  created_at: Scalars['Timestamp']['output'];
  document?: Maybe<Media>;
  external_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  listing_ids?: Maybe<Array<Scalars['String']['output']>>;
  listings?: Maybe<Array<Listing>>;
  name: Scalars['String']['output'];
  outfitter_id: Scalars['String']['output'];
  pricing_package_ids?: Maybe<Array<Scalars['String']['output']>>;
  pricing_packages?: Maybe<Array<PricingPackage>>;
  type: OutfitterDocumentType;
  updated_at: Scalars['Timestamp']['output'];
};

export enum OutfitterDocumentEntityType {
  Listing = 'Listing',
  PricingPackage = 'PricingPackage'
}

export enum OutfitterDocumentType {
  LiabilityWaiver = 'LiabilityWaiver',
  WhatToExpect = 'WhatToExpect'
}

export type OutfitterFeatureAccessInfo = {
  __typename?: 'OutfitterFeatureAccessInfo';
  available_features: Array<FeatureKey>;
  current_features: Array<FeatureAccessSetting>;
};

export type OutfitterIntegrationSettings = {
  __typename?: 'OutfitterIntegrationSettings';
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  quick_books?: Maybe<QuickBooksIntegrationSettings>;
  updated_at: Scalars['Timestamp']['output'];
};

export type OutfitterOtherInfo = {
  __typename?: 'OutfitterOtherInfo';
  domain?: Maybe<Scalars['String']['output']>;
  has_website?: Maybe<Scalars['Boolean']['output']>;
  listings_type?: Maybe<ListingType>;
  nearest_airport?: Maybe<Scalars['String']['output']>;
  offers_corporate_trips?: Maybe<Scalars['Boolean']['output']>;
  required_licenses?: Maybe<Array<Scalars['String']['output']>>;
  what_to_bring?: Maybe<Scalars['String']['output']>;
};

export type OutfitterOtherInfoInput = {
  domain?: InputMaybe<Scalars['String']['input']>;
  has_website?: InputMaybe<Scalars['Boolean']['input']>;
  listings_type?: InputMaybe<ListingType>;
  nearest_airport?: InputMaybe<Scalars['String']['input']>;
  offers_corporate_trips?: InputMaybe<Scalars['Boolean']['input']>;
  required_licenses?: InputMaybe<Array<Scalars['String']['input']>>;
  what_to_bring?: InputMaybe<Scalars['String']['input']>;
};

export type OutfitterSearchResults = {
  __typename?: 'OutfitterSearchResults';
  pages: Scalars['NonNegativeInt']['output'];
  results: Array<Outfitter>;
  total: Scalars['NonNegativeInt']['output'];
};

export type OutfitterSlugResult = {
  __typename?: 'OutfitterSlugResult';
  slug: Scalars['String']['output'];
  valid: Scalars['Boolean']['output'];
};

export enum OutfitterStatus {
  Approved = 'APPROVED',
  PendingApproval = 'PENDING_APPROVAL',
  Suspended = 'SUSPENDED'
}

export type OutfitterSubscriptionInfo = {
  __typename?: 'OutfitterSubscriptionInfo';
  add_ons: Array<Scalars['String']['output']>;
  current_period_end: Scalars['String']['output'];
  current_period_start: Scalars['String']['output'];
  outfitter_name: Scalars['String']['output'];
  products: Array<Scalars['String']['output']>;
  promo_codes: Array<Scalars['String']['output']>;
  subscription_start: Scalars['String']['output'];
  subscription_tier_name: Scalars['String']['output'];
};

export type OwnReactions = {
  __typename?: 'OwnReactions';
  like?: Maybe<Array<Reaction>>;
};

export type PackageInput = {
  add_ons: Array<QuoteAddOnInput>;
  id: Scalars['ID']['input'];
  line_item_key?: InputMaybe<Scalars['ID']['input']>;
  number_of_guests: Scalars['PositiveInt']['input'];
  pricing_package: Scalars['ID']['input'];
};

export type PageSubsection = {
  __typename?: 'PageSubsection';
  items: Array<PageSubsectionItem>;
  label: Scalars['String']['output'];
  sub_label?: Maybe<Scalars['String']['output']>;
};

export type PageSubsectionItem = {
  __typename?: 'PageSubsectionItem';
  cta_url?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  sub_label?: Maybe<Scalars['String']['output']>;
};

export type PaginatedBookingReferrals = {
  __typename?: 'PaginatedBookingReferrals';
  count: Scalars['Int']['output'];
  data: Array<BookingReferral>;
  pages: Scalars['Int']['output'];
};

export type PaginatedLeadList = {
  __typename?: 'PaginatedLeadList';
  count: Scalars['Int']['output'];
  data: Array<Lead>;
  pages: Scalars['Int']['output'];
};

export type PaginatedOutfitterClientList = {
  __typename?: 'PaginatedOutfitterClientList';
  count: Scalars['Int']['output'];
  data: Array<OutfitterClient>;
  pages: Scalars['Int']['output'];
};

export type Paging = {
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
};

export type Payment = {
  __typename?: 'Payment';
  booking?: Maybe<Booking>;
  booking_fee: Scalars['Float']['output'];
  created_at: Scalars['Timestamp']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<PaymentCustomer>;
  date: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  errors: Array<PaymentError>;
  external_payment_reference_id?: Maybe<Scalars['String']['output']>;
  external_payment_type?: Maybe<ExternalPaymentType>;
  group_pay_member?: Maybe<GroupPayMember>;
  id: Scalars['ID']['output'];
  intent_id?: Maybe<Scalars['String']['output']>;
  invoice_hosted_url?: Maybe<Scalars['String']['output']>;
  invoice_id?: Maybe<Scalars['String']['output']>;
  is_ach?: Maybe<Scalars['Boolean']['output']>;
  is_offline?: Maybe<Scalars['Boolean']['output']>;
  is_payment_method_unverified?: Maybe<Scalars['Boolean']['output']>;
  is_quick_pay?: Maybe<Scalars['Boolean']['output']>;
  is_refund_needed?: Maybe<Scalars['Boolean']['output']>;
  mb_amount: Scalars['Float']['output'];
  note?: Maybe<Scalars['String']['output']>;
  outfitter: Outfitter;
  outfitter_amount: Scalars['Float']['output'];
  outfitter_fee: Scalars['Float']['output'];
  payment_method_id?: Maybe<Scalars['String']['output']>;
  payment_processor_type?: Maybe<PaymentProcessorType>;
  payment_request?: Maybe<PaymentRequest>;
  payment_url?: Maybe<Scalars['URL']['output']>;
  processing_fee: Scalars['Float']['output'];
  receipt_hosted_url?: Maybe<Scalars['String']['output']>;
  referral_fee?: Maybe<Scalars['NonNegativeInt']['output']>;
  refund_needed_note?: Maybe<Scalars['String']['output']>;
  refunds: Array<Refund>;
  retries?: Maybe<Array<PaymentRetry>>;
  sales_tax: Scalars['Float']['output'];
  service_fee: Scalars['Float']['output'];
  should_charge_last_day_of_trip?: Maybe<Scalars['Boolean']['output']>;
  status: PaymentStatus;
  stripe_user_id?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  transfer_by?: Maybe<User>;
  transfer_date?: Maybe<Scalars['Timestamp']['output']>;
  transfer_id?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Timestamp']['output'];
  user?: Maybe<User>;
  value: Scalars['Float']['output'];
  was_refunded?: Maybe<Scalars['Boolean']['output']>;
};

export type PaymentBlock = {
  __typename?: 'PaymentBlock';
  brand?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_default?: Maybe<Scalars['Boolean']['output']>;
  is_pending?: Maybe<Scalars['Boolean']['output']>;
  payment_gateway: PaymentGateway;
  setup_intent_id?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  subtitle2?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type?: Maybe<PaymentBlockType>;
};

export enum PaymentBlockType {
  BankAccount = 'BANK_ACCOUNT',
  Card = 'CARD'
}

export type PaymentCustomer = {
  __typename?: 'PaymentCustomer';
  email?: Maybe<Scalars['EmailAddress']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['PhoneNumber']['output']>;
};

export type PaymentCustomerInput = {
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
};

export type PaymentError = {
  __typename?: 'PaymentError';
  code?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  message: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type PaymentErrorInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentFeeSettings = {
  __typename?: 'PaymentFeeSettings';
  created_at: Scalars['Timestamp']['output'];
  dashboard_rate: Scalars['NonNegativeFloat']['output'];
  entity_id: Scalars['ID']['output'];
  entity_type: PaymentFeeSettingsEntityType;
  id: Scalars['ID']['output'];
  is_overriding: Scalars['Boolean']['output'];
  marketplace_quote_rate: Scalars['NonNegativeFloat']['output'];
  standard_quote_rate: Scalars['NonNegativeFloat']['output'];
  updated_at: Scalars['Timestamp']['output'];
  website_rate: Scalars['NonNegativeFloat']['output'];
  widget_rate: Scalars['NonNegativeFloat']['output'];
};

export enum PaymentFeeSettingsEntityType {
  Listing = 'LISTING',
  Outfitter = 'OUTFITTER',
  SubscriptionTier = 'SUBSCRIPTION_TIER'
}

export enum PaymentGateway {
  Stripe = 'STRIPE'
}

export type PaymentItemRequest = {
  __typename?: 'PaymentItemRequest';
  add_on_id?: Maybe<Scalars['ID']['output']>;
  amount: Scalars['Float']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  remaining_payment_id?: Maybe<Scalars['ID']['output']>;
};

export type PaymentItemRequestInput = {
  amount: Scalars['Float']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  remaining_payment_id?: InputMaybe<Scalars['ID']['input']>;
};

export enum PaymentPlanType {
  PayInFull = 'PAY_IN_FULL',
  PayInTwo = 'PAY_IN_TWO'
}

export enum PaymentProcessorType {
  Stripe = 'STRIPE'
}

export type PaymentRequest = {
  __typename?: 'PaymentRequest';
  add_ons?: Maybe<Array<PaymentRequestAddOn>>;
  booking: Booking;
  created_at: Scalars['Timestamp']['output'];
  created_by: User;
  currency?: Maybe<Scalars['String']['output']>;
  errors: Array<PaymentError>;
  id: Scalars['ID']['output'];
  intent_id?: Maybe<Scalars['String']['output']>;
  invoice_hosted_url?: Maybe<Scalars['String']['output']>;
  invoice_id?: Maybe<Scalars['String']['output']>;
  items: Array<PaymentItemRequest>;
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  outfitter: Outfitter;
  paid_offline?: Maybe<Scalars['Boolean']['output']>;
  payment_method_id?: Maybe<Scalars['String']['output']>;
  payments: Array<Payment>;
  processing_fee?: Maybe<Scalars['NonNegativeInt']['output']>;
  receipt_hosted_url?: Maybe<Scalars['String']['output']>;
  sales_tax?: Maybe<Scalars['NonNegativeInt']['output']>;
  should_allow_external_payment?: Maybe<Scalars['Boolean']['output']>;
  should_include_taxes?: Maybe<Scalars['Boolean']['output']>;
  sportsman: User;
  status: PaymentRequestStatus;
  subtotal?: Maybe<Scalars['NonNegativeInt']['output']>;
  timing?: Maybe<PaymentRequestTiming>;
  type?: Maybe<PaymentRequestType>;
  updated_at: Scalars['Timestamp']['output'];
  value: Scalars['Float']['output'];
  was_acknowledged_by_sportsman?: Maybe<Scalars['Boolean']['output']>;
};

export type PaymentRequestAddOn = {
  __typename?: 'PaymentRequestAddOn';
  id: Scalars['ID']['output'];
  number_of_days?: Maybe<Scalars['PositiveInt']['output']>;
  number_of_guests?: Maybe<Scalars['PositiveInt']['output']>;
  quantity: Scalars['PositiveInt']['output'];
  total: Scalars['Int']['output'];
};

export type PaymentRequestAddOnInput = {
  id: Scalars['ID']['input'];
  number_of_days?: InputMaybe<Scalars['PositiveInt']['input']>;
  number_of_guests?: InputMaybe<Scalars['PositiveInt']['input']>;
  quantity: Scalars['PositiveInt']['input'];
};

export enum PaymentRequestStatus {
  Accepted = 'ACCEPTED',
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Requested = 'REQUESTED',
  Success = 'SUCCESS'
}

export enum PaymentRequestTiming {
  DuringTrip = 'DURING_TRIP',
  PostTrip = 'POST_TRIP',
  PreTrip = 'PRE_TRIP'
}

export enum PaymentRequestType {
  Card = 'CARD',
  Cash = 'CASH',
  Check = 'CHECK',
  EmailInvoice = 'EMAIL_INVOICE',
  Other = 'OTHER',
  QrCode = 'QR_CODE',
  StripeTerminal = 'STRIPE_TERMINAL'
}

export type PaymentResults = {
  __typename?: 'PaymentResults';
  count: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  payments: Array<Payment>;
};

export type PaymentRetry = {
  __typename?: 'PaymentRetry';
  by?: Maybe<User>;
  date: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
};

export type PaymentSettings = {
  __typename?: 'PaymentSettings';
  allow_deposit: Scalars['Boolean']['output'];
  amount_deposit?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['Timestamp']['output'];
  /** @deprecated Use day_balance_due_config instead */
  date_before_trip_balance_due?: Maybe<Scalars['Timestamp']['output']>;
  day_balance_due_config?: Maybe<DayBalanceDueConfig>;
  days_before_trip_balance_due?: Maybe<Scalars['Int']['output']>;
  days_out_for_deposit_plan?: Maybe<Scalars['Int']['output']>;
  entity_id: Scalars['ID']['output'];
  entity_type: PaymentSettingsEntityType;
  id: Scalars['ID']['output'];
  is_deposit_per_day?: Maybe<Scalars['Boolean']['output']>;
  is_deposit_per_guest?: Maybe<Scalars['Boolean']['output']>;
  percent_deposit?: Maybe<Scalars['Int']['output']>;
  should_charge_last_day_of_trip?: Maybe<Scalars['Boolean']['output']>;
  statement_descriptor?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Timestamp']['output'];
};

export enum PaymentSettingsEntityType {
  Listing = 'LISTING',
  Outfitter = 'OUTFITTER'
}

export enum PaymentStatus {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  FailedTransfer = 'FAILED_TRANSFER',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Replaced = 'REPLACED',
  Success = 'SUCCESS'
}

export type PaymentSummary = {
  __typename?: 'PaymentSummary';
  line_items: Array<LineItem>;
  prices: Array<QuotePrice>;
  /** @deprecated Use totals instead. */
  total: Scalars['Int']['output'];
  totals: Array<QuotePrice>;
};

export type PaymentSummaryInput = {
  attribution?: InputMaybe<AttributionInput>;
  coupon?: InputMaybe<Scalars['ID']['input']>;
  dates: Array<Scalars['Timestamp']['input']>;
  packages: Array<PackageInput>;
};

export type Payout = {
  __typename?: 'Payout';
  amount: Scalars['Int']['output'];
  arrival_date: Scalars['Timestamp']['output'];
  automatic: Scalars['Boolean']['output'];
  created_at: Scalars['Timestamp']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  destination?: Maybe<PayoutDestination>;
  destination_display_name?: Maybe<Scalars['String']['output']>;
  failure_code?: Maybe<Scalars['String']['output']>;
  failure_message?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  method: Scalars['String']['output'];
  processor_type: PaymentProcessorType;
  statement_descriptor?: Maybe<Scalars['String']['output']>;
  status: PayoutStatus;
  status_display_name: Scalars['String']['output'];
  timeline: Array<PayoutTimeline>;
};

export type PayoutDestination = {
  __typename?: 'PayoutDestination';
  bank_name?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  last4: Scalars['String']['output'];
};

export enum PayoutStatus {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  InTransit = 'IN_TRANSIT',
  Paid = 'PAID',
  Pending = 'PENDING',
  Unknown = 'UNKNOWN',
  Withdrawn = 'WITHDRAWN'
}

export type PayoutTimeline = {
  __typename?: 'PayoutTimeline';
  description: Scalars['String']['output'];
  is_active: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type PayoutTransaction = {
  __typename?: 'PayoutTransaction';
  id: Scalars['ID']['output'];
  payment?: Maybe<Payment>;
  payment_intent_id?: Maybe<Scalars['String']['output']>;
  transaction_amount: Scalars['Int']['output'];
  transaction_date: Scalars['Timestamp']['output'];
  transaction_fee: Scalars['Int']['output'];
  transaction_net: Scalars['Int']['output'];
  transaction_type: Scalars['String']['output'];
};

export type PayoutsList = {
  __typename?: 'PayoutsList';
  info: CursorPaginationInfo;
  payouts: Array<Payout>;
};

export type PreCheckoutData = {
  __typename?: 'PreCheckoutData';
  is_ach_available: Scalars['Boolean']['output'];
};

export enum PriceByDay {
  PerDay = 'PER_DAY',
  SetDay = 'SET_DAY'
}

export enum PriceByGuest {
  PerGuest = 'PER_GUEST',
  SetGuest = 'SET_GUEST'
}

export type PriceSubsection = {
  __typename?: 'PriceSubsection';
  category?: Maybe<QuotePriceCategory>;
  currency?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type Pricing = {
  __typename?: 'Pricing';
  options: Array<PricingOption>;
  type: PricingType;
};

export type PricingInput = {
  options: Array<PricingOptionInput>;
  type: PricingType;
};

export type PricingOption = {
  __typename?: 'PricingOption';
  currency?: Maybe<Scalars['String']['output']>;
  day_rate: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  max: Scalars['PositiveInt']['output'];
  min: Scalars['NonNegativeInt']['output'];
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
};

export type PricingOptionInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  day_rate: Scalars['Float']['input'];
  id: Scalars['ID']['input'];
  max: Scalars['PositiveInt']['input'];
  min: Scalars['NonNegativeInt']['input'];
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type PricingPackage = {
  __typename?: 'PricingPackage';
  check_in_config?: Maybe<CheckInConfig>;
  days_included: Scalars['NonNegativeInt']['output'];
  gear_rentals: Array<AddOn>;
  guests_included: Scalars['NonNegativeInt']['output'];
  id: Scalars['ID']['output'];
  included_add_ons: Array<AddOn>;
  included_lodging_id?: Maybe<Scalars['ID']['output']>;
  included_resource_ids?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  is_active: Scalars['Boolean']['output'];
  is_archived: Scalars['Boolean']['output'];
  is_available?: Maybe<Scalars['Boolean']['output']>;
  is_hidden_from_outfitters?: Maybe<Scalars['Boolean']['output']>;
  is_hidden_from_sportsmen?: Maybe<Scalars['Boolean']['output']>;
  is_lodging_only?: Maybe<Scalars['Boolean']['output']>;
  liability_waivers?: Maybe<Array<OutfitterDocument>>;
  listing: Listing;
  lodging_included: Scalars['Boolean']['output'];
  max_guests?: Maybe<Scalars['PositiveInt']['output']>;
  meal_upgrades: Array<AddOn>;
  min_guests?: Maybe<Scalars['PositiveInt']['output']>;
  name: Scalars['String']['output'];
  not_available_reason?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['PositiveInt']['output']>;
  other_add_ons: Array<AddOn>;
  owner: User;
  price: Scalars['Float']['output'];
  price_by_day: PriceByDay;
  price_by_guest: PriceByGuest;
  trophies: Array<AddOn>;
  what_to_expect_documents?: Maybe<Array<OutfitterDocument>>;
};

export enum PricingType {
  PerGuest = 'PER_GUEST'
}

export type PublicBooking = {
  __typename?: 'PublicBooking';
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  listing: PublicListing;
  listing_id: Scalars['ID']['output'];
};

export type PublicListing = {
  __typename?: 'PublicListing';
  amenities: Array<Amenity>;
  booking_reviews_aggregation?: Maybe<ReviewAggregation>;
  cover_image?: Maybe<Scalars['URL']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_unavailable?: Maybe<Scalars['Boolean']['output']>;
  liability_waivers?: Maybe<Array<OutfitterDocument>>;
  license_info?: Maybe<LicenseInfo>;
  license_required?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Address>;
  lodgings: Array<PublicLodging>;
  lowest_pricing_package?: Maybe<PublicPricingPackage>;
  max_guest?: Maybe<Scalars['PositiveInt']['output']>;
  min_guest?: Maybe<Scalars['PositiveInt']['output']>;
  next_availability?: Maybe<GenericAvailabilityEntry>;
  outfitter: PublicOutfitter;
  photos: Array<Media>;
  /** @deprecated No longer supported */
  pricing?: Maybe<Pricing>;
  published?: Maybe<Scalars['Boolean']['output']>;
  rule?: Maybe<Scalars['String']['output']>;
  should_allow_quote_requests?: Maybe<Scalars['Boolean']['output']>;
  species: Array<Species>;
  time_zone?: Maybe<Scalars['TimeZone']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ListingType>;
  what_to_expect_documents?: Maybe<Array<OutfitterDocument>>;
};

export type PublicListingSearchResults = {
  __typename?: 'PublicListingSearchResults';
  results: Array<PublicListing>;
  total: Scalars['NonNegativeInt']['output'];
};

export type PublicLodging = {
  __typename?: 'PublicLodging';
  /** @deprecated Beds have been replaced by capacity */
  beds: Array<LodgingBed>;
  /** @deprecated Beds have been replaced by capacity */
  beds_icons: Array<Scalars['URL']['output']>;
  /** @deprecated Beds have been replaced by capacity */
  beds_summary: Scalars['String']['output'];
  capacity: Scalars['PositiveInt']['output'];
  cover_image: Scalars['URL']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Media>>;
  location?: Maybe<Address>;
  name: Scalars['String']['output'];
  type: LodgingType;
  type_name: Scalars['String']['output'];
};

export type PublicOutfitter = {
  __typename?: 'PublicOutfitter';
  about: Scalars['String']['output'];
  avatar?: Maybe<Media>;
  booking_reviews_aggregation?: Maybe<ReviewAggregation>;
  cover_image?: Maybe<Scalars['URL']['output']>;
  created_at: Scalars['Timestamp']['output'];
  guides: Array<PublicTeamMember>;
  id: Scalars['ID']['output'];
  is_demo?: Maybe<Scalars['Boolean']['output']>;
  listings: Array<PublicListing>;
  listings_count: Scalars['NonNegativeInt']['output'];
  location?: Maybe<Address>;
  lodgings: Array<PublicLodging>;
  name: Scalars['String']['output'];
  owner: PublicUser;
  photos: Array<Media>;
  resources: Array<Resource>;
  slug: Scalars['String']['output'];
  status: OutfitterStatus;
  video?: Maybe<Video>;
};

export type PublicOutfitterSearchResults = {
  __typename?: 'PublicOutfitterSearchResults';
  results: Array<PublicOutfitter>;
  total: Scalars['NonNegativeInt']['output'];
};

export type PublicPricingPackage = {
  __typename?: 'PublicPricingPackage';
  price: Scalars['Float']['output'];
};

export type PublicTeamMember = {
  __typename?: 'PublicTeamMember';
  avatar?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  role: TeamMemberRole;
  user?: Maybe<PublicUser>;
  years_of_experience?: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type PublicTeamMemberResults = {
  __typename?: 'PublicTeamMemberResults';
  data: Array<PublicTeamMember>;
};

export type PublicUser = {
  __typename?: 'PublicUser';
  avatar_url?: Maybe<Scalars['URL']['output']>;
  bio: Scalars['String']['output'];
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_guest_conversion_disabled?: Maybe<Scalars['Boolean']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  socials?: Maybe<UserSocials>;
  years_of_experience?: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type Query = {
  __typename?: 'Query';
  _empty?: Maybe<Scalars['Void']['output']>;
  additionalBookingPaymentSummary: PaymentSummary;
  additionalPaymentSummary: AdditionalPaymentSummary;
  allAmenities: Array<Amenity>;
  allCoupons?: Maybe<Array<Coupon>>;
  allLicenseInfos: Array<LicenseInfo>;
  allSpecies: Array<Species>;
  availability: Array<GenericAvailabilityEntry>;
  availableDatesForCalendarEventResources: Array<Scalars['Timestamp']['output']>;
  bannersByKey: Array<Banner>;
  booking: Booking;
  bookingCancellationInfo: BookingCancellationInfo;
  /** get all attribution options for a booking deal */
  bookingDealAttributionOptions: Array<DealAttributionOption>;
  bookingInvite: BookingInvite;
  bookingInviteDealAttributionOptions: Array<DealAttributionOption>;
  bookingInvites: BookingInvitesResults;
  /** @deprecated Use bookingInvites instead */
  bookingInvitesByListing: Array<BookingInvite>;
  /** @deprecated Use bookingInvites instead */
  bookingInvitesByOutfitter: Array<BookingInvite>;
  /** @deprecated Use bookingInvites instead */
  bookingInvitesByOwner: Array<BookingInvite>;
  bookingInvitesByQuoteRequest: BookingInvitesResults;
  /** Preview of changes from booking update */
  bookingUpdatesPreview: Array<ValueChange>;
  /** Query bookings by a user */
  bookings: Array<Booking>;
  /** Query bookings from a specific listing */
  bookingsByListing: Array<Booking>;
  /** Query bookings for a listing, time-range */
  bookingsByListingBetweenDates: Array<Booking>;
  /** Query bookings for a listing that includes one of the selected dates */
  bookingsByListingOverlappingDates: Array<Booking>;
  /** Query bookings from a specific outfitter */
  bookingsByOutfitter: Array<Booking>;
  /**
   * Query bookings from all outfitters the member has access to
   * @deprecated No longer supported
   */
  bookingsByOutfitterMember: Array<Booking>;
  bookingsByResource: Array<Booking>;
  calendarEvent: CalendarEvent;
  calendarEvents: Array<CalendarEvent>;
  calendarSubscription: CalendarSubscription;
  canConvertGuestToUser: Scalars['Boolean']['output'];
  cancellationPolicies: Array<CancellationPolicy>;
  client: OutfitterClient;
  clientList: PaginatedOutfitterClientList;
  couponsByOutfitter?: Maybe<Array<Coupon>>;
  denialReasons: Array<DenialReason>;
  draftQuote: DraftQuote;
  existingAuthUser: Scalars['Boolean']['output'];
  exportClientListCsv: Media;
  exportPaymentsCsvByOutfitter: Media;
  exportRemainingPaymentsCsvByOutfitter: Media;
  feedActivities: ActivitiesQueryResponse;
  getAddOnsByListingAndOfferPeriod: Array<AddOn>;
  getAddOnsByOutfitterAndOfferPeriod: Array<AddOn>;
  getAdminChatToken?: Maybe<Scalars['String']['output']>;
  getAiChatMessages: Array<ChatMessage>;
  getBookingInvitePaymentSummary: PaymentSummary;
  getBookingReferral: BookingReferral;
  getBookingReferralFeePreview: Array<LineItem>;
  getBookingReferrals: PaginatedBookingReferrals;
  getCalendarSubscriptions?: Maybe<CalendarSubscriptionsResults>;
  getChatMessages?: Maybe<ChatMessagesResults>;
  getCourierInboxAuthToken: Scalars['String']['output'];
  getDefaultImage?: Maybe<Scalars['String']['output']>;
  getExtraAddOnsForListingAndPricingPackage: Array<AddOn>;
  getInvoicePdf?: Maybe<Scalars['String']['output']>;
  getMetric: Metric;
  getMetricsByOutfitterAndKeys: Array<Metric>;
  getMyBookingReferralsByBookingId: MyBookingReferralsByBookingIdResponse;
  getOutfitterChatToken?: Maybe<Scalars['String']['output']>;
  getOutfitterIntegrationSettings: OutfitterIntegrationSettings;
  getPaymentSettings?: Maybe<PaymentSettings>;
  getQuickBooksClassMappings?: Maybe<QuickBooksClassMappingsResult>;
  getQuickBooksClasses: QuickBooksClassesResult;
  getQuickBooksCompanyInfo: QuickBooksCompanyInfo;
  getQuickBooksDepositAccounts: QuickBooksDepositAccountsResult;
  getQuickBooksItemListingMappings: QuickBooksItemListingMappingsResult;
  getQuickBooksItemOutfitterMappings: QuickBooksItemOutfitterMappingsResult;
  getQuickBooksItems: QuickBooksItemsResult;
  getQuoteRequest: QuoteRequest;
  getQuoteRequestsForOutfitter: QuoteRequestsForOutfitterResponse;
  getRemainingPaymentsByBookingId: Array<RemainingPayment>;
  getRichTextAiSuggestion: RichTextAiSuggestion;
  getSearchSuggestionsForTrip: Array<GenericSearchSuggestionGroup>;
  getSportsmanChatToken?: Maybe<Scalars['String']['output']>;
  getSyncedCalendars?: Maybe<SyncedCalendarsResults>;
  getTimeseriesMetric: Array<Metric>;
  groupPayMemberPaymentBlocks: Array<PaymentBlock>;
  groupPaySharePaymentPlanBySlots: SlotPaymentPlan;
  isUserUsingPasswordLogin: Scalars['Boolean']['output'];
  lead: Lead;
  leadList: PaginatedLeadList;
  listing: Listing;
  listingProgress: ListingProgress;
  listingRegionAggregations: Region;
  listingsByOutfitter: Array<Listing>;
  lodging: Lodging;
  lodgingsByOutfitter: Array<Lodging>;
  lodgingsByOwner: Array<Lodging>;
  notes?: Maybe<Array<Maybe<Note>>>;
  onboarding: Onboarding;
  onboardingPaymentSummary: PaymentSummary;
  onboardingStatusInfo: OnboardingStatusInfo;
  onboardingSubscriptionOptions: OnboardingSubscriptionOptions;
  onboardings: OnboardingQueryResults;
  outfitter: Outfitter;
  outfitterDocument: OutfitterDocument;
  outfitterDocumentsByOutfitter: Array<OutfitterDocument>;
  outfitterFeatureAccessInfo: OutfitterFeatureAccessInfo;
  outfitterSlug: OutfitterSlugResult;
  outfitterSubscriptionBillingPortalUrl: Scalars['String']['output'];
  outfitterSubscriptionInfo: OutfitterSubscriptionInfo;
  outfittersByOwner: Array<Outfitter>;
  payment: Payment;
  paymentRequest: PaymentRequest;
  paymentsByOutfitter?: Maybe<PaymentResults>;
  payoutTransactions: Array<PayoutTransaction>;
  payouts: PayoutsList;
  preCheckoutData: PreCheckoutData;
  pricingPackage: PricingPackage;
  pricingPackagesByListing: Array<PricingPackage>;
  pricingPackagesByOutfitter: Array<PricingPackage>;
  pricingPackagesWithAddOn: Array<PricingPackage>;
  publicListings: Array<PublicListing>;
  publicLodgingsByListing: Array<PublicLodging>;
  publicOutfitters: Array<PublicOutfitter>;
  publicTeamMembers: PublicTeamMemberResults;
  quote: Quote;
  /** Most recent bookings */
  recentPublicBookings: Array<PublicBooking>;
  remainingPaymentsByOutfitter: RemainingPaymentResults;
  resource: Resource;
  resourcesByListing: Array<Resource>;
  resourcesByOutfitter: Array<Resource>;
  reviewForm: ReviewForm;
  searchAllListings: ListingSearchResults;
  /** search bookings by outfitter */
  searchBookingsByOutfitterAndStatus: BookingSearchResults;
  /** search bookings */
  searchBookingsByStatus: BookingSearchResults;
  searchHubspotCompanies: HubspotCompanySearchResult;
  searchListingsForSportsmen: PublicListingSearchResults;
  searchOutfitters: OutfitterSearchResults;
  searchOutfittersForSportsmen: PublicOutfitterSearchResults;
  searchSpecies: Array<Species>;
  searchUsers: UsersSearchResults;
  sportsmanPaymentBlocks: Array<PaymentBlock>;
  streamActivitiesByIds: Array<Activity>;
  /** @deprecated No longer supported */
  stripeAccountCheck: Scalars['Boolean']['output'];
  stripeAccountInfo: StripeAccountInfo;
  /** @deprecated No longer supported */
  stripeAccountLoginLink?: Maybe<Scalars['URL']['output']>;
  /** @deprecated No longer supported */
  stripeAccountOnboardLink: Scalars['URL']['output'];
  stripeBillingPortalUrl: Scalars['String']['output'];
  stripeTerminalInfo: StripeTerminalInfo;
  teamMember: TeamMember;
  teamMembers: Array<TeamMember>;
  terminalConnectionToken: Scalars['String']['output'];
  tripInsurancePolicy: TripInsurancePolicy;
  tripInsuranceProduct?: Maybe<TripInsuranceProduct>;
  tripInsuranceQuote: BookingQuoteTripInsuranceQuote;
  user: User;
  userPaymentsHistory: Array<Payment>;
  userTrackingData: UserTrackingData;
  widget: Widget;
  widgetsByOutfitter: Array<Widget>;
  wishlist: Wishlist;
  wishlistsByUser: Array<Wishlist>;
};


export type QueryAdditionalBookingPaymentSummaryArgs = {
  bookingId: Scalars['ID']['input'];
  data: AdditionalBookingPaymentSummaryInput;
};


export type QueryAdditionalPaymentSummaryArgs = {
  bookingId: Scalars['ID']['input'];
  data: AdditionalPaymentSummaryInput;
};


export type QueryAvailabilityArgs = {
  data: GetGenericAvailabilityInput;
};


export type QueryAvailableDatesForCalendarEventResourcesArgs = {
  data: AvailableDatesForCalendarEventResourcesInput;
};


export type QueryBannersByKeyArgs = {
  page_key: BannerPageKey;
};


export type QueryBookingArgs = {
  id: Scalars['ID']['input'];
  invitationId?: InputMaybe<Scalars['ID']['input']>;
  referralId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBookingCancellationInfoArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBookingInviteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBookingInvitesArgs = {
  filters?: InputMaybe<BookingInviteFilters>;
  listingId?: InputMaybe<Scalars['ID']['input']>;
  outfitterId?: InputMaybe<Scalars['ID']['input']>;
  paging?: InputMaybe<Paging>;
};


export type QueryBookingInvitesByListingArgs = {
  filters?: InputMaybe<BookingInviteFilters>;
  listingId: Scalars['ID']['input'];
};


export type QueryBookingInvitesByOutfitterArgs = {
  filters?: InputMaybe<BookingInviteFilters>;
  outfitterId: Scalars['ID']['input'];
};


export type QueryBookingInvitesByOwnerArgs = {
  ownerId: Scalars['ID']['input'];
};


export type QueryBookingInvitesByQuoteRequestArgs = {
  paging?: InputMaybe<Paging>;
  quoteRequestId: Scalars['ID']['input'];
};


export type QueryBookingUpdatesPreviewArgs = {
  data: UpdateBookingDatesGuestsAndAddonsInput;
  id: Scalars['ID']['input'];
};


export type QueryBookingsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryBookingsByListingArgs = {
  fromDate?: InputMaybe<Scalars['Timestamp']['input']>;
  listingId: Scalars['ID']['input'];
  status?: InputMaybe<BookingStatus>;
  toDate?: InputMaybe<Scalars['Timestamp']['input']>;
};


export type QueryBookingsByListingBetweenDatesArgs = {
  fromDate: Scalars['Timestamp']['input'];
  listingId: Scalars['ID']['input'];
  toDate: Scalars['Timestamp']['input'];
};


export type QueryBookingsByListingOverlappingDatesArgs = {
  fromDate: Scalars['Timestamp']['input'];
  listingId: Scalars['ID']['input'];
  toDate: Scalars['Timestamp']['input'];
};


export type QueryBookingsByOutfitterArgs = {
  fromDate?: InputMaybe<Scalars['Timestamp']['input']>;
  outfitterId: Scalars['ID']['input'];
  status?: InputMaybe<BookingStatus>;
  toDate?: InputMaybe<Scalars['Timestamp']['input']>;
};


export type QueryBookingsByOutfitterMemberArgs = {
  fromDate?: InputMaybe<Scalars['Timestamp']['input']>;
  memberId: Scalars['ID']['input'];
  status?: InputMaybe<BookingStatus>;
  toDate?: InputMaybe<Scalars['Timestamp']['input']>;
};


export type QueryBookingsByResourceArgs = {
  fromDate?: InputMaybe<Scalars['Timestamp']['input']>;
  resourceId: Scalars['ID']['input'];
  status?: InputMaybe<BookingStatus>;
  toDate?: InputMaybe<Scalars['Timestamp']['input']>;
};


export type QueryCalendarEventArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCalendarEventsArgs = {
  filters?: InputMaybe<CalendarEventFilters>;
  outfitterId: Scalars['ID']['input'];
};


export type QueryCanConvertGuestToUserArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
};


export type QueryClientArgs = {
  id: Scalars['ID']['input'];
  outfitterId: Scalars['ID']['input'];
};


export type QueryClientListArgs = {
  fromDate?: InputMaybe<Scalars['Timestamp']['input']>;
  outfitterId: Scalars['ID']['input'];
  paging: Paging;
  text?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['Timestamp']['input']>;
};


export type QueryCouponsByOutfitterArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryDenialReasonsArgs = {
  entityType?: InputMaybe<EntityType>;
};


export type QueryDraftQuoteArgs = {
  data: CreateQuoteInput;
};


export type QueryExistingAuthUserArgs = {
  email: Scalars['EmailAddress']['input'];
};


export type QueryExportClientListCsvArgs = {
  fromDate?: InputMaybe<Scalars['Timestamp']['input']>;
  outfitterId: Scalars['ID']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['Timestamp']['input']>;
};


export type QueryExportPaymentsCsvByOutfitterArgs = {
  data: ExportDataInput;
};


export type QueryExportRemainingPaymentsCsvByOutfitterArgs = {
  data: ExportDataInput;
};


export type QueryFeedActivitiesArgs = {
  feedGroup: FeedGroup;
  feedId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetAddOnsByListingAndOfferPeriodArgs = {
  idsToAlwaysInclude?: InputMaybe<Array<Scalars['ID']['input']>>;
  listingId: Scalars['ID']['input'];
  offerPeriod: AddOnOfferPeriod;
};


export type QueryGetAddOnsByOutfitterAndOfferPeriodArgs = {
  offerPeriod: AddOnOfferPeriod;
  outfitterId: Scalars['ID']['input'];
};


export type QueryGetAiChatMessagesArgs = {
  channelId: Scalars['ID']['input'];
};


export type QueryGetBookingInvitePaymentSummaryArgs = {
  data: PaymentSummaryInput;
};


export type QueryGetBookingReferralArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetBookingReferralFeePreviewArgs = {
  bookingId?: InputMaybe<Scalars['ID']['input']>;
  outfitterId: Scalars['ID']['input'];
};


export type QueryGetBookingReferralsArgs = {
  isRequested: Scalars['Boolean']['input'];
  outfitterId: Scalars['ID']['input'];
  paging?: InputMaybe<Paging>;
  status?: InputMaybe<BookingReferralStatus>;
};


export type QueryGetCalendarSubscriptionsArgs = {
  paging?: InputMaybe<Paging>;
  userId: Scalars['ID']['input'];
};


export type QueryGetChatMessagesArgs = {
  channelId: Scalars['ID']['input'];
  paging?: InputMaybe<Paging>;
};


export type QueryGetDefaultImageArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetExtraAddOnsForListingAndPricingPackageArgs = {
  listingId: Scalars['ID']['input'];
  pricingPackageId: Scalars['ID']['input'];
  shouldFilterHiddenAddons?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetInvoicePdfArgs = {
  accessCodeId?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['ID']['input'];
  entityType: EntityType;
};


export type QueryGetMetricArgs = {
  metricParams: MetricParams;
};


export type QueryGetMetricsByOutfitterAndKeysArgs = {
  metricParams: MetricByOutfitterAndKeysParams;
};


export type QueryGetMyBookingReferralsByBookingIdArgs = {
  bookingId: Scalars['ID']['input'];
};


export type QueryGetOutfitterChatTokenArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryGetOutfitterIntegrationSettingsArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryGetPaymentSettingsArgs = {
  entity_id: Scalars['ID']['input'];
  entity_type: PaymentSettingsEntityType;
};


export type QueryGetQuickBooksClassMappingsArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryGetQuickBooksClassesArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryGetQuickBooksCompanyInfoArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryGetQuickBooksDepositAccountsArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryGetQuickBooksItemListingMappingsArgs = {
  listingId: Scalars['ID']['input'];
};


export type QueryGetQuickBooksItemOutfitterMappingsArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryGetQuickBooksItemsArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryGetQuoteRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetQuoteRequestsForOutfitterArgs = {
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  listing_id?: InputMaybe<Scalars['ID']['input']>;
  outfitter_id: Scalars['ID']['input'];
  paging: Paging;
};


export type QueryGetRemainingPaymentsByBookingIdArgs = {
  booking_id: Scalars['ID']['input'];
};


export type QueryGetRichTextAiSuggestionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSearchSuggestionsForTripArgs = {
  searchParams: SearchListingsForSportsmenInput;
};


export type QueryGetSyncedCalendarsArgs = {
  outfitterId: Scalars['ID']['input'];
  paging?: InputMaybe<Paging>;
};


export type QueryGetTimeseriesMetricArgs = {
  metricParams: MetricParams;
};


export type QueryGroupPayMemberPaymentBlocksArgs = {
  groupPayMemberId: Scalars['ID']['input'];
};


export type QueryGroupPaySharePaymentPlanBySlotsArgs = {
  bookingId: Scalars['ID']['input'];
  isAchPaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
  isExternalPaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
  shouldAcceptTripInsurance?: InputMaybe<Scalars['Boolean']['input']>;
  slots: Scalars['PositiveInt']['input'];
  sportsmanZipCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLeadArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLeadListArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  outfitterId: Scalars['ID']['input'];
  paging: Paging;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<LeadStatus>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryListingProgressArgs = {
  id: Scalars['ID']['input'];
};


export type QueryListingsByOutfitterArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryLodgingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLodgingsByOutfitterArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryLodgingsByOwnerArgs = {
  ownerId: Scalars['ID']['input'];
};


export type QueryNotesArgs = {
  entityId: Scalars['String']['input'];
  entityType: NotesEntityType;
};


export type QueryOnboardingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOnboardingPaymentSummaryArgs = {
  data: OnboardingPaymentSummaryInput;
};


export type QueryOnboardingStatusInfoArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOnboardingsArgs = {
  filters?: InputMaybe<OnboardingFilters>;
  paging: Paging;
};


export type QueryOutfitterArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOutfitterDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOutfitterDocumentsByOutfitterArgs = {
  outfitterId: Scalars['ID']['input'];
  type?: InputMaybe<OutfitterDocumentType>;
};


export type QueryOutfitterFeatureAccessInfoArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryOutfitterSlugArgs = {
  name: Scalars['String']['input'];
};


export type QueryOutfitterSubscriptionBillingPortalUrlArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryOutfitterSubscriptionInfoArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryOutfittersByOwnerArgs = {
  ownerId: Scalars['ID']['input'];
};


export type QueryPaymentArgs = {
  id: Scalars['ID']['input'];
  invitationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPaymentRequestArgs = {
  id: Scalars['ID']['input'];
  isAchPaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
  isExternalPaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
  shouldCalculateFees?: InputMaybe<Scalars['Boolean']['input']>;
  tipAmount?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};


export type QueryPaymentsByOutfitterArgs = {
  fromDate?: InputMaybe<Scalars['Timestamp']['input']>;
  isQuickPay?: InputMaybe<Scalars['Boolean']['input']>;
  outfitterId: Scalars['ID']['input'];
  paging?: InputMaybe<Paging>;
  status?: InputMaybe<PaymentStatus>;
  toDate?: InputMaybe<Scalars['Timestamp']['input']>;
};


export type QueryPayoutTransactionsArgs = {
  outfitterId: Scalars['ID']['input'];
  payoutId: Scalars['ID']['input'];
};


export type QueryPayoutsArgs = {
  options?: InputMaybe<CursorPaginationOptions>;
  outfitterId: Scalars['ID']['input'];
};


export type QueryPreCheckoutDataArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryPricingPackageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPricingPackagesByListingArgs = {
  dates?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  idsToAlwaysInclude?: InputMaybe<Array<Scalars['ID']['input']>>;
  listing: Scalars['ID']['input'];
  numberOfGuests?: InputMaybe<Scalars['PositiveInt']['input']>;
  shouldIncludeHidden?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPricingPackagesByOutfitterArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryPricingPackagesWithAddOnArgs = {
  addOn: Scalars['ID']['input'];
};


export type QueryPublicListingsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryPublicLodgingsByListingArgs = {
  listingId: Scalars['ID']['input'];
};


export type QueryPublicOutfittersArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryPublicTeamMembersArgs = {
  outfitterId: Scalars['ID']['input'];
  role?: InputMaybe<TeamMemberRole>;
};


export type QueryQuoteArgs = {
  id: Scalars['ID']['input'];
  isAchPaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
  isExternalPaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
  paymentPlanType?: InputMaybe<PaymentPlanType>;
  shouldAcceptTripInsurance?: InputMaybe<Scalars['Boolean']['input']>;
  sportmanZipCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRecentPublicBookingsArgs = {
  size?: InputMaybe<Scalars['PositiveInt']['input']>;
};


export type QueryRemainingPaymentsByOutfitterArgs = {
  outfitter_id: Scalars['ID']['input'];
  paging?: InputMaybe<Paging>;
};


export type QueryResourceArgs = {
  id: Scalars['String']['input'];
};


export type QueryResourcesByListingArgs = {
  listingId: Scalars['String']['input'];
};


export type QueryResourcesByOutfitterArgs = {
  outfitterId: Scalars['String']['input'];
};


export type QueryReviewFormArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySearchAllListingsArgs = {
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  from: Scalars['NonNegativeInt']['input'];
  published?: InputMaybe<Scalars['Boolean']['input']>;
  size?: InputMaybe<Scalars['PositiveInt']['input']>;
  title: Scalars['String']['input'];
};


export type QuerySearchBookingsByOutfitterAndStatusArgs = {
  outfitterId: Scalars['ID']['input'];
  paging: Paging;
  sort?: InputMaybe<Sort>;
  status?: InputMaybe<BookingStatus>;
  text?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchBookingsByStatusArgs = {
  paging: Paging;
  sort?: InputMaybe<Sort>;
  status: BookingStatus;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchHubspotCompaniesArgs = {
  searchTerm: Scalars['String']['input'];
};


export type QuerySearchListingsForSportsmenArgs = {
  options: SearchOptions;
  searchParams: SearchListingsForSportsmenInput;
};


export type QuerySearchOutfittersArgs = {
  page: Scalars['NonNegativeInt']['input'];
  size: Scalars['PositiveInt']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};


export type QuerySearchOutfittersForSportsmenArgs = {
  options: SearchOptions;
  searchParams: SearchOutfittersForSportsmenInput;
};


export type QuerySearchSpeciesArgs = {
  data: SearchSpeciesInput;
};


export type QuerySearchUsersArgs = {
  page: Scalars['NonNegativeInt']['input'];
  size: Scalars['PositiveInt']['input'];
  text: Scalars['String']['input'];
};


export type QuerySportsmanPaymentBlocksArgs = {
  sportsmanId: Scalars['ID']['input'];
};


export type QueryStreamActivitiesByIdsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryStripeAccountInfoArgs = {
  onboardLinkUrls?: InputMaybe<AccountOnboardLinkInput>;
};


export type QueryStripeAccountOnboardLinkArgs = {
  data: AccountOnboardLinkInput;
};


export type QueryStripeBillingPortalUrlArgs = {
  code: Scalars['String']['input'];
};


export type QueryStripeTerminalInfoArgs = {
  paymentRequestId: Scalars['ID']['input'];
};


export type QueryTeamMemberArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTeamMembersArgs = {
  outfitterId: Scalars['ID']['input'];
  role?: InputMaybe<TeamMemberRole>;
};


export type QueryTripInsurancePolicyArgs = {
  bookingId: Scalars['String']['input'];
  policyNumber: Scalars['String']['input'];
};


export type QueryTripInsuranceProductArgs = {
  insurableAmount: Scalars['PositiveInt']['input'];
  zipCode: Scalars['String']['input'];
};


export type QueryTripInsuranceQuoteArgs = {
  bookingId: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};


export type QueryWidgetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWidgetsByOutfitterArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryWishlistArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWishlistsByUserArgs = {
  userId: Scalars['ID']['input'];
};

export type QuickBooksClass = {
  __typename?: 'QuickBooksClass';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type QuickBooksClassMappingInput = {
  class_id?: InputMaybe<Scalars['String']['input']>;
  class_name?: InputMaybe<Scalars['String']['input']>;
  entity_id: Scalars['ID']['input'];
  entity_type: EntityIntegrationSettingsEntityType;
};

export type QuickBooksClassMappingsResult = {
  __typename?: 'QuickBooksClassMappingsResult';
  listing_class_mappings: Array<QuickBooksListingClassMapping>;
};

export type QuickBooksClassesResult = {
  __typename?: 'QuickBooksClassesResult';
  classes: Array<QuickBooksClass>;
};

export type QuickBooksCompanyInfo = {
  __typename?: 'QuickBooksCompanyInfo';
  account_owner_full_name?: Maybe<Scalars['String']['output']>;
  company_name?: Maybe<Scalars['String']['output']>;
};

export type QuickBooksConnectionInput = {
  outfitter_id: Scalars['String']['input'];
};

export type QuickBooksDepositAccount = {
  __typename?: 'QuickBooksDepositAccount';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type QuickBooksDepositAccountsResult = {
  __typename?: 'QuickBooksDepositAccountsResult';
  accounts: Array<QuickBooksDepositAccount>;
};

export type QuickBooksIntegrationSettings = {
  __typename?: 'QuickBooksIntegrationSettings';
  default_product_service_id?: Maybe<Scalars['String']['output']>;
  deposit_account_id?: Maybe<Scalars['String']['output']>;
  invoice_date?: Maybe<QuickBooksInvoiceDateSetting>;
};

export enum QuickBooksInvoiceDateSetting {
  BookingApprovalDate = 'BOOKING_APPROVAL_DATE',
  BookingDate = 'BOOKING_DATE',
  TripStartDate = 'TRIP_START_DATE'
}

export type QuickBooksItem = {
  __typename?: 'QuickBooksItem';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type QuickBooksItemListingMappingsResult = {
  __typename?: 'QuickBooksItemListingMappingsResult';
  pricing_package_item_mappings: Array<QuickBooksItemMapping>;
};

export type QuickBooksItemMapping = {
  __typename?: 'QuickBooksItemMapping';
  entity_id: Scalars['ID']['output'];
  entity_order?: Maybe<Scalars['PositiveInt']['output']>;
  entity_title: Scalars['String']['output'];
  entity_type: EntityIntegrationSettingsEntityType;
  item_id?: Maybe<Scalars['String']['output']>;
  item_name?: Maybe<Scalars['String']['output']>;
};

export type QuickBooksItemMappingInput = {
  entity_id: Scalars['ID']['input'];
  entity_type: EntityIntegrationSettingsEntityType;
  item_id?: InputMaybe<Scalars['String']['input']>;
  item_name?: InputMaybe<Scalars['String']['input']>;
};

export type QuickBooksItemOutfitterMappingsResult = {
  __typename?: 'QuickBooksItemOutfitterMappingsResult';
  add_on_item_mappings: Array<QuickBooksItemMapping>;
};

export type QuickBooksItemsResult = {
  __typename?: 'QuickBooksItemsResult';
  items: Array<QuickBooksItem>;
};

export type QuickBooksListingClassMapping = {
  __typename?: 'QuickBooksListingClassMapping';
  class_id?: Maybe<Scalars['String']['output']>;
  class_name?: Maybe<Scalars['String']['output']>;
  listing_id: Scalars['ID']['output'];
  listing_order?: Maybe<Scalars['PositiveInt']['output']>;
  listing_title: Scalars['String']['output'];
};

export type Quote = QuoteInterface & {
  __typename?: 'Quote';
  add_ons?: Maybe<Array<QuoteAddOn>>;
  attribution?: Maybe<Attribution>;
  booking_invite?: Maybe<BookingInvite>;
  coupon?: Maybe<Coupon>;
  created_at: Scalars['Timestamp']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  dates: Array<Scalars['Timestamp']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  items: Array<QuoteItem>;
  itinerary?: Maybe<TripItinerary>;
  listing: Listing;
  lodging_included?: Maybe<Scalars['Boolean']['output']>;
  packages: Array<QuotePackage>;
  payment_group?: Maybe<QuotePaymentGroup>;
  payment_plans: Array<QuotePaymentPlan>;
  payment_summary?: Maybe<PaymentSummary>;
  prices: Array<QuotePrice>;
  /** @deprecated Use packages instead */
  pricing_package?: Maybe<PricingPackage>;
  should_allow_external_payment?: Maybe<Scalars['Boolean']['output']>;
  total: Scalars['Float']['output'];
  trip_insurance?: Maybe<BookingQuoteTripInsuranceQuote>;
  updated_at: Scalars['Timestamp']['output'];
};

export type QuoteAddOn = {
  __typename?: 'QuoteAddOn';
  category: Scalars['String']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  deposit_amount?: Maybe<Scalars['Float']['output']>;
  deposit_percentage?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Scalars['String']['output']>>;
  listings: Array<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  offer_period: AddOnOfferPeriod;
  package_id?: Maybe<Scalars['String']['output']>;
  price_by_day?: Maybe<PriceByDay>;
  price_by_guest?: Maybe<PriceByGuest>;
  quantity: Scalars['PositiveInt']['output'];
  species?: Maybe<Species>;
  stripe_product_id?: Maybe<Scalars['String']['output']>;
  unit_price: Scalars['Float']['output'];
};

export type QuoteAddOnInput = {
  id: Scalars['ID']['input'];
  package_id?: InputMaybe<Scalars['ID']['input']>;
  quantity: Scalars['PositiveInt']['input'];
};

export type QuoteInterface = {
  add_ons?: Maybe<Array<QuoteAddOn>>;
  attribution?: Maybe<Attribution>;
  booking_invite?: Maybe<BookingInvite>;
  coupon?: Maybe<Coupon>;
  currency?: Maybe<Scalars['String']['output']>;
  dates: Array<Scalars['Timestamp']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  items: Array<QuoteItem>;
  itinerary?: Maybe<TripItinerary>;
  listing: Listing;
  lodging_included?: Maybe<Scalars['Boolean']['output']>;
  packages: Array<QuotePackage>;
  payment_plans: Array<QuotePaymentPlan>;
  payment_summary?: Maybe<PaymentSummary>;
  /** @deprecated Use payment_summary.prices instead */
  prices: Array<QuotePrice>;
  /** @deprecated Use packages instead */
  pricing_package?: Maybe<PricingPackage>;
  /** @deprecated Use payment_summary.totals instead */
  total: Scalars['Float']['output'];
  trip_insurance?: Maybe<BookingQuoteTripInsuranceQuote>;
};

export type QuoteItem = {
  __typename?: 'QuoteItem';
  currency?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  option_id: Scalars['ID']['output'];
  price: Scalars['Float']['output'];
  quantity: Scalars['PositiveInt']['output'];
  rate: Scalars['Float']['output'];
};

export type QuoteItemInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  option_id: Scalars['ID']['input'];
  price: Scalars['Float']['input'];
  quantity: Scalars['PositiveInt']['input'];
  rate: Scalars['Float']['input'];
};

export type QuotePackage = {
  __typename?: 'QuotePackage';
  add_ons: Array<QuoteAddOn>;
  id: Scalars['ID']['output'];
  items: Array<QuoteItem>;
  line_item_key?: Maybe<Scalars['ID']['output']>;
  number_of_guests: Scalars['PositiveInt']['output'];
  pricing_package: PricingPackage;
};

export type QuotePayment = {
  __typename?: 'QuotePayment';
  booking_fee: Scalars['Float']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  date: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  mb_amount: Scalars['Float']['output'];
  outfitter_amount: Scalars['Float']['output'];
  outfitter_fee: Scalars['Float']['output'];
  processing_fee: Scalars['Float']['output'];
  sales_tax: Scalars['Float']['output'];
  service_fee: Scalars['Float']['output'];
  should_charge_last_day_of_trip?: Maybe<Scalars['Boolean']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  value: Scalars['Float']['output'];
};

export type QuotePaymentGroup = {
  __typename?: 'QuotePaymentGroup';
  host: QuotePaymentGroupMember;
  last_payment_due_date: Scalars['Timestamp']['output'];
  members: Array<QuotePaymentGroupMember>;
  remaining_slots: Scalars['PositiveInt']['output'];
};

export type QuotePaymentGroupMember = {
  __typename?: 'QuotePaymentGroupMember';
  amount: Scalars['NonNegativeInt']['output'];
  email: Scalars['EmailAddress']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  payment_plans: Array<QuotePaymentPlan>;
  slots: Scalars['NonNegativeInt']['output'];
};

export type QuotePaymentGroupMemberInput = {
  email: Scalars['EmailAddress']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  slots: Scalars['PositiveInt']['input'];
};

export type QuotePaymentPlan = {
  __typename?: 'QuotePaymentPlan';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  payments: Array<QuotePayment>;
  type: PaymentPlanType;
};

export type QuotePrice = {
  __typename?: 'QuotePrice';
  category?: Maybe<QuotePriceCategory>;
  currency?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  subsections: Array<PriceSubsection>;
  value: Scalars['Float']['output'];
};

export enum QuotePriceCategory {
  BookingFee = 'BOOKING_FEE',
  Discount = 'DISCOUNT',
  GrandTotal = 'GRAND_TOTAL',
  Other = 'OTHER',
  ProcessingFee = 'PROCESSING_FEE',
  RemainingGroupMembersTotal = 'REMAINING_GROUP_MEMBERS_TOTAL',
  SalesTax = 'SALES_TAX',
  Subtotal = 'SUBTOTAL',
  TaxesAndOtherFees = 'TAXES_AND_OTHER_FEES',
  Total = 'TOTAL',
  TotalWithoutProcessingFees = 'TOTAL_WITHOUT_PROCESSING_FEES',
  TripInsuranceTotal = 'TRIP_INSURANCE_TOTAL',
  YourSubtotal = 'YOUR_SUBTOTAL'
}

export type QuotePricingOptionInput = {
  id: Scalars['ID']['input'];
  quantity: Scalars['PositiveInt']['input'];
};

export type QuoteRequest = {
  __typename?: 'QuoteRequest';
  booking_invite?: Maybe<BookingInvite>;
  booking_invite_id?: Maybe<Scalars['ID']['output']>;
  contact: QuoteRequestContact;
  created_at: Scalars['Timestamp']['output'];
  dates: Array<Scalars['NonNegativeInt']['output']>;
  id: Scalars['ID']['output'];
  is_archived: Scalars['Boolean']['output'];
  listing?: Maybe<Listing>;
  listing_id?: Maybe<Scalars['ID']['output']>;
  outfitter?: Maybe<Outfitter>;
  outfitter_id: Scalars['ID']['output'];
  trip_details: Scalars['String']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type QuoteRequestContact = {
  __typename?: 'QuoteRequestContact';
  email: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  last_name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  preferred_method: QuoteRequestPreferredMethod;
};

export type QuoteRequestContactInput = {
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  preferred_method: QuoteRequestPreferredMethod;
};

export type QuoteRequestInput = {
  contact: QuoteRequestContactInput;
  dates: Array<Scalars['NonNegativeInt']['input']>;
  listing_id?: InputMaybe<Scalars['ID']['input']>;
  outfitter_id?: InputMaybe<Scalars['ID']['input']>;
  trip_details: Scalars['String']['input'];
};

export enum QuoteRequestPreferredMethod {
  Email = 'EMAIL',
  Phone = 'PHONE'
}

export type QuoteRequestsForOutfitterResponse = {
  __typename?: 'QuoteRequestsForOutfitterResponse';
  count: Scalars['Int']['output'];
  data: Array<QuoteRequest>;
  pages: Scalars['Int']['output'];
};

export type Rates = {
  __typename?: 'Rates';
  booking_fee_fixed: Scalars['Float']['output'];
  booking_fee_rate: Scalars['Float']['output'];
  is_processing_fee_payed_by_sportsman?: Maybe<Scalars['Boolean']['output']>;
  max_booking_fee: Scalars['Float']['output'];
  max_service_fee: Scalars['Float']['output'];
  outfitter_fee_rate?: Maybe<Scalars['Float']['output']>;
  processing_fee_ach_fixed?: Maybe<Scalars['Float']['output']>;
  processing_fee_ach_max?: Maybe<Scalars['NonNegativeInt']['output']>;
  processing_fee_ach_rate?: Maybe<Scalars['Float']['output']>;
  processing_fee_fixed: Scalars['Float']['output'];
  processing_fee_rate: Scalars['Float']['output'];
  service_fee_fixed: Scalars['Float']['output'];
  service_fee_rate: Scalars['Float']['output'];
};

export type RatesInput = {
  booking_fee_fixed?: InputMaybe<Scalars['Float']['input']>;
  booking_fee_rate?: InputMaybe<Scalars['Float']['input']>;
  max_booking_fee?: InputMaybe<Scalars['Float']['input']>;
  max_service_fee?: InputMaybe<Scalars['Float']['input']>;
  outfitter_fee_fixed?: InputMaybe<Scalars['Float']['input']>;
  outfitter_fee_rate?: InputMaybe<Scalars['Float']['input']>;
  processing_fee_ach_fixed?: InputMaybe<Scalars['Float']['input']>;
  processing_fee_ach_max?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  processing_fee_ach_rate?: InputMaybe<Scalars['Float']['input']>;
  processing_fee_fixed?: InputMaybe<Scalars['Float']['input']>;
  processing_fee_rate?: InputMaybe<Scalars['Float']['input']>;
  service_fee_fixed?: InputMaybe<Scalars['Float']['input']>;
  service_fee_rate?: InputMaybe<Scalars['Float']['input']>;
};

export type Reaction = {
  __typename?: 'Reaction';
  activity_id: Scalars['String']['output'];
  id: Scalars['String']['output'];
  user_id: Scalars['String']['output'];
};

export type ReactionCounts = {
  __typename?: 'ReactionCounts';
  like?: Maybe<Scalars['Int']['output']>;
};

export enum ReactionType {
  Like = 'like'
}

export enum ReferralSource {
  Ad = 'AD',
  BookingAgent = 'BOOKING_AGENT',
  CustomerReferral = 'CUSTOMER_REFERRAL',
  Google = 'GOOGLE',
  TradeShow = 'TRADE_SHOW',
  Website = 'WEBSITE',
  WordOfMouth = 'WORD_OF_MOUTH'
}

export type Refund = {
  __typename?: 'Refund';
  amount: Scalars['PositiveInt']['output'];
  approved_by_name: Scalars['String']['output'];
  cancelled_at?: Maybe<Scalars['Timestamp']['output']>;
  cancelled_by?: Maybe<User>;
  created_at: Scalars['Timestamp']['output'];
  created_by: User;
  currency?: Maybe<Scalars['String']['output']>;
  error?: Maybe<PaymentError>;
  gateway_refund_id: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  payment_gateway: PaymentGateway;
  payment_id: Scalars['ID']['output'];
  status: RefundStatus;
  stripe_reason?: Maybe<StripeRefundReason>;
  updated_at: Scalars['Timestamp']['output'];
  user_reason: Scalars['String']['output'];
};

export enum RefundStatus {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  RequiresAction = 'REQUIRES_ACTION',
  Succeeded = 'SUCCEEDED'
}

export type Region = {
  __typename?: 'Region';
  countries_subsection: PageSubsection;
  label: Scalars['String']['output'];
  states_subsection: PageSubsection;
  sub_label: Scalars['String']['output'];
};

export type RemainingPayment = {
  __typename?: 'RemainingPayment';
  amount: Scalars['Int']['output'];
  booking_add_on_id: Scalars['ID']['output'];
  booking_id: Scalars['ID']['output'];
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  is_archived?: Maybe<Scalars['Boolean']['output']>;
  outfitter_id: Scalars['ID']['output'];
  payment_id?: Maybe<Scalars['ID']['output']>;
  payment_request_id?: Maybe<Scalars['ID']['output']>;
  status: PaymentStatus;
  updated_at: Scalars['Timestamp']['output'];
};

export type RemainingPaymentResults = {
  __typename?: 'RemainingPaymentResults';
  count: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  remaining_payments: Array<RemainingPayment>;
};

export type Resource = {
  __typename?: 'Resource';
  atv_props?: Maybe<AtvProps>;
  blind_props?: Maybe<BlindProps>;
  boat_props?: Maybe<BoatProps>;
  capacity?: Maybe<Scalars['Int']['output']>;
  cover_image: Scalars['URL']['output'];
  created_at: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  gear_props?: Maybe<GearProps>;
  id: Scalars['String']['output'];
  images?: Maybe<Array<Media>>;
  is_single_use?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  outfitter_id: Scalars['String']['output'];
  type: ResourceType;
  updated_at: Scalars['Timestamp']['output'];
  vehicle_props?: Maybe<VehicleProps>;
  year?: Maybe<Scalars['Int']['output']>;
};

export enum ResourceType {
  Atv = 'ATV',
  Blind = 'BLIND',
  Boat = 'BOAT',
  Gear = 'GEAR',
  Listing = 'LISTING',
  Lodging = 'LODGING',
  Vehicle = 'VEHICLE'
}

export type RetryPaymentInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  payment_method_id: Scalars['String']['input'];
};

export type Review = {
  __typename?: 'Review';
  content: Scalars['String']['output'];
  created_at: Scalars['Timestamp']['output'];
  group_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  is_public: Scalars['Boolean']['output'];
  owner?: Maybe<Scalars['ID']['output']>;
  owner_type: ReviewOwnerType;
  photos: Array<Media>;
  rating: Scalars['PositiveInt']['output'];
  reviewer: User;
  sub_owner?: Maybe<Scalars['ID']['output']>;
  sub_owner_type?: Maybe<ReviewOwnerType>;
  subject?: Maybe<Scalars['ID']['output']>;
  subject_type: ReviewSubjectType;
  updated_at: Scalars['Timestamp']['output'];
};

export type ReviewAggregation = {
  __typename?: 'ReviewAggregation';
  average_rating: Scalars['NonNegativeFloat']['output'];
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  is_for_sub_owner?: Maybe<Scalars['Boolean']['output']>;
  number_of_reviews: Scalars['NonNegativeInt']['output'];
  owner?: Maybe<Scalars['ID']['output']>;
  owner_type: ReviewOwnerType;
  reviews: Array<Review>;
  subject?: Maybe<Scalars['ID']['output']>;
  subject_type?: Maybe<ReviewSubjectType>;
  updated_at: Scalars['Timestamp']['output'];
};

export type ReviewForm = {
  __typename?: 'ReviewForm';
  id: Scalars['ID']['output'];
  main_subject_type: ReviewSubjectType;
  name: Scalars['String']['output'];
  owner_type: ReviewOwnerType;
  questions: Array<ReviewFormQuestion>;
  sub_owner_type?: Maybe<ReviewOwnerType>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ReviewFormAnswerInput = {
  answer: CreateReviewInput;
  question_id: Scalars['ID']['input'];
};

export type ReviewFormQuestion = {
  __typename?: 'ReviewFormQuestion';
  id: Scalars['ID']['output'];
  is_question_required: Scalars['Boolean']['output'];
  should_collect_content: Scalars['Boolean']['output'];
  should_collect_photos: Scalars['Boolean']['output'];
  subject_type: ReviewSubjectType;
  subtitle_for_content?: Maybe<Scalars['String']['output']>;
  subtitle_for_photos?: Maybe<Scalars['String']['output']>;
  subtitle_for_rating?: Maybe<Scalars['String']['output']>;
  title_for_content: Scalars['String']['output'];
  title_for_photos: Scalars['String']['output'];
  title_for_rating: Scalars['String']['output'];
};

export type ReviewFormQuestionInput = {
  is_question_required: Scalars['Boolean']['input'];
  should_collect_content: Scalars['Boolean']['input'];
  should_collect_photos: Scalars['Boolean']['input'];
  subject_type: ReviewSubjectType;
  subtitle_for_content?: InputMaybe<Scalars['String']['input']>;
  subtitle_for_photos?: InputMaybe<Scalars['String']['input']>;
  subtitle_for_rating?: InputMaybe<Scalars['String']['input']>;
  title_for_content: Scalars['String']['input'];
  title_for_photos: Scalars['String']['input'];
  title_for_rating: Scalars['String']['input'];
};

export enum ReviewOwnerType {
  Listing = 'LISTING',
  Outfitter = 'OUTFITTER'
}

export enum ReviewSubjectType {
  Booking = 'BOOKING',
  Communication = 'COMMUNICATION',
  Hunt = 'HUNT',
  Listing = 'LISTING',
  Lodging = 'LODGING',
  Outfitter = 'OUTFITTER',
  Value = 'VALUE'
}

export type ReviewsPerScore = {
  __typename?: 'ReviewsPerScore';
  five?: Maybe<Scalars['NonNegativeInt']['output']>;
  four?: Maybe<Scalars['NonNegativeInt']['output']>;
  one?: Maybe<Scalars['NonNegativeInt']['output']>;
  three?: Maybe<Scalars['NonNegativeInt']['output']>;
  two?: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type ReviewsPerScoreInput = {
  five?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  four?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  one?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  three?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  two?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type RichTextAiSuggestion = {
  __typename?: 'RichTextAiSuggestion';
  ai_agent: AiAgent;
  created_at: Scalars['Timestamp']['output'];
  has_been_applied: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  suggestion: Scalars['String']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type SearchListingsForSportsmenInput = {
  amenities?: InputMaybe<Array<Scalars['ID']['input']>>;
  country?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  hasAvailability?: InputMaybe<Scalars['Boolean']['input']>;
  hasIncludedLodging?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  maxGuest?: InputMaybe<Scalars['PositiveInt']['input']>;
  minGuest?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  priceMax?: InputMaybe<Scalars['PositiveInt']['input']>;
  priceMin?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  species?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type SearchOptions = {
  from?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  size?: InputMaybe<Scalars['PositiveInt']['input']>;
};

export type SearchOutfittersForSportsmenInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OutfitterStatus>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type SearchSpeciesInput = {
  text: Scalars['String']['input'];
};

export enum SelfOnboardingStepType {
  AddAvailability = 'ADD_AVAILABILITY',
  AddEditListings = 'ADD_EDIT_LISTINGS',
  AddEditLodging = 'ADD_EDIT_LODGING',
  AddOnsAndPackagesReview = 'ADD_ONS_AND_PACKAGES_REVIEW',
  Availability = 'AVAILABILITY',
  AvailabilityReview = 'AVAILABILITY_REVIEW',
  DepositSettings = 'DEPOSIT_SETTINGS',
  FinishedSetup = 'FINISHED_SETUP',
  GettingPaid = 'GETTING_PAID',
  GettingPaidStripe = 'GETTING_PAID_STRIPE',
  ListingsAndLodging = 'LISTINGS_AND_LODGING',
  ListingsAndLodgingReview = 'LISTINGS_AND_LODGING_REVIEW',
  OutfitterAdditionalInfo = 'OUTFITTER_ADDITIONAL_INFO',
  OutfitterAddOns = 'OUTFITTER_ADD_ONS',
  OutfitterCancellationPolicy = 'OUTFITTER_CANCELLATION_POLICY',
  OutfitterCheckInOut = 'OUTFITTER_CHECK_IN_OUT',
  OutfitterDescription = 'OUTFITTER_DESCRIPTION',
  OutfitterMedia = 'OUTFITTER_MEDIA',
  OutfitterName = 'OUTFITTER_NAME',
  OutfitterReview = 'OUTFITTER_REVIEW',
  OutfitterSetup = 'OUTFITTER_SETUP',
  PackagesAndAddOns = 'PACKAGES_AND_ADD_ONS',
  PaymentDetails = 'PAYMENT_DETAILS',
  PaymentSettingsReview = 'PAYMENT_SETTINGS_REVIEW',
  PricingPackages = 'PRICING_PACKAGES',
  StatementDescriptor = 'STATEMENT_DESCRIPTOR'
}

export type SlotPaymentPlan = {
  __typename?: 'SlotPaymentPlan';
  payment_plan: QuotePaymentPlan;
  slots: Scalars['PositiveInt']['output'];
  total: Scalars['NonNegativeInt']['output'];
  totals?: Maybe<Array<QuotePrice>>;
  trip_insurance?: Maybe<BookingQuoteTripInsuranceQuote>;
};

export type SlotShare = {
  __typename?: 'SlotShare';
  is_host: Scalars['Boolean']['output'];
  is_invitation_accepted: Scalars['Boolean']['output'];
  member: GroupPayMember;
  payments: Array<Payment>;
  slots: Scalars['NonNegativeInt']['output'];
  total: Scalars['Int']['output'];
  trip_insurance?: Maybe<BookingTripInsurance>;
};

export type Sort = {
  direction: SortDirection;
  field: Scalars['String']['input'];
};

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type Species = {
  __typename?: 'Species';
  category?: Maybe<SpeciesCategory>;
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Media>;
  is_archived: Scalars['Boolean']['output'];
  keywords?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  type: SpeciesType;
  updated_at: Scalars['Timestamp']['output'];
};

export type SpeciesCategory = {
  __typename?: 'SpeciesCategory';
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Media>;
  keywords?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  species?: Maybe<Array<Species>>;
  updated_at: Scalars['Timestamp']['output'];
};

export type SpeciesCategoryInput = {
  id: Scalars['ID']['input'];
  image?: InputMaybe<MediaInput>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
};

export enum SpeciesType {
  Fishing = 'FISHING',
  Hunting = 'HUNTING'
}

export type StatesAndCountries = {
  __typename?: 'StatesAndCountries';
  countries: Array<Scalars['String']['output']>;
  states: Array<Scalars['String']['output']>;
};

export type StripeAccountInfo = {
  __typename?: 'StripeAccountInfo';
  is_onboarded: Scalars['Boolean']['output'];
  login_link?: Maybe<Scalars['URL']['output']>;
  onboard_link?: Maybe<Scalars['URL']['output']>;
};

export type StripePaymentIntent = {
  __typename?: 'StripePaymentIntent';
  client_secret: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export enum StripeRefundReason {
  Duplicate = 'duplicate',
  Fraudulent = 'fraudulent',
  RequestedByCustomer = 'requested_by_customer'
}

export type StripeSetupIntent = {
  __typename?: 'StripeSetupIntent';
  client_secret: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type StripeTerminalInfo = {
  __typename?: 'StripeTerminalInfo';
  location_id: Scalars['String']['output'];
  payment_intent_id: Scalars['String']['output'];
};

export type SubItem = {
  __typename?: 'SubItem';
  details_label?: Maybe<Scalars['String']['output']>;
  details_value?: Maybe<Scalars['String']['output']>;
  display_value?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  total?: Maybe<Scalars['Int']['output']>;
};

export type SubmitReviewFormInput = {
  answers: Array<ReviewFormAnswerInput>;
  form_id: Scalars['ID']['input'];
  main_subject_id: Scalars['ID']['input'];
};

export enum SubscriptionTier {
  Elite = 'ELITE',
  Free = 'FREE',
  Legacy = 'LEGACY',
  Lite = 'LITE',
  Pro = 'PRO'
}

export type SyncedCalendar = {
  __typename?: 'SyncedCalendar';
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  is_archived: Scalars['Boolean']['output'];
  outfitter_id: Scalars['ID']['output'];
  resources: Array<MinimalResource>;
  should_remove_all_slots: Scalars['Boolean']['output'];
  slots_to_remove: Scalars['NonNegativeInt']['output'];
  source: Scalars['String']['output'];
  updated_at: Scalars['Timestamp']['output'];
  url: Scalars['String']['output'];
};

export type SyncedCalendarInput = {
  outfitter_id: Scalars['ID']['input'];
  resources: Array<MinimalResourceInput>;
  should_remove_all_slots: Scalars['Boolean']['input'];
  slots_to_remove: Scalars['NonNegativeInt']['input'];
  source: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type SyncedCalendarUpdateInput = {
  resources?: InputMaybe<Array<MinimalResourceInput>>;
  should_remove_all_slots?: InputMaybe<Scalars['Boolean']['input']>;
  slots_to_remove?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type SyncedCalendarsResults = {
  __typename?: 'SyncedCalendarsResults';
  count: Scalars['NonNegativeInt']['output'];
  data: Array<SyncedCalendar>;
  pages: Scalars['NonNegativeInt']['output'];
};

export type TeamMember = {
  __typename?: 'TeamMember';
  avatar?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['Timestamp']['output'];
  email: Scalars['EmailAddress']['output'];
  id: Scalars['ID']['output'];
  is_archived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  outfitter: Outfitter;
  role: TeamMemberRole;
  updated_at: Scalars['Timestamp']['output'];
  user?: Maybe<User>;
  years_of_experience?: Maybe<Scalars['NonNegativeInt']['output']>;
};

export enum TeamMemberRole {
  CoOwner = 'CO_OWNER',
  Guide = 'GUIDE',
  Owner = 'OWNER'
}

export type Transaction = {
  __typename?: 'Transaction';
  payment_processor_transaction_id: Scalars['ID']['output'];
  payment_processor_type: Scalars['String']['output'];
};

export type TripInsuranceCustomer = {
  __typename?: 'TripInsuranceCustomer';
  postal_code: Scalars['String']['output'];
};

export type TripInsuranceError = {
  __typename?: 'TripInsuranceError';
  date?: Maybe<Scalars['Timestamp']['output']>;
  message: Scalars['String']['output'];
};

export type TripInsurancePolicy = {
  __typename?: 'TripInsurancePolicy';
  policy_attributes?: Maybe<TripInsurancePolicyAttribute>;
  policy_holder?: Maybe<TripInsurancePolicyHolder>;
  policy_number: Scalars['String']['output'];
  policy_status: Scalars['String']['output'];
  premium_amount: Scalars['String']['output'];
  quote_id?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['PositiveInt']['output']>;
};

export type TripInsurancePolicyAttribute = {
  __typename?: 'TripInsurancePolicyAttribute';
  event_end_date: Scalars['Timestamp']['output'];
  event_start_date: Scalars['Timestamp']['output'];
  insurable_amount: Scalars['PositiveInt']['output'];
  insurable_amount_currency: Scalars['String']['output'];
};

export type TripInsurancePolicyHolder = {
  __typename?: 'TripInsurancePolicyHolder';
  email_address?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
};

export type TripInsurancePolicyInput = {
  booking_id: Scalars['String']['input'];
  quote_id: Scalars['String']['input'];
  zip_code: Scalars['String']['input'];
};

export type TripInsuranceProduct = {
  __typename?: 'TripInsuranceProduct';
  accept_action_text?: Maybe<Scalars['String']['output']>;
  additional_policy_purchase_email_message?: Maybe<Scalars['String']['output']>;
  carrier_logo_url?: Maybe<Scalars['String']['output']>;
  decline_action_text?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  descriptors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  legal_disclaimer?: Maybe<Scalars['String']['output']>;
  peril_heading?: Maybe<Scalars['String']['output']>;
  perils?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  privacy_policy_url?: Maybe<Scalars['String']['output']>;
  promotional_description?: Maybe<Scalars['String']['output']>;
  promotional_header?: Maybe<Scalars['String']['output']>;
  terms_conditions_url?: Maybe<Scalars['String']['output']>;
};

export type TripInsuranceQuote = TripInsuranceQuoteInterface & {
  __typename?: 'TripInsuranceQuote';
  policy_attributes?: Maybe<TripInsurancePolicyAttribute>;
  product: TripInsuranceProduct;
  quote_id: Scalars['String']['output'];
  taxes_and_fees?: Maybe<Array<TripInsuranceTaxesAndFees>>;
  total: Scalars['PositiveInt']['output'];
};

export type TripInsuranceQuoteInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  event_end_date: Scalars['Timestamp']['input'];
  event_start_date: Scalars['Timestamp']['input'];
  insurable_amount: Scalars['PositiveInt']['input'];
  quote_id?: InputMaybe<Scalars['String']['input']>;
  zip_code: Scalars['String']['input'];
};

export type TripInsuranceQuoteInterface = {
  policy_attributes?: Maybe<TripInsurancePolicyAttribute>;
  product: TripInsuranceProduct;
  quote_id: Scalars['String']['output'];
  taxes_and_fees?: Maybe<Array<TripInsuranceTaxesAndFees>>;
  total: Scalars['PositiveInt']['output'];
};

export type TripInsuranceTaxesAndFees = {
  __typename?: 'TripInsuranceTaxesAndFees';
  amount: Scalars['PositiveInt']['output'];
  description: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type TripItinerary = {
  __typename?: 'TripItinerary';
  items: Array<TripItineraryItem>;
  label?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TripItineraryItem = {
  __typename?: 'TripItineraryItem';
  helper_text?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  timestamp: Scalars['Timestamp']['output'];
  title: Scalars['String']['output'];
  type: TripItineraryItemType;
};

export enum TripItineraryItemType {
  CheckIn = 'CHECK_IN',
  CheckOut = 'CHECK_OUT',
  End = 'END',
  Start = 'START'
}

export type UpdateAddOnInput = {
  apply_to_all_listings?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  category_id?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  deposit_amount?: InputMaybe<Scalars['Float']['input']>;
  deposit_percentage?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  is_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_hidden_from_outfitters?: InputMaybe<Scalars['Boolean']['input']>;
  is_hidden_from_sportsmen?: InputMaybe<Scalars['Boolean']['input']>;
  listings?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  offer_period?: InputMaybe<AddOnOfferPeriod>;
  price_by_day?: InputMaybe<PriceByDay>;
  price_by_guest?: InputMaybe<PriceByGuest>;
  species?: InputMaybe<Scalars['ID']['input']>;
  stripe_product_id?: InputMaybe<Scalars['String']['input']>;
  unit_price?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateAddOnOptionInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  deposit_amount?: InputMaybe<Scalars['Float']['input']>;
  deposit_percentage?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  stripe_product_id?: InputMaybe<Scalars['String']['input']>;
  unit_price: Scalars['Float']['input'];
};

export type UpdateAmenityInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon_url?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBookingDatesGuestsAndAddonsInput = {
  dates: Array<Scalars['NonNegativeInt']['input']>;
  groupPayHost?: InputMaybe<UpdateBookingGroupPayMemberInput>;
  groupPayMembers?: InputMaybe<Array<UpdateBookingGroupPayMemberInput>>;
  numberOfGuests: Scalars['NonNegativeInt']['input'];
};

export type UpdateBookingGroupPayMemberInput = {
  id: Scalars['ID']['input'];
  slots: Scalars['NonNegativeInt']['input'];
};

export type UpdateBookingInput = {
  attribution?: InputMaybe<AttributionInput>;
  check_in_time?: InputMaybe<Scalars['Timestamp']['input']>;
  check_out_time?: InputMaybe<Scalars['Timestamp']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  dates?: InputMaybe<Array<Scalars['NonNegativeInt']['input']>>;
  /** @deprecated end_date is now inferred from dates */
  end_date?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  guides?: InputMaybe<Array<Scalars['ID']['input']>>;
  items?: InputMaybe<Array<QuoteItemInput>>;
  message_to_outfitter?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  service_fee?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated start_date is now inferred from dates */
  start_date?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  state_tax?: InputMaybe<Scalars['Float']['input']>;
  sub_total?: InputMaybe<Scalars['Float']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateBookingInviteInput = {
  /** @deprecated Use packages instead */
  add_ons?: InputMaybe<Array<QuoteAddOnInput>>;
  coupon?: InputMaybe<Scalars['ID']['input']>;
  dates?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  editable_fields?: InputMaybe<BookingInviteEditableFieldsInput>;
  invoice_note?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  packages?: InputMaybe<Array<BookingInvitePackageInput>>;
  /** @deprecated Use packages instead */
  pricing_package?: InputMaybe<Scalars['ID']['input']>;
  should_allow_external_payment?: InputMaybe<Scalars['Boolean']['input']>;
  sportsman_email?: InputMaybe<Scalars['String']['input']>;
  sportsman_name?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use packages instead */
  total_guests?: InputMaybe<Scalars['PositiveInt']['input']>;
};

export type UpdateCalendarEventInput = {
  no_side_effects_properties?: InputMaybe<UpdateCalendarEventNoSideEffectsPropertiesInput>;
  side_effects_properties?: InputMaybe<UpdateCalendarEventSideEffectsPropertiesInput>;
};

export type UpdateCalendarEventNoSideEffectsPropertiesInput = {
  base_color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCalendarEventSideEffectsPropertiesInput = {
  end_date?: InputMaybe<Scalars['Timestamp']['input']>;
  is_single_use_resources?: InputMaybe<Scalars['Boolean']['input']>;
  number_of_guests?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  start_date?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type UpdateCalendarSubscriptionInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  resources?: InputMaybe<Array<MinimalResourceInput>>;
};

export type UpdateGroupPayInput = {
  members?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGroupPayMemberInput = {
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
};

export type UpdateLeadInput = {
  disqualification?: InputMaybe<DisqualificationInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  quality?: InputMaybe<LeadQuality>;
  referral_source?: InputMaybe<ReferralSource>;
  schedule_new_lead_at?: InputMaybe<Scalars['Timestamp']['input']>;
  status?: InputMaybe<LeadStatus>;
};

export type UpdateLicenseInfoInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  fishing_info_url?: InputMaybe<Scalars['String']['input']>;
  general_info_url?: InputMaybe<Scalars['String']['input']>;
  hunting_info_url?: InputMaybe<Scalars['String']['input']>;
  online_portal_url?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateListingInput = {
  admin_note?: InputMaybe<Scalars['String']['input']>;
  amenities?: InputMaybe<Array<Scalars['ID']['input']>>;
  booking_instructions?: InputMaybe<Scalars['String']['input']>;
  check_in_config?: InputMaybe<CheckInConfigInput>;
  check_in_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  check_out_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  deposit_percentage?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<ListingDuration>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  guides?: InputMaybe<Array<Scalars['ID']['input']>>;
  is_hidden_from_marketplace?: InputMaybe<Scalars['Boolean']['input']>;
  license_info?: InputMaybe<Scalars['ID']['input']>;
  license_required?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<AddressInput>;
  lodging?: InputMaybe<Scalars['ID']['input']>;
  max_guest?: InputMaybe<Scalars['PositiveInt']['input']>;
  min_guest?: InputMaybe<Scalars['PositiveInt']['input']>;
  order?: InputMaybe<Scalars['PositiveInt']['input']>;
  photos?: InputMaybe<Array<MediaInput>>;
  pricing?: InputMaybe<PricingInput>;
  pricing_packages?: InputMaybe<Array<Scalars['ID']['input']>>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  rule?: InputMaybe<Scalars['String']['input']>;
  should_allow_quote_requests?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<Array<Scalars['ID']['input']>>;
  time_of_day?: InputMaybe<ListingTimeOfDay>;
  time_zone?: InputMaybe<Scalars['TimeZone']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ListingType>;
};

export type UpdateListingNoteInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type UpdateListingRatesInput = {
  booking_fee_fixed?: InputMaybe<Scalars['Float']['input']>;
  booking_fee_rate?: InputMaybe<Scalars['Float']['input']>;
  tax_rate?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateLodgingInput = {
  /** @deprecated Beds have been replaced by capacity */
  beds?: InputMaybe<Array<LodgingBedInput>>;
  capacity?: InputMaybe<Scalars['PositiveInt']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<MediaInput>>;
  is_single_use?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<AddressInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<LodgingType>;
};

export type UpdateNoteInput = {
  content: Scalars['String']['input'];
};

export type UpdateOnboardingInput = {
  add_ons: Array<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  outfitter_name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  products: Array<Scalars['String']['input']>;
  promo_codes: Array<Scalars['String']['input']>;
  should_send_pay_link?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOutfitterDocumentInput = {
  document?: InputMaybe<MediaInput>;
  external_url?: InputMaybe<Scalars['String']['input']>;
  listing_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricing_package_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<OutfitterDocumentType>;
};

export type UpdateOutfitterFeesAsOutfitterOwnerInput = {
  is_processing_fee_payed_by_sportsman?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOutfitterFeesInput = {
  booking_fee_fixed?: InputMaybe<Scalars['Float']['input']>;
  booking_fee_rate?: InputMaybe<Scalars['Float']['input']>;
  is_processing_fee_payed_by_sportsman?: InputMaybe<Scalars['Boolean']['input']>;
  max_booking_fee?: InputMaybe<Scalars['Float']['input']>;
  outfitter_fee_fixed?: InputMaybe<Scalars['Float']['input']>;
  outfitter_fee_rate?: InputMaybe<Scalars['Float']['input']>;
  processing_fee_ach_fixed?: InputMaybe<Scalars['Float']['input']>;
  processing_fee_ach_max?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  processing_fee_ach_rate?: InputMaybe<Scalars['Float']['input']>;
  processing_fee_fixed?: InputMaybe<Scalars['Float']['input']>;
  processing_fee_rate?: InputMaybe<Scalars['Float']['input']>;
  tax_rate?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOutfitterInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  admin_note?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<MediaInput>;
  cancellation_policy?: InputMaybe<OutfitterCancellationPolicyInput>;
  check_in_config?: InputMaybe<CheckInConfigInput>;
  contacts?: InputMaybe<Array<OutfitterContactInput>>;
  currency?: InputMaybe<Scalars['String']['input']>;
  default_check_in_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  default_check_out_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  gmb_id?: InputMaybe<Scalars['String']['input']>;
  hubspot_company_id?: InputMaybe<Scalars['String']['input']>;
  is_guide_tech?: InputMaybe<Scalars['Boolean']['input']>;
  is_hidden_from_marketplace?: InputMaybe<Scalars['Boolean']['input']>;
  land_size?: InputMaybe<Scalars['PositiveInt']['input']>;
  licensed?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<AddressInput>;
  lodging_instructions?: InputMaybe<Scalars['String']['input']>;
  lodging_rules?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  other_info?: InputMaybe<OutfitterOtherInfoInput>;
  photos?: InputMaybe<Array<MediaInput>>;
  primary_contact_email?: InputMaybe<Scalars['EmailAddress']['input']>;
  referral_fee_fixed?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  referral_fee_rate?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  status?: InputMaybe<OutfitterStatus>;
  tax_rate?: InputMaybe<Scalars['Float']['input']>;
  time_zone?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  video?: InputMaybe<VideoInput>;
  website?: InputMaybe<Scalars['String']['input']>;
  years_in_operation?: InputMaybe<Scalars['PositiveInt']['input']>;
};

export type UpdateOutfitterSubscriptionInput = {
  add_ons: Array<Scalars['String']['input']>;
  outfitter_id: Scalars['String']['input'];
  products: Array<Scalars['String']['input']>;
  promo_codes: Array<Scalars['String']['input']>;
};

export type UpdatePackageOnQuoteInput = {
  add_ons?: InputMaybe<Array<QuoteAddOnInput>>;
  number_of_guests: Scalars['PositiveInt']['input'];
};

export type UpdatePaymentInput = {
  customer?: InputMaybe<PaymentCustomerInput>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePostInput = {
  attachments?: InputMaybe<Array<AttachmentInput>>;
  content?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePricingPackageInput = {
  check_in_config?: InputMaybe<CheckInConfigInput>;
  days_included?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  gear_rentals?: InputMaybe<Array<Scalars['ID']['input']>>;
  guests_included?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  included_lodging_id?: InputMaybe<Scalars['ID']['input']>;
  included_resource_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_hidden_from_outfitters?: InputMaybe<Scalars['Boolean']['input']>;
  is_hidden_from_sportsmen?: InputMaybe<Scalars['Boolean']['input']>;
  is_lodging_only?: InputMaybe<Scalars['Boolean']['input']>;
  lodging_included?: InputMaybe<Scalars['Boolean']['input']>;
  max_guests?: InputMaybe<Scalars['PositiveInt']['input']>;
  meal_upgrades?: InputMaybe<Array<Scalars['ID']['input']>>;
  min_guests?: InputMaybe<Scalars['PositiveInt']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  other_add_ons?: InputMaybe<Array<Scalars['ID']['input']>>;
  price?: InputMaybe<Scalars['Float']['input']>;
  price_by_day?: InputMaybe<PriceByDay>;
  price_by_guest?: InputMaybe<PriceByGuest>;
  trophies?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateResourceInput = {
  atv_props?: InputMaybe<AtvInput>;
  blind_props?: InputMaybe<BlindInput>;
  boat_props?: InputMaybe<BoatInput>;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  gear_props?: InputMaybe<GearInput>;
  images?: InputMaybe<Array<MediaInput>>;
  is_single_use?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  vehicle_props?: InputMaybe<VehicleInput>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateReviewFormInput = {
  main_subject_type?: InputMaybe<ReviewSubjectType>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner_type?: InputMaybe<ReviewOwnerType>;
  questions?: InputMaybe<Array<ReviewFormQuestionInput>>;
  sub_owner_type?: InputMaybe<ReviewOwnerType>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSpeciesCategoryInput = {
  image?: InputMaybe<MediaInput>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSpeciesInput = {
  category?: InputMaybe<SpeciesCategoryInput>;
  image?: InputMaybe<MediaInput>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SpeciesType>;
};

export type UpdateTeamMemberInput = {
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<TeamMemberRole>;
};

export type UpdateTransactionInput = {
  payment_processor_transaction_id?: InputMaybe<Scalars['ID']['input']>;
  payment_processor_type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  date_of_birth?: InputMaybe<Scalars['PositiveInt']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  favorite_game?: InputMaybe<Array<Scalars['String']['input']>>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
  socials?: InputMaybe<UserSocialsInput>;
  stripe_connected_account_id?: InputMaybe<Scalars['String']['input']>;
  stripe_user_id?: InputMaybe<Scalars['String']['input']>;
  years_of_experience?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type UpdateWidgetInput = {
  button_color?: InputMaybe<Scalars['String']['input']>;
  button_text?: InputMaybe<Scalars['String']['input']>;
  google_analytics_id?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_external?: InputMaybe<Scalars['Boolean']['input']>;
  listing_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  pixel_id?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  text_color?: InputMaybe<Scalars['String']['input']>;
  trigger_type?: InputMaybe<WidgetTriggerType>;
  widget_name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWishlistInput = {
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  listings?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertOutfitterIntegrationSettingsInput = {
  quick_books?: InputMaybe<UpsertQuickBooksSettingsInput>;
};

export type UpsertPaymentFeeSettingsInput = {
  dashboard_rate: Scalars['NonNegativeFloat']['input'];
  entity_id: Scalars['ID']['input'];
  entity_type: PaymentFeeSettingsEntityType;
  id?: InputMaybe<Scalars['ID']['input']>;
  marketplace_quote_rate: Scalars['NonNegativeFloat']['input'];
  standard_quote_rate: Scalars['NonNegativeFloat']['input'];
  website_rate: Scalars['NonNegativeFloat']['input'];
  widget_rate: Scalars['NonNegativeFloat']['input'];
};

export type UpsertPaymentSettingsInput = {
  allow_deposit?: InputMaybe<Scalars['Boolean']['input']>;
  amount_deposit?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Use day_balance_due_config instead */
  date_before_trip_balance_due?: InputMaybe<Scalars['Timestamp']['input']>;
  day_balance_due_config?: InputMaybe<DayBalanceDueConfigInput>;
  days_before_trip_balance_due?: InputMaybe<Scalars['Int']['input']>;
  days_out_for_deposit_plan?: InputMaybe<Scalars['Int']['input']>;
  entity_id: Scalars['ID']['input'];
  entity_type: PaymentSettingsEntityType;
  id?: InputMaybe<Scalars['ID']['input']>;
  is_deposit_per_day?: InputMaybe<Scalars['Boolean']['input']>;
  is_deposit_per_guest?: InputMaybe<Scalars['Boolean']['input']>;
  percent_deposit?: InputMaybe<Scalars['Int']['input']>;
  should_charge_last_day_of_trip?: InputMaybe<Scalars['Boolean']['input']>;
  statement_descriptor?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertQuickBooksSettingsInput = {
  default_product_service_id?: InputMaybe<Scalars['String']['input']>;
  deposit_account_id?: InputMaybe<Scalars['String']['input']>;
  invoice_date?: InputMaybe<QuickBooksInvoiceDateSetting>;
};

/** A type that describes a user */
export type User = {
  __typename?: 'User';
  avatar_url?: Maybe<Scalars['URL']['output']>;
  bio: Scalars['String']['output'];
  bookings: Array<Booking>;
  created_at: Scalars['Timestamp']['output'];
  date_of_birth?: Maybe<Scalars['Timestamp']['output']>;
  email: Scalars['EmailAddress']['output'];
  favorite_game: Array<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  impersonation_details?: Maybe<ImpersonationDetails>;
  is_admin?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_developer?: Maybe<Scalars['Boolean']['output']>;
  is_guest?: Maybe<Scalars['Boolean']['output']>;
  is_guest_conversion_disabled?: Maybe<Scalars['Boolean']['output']>;
  is_owner?: Maybe<Scalars['Boolean']['output']>;
  is_team_member?: Maybe<Scalars['Boolean']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  location: Scalars['String']['output'];
  phone?: Maybe<Scalars['PhoneNumber']['output']>;
  settings?: Maybe<UserSetting>;
  socials?: Maybe<UserSocials>;
  stripe_connected_account_id?: Maybe<Scalars['String']['output']>;
  stripe_user_id?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Timestamp']['output'];
  years_of_experience?: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type UserMetadata = {
  __typename?: 'UserMetadata';
  email?: Maybe<Scalars['String']['output']>;
  email_verified?: Maybe<Scalars['Boolean']['output']>;
  family_name?: Maybe<Scalars['String']['output']>;
  given_name?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  phone_verified?: Maybe<Scalars['Boolean']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
};

export type UserSetting = {
  __typename?: 'UserSetting';
  push_notifications?: Maybe<Scalars['Boolean']['output']>;
  theme: Scalars['String']['output'];
};

export type UserSocials = {
  __typename?: 'UserSocials';
  facebook: Scalars['String']['output'];
  instagram: Scalars['String']['output'];
  twitter: Scalars['String']['output'];
};

export type UserSocialsInput = {
  facebook?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
};

export type UserTrackingData = {
  __typename?: 'UserTrackingData';
  props: Array<UserTrackingProp>;
};

export type UserTrackingProp = {
  __typename?: 'UserTrackingProp';
  boolean_value?: Maybe<Scalars['Boolean']['output']>;
  number_value?: Maybe<Scalars['Int']['output']>;
  prop: Scalars['String']['output'];
  string_value?: Maybe<Scalars['String']['output']>;
  value_prop_name: Scalars['String']['output'];
};

export type UsersSearchResults = {
  __typename?: 'UsersSearchResults';
  pages: Scalars['NonNegativeInt']['output'];
  results: Array<User>;
  total: Scalars['NonNegativeInt']['output'];
};

export type ValueChange = {
  __typename?: 'ValueChange';
  label: Scalars['String']['output'];
  new_value: Scalars['String']['output'];
  previous_value: Scalars['String']['output'];
};

export enum VehicleCategory {
  Coupe = 'COUPE',
  Jeep = 'JEEP',
  Minivan = 'MINIVAN',
  Sedan = 'SEDAN',
  SideBySide = 'SIDE_BY_SIDE',
  Suv = 'SUV',
  Truck = 'TRUCK'
}

export type VehicleInput = {
  category: VehicleCategory;
  make?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
};

export type VehicleProps = {
  __typename?: 'VehicleProps';
  category: VehicleCategory;
  make?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
};

export type Video = {
  __typename?: 'Video';
  hosted?: Maybe<Media>;
  social?: Maybe<Media>;
};

export type VideoInput = {
  hosted?: InputMaybe<MediaInput>;
  social?: InputMaybe<MediaInput>;
};

/** A type that describes a widget */
export type Widget = {
  __typename?: 'Widget';
  button_color?: Maybe<Scalars['String']['output']>;
  button_text?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['Timestamp']['output'];
  google_analytics_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_external: Scalars['Boolean']['output'];
  listing_ids?: Maybe<Array<Scalars['ID']['output']>>;
  outfitter: Outfitter;
  pixel_id?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  text_color?: Maybe<Scalars['String']['output']>;
  trigger_type: WidgetTriggerType;
  updated_at: Scalars['Timestamp']['output'];
  widget_name: Scalars['String']['output'];
};

export enum WidgetTriggerType {
  Button = 'BUTTON',
  Inline = 'INLINE',
  Modal = 'MODAL',
  Tab = 'TAB'
}

/** A type that describes a wishlist */
export type Wishlist = {
  __typename?: 'Wishlist';
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  isPrivate: Scalars['Boolean']['output'];
  listings: Array<Listing>;
  name: Scalars['String']['output'];
  updated_at: Scalars['Timestamp']['output'];
  user: User;
};

export type AddOnFormFieldsFragment = { __typename?: 'AddOn', id: string, name: string, listings: Array<string>, category: string, unit_price: number, deposit_amount?: number | null, deposit_percentage?: number | null, offer_period: AddOnOfferPeriod, is_enabled: boolean, created_at: number, updated_at: number, description?: string | null, images?: Array<string> | null, price_by_day?: PriceByDay | null, price_by_guest?: PriceByGuest | null, species?: { __typename?: 'Species', id: string, type: SpeciesType, name: string } | null };

export type BookingAddOnFieldsFragment = { __typename?: 'QuoteAddOn', id: string, name: string, category: string, note?: string | null, unit_price: number, deposit_amount?: number | null, deposit_percentage?: number | null, offer_period: AddOnOfferPeriod, quantity: number, package_id?: string | null };

export type GetExtraAddOnsForListingAndPricingPackageQueryVariables = Exact<{
  listingId: Scalars['ID']['input'];
  pricingPackageId: Scalars['ID']['input'];
}>;


export type GetExtraAddOnsForListingAndPricingPackageQuery = { __typename?: 'Query', getExtraAddOnsForListingAndPricingPackage: Array<{ __typename?: 'AddOn', id: string, name: string, listings: Array<string>, category: string, unit_price: number, deposit_amount?: number | null, deposit_percentage?: number | null, offer_period: AddOnOfferPeriod, is_enabled: boolean, created_at: number, updated_at: number, description?: string | null, images?: Array<string> | null, price_by_day?: PriceByDay | null, price_by_guest?: PriceByGuest | null, species?: { __typename?: 'Species', id: string, type: SpeciesType, name: string } | null }> };

export type AddressFieldsFragment = { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string };

export type CityAndStateFieldsFragment = { __typename?: 'Address', city: string, state: string };

export type AmenityFieldsFragment = { __typename?: 'Amenity', id: string, name: string, description: string, category: AmenityCategory, icon_url: string };

export type AllAmenitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllAmenitiesQuery = { __typename?: 'Query', allAmenities: Array<{ __typename?: 'Amenity', id: string, name: string, description: string, category: AmenityCategory, icon_url: string }> };

export type CanConvertGuestToUserQueryVariables = Exact<{
  code?: InputMaybe<Scalars['String']['input']>;
}>;


export type CanConvertGuestToUserQuery = { __typename?: 'Query', canConvertGuestToUser: boolean };

export type LogInAsGuestUserMutationVariables = Exact<{
  data: GuestUserInput;
}>;


export type LogInAsGuestUserMutation = { __typename?: 'Mutation', logInAsGuestUser: string };

export type ConvertGuestToUserMutationVariables = Exact<{
  password: Scalars['String']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
}>;


export type ConvertGuestToUserMutation = { __typename?: 'Mutation', convertGuestToUser?: any | null };

export type GenericAvailabilityFieldsFragment = { __typename?: 'GenericAvailabilityEntry', id: string, resource_type: string, resource_id: string, date: number, is_available: boolean, total_slots: number, booked_slots: number, available_slots: number, created_at: number, updated_at: number };

export type AvailabilityQueryVariables = Exact<{
  data: GetGenericAvailabilityInput;
}>;


export type AvailabilityQuery = { __typename?: 'Query', availability: Array<{ __typename?: 'GenericAvailabilityEntry', id: string, resource_type: string, resource_id: string, date: number, is_available: boolean, total_slots: number, booked_slots: number, available_slots: number, created_at: number, updated_at: number }> };

export type BookingInviteFieldsFragment = { __typename?: 'BookingInvite', id: string, is_active: boolean, dates?: Array<number> | null, booked_redirect_url?: string | null, created_at: number, updated_at: number, listing: { __typename?: 'Listing', id: string, title?: string | null, type?: ListingType | null }, outfitter: { __typename?: 'Outfitter', id: string, name: string }, editable_fields: { __typename?: 'BookingInviteEditableFields', dates: boolean, pricing_package: boolean, total_guests: boolean, add_ons: boolean, coupon: boolean }, packages: Array<{ __typename?: 'BookingInvitePackage', id: string, total_guests?: number | null, pricing_package?: { __typename?: 'PricingPackage', id: string, name: string, price: number, price_by_guest: PriceByGuest, price_by_day: PriceByDay, guests_included: number, min_guests?: number | null, max_guests?: number | null, days_included: number, lodging_included: boolean, included_lodging_id?: string | null, is_active: boolean, is_available?: boolean | null, not_available_reason?: string | null, included_resource_ids?: Array<string | null> | null, trophies: Array<{ __typename?: 'AddOn', id: string, name: string, category: string, species?: { __typename?: 'Species', id: string, type: SpeciesType, name: string } | null }>, gear_rentals: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, meal_upgrades: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, other_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, included_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, listing: { __typename?: 'Listing', id: string } } | null, add_ons?: Array<{ __typename?: 'QuoteAddOn', id: string, name: string, category: string, note?: string | null, unit_price: number, deposit_amount?: number | null, deposit_percentage?: number | null, offer_period: AddOnOfferPeriod, quantity: number, package_id?: string | null }> | null, editable_fields: { __typename?: 'BookingInviteEditableFields', dates: boolean, pricing_package: boolean, total_guests: boolean, add_ons: boolean, coupon: boolean } }>, coupon?: { __typename?: 'Coupon', id: string, name?: string | null, percent_off?: number | null, amount_off?: number | null, currency?: string | null, duration: CouponDuration, duration_in_months?: number | null, max_redemptions?: number | null, redeem_by?: number | null, created_at: number, updated_at: number, outfitter?: { __typename?: 'Outfitter', id: string, name: string, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null } | null } | null, itinerary?: { __typename?: 'TripItinerary', title?: string | null, label?: string | null, items: Array<{ __typename?: 'TripItineraryItem', title: string, label: string, helper_text?: string | null, timestamp: number, type: TripItineraryItemType }> } | null };

export type BookingInviteEditableFieldsFragment = { __typename?: 'BookingInviteEditableFields', dates: boolean, pricing_package: boolean, total_guests: boolean, add_ons: boolean, coupon: boolean };

export type BookingInvitePackageFieldsFragment = { __typename?: 'BookingInvitePackage', id: string, total_guests?: number | null, pricing_package?: { __typename?: 'PricingPackage', id: string, name: string, price: number, price_by_guest: PriceByGuest, price_by_day: PriceByDay, guests_included: number, min_guests?: number | null, max_guests?: number | null, days_included: number, lodging_included: boolean, included_lodging_id?: string | null, is_active: boolean, is_available?: boolean | null, not_available_reason?: string | null, included_resource_ids?: Array<string | null> | null, trophies: Array<{ __typename?: 'AddOn', id: string, name: string, category: string, species?: { __typename?: 'Species', id: string, type: SpeciesType, name: string } | null }>, gear_rentals: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, meal_upgrades: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, other_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, included_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, listing: { __typename?: 'Listing', id: string } } | null, add_ons?: Array<{ __typename?: 'QuoteAddOn', id: string, name: string, category: string, note?: string | null, unit_price: number, deposit_amount?: number | null, deposit_percentage?: number | null, offer_period: AddOnOfferPeriod, quantity: number, package_id?: string | null }> | null, editable_fields: { __typename?: 'BookingInviteEditableFields', dates: boolean, pricing_package: boolean, total_guests: boolean, add_ons: boolean, coupon: boolean } };

export type BookingInviteQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type BookingInviteQuery = { __typename?: 'Query', bookingInvite: { __typename?: 'BookingInvite', id: string, is_active: boolean, dates?: Array<number> | null, booked_redirect_url?: string | null, created_at: number, updated_at: number, listing: { __typename?: 'Listing', id: string, title?: string | null, type?: ListingType | null }, outfitter: { __typename?: 'Outfitter', id: string, name: string }, editable_fields: { __typename?: 'BookingInviteEditableFields', dates: boolean, pricing_package: boolean, total_guests: boolean, add_ons: boolean, coupon: boolean }, packages: Array<{ __typename?: 'BookingInvitePackage', id: string, total_guests?: number | null, pricing_package?: { __typename?: 'PricingPackage', id: string, name: string, price: number, price_by_guest: PriceByGuest, price_by_day: PriceByDay, guests_included: number, min_guests?: number | null, max_guests?: number | null, days_included: number, lodging_included: boolean, included_lodging_id?: string | null, is_active: boolean, is_available?: boolean | null, not_available_reason?: string | null, included_resource_ids?: Array<string | null> | null, trophies: Array<{ __typename?: 'AddOn', id: string, name: string, category: string, species?: { __typename?: 'Species', id: string, type: SpeciesType, name: string } | null }>, gear_rentals: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, meal_upgrades: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, other_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, included_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, listing: { __typename?: 'Listing', id: string } } | null, add_ons?: Array<{ __typename?: 'QuoteAddOn', id: string, name: string, category: string, note?: string | null, unit_price: number, deposit_amount?: number | null, deposit_percentage?: number | null, offer_period: AddOnOfferPeriod, quantity: number, package_id?: string | null }> | null, editable_fields: { __typename?: 'BookingInviteEditableFields', dates: boolean, pricing_package: boolean, total_guests: boolean, add_ons: boolean, coupon: boolean } }>, coupon?: { __typename?: 'Coupon', id: string, name?: string | null, percent_off?: number | null, amount_off?: number | null, currency?: string | null, duration: CouponDuration, duration_in_months?: number | null, max_redemptions?: number | null, redeem_by?: number | null, created_at: number, updated_at: number, outfitter?: { __typename?: 'Outfitter', id: string, name: string, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null } | null } | null, itinerary?: { __typename?: 'TripItinerary', title?: string | null, label?: string | null, items: Array<{ __typename?: 'TripItineraryItem', title: string, label: string, helper_text?: string | null, timestamp: number, type: TripItineraryItemType }> } | null } };

export type BookingFieldsFragment = { __typename?: 'Booking', id: string, dates: Array<number>, start_date: number, end_date: number, status: BookingStatus, sub_total: number, service_fee: number, state_tax: number, total: number, notes?: string | null, discount?: number | null, check_in_time: number, check_out_time: number, should_allow_external_payment?: boolean | null, created_at: number, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, is_guest_conversion_disabled?: boolean | null }, listing: { __typename?: 'Listing', time_zone?: string | null, id: string, type?: ListingType | null, title?: string | null, description?: string | null, published?: boolean | null, license_required?: boolean | null, cover_image?: string | null, species: Array<{ __typename?: 'Species', id: string, type: SpeciesType, name: string, image?: { __typename?: 'Media', url: string, description?: string | null } | null }>, lodging?: { __typename?: 'Lodging', id: string } | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null, lowest_pricing_package?: { __typename?: 'PricingPackage', name: string, price: number } | null }, outfitter: { __typename?: 'Outfitter', id: string, slug: string, name: string, status: OutfitterStatus, time_zone?: string | null, avatar?: { __typename?: 'Media', url: string, description?: string | null } | null, owner: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email: string, phone?: string | null, bio: string, location: string, avatar_url?: string | null, favorite_game: Array<string>, years_of_experience?: number | null, is_admin?: boolean | null, is_team_member?: boolean | null, created_at: number, updated_at: number, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null, impersonation_details?: { __typename?: 'ImpersonationDetails', is_impersonated: boolean } | null }, cancellation_policy: { __typename?: 'OutfitterCancellationPolicy', policy_id: string, description: string } }, payments: Array<{ __typename?: 'Payment', id: string, date: number, value: number, status: PaymentStatus, is_payment_method_unverified?: boolean | null, errors: Array<{ __typename?: 'PaymentError', code?: string | null, message: string }>, refunds: Array<{ __typename?: 'Refund', id: string, amount: number, payment_id: string, status: RefundStatus, approved_by_name: string, user_reason: string, stripe_reason?: StripeRefundReason | null, created_at: number, cancelled_at?: number | null, error?: { __typename?: 'PaymentError', message: string } | null, created_by: { __typename?: 'User', first_name?: string | null, last_name?: string | null }, cancelled_by?: { __typename?: 'User', first_name?: string | null, last_name?: string | null } | null }> }>, paymentRequests: Array<{ __typename?: 'PaymentRequest', id: string, value: number, status: PaymentRequestStatus, paid_offline?: boolean | null, created_at: number, errors: Array<{ __typename?: 'PaymentError', code?: string | null, message: string }>, add_ons?: Array<{ __typename?: 'PaymentRequestAddOn', id: string, total: number, quantity: number, number_of_days?: number | null, number_of_guests?: number | null }> | null, items: Array<{ __typename?: 'PaymentItemRequest', amount: number, description: string, add_on_id?: string | null }> }>, coupon?: { __typename?: 'Coupon', id: string, custom_code: string, amount_off?: number | null, percent_off?: number | null } | null, items: Array<{ __typename?: 'QuoteItem', name: string, option_id: string, rate: number, quantity: number, price: number }>, group_pay_share?: { __typename?: 'GroupPayShare', id: string, remaining_slots?: number | null, last_payment_due_date?: number | null, join_url?: string | null, shares: Array<{ __typename?: 'SlotShare', slots: number, total: number, is_invitation_accepted: boolean, is_host: boolean, member: { __typename?: 'GroupPayMember', id: string, name: string, email: string }, payments: Array<{ __typename?: 'Payment', id: string, date: number, value: number, status: PaymentStatus, errors: Array<{ __typename?: 'PaymentError', code?: string | null, message: string }>, refunds: Array<{ __typename?: 'Refund', id: string, amount: number, payment_id: string, status: RefundStatus, approved_by_name: string, user_reason: string, stripe_reason?: StripeRefundReason | null, created_at: number, cancelled_at?: number | null, error?: { __typename?: 'PaymentError', message: string } | null, created_by: { __typename?: 'User', first_name?: string | null, last_name?: string | null }, cancelled_by?: { __typename?: 'User', first_name?: string | null, last_name?: string | null } | null }> }> }> } | null, packages: Array<{ __typename?: 'QuotePackage', id: string, line_item_key?: string | null, pricing_package: { __typename?: 'PricingPackage', id: string, name: string, price: number, price_by_guest: PriceByGuest, price_by_day: PriceByDay, guests_included: number, min_guests?: number | null, max_guests?: number | null, days_included: number, lodging_included: boolean, included_lodging_id?: string | null, is_active: boolean, is_available?: boolean | null, not_available_reason?: string | null, included_resource_ids?: Array<string | null> | null, trophies: Array<{ __typename?: 'AddOn', id: string, name: string, category: string, species?: { __typename?: 'Species', id: string, type: SpeciesType, name: string } | null }>, gear_rentals: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, meal_upgrades: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, other_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, included_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, listing: { __typename?: 'Listing', id: string } } }>, add_ons?: Array<{ __typename?: 'QuoteAddOn', id: string, name: string, package_id?: string | null }> | null, attribution?: { __typename?: 'Attribution', deal_attribution?: string | null } | null, itinerary?: { __typename?: 'TripItinerary', title?: string | null, label?: string | null, items: Array<{ __typename?: 'TripItineraryItem', title: string, label: string, helper_text?: string | null, timestamp: number, type: TripItineraryItemType }> } | null, liability_waivers?: Array<{ __typename?: 'OutfitterDocument', id: string, name: string, external_url?: string | null }> | null, what_to_expect_documents?: Array<{ __typename?: 'OutfitterDocument', id: string, name: string, external_url?: string | null }> | null, trip_insurance?: { __typename?: 'BookingTripInsurance', insurance_quote_id: string, insurance_policy_number?: string | null, zip_code: string, status: BookingTripInsuranceStatus, is_accepted?: boolean | null } | null, quote?: { __typename?: 'Quote', id: string } | null };

export type OutfitterDocumentFieldsFragment = { __typename?: 'OutfitterDocument', id: string, name: string, external_url?: string | null };

export type BookingPackageFieldsFragment = { __typename?: 'QuotePackage', id: string, line_item_key?: string | null, pricing_package: { __typename?: 'PricingPackage', id: string, name: string, price: number, price_by_guest: PriceByGuest, price_by_day: PriceByDay, guests_included: number, min_guests?: number | null, max_guests?: number | null, days_included: number, lodging_included: boolean, included_lodging_id?: string | null, is_active: boolean, is_available?: boolean | null, not_available_reason?: string | null, included_resource_ids?: Array<string | null> | null, trophies: Array<{ __typename?: 'AddOn', id: string, name: string, category: string, species?: { __typename?: 'Species', id: string, type: SpeciesType, name: string } | null }>, gear_rentals: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, meal_upgrades: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, other_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, included_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, listing: { __typename?: 'Listing', id: string } } };

export type BookingPaymentFieldsFragment = { __typename?: 'Payment', id: string, date: number, value: number, status: PaymentStatus, is_payment_method_unverified?: boolean | null, errors: Array<{ __typename?: 'PaymentError', code?: string | null, message: string }>, refunds: Array<{ __typename?: 'Refund', id: string, amount: number, payment_id: string, status: RefundStatus, approved_by_name: string, user_reason: string, stripe_reason?: StripeRefundReason | null, created_at: number, cancelled_at?: number | null, error?: { __typename?: 'PaymentError', message: string } | null, created_by: { __typename?: 'User', first_name?: string | null, last_name?: string | null }, cancelled_by?: { __typename?: 'User', first_name?: string | null, last_name?: string | null } | null }> };

export type BookingPaymentWithStripeUrlFieldsFragment = { __typename?: 'Payment', receipt_hosted_url?: string | null, total?: number | null, intent_id?: string | null, note?: string | null, payment_method_id?: string | null, id: string, date: number, value: number, status: PaymentStatus, is_payment_method_unverified?: boolean | null, user?: { __typename?: 'User', id: string } | null, group_pay_member?: { __typename?: 'GroupPayMember', id: string } | null, errors: Array<{ __typename?: 'PaymentError', code?: string | null, message: string }>, refunds: Array<{ __typename?: 'Refund', id: string, amount: number, payment_id: string, status: RefundStatus, approved_by_name: string, user_reason: string, stripe_reason?: StripeRefundReason | null, created_at: number, cancelled_at?: number | null, error?: { __typename?: 'PaymentError', message: string } | null, created_by: { __typename?: 'User', first_name?: string | null, last_name?: string | null }, cancelled_by?: { __typename?: 'User', first_name?: string | null, last_name?: string | null } | null }> };

export type BookingPaymentRequestFieldsFragment = { __typename?: 'PaymentRequest', id: string, value: number, status: PaymentRequestStatus, paid_offline?: boolean | null, created_at: number, errors: Array<{ __typename?: 'PaymentError', code?: string | null, message: string }>, add_ons?: Array<{ __typename?: 'PaymentRequestAddOn', id: string, total: number, quantity: number, number_of_days?: number | null, number_of_guests?: number | null }> | null, items: Array<{ __typename?: 'PaymentItemRequest', amount: number, description: string, add_on_id?: string | null }> };

export type BookingMinimalFieldsFragment = { __typename?: 'Booking', id: string, dates: Array<number>, start_date: number, end_date: number, check_in_time: number, check_out_time: number, status: BookingStatus, can_be_reviewed?: boolean | null, review_form_url?: string | null, listing: { __typename?: 'Listing', id: string, type?: ListingType | null, title?: string | null, description?: string | null, published?: boolean | null, license_required?: boolean | null, cover_image?: string | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null, lowest_pricing_package?: { __typename?: 'PricingPackage', name: string, price: number } | null }, outfitter: { __typename?: 'Outfitter', name: string, status: OutfitterStatus } };

export type BookingListingFieldsFragment = { __typename?: 'Listing', time_zone?: string | null, id: string, type?: ListingType | null, title?: string | null, description?: string | null, published?: boolean | null, license_required?: boolean | null, cover_image?: string | null, species: Array<{ __typename?: 'Species', id: string, type: SpeciesType, name: string, image?: { __typename?: 'Media', url: string, description?: string | null } | null }>, lodging?: { __typename?: 'Lodging', id: string } | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null, lowest_pricing_package?: { __typename?: 'PricingPackage', name: string, price: number } | null };

export type BookingOutfitterFieldsFragment = { __typename?: 'Outfitter', id: string, slug: string, name: string, status: OutfitterStatus, time_zone?: string | null, avatar?: { __typename?: 'Media', url: string, description?: string | null } | null, owner: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email: string, phone?: string | null, bio: string, location: string, avatar_url?: string | null, favorite_game: Array<string>, years_of_experience?: number | null, is_admin?: boolean | null, is_team_member?: boolean | null, created_at: number, updated_at: number, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null, impersonation_details?: { __typename?: 'ImpersonationDetails', is_impersonated: boolean } | null }, cancellation_policy: { __typename?: 'OutfitterCancellationPolicy', policy_id: string, description: string } };

export type RecentPublicBookingsFieldsFragment = { __typename?: 'PublicBooking', id: string, created_at: number, listing: { __typename?: 'PublicListing', id: string, type?: ListingType | null, title?: string | null, published?: boolean | null, min_guest?: number | null, max_guest?: number | null, license_required?: boolean | null, cover_image?: string | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null, lowest_pricing_package?: { __typename?: 'PublicPricingPackage', price: number } | null } };

export type TripItineraryFieldsFragment = { __typename?: 'TripItinerary', title?: string | null, label?: string | null, items: Array<{ __typename?: 'TripItineraryItem', title: string, label: string, helper_text?: string | null, timestamp: number, type: TripItineraryItemType }> };

export type TripItineraryItemFieldsFragment = { __typename?: 'TripItineraryItem', title: string, label: string, helper_text?: string | null, timestamp: number, type: TripItineraryItemType };

export type BookingPaymentSummaryFieldsFragment = { __typename?: 'BookingPaymentSummary', member_total?: number | null, line_items: Array<{ __typename?: 'LineItem', total: number, label: string, display_value: string, details_label?: string | null, details_value?: string | null, key?: string | null, section_key?: string | null, sub_items?: Array<{ __typename?: 'SubItem', label: string }> | null }>, totals: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }>, member_summaries: Array<{ __typename?: 'MemberPaymentSummary', member_id: string, member_name: string, prices: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }>, totals: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }> }> };

export type MemberPaymentSummaryFieldsFragment = { __typename?: 'MemberPaymentSummary', member_id: string, member_name: string, prices: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }>, totals: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }> };

export type BookingWithPaymentSummaryFieldsFragment = { __typename?: 'Booking', can_be_reviewed?: boolean | null, review_form_url?: string | null, id: string, dates: Array<number>, start_date: number, end_date: number, status: BookingStatus, sub_total: number, service_fee: number, state_tax: number, total: number, notes?: string | null, discount?: number | null, check_in_time: number, check_out_time: number, should_allow_external_payment?: boolean | null, created_at: number, payment_summary: { __typename?: 'BookingPaymentSummary', member_total?: number | null, line_items: Array<{ __typename?: 'LineItem', total: number, label: string, display_value: string, details_label?: string | null, details_value?: string | null, key?: string | null, section_key?: string | null, sub_items?: Array<{ __typename?: 'SubItem', label: string }> | null }>, totals: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }>, member_summaries: Array<{ __typename?: 'MemberPaymentSummary', member_id: string, member_name: string, prices: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }>, totals: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }> }> }, payments: Array<{ __typename?: 'Payment', receipt_hosted_url?: string | null, total?: number | null, intent_id?: string | null, note?: string | null, payment_method_id?: string | null, id: string, date: number, value: number, status: PaymentStatus, is_payment_method_unverified?: boolean | null, user?: { __typename?: 'User', id: string } | null, group_pay_member?: { __typename?: 'GroupPayMember', id: string } | null, errors: Array<{ __typename?: 'PaymentError', code?: string | null, message: string }>, refunds: Array<{ __typename?: 'Refund', id: string, amount: number, payment_id: string, status: RefundStatus, approved_by_name: string, user_reason: string, stripe_reason?: StripeRefundReason | null, created_at: number, cancelled_at?: number | null, error?: { __typename?: 'PaymentError', message: string } | null, created_by: { __typename?: 'User', first_name?: string | null, last_name?: string | null }, cancelled_by?: { __typename?: 'User', first_name?: string | null, last_name?: string | null } | null }> }>, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, is_guest_conversion_disabled?: boolean | null }, listing: { __typename?: 'Listing', time_zone?: string | null, id: string, type?: ListingType | null, title?: string | null, description?: string | null, published?: boolean | null, license_required?: boolean | null, cover_image?: string | null, species: Array<{ __typename?: 'Species', id: string, type: SpeciesType, name: string, image?: { __typename?: 'Media', url: string, description?: string | null } | null }>, lodging?: { __typename?: 'Lodging', id: string } | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null, lowest_pricing_package?: { __typename?: 'PricingPackage', name: string, price: number } | null }, outfitter: { __typename?: 'Outfitter', id: string, slug: string, name: string, status: OutfitterStatus, time_zone?: string | null, avatar?: { __typename?: 'Media', url: string, description?: string | null } | null, owner: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email: string, phone?: string | null, bio: string, location: string, avatar_url?: string | null, favorite_game: Array<string>, years_of_experience?: number | null, is_admin?: boolean | null, is_team_member?: boolean | null, created_at: number, updated_at: number, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null, impersonation_details?: { __typename?: 'ImpersonationDetails', is_impersonated: boolean } | null }, cancellation_policy: { __typename?: 'OutfitterCancellationPolicy', policy_id: string, description: string } }, paymentRequests: Array<{ __typename?: 'PaymentRequest', id: string, value: number, status: PaymentRequestStatus, paid_offline?: boolean | null, created_at: number, errors: Array<{ __typename?: 'PaymentError', code?: string | null, message: string }>, add_ons?: Array<{ __typename?: 'PaymentRequestAddOn', id: string, total: number, quantity: number, number_of_days?: number | null, number_of_guests?: number | null }> | null, items: Array<{ __typename?: 'PaymentItemRequest', amount: number, description: string, add_on_id?: string | null }> }>, coupon?: { __typename?: 'Coupon', id: string, custom_code: string, amount_off?: number | null, percent_off?: number | null } | null, items: Array<{ __typename?: 'QuoteItem', name: string, option_id: string, rate: number, quantity: number, price: number }>, group_pay_share?: { __typename?: 'GroupPayShare', id: string, remaining_slots?: number | null, last_payment_due_date?: number | null, join_url?: string | null, shares: Array<{ __typename?: 'SlotShare', slots: number, total: number, is_invitation_accepted: boolean, is_host: boolean, member: { __typename?: 'GroupPayMember', id: string, name: string, email: string }, payments: Array<{ __typename?: 'Payment', id: string, date: number, value: number, status: PaymentStatus, errors: Array<{ __typename?: 'PaymentError', code?: string | null, message: string }>, refunds: Array<{ __typename?: 'Refund', id: string, amount: number, payment_id: string, status: RefundStatus, approved_by_name: string, user_reason: string, stripe_reason?: StripeRefundReason | null, created_at: number, cancelled_at?: number | null, error?: { __typename?: 'PaymentError', message: string } | null, created_by: { __typename?: 'User', first_name?: string | null, last_name?: string | null }, cancelled_by?: { __typename?: 'User', first_name?: string | null, last_name?: string | null } | null }> }> }> } | null, packages: Array<{ __typename?: 'QuotePackage', id: string, line_item_key?: string | null, pricing_package: { __typename?: 'PricingPackage', id: string, name: string, price: number, price_by_guest: PriceByGuest, price_by_day: PriceByDay, guests_included: number, min_guests?: number | null, max_guests?: number | null, days_included: number, lodging_included: boolean, included_lodging_id?: string | null, is_active: boolean, is_available?: boolean | null, not_available_reason?: string | null, included_resource_ids?: Array<string | null> | null, trophies: Array<{ __typename?: 'AddOn', id: string, name: string, category: string, species?: { __typename?: 'Species', id: string, type: SpeciesType, name: string } | null }>, gear_rentals: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, meal_upgrades: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, other_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, included_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, listing: { __typename?: 'Listing', id: string } } }>, add_ons?: Array<{ __typename?: 'QuoteAddOn', id: string, name: string, package_id?: string | null }> | null, attribution?: { __typename?: 'Attribution', deal_attribution?: string | null } | null, itinerary?: { __typename?: 'TripItinerary', title?: string | null, label?: string | null, items: Array<{ __typename?: 'TripItineraryItem', title: string, label: string, helper_text?: string | null, timestamp: number, type: TripItineraryItemType }> } | null, liability_waivers?: Array<{ __typename?: 'OutfitterDocument', id: string, name: string, external_url?: string | null }> | null, what_to_expect_documents?: Array<{ __typename?: 'OutfitterDocument', id: string, name: string, external_url?: string | null }> | null, trip_insurance?: { __typename?: 'BookingTripInsurance', insurance_quote_id: string, insurance_policy_number?: string | null, zip_code: string, status: BookingTripInsuranceStatus, is_accepted?: boolean | null } | null, quote?: { __typename?: 'Quote', id: string } | null };

export type BookingQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  invitationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type BookingQuery = { __typename?: 'Query', booking: { __typename?: 'Booking', id: string, dates: Array<number>, start_date: number, end_date: number, status: BookingStatus, sub_total: number, service_fee: number, state_tax: number, total: number, notes?: string | null, discount?: number | null, check_in_time: number, check_out_time: number, should_allow_external_payment?: boolean | null, created_at: number, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, is_guest_conversion_disabled?: boolean | null }, listing: { __typename?: 'Listing', time_zone?: string | null, id: string, type?: ListingType | null, title?: string | null, description?: string | null, published?: boolean | null, license_required?: boolean | null, cover_image?: string | null, species: Array<{ __typename?: 'Species', id: string, type: SpeciesType, name: string, image?: { __typename?: 'Media', url: string, description?: string | null } | null }>, lodging?: { __typename?: 'Lodging', id: string } | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null, lowest_pricing_package?: { __typename?: 'PricingPackage', name: string, price: number } | null }, outfitter: { __typename?: 'Outfitter', id: string, slug: string, name: string, status: OutfitterStatus, time_zone?: string | null, avatar?: { __typename?: 'Media', url: string, description?: string | null } | null, owner: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email: string, phone?: string | null, bio: string, location: string, avatar_url?: string | null, favorite_game: Array<string>, years_of_experience?: number | null, is_admin?: boolean | null, is_team_member?: boolean | null, created_at: number, updated_at: number, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null, impersonation_details?: { __typename?: 'ImpersonationDetails', is_impersonated: boolean } | null }, cancellation_policy: { __typename?: 'OutfitterCancellationPolicy', policy_id: string, description: string } }, payments: Array<{ __typename?: 'Payment', id: string, date: number, value: number, status: PaymentStatus, is_payment_method_unverified?: boolean | null, errors: Array<{ __typename?: 'PaymentError', code?: string | null, message: string }>, refunds: Array<{ __typename?: 'Refund', id: string, amount: number, payment_id: string, status: RefundStatus, approved_by_name: string, user_reason: string, stripe_reason?: StripeRefundReason | null, created_at: number, cancelled_at?: number | null, error?: { __typename?: 'PaymentError', message: string } | null, created_by: { __typename?: 'User', first_name?: string | null, last_name?: string | null }, cancelled_by?: { __typename?: 'User', first_name?: string | null, last_name?: string | null } | null }> }>, paymentRequests: Array<{ __typename?: 'PaymentRequest', id: string, value: number, status: PaymentRequestStatus, paid_offline?: boolean | null, created_at: number, errors: Array<{ __typename?: 'PaymentError', code?: string | null, message: string }>, add_ons?: Array<{ __typename?: 'PaymentRequestAddOn', id: string, total: number, quantity: number, number_of_days?: number | null, number_of_guests?: number | null }> | null, items: Array<{ __typename?: 'PaymentItemRequest', amount: number, description: string, add_on_id?: string | null }> }>, coupon?: { __typename?: 'Coupon', id: string, custom_code: string, amount_off?: number | null, percent_off?: number | null } | null, items: Array<{ __typename?: 'QuoteItem', name: string, option_id: string, rate: number, quantity: number, price: number }>, group_pay_share?: { __typename?: 'GroupPayShare', id: string, remaining_slots?: number | null, last_payment_due_date?: number | null, join_url?: string | null, shares: Array<{ __typename?: 'SlotShare', slots: number, total: number, is_invitation_accepted: boolean, is_host: boolean, member: { __typename?: 'GroupPayMember', id: string, name: string, email: string }, payments: Array<{ __typename?: 'Payment', id: string, date: number, value: number, status: PaymentStatus, errors: Array<{ __typename?: 'PaymentError', code?: string | null, message: string }>, refunds: Array<{ __typename?: 'Refund', id: string, amount: number, payment_id: string, status: RefundStatus, approved_by_name: string, user_reason: string, stripe_reason?: StripeRefundReason | null, created_at: number, cancelled_at?: number | null, error?: { __typename?: 'PaymentError', message: string } | null, created_by: { __typename?: 'User', first_name?: string | null, last_name?: string | null }, cancelled_by?: { __typename?: 'User', first_name?: string | null, last_name?: string | null } | null }> }> }> } | null, packages: Array<{ __typename?: 'QuotePackage', id: string, line_item_key?: string | null, pricing_package: { __typename?: 'PricingPackage', id: string, name: string, price: number, price_by_guest: PriceByGuest, price_by_day: PriceByDay, guests_included: number, min_guests?: number | null, max_guests?: number | null, days_included: number, lodging_included: boolean, included_lodging_id?: string | null, is_active: boolean, is_available?: boolean | null, not_available_reason?: string | null, included_resource_ids?: Array<string | null> | null, trophies: Array<{ __typename?: 'AddOn', id: string, name: string, category: string, species?: { __typename?: 'Species', id: string, type: SpeciesType, name: string } | null }>, gear_rentals: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, meal_upgrades: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, other_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, included_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, listing: { __typename?: 'Listing', id: string } } }>, add_ons?: Array<{ __typename?: 'QuoteAddOn', id: string, name: string, package_id?: string | null }> | null, attribution?: { __typename?: 'Attribution', deal_attribution?: string | null } | null, itinerary?: { __typename?: 'TripItinerary', title?: string | null, label?: string | null, items: Array<{ __typename?: 'TripItineraryItem', title: string, label: string, helper_text?: string | null, timestamp: number, type: TripItineraryItemType }> } | null, liability_waivers?: Array<{ __typename?: 'OutfitterDocument', id: string, name: string, external_url?: string | null }> | null, what_to_expect_documents?: Array<{ __typename?: 'OutfitterDocument', id: string, name: string, external_url?: string | null }> | null, trip_insurance?: { __typename?: 'BookingTripInsurance', insurance_quote_id: string, insurance_policy_number?: string | null, zip_code: string, status: BookingTripInsuranceStatus, is_accepted?: boolean | null } | null, quote?: { __typename?: 'Quote', id: string } | null } };

export type BookingWithPaymentSummaryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  invitationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type BookingWithPaymentSummaryQuery = { __typename?: 'Query', booking: { __typename?: 'Booking', can_be_reviewed?: boolean | null, review_form_url?: string | null, id: string, dates: Array<number>, start_date: number, end_date: number, status: BookingStatus, sub_total: number, service_fee: number, state_tax: number, total: number, notes?: string | null, discount?: number | null, check_in_time: number, check_out_time: number, should_allow_external_payment?: boolean | null, created_at: number, payment_summary: { __typename?: 'BookingPaymentSummary', member_total?: number | null, line_items: Array<{ __typename?: 'LineItem', total: number, label: string, display_value: string, details_label?: string | null, details_value?: string | null, key?: string | null, section_key?: string | null, sub_items?: Array<{ __typename?: 'SubItem', label: string }> | null }>, totals: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }>, member_summaries: Array<{ __typename?: 'MemberPaymentSummary', member_id: string, member_name: string, prices: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }>, totals: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }> }> }, payments: Array<{ __typename?: 'Payment', receipt_hosted_url?: string | null, total?: number | null, intent_id?: string | null, note?: string | null, payment_method_id?: string | null, id: string, date: number, value: number, status: PaymentStatus, is_payment_method_unverified?: boolean | null, user?: { __typename?: 'User', id: string } | null, group_pay_member?: { __typename?: 'GroupPayMember', id: string } | null, errors: Array<{ __typename?: 'PaymentError', code?: string | null, message: string }>, refunds: Array<{ __typename?: 'Refund', id: string, amount: number, payment_id: string, status: RefundStatus, approved_by_name: string, user_reason: string, stripe_reason?: StripeRefundReason | null, created_at: number, cancelled_at?: number | null, error?: { __typename?: 'PaymentError', message: string } | null, created_by: { __typename?: 'User', first_name?: string | null, last_name?: string | null }, cancelled_by?: { __typename?: 'User', first_name?: string | null, last_name?: string | null } | null }> }>, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, is_guest_conversion_disabled?: boolean | null }, listing: { __typename?: 'Listing', time_zone?: string | null, id: string, type?: ListingType | null, title?: string | null, description?: string | null, published?: boolean | null, license_required?: boolean | null, cover_image?: string | null, species: Array<{ __typename?: 'Species', id: string, type: SpeciesType, name: string, image?: { __typename?: 'Media', url: string, description?: string | null } | null }>, lodging?: { __typename?: 'Lodging', id: string } | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null, lowest_pricing_package?: { __typename?: 'PricingPackage', name: string, price: number } | null }, outfitter: { __typename?: 'Outfitter', id: string, slug: string, name: string, status: OutfitterStatus, time_zone?: string | null, avatar?: { __typename?: 'Media', url: string, description?: string | null } | null, owner: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email: string, phone?: string | null, bio: string, location: string, avatar_url?: string | null, favorite_game: Array<string>, years_of_experience?: number | null, is_admin?: boolean | null, is_team_member?: boolean | null, created_at: number, updated_at: number, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null, impersonation_details?: { __typename?: 'ImpersonationDetails', is_impersonated: boolean } | null }, cancellation_policy: { __typename?: 'OutfitterCancellationPolicy', policy_id: string, description: string } }, paymentRequests: Array<{ __typename?: 'PaymentRequest', id: string, value: number, status: PaymentRequestStatus, paid_offline?: boolean | null, created_at: number, errors: Array<{ __typename?: 'PaymentError', code?: string | null, message: string }>, add_ons?: Array<{ __typename?: 'PaymentRequestAddOn', id: string, total: number, quantity: number, number_of_days?: number | null, number_of_guests?: number | null }> | null, items: Array<{ __typename?: 'PaymentItemRequest', amount: number, description: string, add_on_id?: string | null }> }>, coupon?: { __typename?: 'Coupon', id: string, custom_code: string, amount_off?: number | null, percent_off?: number | null } | null, items: Array<{ __typename?: 'QuoteItem', name: string, option_id: string, rate: number, quantity: number, price: number }>, group_pay_share?: { __typename?: 'GroupPayShare', id: string, remaining_slots?: number | null, last_payment_due_date?: number | null, join_url?: string | null, shares: Array<{ __typename?: 'SlotShare', slots: number, total: number, is_invitation_accepted: boolean, is_host: boolean, member: { __typename?: 'GroupPayMember', id: string, name: string, email: string }, payments: Array<{ __typename?: 'Payment', id: string, date: number, value: number, status: PaymentStatus, errors: Array<{ __typename?: 'PaymentError', code?: string | null, message: string }>, refunds: Array<{ __typename?: 'Refund', id: string, amount: number, payment_id: string, status: RefundStatus, approved_by_name: string, user_reason: string, stripe_reason?: StripeRefundReason | null, created_at: number, cancelled_at?: number | null, error?: { __typename?: 'PaymentError', message: string } | null, created_by: { __typename?: 'User', first_name?: string | null, last_name?: string | null }, cancelled_by?: { __typename?: 'User', first_name?: string | null, last_name?: string | null } | null }> }> }> } | null, packages: Array<{ __typename?: 'QuotePackage', id: string, line_item_key?: string | null, pricing_package: { __typename?: 'PricingPackage', id: string, name: string, price: number, price_by_guest: PriceByGuest, price_by_day: PriceByDay, guests_included: number, min_guests?: number | null, max_guests?: number | null, days_included: number, lodging_included: boolean, included_lodging_id?: string | null, is_active: boolean, is_available?: boolean | null, not_available_reason?: string | null, included_resource_ids?: Array<string | null> | null, trophies: Array<{ __typename?: 'AddOn', id: string, name: string, category: string, species?: { __typename?: 'Species', id: string, type: SpeciesType, name: string } | null }>, gear_rentals: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, meal_upgrades: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, other_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, included_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, listing: { __typename?: 'Listing', id: string } } }>, add_ons?: Array<{ __typename?: 'QuoteAddOn', id: string, name: string, package_id?: string | null }> | null, attribution?: { __typename?: 'Attribution', deal_attribution?: string | null } | null, itinerary?: { __typename?: 'TripItinerary', title?: string | null, label?: string | null, items: Array<{ __typename?: 'TripItineraryItem', title: string, label: string, helper_text?: string | null, timestamp: number, type: TripItineraryItemType }> } | null, liability_waivers?: Array<{ __typename?: 'OutfitterDocument', id: string, name: string, external_url?: string | null }> | null, what_to_expect_documents?: Array<{ __typename?: 'OutfitterDocument', id: string, name: string, external_url?: string | null }> | null, trip_insurance?: { __typename?: 'BookingTripInsurance', insurance_quote_id: string, insurance_policy_number?: string | null, zip_code: string, status: BookingTripInsuranceStatus, is_accepted?: boolean | null } | null, quote?: { __typename?: 'Quote', id: string } | null } };

export type BookingsQueryVariables = Exact<{ [key: string]: never; }>;


export type BookingsQuery = { __typename?: 'Query', bookings: Array<{ __typename?: 'Booking', id: string, dates: Array<number>, start_date: number, end_date: number, check_in_time: number, check_out_time: number, status: BookingStatus, can_be_reviewed?: boolean | null, review_form_url?: string | null, listing: { __typename?: 'Listing', id: string, type?: ListingType | null, title?: string | null, description?: string | null, published?: boolean | null, license_required?: boolean | null, cover_image?: string | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null, lowest_pricing_package?: { __typename?: 'PricingPackage', name: string, price: number } | null }, outfitter: { __typename?: 'Outfitter', name: string, status: OutfitterStatus } }> };

export type RecentPublicBookingsQueryVariables = Exact<{
  size?: InputMaybe<Scalars['PositiveInt']['input']>;
}>;


export type RecentPublicBookingsQuery = { __typename?: 'Query', recentPublicBookings: Array<{ __typename?: 'PublicBooking', id: string, created_at: number, listing: { __typename?: 'PublicListing', id: string, type?: ListingType | null, title?: string | null, published?: boolean | null, min_guest?: number | null, max_guest?: number | null, license_required?: boolean | null, cover_image?: string | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null, lowest_pricing_package?: { __typename?: 'PublicPricingPackage', price: number } | null } }> };

export type GetBookingDealAttributionOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBookingDealAttributionOptionsQuery = { __typename?: 'Query', bookingDealAttributionOptions: Array<{ __typename?: 'DealAttributionOption', id: string, title: string }> };

export type CreateBookingMutationVariables = Exact<{
  data: CreateBookingInput;
}>;


export type CreateBookingMutation = { __typename?: 'Mutation', createBooking: { __typename?: 'Booking', id: string } };

export type UpdateBookingMutationVariables = Exact<{
  updateBookingId: Scalars['ID']['input'];
  data: UpdateBookingInput;
}>;


export type UpdateBookingMutation = { __typename?: 'Mutation', updateBooking: { __typename?: 'Booking', id: string, dates: Array<number>, start_date: number, end_date: number, status: BookingStatus, sub_total: number, service_fee: number, state_tax: number, total: number, notes?: string | null, discount?: number | null, check_in_time: number, check_out_time: number, should_allow_external_payment?: boolean | null, created_at: number, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, is_guest_conversion_disabled?: boolean | null }, listing: { __typename?: 'Listing', time_zone?: string | null, id: string, type?: ListingType | null, title?: string | null, description?: string | null, published?: boolean | null, license_required?: boolean | null, cover_image?: string | null, species: Array<{ __typename?: 'Species', id: string, type: SpeciesType, name: string, image?: { __typename?: 'Media', url: string, description?: string | null } | null }>, lodging?: { __typename?: 'Lodging', id: string } | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null, lowest_pricing_package?: { __typename?: 'PricingPackage', name: string, price: number } | null }, outfitter: { __typename?: 'Outfitter', id: string, slug: string, name: string, status: OutfitterStatus, time_zone?: string | null, avatar?: { __typename?: 'Media', url: string, description?: string | null } | null, owner: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email: string, phone?: string | null, bio: string, location: string, avatar_url?: string | null, favorite_game: Array<string>, years_of_experience?: number | null, is_admin?: boolean | null, is_team_member?: boolean | null, created_at: number, updated_at: number, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null, impersonation_details?: { __typename?: 'ImpersonationDetails', is_impersonated: boolean } | null }, cancellation_policy: { __typename?: 'OutfitterCancellationPolicy', policy_id: string, description: string } }, payments: Array<{ __typename?: 'Payment', id: string, date: number, value: number, status: PaymentStatus, is_payment_method_unverified?: boolean | null, errors: Array<{ __typename?: 'PaymentError', code?: string | null, message: string }>, refunds: Array<{ __typename?: 'Refund', id: string, amount: number, payment_id: string, status: RefundStatus, approved_by_name: string, user_reason: string, stripe_reason?: StripeRefundReason | null, created_at: number, cancelled_at?: number | null, error?: { __typename?: 'PaymentError', message: string } | null, created_by: { __typename?: 'User', first_name?: string | null, last_name?: string | null }, cancelled_by?: { __typename?: 'User', first_name?: string | null, last_name?: string | null } | null }> }>, paymentRequests: Array<{ __typename?: 'PaymentRequest', id: string, value: number, status: PaymentRequestStatus, paid_offline?: boolean | null, created_at: number, errors: Array<{ __typename?: 'PaymentError', code?: string | null, message: string }>, add_ons?: Array<{ __typename?: 'PaymentRequestAddOn', id: string, total: number, quantity: number, number_of_days?: number | null, number_of_guests?: number | null }> | null, items: Array<{ __typename?: 'PaymentItemRequest', amount: number, description: string, add_on_id?: string | null }> }>, coupon?: { __typename?: 'Coupon', id: string, custom_code: string, amount_off?: number | null, percent_off?: number | null } | null, items: Array<{ __typename?: 'QuoteItem', name: string, option_id: string, rate: number, quantity: number, price: number }>, group_pay_share?: { __typename?: 'GroupPayShare', id: string, remaining_slots?: number | null, last_payment_due_date?: number | null, join_url?: string | null, shares: Array<{ __typename?: 'SlotShare', slots: number, total: number, is_invitation_accepted: boolean, is_host: boolean, member: { __typename?: 'GroupPayMember', id: string, name: string, email: string }, payments: Array<{ __typename?: 'Payment', id: string, date: number, value: number, status: PaymentStatus, errors: Array<{ __typename?: 'PaymentError', code?: string | null, message: string }>, refunds: Array<{ __typename?: 'Refund', id: string, amount: number, payment_id: string, status: RefundStatus, approved_by_name: string, user_reason: string, stripe_reason?: StripeRefundReason | null, created_at: number, cancelled_at?: number | null, error?: { __typename?: 'PaymentError', message: string } | null, created_by: { __typename?: 'User', first_name?: string | null, last_name?: string | null }, cancelled_by?: { __typename?: 'User', first_name?: string | null, last_name?: string | null } | null }> }> }> } | null, packages: Array<{ __typename?: 'QuotePackage', id: string, line_item_key?: string | null, pricing_package: { __typename?: 'PricingPackage', id: string, name: string, price: number, price_by_guest: PriceByGuest, price_by_day: PriceByDay, guests_included: number, min_guests?: number | null, max_guests?: number | null, days_included: number, lodging_included: boolean, included_lodging_id?: string | null, is_active: boolean, is_available?: boolean | null, not_available_reason?: string | null, included_resource_ids?: Array<string | null> | null, trophies: Array<{ __typename?: 'AddOn', id: string, name: string, category: string, species?: { __typename?: 'Species', id: string, type: SpeciesType, name: string } | null }>, gear_rentals: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, meal_upgrades: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, other_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, included_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, listing: { __typename?: 'Listing', id: string } } }>, add_ons?: Array<{ __typename?: 'QuoteAddOn', id: string, name: string, package_id?: string | null }> | null, attribution?: { __typename?: 'Attribution', deal_attribution?: string | null } | null, itinerary?: { __typename?: 'TripItinerary', title?: string | null, label?: string | null, items: Array<{ __typename?: 'TripItineraryItem', title: string, label: string, helper_text?: string | null, timestamp: number, type: TripItineraryItemType }> } | null, liability_waivers?: Array<{ __typename?: 'OutfitterDocument', id: string, name: string, external_url?: string | null }> | null, what_to_expect_documents?: Array<{ __typename?: 'OutfitterDocument', id: string, name: string, external_url?: string | null }> | null, trip_insurance?: { __typename?: 'BookingTripInsurance', insurance_quote_id: string, insurance_policy_number?: string | null, zip_code: string, status: BookingTripInsuranceStatus, is_accepted?: boolean | null } | null, quote?: { __typename?: 'Quote', id: string } | null } };

export type UpdateBookingAttributionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: AttributionInput;
}>;


export type UpdateBookingAttributionMutation = { __typename?: 'Mutation', updateBookingAttribution: { __typename?: 'Booking', id: string, dates: Array<number>, start_date: number, end_date: number, status: BookingStatus, sub_total: number, service_fee: number, state_tax: number, total: number, notes?: string | null, discount?: number | null, check_in_time: number, check_out_time: number, should_allow_external_payment?: boolean | null, created_at: number, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, is_guest_conversion_disabled?: boolean | null }, listing: { __typename?: 'Listing', time_zone?: string | null, id: string, type?: ListingType | null, title?: string | null, description?: string | null, published?: boolean | null, license_required?: boolean | null, cover_image?: string | null, species: Array<{ __typename?: 'Species', id: string, type: SpeciesType, name: string, image?: { __typename?: 'Media', url: string, description?: string | null } | null }>, lodging?: { __typename?: 'Lodging', id: string } | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null, lowest_pricing_package?: { __typename?: 'PricingPackage', name: string, price: number } | null }, outfitter: { __typename?: 'Outfitter', id: string, slug: string, name: string, status: OutfitterStatus, time_zone?: string | null, avatar?: { __typename?: 'Media', url: string, description?: string | null } | null, owner: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email: string, phone?: string | null, bio: string, location: string, avatar_url?: string | null, favorite_game: Array<string>, years_of_experience?: number | null, is_admin?: boolean | null, is_team_member?: boolean | null, created_at: number, updated_at: number, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null, impersonation_details?: { __typename?: 'ImpersonationDetails', is_impersonated: boolean } | null }, cancellation_policy: { __typename?: 'OutfitterCancellationPolicy', policy_id: string, description: string } }, payments: Array<{ __typename?: 'Payment', id: string, date: number, value: number, status: PaymentStatus, is_payment_method_unverified?: boolean | null, errors: Array<{ __typename?: 'PaymentError', code?: string | null, message: string }>, refunds: Array<{ __typename?: 'Refund', id: string, amount: number, payment_id: string, status: RefundStatus, approved_by_name: string, user_reason: string, stripe_reason?: StripeRefundReason | null, created_at: number, cancelled_at?: number | null, error?: { __typename?: 'PaymentError', message: string } | null, created_by: { __typename?: 'User', first_name?: string | null, last_name?: string | null }, cancelled_by?: { __typename?: 'User', first_name?: string | null, last_name?: string | null } | null }> }>, paymentRequests: Array<{ __typename?: 'PaymentRequest', id: string, value: number, status: PaymentRequestStatus, paid_offline?: boolean | null, created_at: number, errors: Array<{ __typename?: 'PaymentError', code?: string | null, message: string }>, add_ons?: Array<{ __typename?: 'PaymentRequestAddOn', id: string, total: number, quantity: number, number_of_days?: number | null, number_of_guests?: number | null }> | null, items: Array<{ __typename?: 'PaymentItemRequest', amount: number, description: string, add_on_id?: string | null }> }>, coupon?: { __typename?: 'Coupon', id: string, custom_code: string, amount_off?: number | null, percent_off?: number | null } | null, items: Array<{ __typename?: 'QuoteItem', name: string, option_id: string, rate: number, quantity: number, price: number }>, group_pay_share?: { __typename?: 'GroupPayShare', id: string, remaining_slots?: number | null, last_payment_due_date?: number | null, join_url?: string | null, shares: Array<{ __typename?: 'SlotShare', slots: number, total: number, is_invitation_accepted: boolean, is_host: boolean, member: { __typename?: 'GroupPayMember', id: string, name: string, email: string }, payments: Array<{ __typename?: 'Payment', id: string, date: number, value: number, status: PaymentStatus, errors: Array<{ __typename?: 'PaymentError', code?: string | null, message: string }>, refunds: Array<{ __typename?: 'Refund', id: string, amount: number, payment_id: string, status: RefundStatus, approved_by_name: string, user_reason: string, stripe_reason?: StripeRefundReason | null, created_at: number, cancelled_at?: number | null, error?: { __typename?: 'PaymentError', message: string } | null, created_by: { __typename?: 'User', first_name?: string | null, last_name?: string | null }, cancelled_by?: { __typename?: 'User', first_name?: string | null, last_name?: string | null } | null }> }> }> } | null, packages: Array<{ __typename?: 'QuotePackage', id: string, line_item_key?: string | null, pricing_package: { __typename?: 'PricingPackage', id: string, name: string, price: number, price_by_guest: PriceByGuest, price_by_day: PriceByDay, guests_included: number, min_guests?: number | null, max_guests?: number | null, days_included: number, lodging_included: boolean, included_lodging_id?: string | null, is_active: boolean, is_available?: boolean | null, not_available_reason?: string | null, included_resource_ids?: Array<string | null> | null, trophies: Array<{ __typename?: 'AddOn', id: string, name: string, category: string, species?: { __typename?: 'Species', id: string, type: SpeciesType, name: string } | null }>, gear_rentals: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, meal_upgrades: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, other_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, included_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, listing: { __typename?: 'Listing', id: string } } }>, add_ons?: Array<{ __typename?: 'QuoteAddOn', id: string, name: string, package_id?: string | null }> | null, attribution?: { __typename?: 'Attribution', deal_attribution?: string | null } | null, itinerary?: { __typename?: 'TripItinerary', title?: string | null, label?: string | null, items: Array<{ __typename?: 'TripItineraryItem', title: string, label: string, helper_text?: string | null, timestamp: number, type: TripItineraryItemType }> } | null, liability_waivers?: Array<{ __typename?: 'OutfitterDocument', id: string, name: string, external_url?: string | null }> | null, what_to_expect_documents?: Array<{ __typename?: 'OutfitterDocument', id: string, name: string, external_url?: string | null }> | null, trip_insurance?: { __typename?: 'BookingTripInsurance', insurance_quote_id: string, insurance_policy_number?: string | null, zip_code: string, status: BookingTripInsuranceStatus, is_accepted?: boolean | null } | null, quote?: { __typename?: 'Quote', id: string } | null } };

export type GetSportsmanChatTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSportsmanChatTokenQuery = { __typename?: 'Query', getSportsmanChatToken?: string | null };

export type CreateChatChannelWithOutfitterMutationVariables = Exact<{
  outfitterId: Scalars['ID']['input'];
}>;


export type CreateChatChannelWithOutfitterMutation = { __typename?: 'Mutation', createChatChannelWithOutfitter?: string | null };

export type ReviewAggregationFieldsFragment = { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number };

export type AttributionFieldsFragment = { __typename?: 'Attribution', internal_source?: BookingInternalSource | null, internal_source_entity_id?: string | null, internal_source_entity_type?: BookingInternalSourceEntityType | null };

export type PageSubsectionFieldsFragment = { __typename?: 'PageSubsection', label: string, sub_label?: string | null, items: Array<{ __typename?: 'PageSubsectionItem', label: string, sub_label?: string | null, cta_url?: string | null }> };

export type PageSubsectionItemFieldsFragment = { __typename?: 'PageSubsectionItem', label: string, sub_label?: string | null, cta_url?: string | null };

export type CouponFieldsFragment = { __typename?: 'Coupon', id: string, name?: string | null, percent_off?: number | null, amount_off?: number | null, currency?: string | null, duration: CouponDuration, duration_in_months?: number | null, max_redemptions?: number | null, redeem_by?: number | null, created_at: number, updated_at: number, outfitter?: { __typename?: 'Outfitter', id: string, name: string, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null } | null };

export type GetCourierInboxAuthTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCourierInboxAuthTokenQuery = { __typename?: 'Query', getCourierInboxAuthToken: string };

export type CreateListingVisitedEventMutationVariables = Exact<{
  data: CreateListingVisitedEventInput;
}>;


export type CreateListingVisitedEventMutation = { __typename?: 'Mutation', createListingVisitedEvent: { __typename?: 'ListingVisitedEvent', id: string } };

export type CreateBookingStartedEventMutationVariables = Exact<{
  data: CreateBookingStartedEventInput;
}>;


export type CreateBookingStartedEventMutation = { __typename?: 'Mutation', createBookingStartedEvent: { __typename?: 'BookingStartedEvent', id: string } };

export type CreateNewsfeedPostInteractedWithEventMutationVariables = Exact<{
  data: CreateNewsfeedEventInput;
}>;


export type CreateNewsfeedPostInteractedWithEventMutation = { __typename?: 'Mutation', createNewsfeedPostInteractedWithEvent: { __typename?: 'NewsfeedEvent', id: string } };

export type CreateNewsfeedPostOpenedEventMutationVariables = Exact<{
  data: CreateNewsfeedEventInput;
}>;


export type CreateNewsfeedPostOpenedEventMutation = { __typename?: 'Mutation', createNewsfeedPostOpenedEvent: { __typename?: 'NewsfeedEvent', id: string } };

export type CreateGenericEventMutationVariables = Exact<{
  data: CreateGenericEventInput;
}>;


export type CreateGenericEventMutation = { __typename?: 'Mutation', createGenericEvent: { __typename?: 'GenericEvent', id: string } };

export type GroupPayMemberFieldsFragment = { __typename?: 'GroupPayMember', id: string, name: string, email: string };

export type GroupPayShareFieldsFragment = { __typename?: 'GroupPayShare', id: string, remaining_slots?: number | null, last_payment_due_date?: number | null, join_url?: string | null, shares: Array<{ __typename?: 'SlotShare', slots: number, total: number, is_invitation_accepted: boolean, is_host: boolean, member: { __typename?: 'GroupPayMember', id: string, name: string, email: string }, payments: Array<{ __typename?: 'Payment', id: string, date: number, value: number, status: PaymentStatus, errors: Array<{ __typename?: 'PaymentError', code?: string | null, message: string }>, refunds: Array<{ __typename?: 'Refund', id: string, amount: number, payment_id: string, status: RefundStatus, approved_by_name: string, user_reason: string, stripe_reason?: StripeRefundReason | null, created_at: number, cancelled_at?: number | null, error?: { __typename?: 'PaymentError', message: string } | null, created_by: { __typename?: 'User', first_name?: string | null, last_name?: string | null }, cancelled_by?: { __typename?: 'User', first_name?: string | null, last_name?: string | null } | null }> }> }> };

export type SlotShareFieldsFragment = { __typename?: 'SlotShare', slots: number, total: number, is_invitation_accepted: boolean, is_host: boolean, member: { __typename?: 'GroupPayMember', id: string, name: string, email: string }, payments: Array<{ __typename?: 'Payment', id: string, date: number, value: number, status: PaymentStatus, errors: Array<{ __typename?: 'PaymentError', code?: string | null, message: string }>, refunds: Array<{ __typename?: 'Refund', id: string, amount: number, payment_id: string, status: RefundStatus, approved_by_name: string, user_reason: string, stripe_reason?: StripeRefundReason | null, created_at: number, cancelled_at?: number | null, error?: { __typename?: 'PaymentError', message: string } | null, created_by: { __typename?: 'User', first_name?: string | null, last_name?: string | null }, cancelled_by?: { __typename?: 'User', first_name?: string | null, last_name?: string | null } | null }> }> };

export type SlotSharePaymentFieldsFragment = { __typename?: 'Payment', id: string, date: number, value: number, status: PaymentStatus, errors: Array<{ __typename?: 'PaymentError', code?: string | null, message: string }>, refunds: Array<{ __typename?: 'Refund', id: string, amount: number, payment_id: string, status: RefundStatus, approved_by_name: string, user_reason: string, stripe_reason?: StripeRefundReason | null, created_at: number, cancelled_at?: number | null, error?: { __typename?: 'PaymentError', message: string } | null, created_by: { __typename?: 'User', first_name?: string | null, last_name?: string | null }, cancelled_by?: { __typename?: 'User', first_name?: string | null, last_name?: string | null } | null }> };

export type SlotPaymentPlanFieldsFragment = { __typename?: 'SlotPaymentPlan', slots: number, total: number, payment_plan: { __typename?: 'QuotePaymentPlan', id: string, name?: string | null, note?: string | null, type: PaymentPlanType, payments: Array<{ __typename?: 'QuotePayment', id: string, date: number, value: number }> }, trip_insurance?: { __typename?: 'BookingQuoteTripInsuranceQuote', quote_id: string, is_accepted?: boolean | null, zip_code?: string | null, cost: number, policy_attributes?: { __typename?: 'TripInsurancePolicyAttribute', insurable_amount: number, insurable_amount_currency: string, event_start_date: number, event_end_date: number } | null, taxes_and_fees?: Array<{ __typename?: 'TripInsuranceTaxesAndFees', amount: number, description: string, type?: string | null }> | null, product: { __typename?: 'TripInsuranceProduct', description: string, promotional_header?: string | null, promotional_description?: string | null, accept_action_text?: string | null, decline_action_text?: string | null, legal_disclaimer?: string | null, privacy_policy_url?: string | null, terms_conditions_url?: string | null, additional_policy_purchase_email_message?: string | null, carrier_logo_url?: string | null, descriptors?: Array<string | null> | null, perils?: Array<string | null> | null, peril_heading?: string | null } } | null, totals?: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }> | null };

export type JoinGroupPayMutationVariables = Exact<{
  input: JoinGroupPayInput;
}>;


export type JoinGroupPayMutation = { __typename?: 'Mutation', joinGroupPay: { __typename?: 'GroupPayShare', id: string, remaining_slots?: number | null, last_payment_due_date?: number | null, join_url?: string | null, shares: Array<{ __typename?: 'SlotShare', slots: number, total: number, is_invitation_accepted: boolean, is_host: boolean, member: { __typename?: 'GroupPayMember', id: string, name: string, email: string }, payments: Array<{ __typename?: 'Payment', id: string, date: number, value: number, status: PaymentStatus, errors: Array<{ __typename?: 'PaymentError', code?: string | null, message: string }>, refunds: Array<{ __typename?: 'Refund', id: string, amount: number, payment_id: string, status: RefundStatus, approved_by_name: string, user_reason: string, stripe_reason?: StripeRefundReason | null, created_at: number, cancelled_at?: number | null, error?: { __typename?: 'PaymentError', message: string } | null, created_by: { __typename?: 'User', first_name?: string | null, last_name?: string | null }, cancelled_by?: { __typename?: 'User', first_name?: string | null, last_name?: string | null } | null }> }> }> } };

export type GroupPaySharePaymentPlanBySlotsQueryVariables = Exact<{
  bookingId: Scalars['ID']['input'];
  slots: Scalars['PositiveInt']['input'];
  isAchPaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
  isExternalPaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
  sportsmanZipCode?: InputMaybe<Scalars['String']['input']>;
  shouldAcceptTripInsurance?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GroupPaySharePaymentPlanBySlotsQuery = { __typename?: 'Query', groupPaySharePaymentPlanBySlots: { __typename?: 'SlotPaymentPlan', slots: number, total: number, payment_plan: { __typename?: 'QuotePaymentPlan', id: string, name?: string | null, note?: string | null, type: PaymentPlanType, payments: Array<{ __typename?: 'QuotePayment', id: string, date: number, value: number }> }, trip_insurance?: { __typename?: 'BookingQuoteTripInsuranceQuote', quote_id: string, is_accepted?: boolean | null, zip_code?: string | null, cost: number, policy_attributes?: { __typename?: 'TripInsurancePolicyAttribute', insurable_amount: number, insurable_amount_currency: string, event_start_date: number, event_end_date: number } | null, taxes_and_fees?: Array<{ __typename?: 'TripInsuranceTaxesAndFees', amount: number, description: string, type?: string | null }> | null, product: { __typename?: 'TripInsuranceProduct', description: string, promotional_header?: string | null, promotional_description?: string | null, accept_action_text?: string | null, decline_action_text?: string | null, legal_disclaimer?: string | null, privacy_policy_url?: string | null, terms_conditions_url?: string | null, additional_policy_purchase_email_message?: string | null, carrier_logo_url?: string | null, descriptors?: Array<string | null> | null, perils?: Array<string | null> | null, peril_heading?: string | null } } | null, totals?: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }> | null } };

export type GetInvoicePdfQueryVariables = Exact<{
  entityType: EntityType;
  entityId: Scalars['ID']['input'];
  accessCodeId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetInvoicePdfQuery = { __typename?: 'Query', getInvoicePdf?: string | null };

export type RegionFieldsFragment = { __typename?: 'Region', label: string, sub_label: string, states_subsection: { __typename?: 'PageSubsection', label: string, sub_label?: string | null, items: Array<{ __typename?: 'PageSubsectionItem', label: string, sub_label?: string | null, cta_url?: string | null }> }, countries_subsection: { __typename?: 'PageSubsection', label: string, sub_label?: string | null, items: Array<{ __typename?: 'PageSubsectionItem', label: string, sub_label?: string | null, cta_url?: string | null }> } };

export type ListingRegionAggregationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListingRegionAggregationsQuery = { __typename?: 'Query', listingRegionAggregations: { __typename?: 'Region', label: string, sub_label: string, states_subsection: { __typename?: 'PageSubsection', label: string, sub_label?: string | null, items: Array<{ __typename?: 'PageSubsectionItem', label: string, sub_label?: string | null, cta_url?: string | null }> }, countries_subsection: { __typename?: 'PageSubsection', label: string, sub_label?: string | null, items: Array<{ __typename?: 'PageSubsectionItem', label: string, sub_label?: string | null, cta_url?: string | null }> } } };

export type ListingFieldsFragment = { __typename?: 'Listing', id: string, type?: ListingType | null, published?: boolean | null, title?: string | null, description?: string | null, rule?: string | null, booking_instructions?: string | null, min_guest?: number | null, max_guest?: number | null, duration?: ListingDuration | null, admin_note?: string | null, featured?: boolean | null, created_at: number, updated_at: number, is_unavailable?: boolean | null, cover_image?: string | null, license_required?: boolean | null, should_allow_quote_requests?: boolean | null, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, description: string, category: AmenityCategory, icon_url: string }>, species: Array<{ __typename?: 'Species', id: string, type: SpeciesType, name: string, image?: { __typename?: 'Media', url: string, description?: string | null } | null }>, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, lodging?: { __typename?: 'Lodging', id: string } | null, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, license_info?: { __typename?: 'LicenseInfo', general_info_url?: string | null, hunting_info_url?: string | null, fishing_info_url?: string | null, online_portal_url?: string | null } | null, outfitter: { __typename?: 'Outfitter', id: string, slug: string, created_at: number, name: string, about: string, cancellation_policy: { __typename?: 'OutfitterCancellationPolicy', policy_id: string, description: string }, avatar?: { __typename?: 'Media', url: string, description?: string | null } | null, location?: { __typename?: 'Address', city: string, state: string } | null, owner: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, bio: string, years_of_experience?: number | null, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null } }, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null, lowest_pricing_package?: { __typename?: 'PricingPackage', name: string, price: number } | null, next_availability?: { __typename?: 'GenericAvailabilityEntry', id: string, resource_type: string, resource_id: string, date: number, is_available: boolean, total_slots: number, booked_slots: number, available_slots: number, created_at: number, updated_at: number } | null };

export type ListingsFieldsFragment = { __typename?: 'Listing', id: string, type?: ListingType | null, published?: boolean | null, title?: string | null, description?: string | null, min_guest?: number | null, max_guest?: number | null, cover_image?: string | null, license_required?: boolean | null, should_allow_quote_requests?: boolean | null, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, description: string, category: AmenityCategory, icon_url: string }>, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, license_info?: { __typename?: 'LicenseInfo', general_info_url?: string | null, hunting_info_url?: string | null, fishing_info_url?: string | null, online_portal_url?: string | null } | null, outfitter: { __typename?: 'Outfitter', id: string, slug: string, created_at: number, name: string, about: string, avatar?: { __typename?: 'Media', url: string, description?: string | null } | null, location?: { __typename?: 'Address', city: string, state: string } | null, owner: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, bio: string, years_of_experience?: number | null, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null } }, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null, lowest_pricing_package?: { __typename?: 'PricingPackage', name: string, price: number } | null };

export type PublicListingFieldsFragment = { __typename?: 'PublicListing', description?: string | null, rule?: string | null, is_unavailable?: boolean | null, should_allow_quote_requests?: boolean | null, id: string, type?: ListingType | null, title?: string | null, published?: boolean | null, min_guest?: number | null, max_guest?: number | null, license_required?: boolean | null, cover_image?: string | null, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, description: string, category: AmenityCategory, icon_url: string }>, species: Array<{ __typename?: 'Species', id: string, type: SpeciesType, name: string, image?: { __typename?: 'Media', url: string, description?: string | null } | null }>, next_availability?: { __typename?: 'GenericAvailabilityEntry', date: number } | null, license_info?: { __typename?: 'LicenseInfo', general_info_url?: string | null, hunting_info_url?: string | null, fishing_info_url?: string | null, online_portal_url?: string | null } | null, outfitter: { __typename?: 'PublicOutfitter', id: string, slug: string, created_at: number, name: string, about: string, avatar?: { __typename?: 'Media', url: string, description?: string | null } | null, location?: { __typename?: 'Address', city: string, state: string } | null, owner: { __typename?: 'PublicUser', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, bio: string, years_of_experience?: number | null, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null } }, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null, lowest_pricing_package?: { __typename?: 'PublicPricingPackage', price: number } | null };

export type PublicListingFieldsWithoutOutfitterFragment = { __typename?: 'PublicListing', id: string, type?: ListingType | null, title?: string | null, published?: boolean | null, min_guest?: number | null, max_guest?: number | null, license_required?: boolean | null, cover_image?: string | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null, lowest_pricing_package?: { __typename?: 'PublicPricingPackage', price: number } | null };

export type SearchListingFieldsFragment = { __typename?: 'Listing', id: string, type?: ListingType | null, title?: string | null, published?: boolean | null, min_guest?: number | null, max_guest?: number | null, cover_image?: string | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, outfitter: { __typename?: 'Outfitter', id: string, slug: string, created_at: number, name: string, about: string, avatar?: { __typename?: 'Media', url: string, description?: string | null } | null, location?: { __typename?: 'Address', city: string, state: string } | null, owner: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, bio: string, years_of_experience?: number | null, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null } }, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null, lowest_pricing_package?: { __typename?: 'PricingPackage', name: string, price: number } | null };

export type PublicSearchListingFieldsFragment = { __typename?: 'PublicListing', id: string, type?: ListingType | null, title?: string | null, published?: boolean | null, min_guest?: number | null, max_guest?: number | null, cover_image?: string | null, is_unavailable?: boolean | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, outfitter: { __typename?: 'PublicOutfitter', id: string, slug: string, created_at: number, name: string, about: string, avatar?: { __typename?: 'Media', url: string, description?: string | null } | null, location?: { __typename?: 'Address', city: string, state: string } | null, owner: { __typename?: 'PublicUser', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, bio: string, years_of_experience?: number | null, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null } }, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null, lowest_pricing_package?: { __typename?: 'PublicPricingPackage', price: number } | null, next_availability?: { __typename?: 'GenericAvailabilityEntry', date: number } | null };

export type ListingMinimalFieldsFragment = { __typename?: 'Listing', id: string, type?: ListingType | null, title?: string | null, description?: string | null, published?: boolean | null, license_required?: boolean | null, cover_image?: string | null, outfitter: { __typename?: 'Outfitter', id: string, slug: string, created_at: number, name: string, about: string, avatar?: { __typename?: 'Media', url: string, description?: string | null } | null, location?: { __typename?: 'Address', city: string, state: string } | null, owner: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, bio: string, years_of_experience?: number | null, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null } }, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null, lowest_pricing_package?: { __typename?: 'PricingPackage', name: string, price: number } | null };

export type ListingMinimalFieldsWithoutOutfitterFragment = { __typename?: 'Listing', id: string, type?: ListingType | null, title?: string | null, description?: string | null, published?: boolean | null, license_required?: boolean | null, cover_image?: string | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null, lowest_pricing_package?: { __typename?: 'PricingPackage', name: string, price: number } | null };

export type ListingPricingFieldsFragment = { __typename?: 'Pricing', type: PricingType, options: Array<{ __typename?: 'PricingOption', id: string, name: string, day_rate: number, min: number, max: number, note?: string | null }> };

export type ListingPricingOptionFieldsFragment = { __typename?: 'PricingOption', id: string, name: string, day_rate: number, min: number, max: number, note?: string | null };

export type ListingOutfitterFieldsFragment = { __typename?: 'Outfitter', id: string, slug: string, created_at: number, name: string, about: string, avatar?: { __typename?: 'Media', url: string, description?: string | null } | null, location?: { __typename?: 'Address', city: string, state: string } | null, owner: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, bio: string, years_of_experience?: number | null, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null } };

export type ListingPublicOutfitterFieldsFragment = { __typename?: 'PublicOutfitter', id: string, slug: string, created_at: number, name: string, about: string, avatar?: { __typename?: 'Media', url: string, description?: string | null } | null, location?: { __typename?: 'Address', city: string, state: string } | null, owner: { __typename?: 'PublicUser', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, bio: string, years_of_experience?: number | null, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null } };

export type ListingOutfitterWithCancellationPolicyFieldsFragment = { __typename?: 'Outfitter', id: string, slug: string, created_at: number, name: string, about: string, cancellation_policy: { __typename?: 'OutfitterCancellationPolicy', policy_id: string, description: string }, avatar?: { __typename?: 'Media', url: string, description?: string | null } | null, location?: { __typename?: 'Address', city: string, state: string } | null, owner: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, bio: string, years_of_experience?: number | null, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null } };

export type LicenseInfoFieldsFragment = { __typename?: 'LicenseInfo', general_info_url?: string | null, hunting_info_url?: string | null, fishing_info_url?: string | null, online_portal_url?: string | null };

export type ListingQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ListingQuery = { __typename?: 'Query', listing: { __typename?: 'Listing', id: string, type?: ListingType | null, published?: boolean | null, title?: string | null, description?: string | null, rule?: string | null, booking_instructions?: string | null, min_guest?: number | null, max_guest?: number | null, duration?: ListingDuration | null, admin_note?: string | null, featured?: boolean | null, created_at: number, updated_at: number, is_unavailable?: boolean | null, cover_image?: string | null, license_required?: boolean | null, should_allow_quote_requests?: boolean | null, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, description: string, category: AmenityCategory, icon_url: string }>, species: Array<{ __typename?: 'Species', id: string, type: SpeciesType, name: string, image?: { __typename?: 'Media', url: string, description?: string | null } | null }>, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, lodging?: { __typename?: 'Lodging', id: string } | null, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, license_info?: { __typename?: 'LicenseInfo', general_info_url?: string | null, hunting_info_url?: string | null, fishing_info_url?: string | null, online_portal_url?: string | null } | null, outfitter: { __typename?: 'Outfitter', id: string, slug: string, created_at: number, name: string, about: string, cancellation_policy: { __typename?: 'OutfitterCancellationPolicy', policy_id: string, description: string }, avatar?: { __typename?: 'Media', url: string, description?: string | null } | null, location?: { __typename?: 'Address', city: string, state: string } | null, owner: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, bio: string, years_of_experience?: number | null, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null } }, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null, lowest_pricing_package?: { __typename?: 'PricingPackage', name: string, price: number } | null, next_availability?: { __typename?: 'GenericAvailabilityEntry', id: string, resource_type: string, resource_id: string, date: number, is_available: boolean, total_slots: number, booked_slots: number, available_slots: number, created_at: number, updated_at: number } | null } };

export type PublicListingsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type PublicListingsQuery = { __typename?: 'Query', publicListings: Array<{ __typename?: 'PublicListing', description?: string | null, rule?: string | null, is_unavailable?: boolean | null, should_allow_quote_requests?: boolean | null, id: string, type?: ListingType | null, title?: string | null, published?: boolean | null, min_guest?: number | null, max_guest?: number | null, license_required?: boolean | null, cover_image?: string | null, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, description: string, category: AmenityCategory, icon_url: string }>, species: Array<{ __typename?: 'Species', id: string, type: SpeciesType, name: string, image?: { __typename?: 'Media', url: string, description?: string | null } | null }>, next_availability?: { __typename?: 'GenericAvailabilityEntry', date: number } | null, license_info?: { __typename?: 'LicenseInfo', general_info_url?: string | null, hunting_info_url?: string | null, fishing_info_url?: string | null, online_portal_url?: string | null } | null, outfitter: { __typename?: 'PublicOutfitter', id: string, slug: string, created_at: number, name: string, about: string, avatar?: { __typename?: 'Media', url: string, description?: string | null } | null, location?: { __typename?: 'Address', city: string, state: string } | null, owner: { __typename?: 'PublicUser', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, bio: string, years_of_experience?: number | null, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null } }, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null, lowest_pricing_package?: { __typename?: 'PublicPricingPackage', price: number } | null }> };

export type PublicListingsIdsOnlyQueryVariables = Exact<{ [key: string]: never; }>;


export type PublicListingsIdsOnlyQuery = { __typename?: 'Query', publicListings: Array<{ __typename?: 'PublicListing', id: string }> };

export type SearchListingsForSportsmenQueryVariables = Exact<{
  searchParams: SearchListingsForSportsmenInput;
  options: SearchOptions;
}>;


export type SearchListingsForSportsmenQuery = { __typename?: 'Query', searchListingsForSportsmen: { __typename?: 'PublicListingSearchResults', total: number, results: Array<{ __typename?: 'PublicListing', id: string, type?: ListingType | null, title?: string | null, published?: boolean | null, min_guest?: number | null, max_guest?: number | null, cover_image?: string | null, is_unavailable?: boolean | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, outfitter: { __typename?: 'PublicOutfitter', id: string, slug: string, created_at: number, name: string, about: string, avatar?: { __typename?: 'Media', url: string, description?: string | null } | null, location?: { __typename?: 'Address', city: string, state: string } | null, owner: { __typename?: 'PublicUser', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, bio: string, years_of_experience?: number | null, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null } }, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null, lowest_pricing_package?: { __typename?: 'PublicPricingPackage', price: number } | null, next_availability?: { __typename?: 'GenericAvailabilityEntry', date: number } | null }> } };

export type LodgingFieldsFragment = { __typename?: 'Lodging', id: string, name: string, description: string, type: LodgingType, capacity: number, created_at: number, updated_at: number, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, outfitter: { __typename?: 'Outfitter', id: string, slug: string, name: string }, images?: Array<{ __typename?: 'Media', url: string }> | null };

export type PublicLodgingFieldsFragment = { __typename?: 'PublicLodging', id: string, name: string, description: string, type: LodgingType, type_name: string, capacity: number, cover_image: string, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, images?: Array<{ __typename?: 'Media', url: string, description?: string | null }> | null };

export type LodgingQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LodgingQuery = { __typename?: 'Query', lodging: { __typename?: 'Lodging', id: string, name: string, description: string, type: LodgingType, type_name: string, capacity: number, cover_image: string, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, images?: Array<{ __typename?: 'Media', url: string, description?: string | null }> | null } };

export type PublicLodgingsByListingQueryVariables = Exact<{
  listingId: Scalars['ID']['input'];
}>;


export type PublicLodgingsByListingQuery = { __typename?: 'Query', publicLodgingsByListing: Array<{ __typename?: 'PublicLodging', id: string, name: string, description: string, type: LodgingType, type_name: string, capacity: number, cover_image: string, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, images?: Array<{ __typename?: 'Media', url: string, description?: string | null }> | null }> };

export type MediaFieldsFragment = { __typename?: 'Media', url: string, description?: string | null };

export type GenericSearchSuggestionGroupFieldsFragment = { __typename?: 'GenericSearchSuggestionGroup', title: string, type: string, items: Array<{ __typename?: 'GenericSearchSuggestionItem', type: string, label: string, value: string, image_url?: string | null, icon_url?: string | null, cta_url?: string | null }> };

export type GenericSearchSuggestionItemFieldsFragment = { __typename?: 'GenericSearchSuggestionItem', type: string, label: string, value: string, image_url?: string | null, icon_url?: string | null, cta_url?: string | null };

export type GetSearchSuggestionsForTripQueryVariables = Exact<{
  searchParams: SearchListingsForSportsmenInput;
}>;


export type GetSearchSuggestionsForTripQuery = { __typename?: 'Query', getSearchSuggestionsForTrip: Array<{ __typename?: 'GenericSearchSuggestionGroup', title: string, type: string, items: Array<{ __typename?: 'GenericSearchSuggestionItem', type: string, label: string, value: string, image_url?: string | null, icon_url?: string | null, cta_url?: string | null }> }> };

export type OnboardingFieldsFragment = { __typename?: 'Onboarding', id: string };

export type OnboardingStatusInfoFieldsFragment = { __typename?: 'OnboardingStatusInfo', status: OnboardingStatus };

export type OnboardingStatusInfoQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OnboardingStatusInfoQuery = { __typename?: 'Query', onboardingStatusInfo: { __typename?: 'OnboardingStatusInfo', status: OnboardingStatus } };

export type CreateDraftOnboardingMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateDraftOnboardingMutation = { __typename?: 'Mutation', createDraftOnboarding: { __typename?: 'Onboarding', id: string } };

export type OutfitterFieldsFragment = { __typename?: 'Outfitter', listings_count: number, id: string, slug: string, name: string, about: string, status: OutfitterStatus, cover_image?: string | null, is_demo?: boolean | null, listings: Array<{ __typename?: 'Listing', min_guest?: number | null, max_guest?: number | null, id: string, type?: ListingType | null, title?: string | null, description?: string | null, published?: boolean | null, license_required?: boolean | null, cover_image?: string | null, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null, next_availability?: { __typename?: 'GenericAvailabilityEntry', date: number } | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, lowest_pricing_package?: { __typename?: 'PricingPackage', name: string, price: number } | null }>, owner: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, bio: string, years_of_experience?: number | null, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null }, lodgings: Array<{ __typename?: 'Lodging', id: string, name: string, description: string, type: LodgingType, type_name: string, capacity: number, cover_image: string, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, images?: Array<{ __typename?: 'Media', url: string, description?: string | null }> | null }>, guides: Array<{ __typename?: 'TeamMember', id: string, name: string, user?: { __typename?: 'User', avatar_url?: string | null } | null }>, resources: Array<{ __typename?: 'Resource', id: string, outfitter_id: string, type: ResourceType, name: string, capacity?: number | null, year?: number | null, cover_image: string, description?: string | null, created_at: number, updated_at: number, images?: Array<{ __typename?: 'Media', url: string }> | null, vehicle_props?: { __typename?: 'VehicleProps', category: VehicleCategory, make?: string | null, model?: string | null } | null, boat_props?: { __typename?: 'BoatProps', category: BoatCategory, length?: number | null, boat_manufacturer?: string | null, boat_type?: string | null } | null, blind_props?: { __typename?: 'BlindProps', category: BlindCategory } | null, atv_props?: { __typename?: 'AtvProps', category: AtvCategory, manufacturer?: string | null } | null, gear_props?: { __typename?: 'GearProps', other?: string | null } | null }>, avatar?: { __typename?: 'Media', url: string, description?: string | null } | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, video?: { __typename?: 'Video', hosted?: { __typename?: 'Media', url: string, description?: string | null } | null, social?: { __typename?: 'Media', url: string, description?: string | null } | null } | null, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null };

export type PublicOutfitterFieldsFragment = { __typename?: 'PublicOutfitter', id: string, slug: string, created_at: number, name: string, about: string, listings_count: number, avatar?: { __typename?: 'Media', url: string, description?: string | null } | null, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, video?: { __typename?: 'Video', hosted?: { __typename?: 'Media', url: string, description?: string | null } | null, social?: { __typename?: 'Media', url: string, description?: string | null } | null } | null, owner: { __typename?: 'PublicUser', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, bio: string, years_of_experience?: number | null, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null }, guides: Array<{ __typename?: 'PublicTeamMember', id: string, name: string, avatar?: string | null, role: TeamMemberRole, user?: { __typename?: 'PublicUser', avatar_url?: string | null, bio: string, years_of_experience?: number | null, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null } | null }>, lodgings: Array<{ __typename?: 'PublicLodging', id: string, name: string, description: string, type: LodgingType, type_name: string, capacity: number, cover_image: string, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, images?: Array<{ __typename?: 'Media', url: string, description?: string | null }> | null }> };

export type AllOutfittersFieldsFragment = { __typename?: 'Outfitter', id: string, slug: string, name: string, about: string, status: OutfitterStatus, cover_image?: string | null, is_demo?: boolean | null, listings_count: number, avatar?: { __typename?: 'Media', url: string, description?: string | null } | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, video?: { __typename?: 'Video', hosted?: { __typename?: 'Media', url: string, description?: string | null } | null, social?: { __typename?: 'Media', url: string, description?: string | null } | null } | null, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null };

export type OutfitterListingFieldsFragment = { __typename?: 'Listing', min_guest?: number | null, max_guest?: number | null, id: string, type?: ListingType | null, title?: string | null, description?: string | null, published?: boolean | null, license_required?: boolean | null, cover_image?: string | null, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null, next_availability?: { __typename?: 'GenericAvailabilityEntry', date: number } | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, lowest_pricing_package?: { __typename?: 'PricingPackage', name: string, price: number } | null };

export type OutfitterLodgingFieldsFragment = { __typename?: 'Lodging', id: string, name: string, description: string, type: LodgingType, type_name: string, capacity: number, cover_image: string, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, images?: Array<{ __typename?: 'Media', url: string, description?: string | null }> | null };

export type OutfitterCancellationPolicyFieldsFragment = { __typename?: 'OutfitterCancellationPolicy', policy_id: string, description: string };

export type OutfitterMinimalFieldsFragment = { __typename?: 'Outfitter', id: string, slug: string, name: string, status: OutfitterStatus, time_zone?: string | null, avatar?: { __typename?: 'Media', url: string, description?: string | null } | null, owner: { __typename?: 'User', first_name?: string | null, last_name?: string | null, avatar_url?: string | null } };

export type OutfitterQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OutfitterQuery = { __typename?: 'Query', outfitter: { __typename?: 'Outfitter', listings_count: number, id: string, slug: string, name: string, about: string, status: OutfitterStatus, cover_image?: string | null, is_demo?: boolean | null, listings: Array<{ __typename?: 'Listing', min_guest?: number | null, max_guest?: number | null, id: string, type?: ListingType | null, title?: string | null, description?: string | null, published?: boolean | null, license_required?: boolean | null, cover_image?: string | null, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null, next_availability?: { __typename?: 'GenericAvailabilityEntry', date: number } | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, lowest_pricing_package?: { __typename?: 'PricingPackage', name: string, price: number } | null }>, owner: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, bio: string, years_of_experience?: number | null, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null }, lodgings: Array<{ __typename?: 'Lodging', id: string, name: string, description: string, type: LodgingType, type_name: string, capacity: number, cover_image: string, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, images?: Array<{ __typename?: 'Media', url: string, description?: string | null }> | null }>, guides: Array<{ __typename?: 'TeamMember', id: string, name: string, user?: { __typename?: 'User', avatar_url?: string | null } | null }>, resources: Array<{ __typename?: 'Resource', id: string, outfitter_id: string, type: ResourceType, name: string, capacity?: number | null, year?: number | null, cover_image: string, description?: string | null, created_at: number, updated_at: number, images?: Array<{ __typename?: 'Media', url: string }> | null, vehicle_props?: { __typename?: 'VehicleProps', category: VehicleCategory, make?: string | null, model?: string | null } | null, boat_props?: { __typename?: 'BoatProps', category: BoatCategory, length?: number | null, boat_manufacturer?: string | null, boat_type?: string | null } | null, blind_props?: { __typename?: 'BlindProps', category: BlindCategory } | null, atv_props?: { __typename?: 'AtvProps', category: AtvCategory, manufacturer?: string | null } | null, gear_props?: { __typename?: 'GearProps', other?: string | null } | null }>, avatar?: { __typename?: 'Media', url: string, description?: string | null } | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, video?: { __typename?: 'Video', hosted?: { __typename?: 'Media', url: string, description?: string | null } | null, social?: { __typename?: 'Media', url: string, description?: string | null } | null } | null, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null } };

export type OutfitterListingsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OutfitterListingsQuery = { __typename?: 'Query', outfitter: { __typename?: 'Outfitter', listings: Array<{ __typename?: 'Listing', id: string, type?: ListingType | null, title?: string | null, description?: string | null, published?: boolean | null, license_required?: boolean | null, cover_image?: string | null, outfitter: { __typename?: 'Outfitter', id: string, slug: string, created_at: number, name: string, about: string, avatar?: { __typename?: 'Media', url: string, description?: string | null } | null, location?: { __typename?: 'Address', city: string, state: string } | null, owner: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, bio: string, years_of_experience?: number | null, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null } }, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null, lowest_pricing_package?: { __typename?: 'PricingPackage', name: string, price: number } | null }> } };

export type PublicOutfittersQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type PublicOutfittersQuery = { __typename?: 'Query', publicOutfitters: Array<{ __typename?: 'PublicOutfitter', id: string, slug: string, created_at: number, name: string, about: string, listings_count: number, avatar?: { __typename?: 'Media', url: string, description?: string | null } | null, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, video?: { __typename?: 'Video', hosted?: { __typename?: 'Media', url: string, description?: string | null } | null, social?: { __typename?: 'Media', url: string, description?: string | null } | null } | null, owner: { __typename?: 'PublicUser', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, bio: string, years_of_experience?: number | null, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null }, guides: Array<{ __typename?: 'PublicTeamMember', id: string, name: string, avatar?: string | null, role: TeamMemberRole, user?: { __typename?: 'PublicUser', avatar_url?: string | null, bio: string, years_of_experience?: number | null, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null } | null }>, lodgings: Array<{ __typename?: 'PublicLodging', id: string, name: string, description: string, type: LodgingType, type_name: string, capacity: number, cover_image: string, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, images?: Array<{ __typename?: 'Media', url: string, description?: string | null }> | null }> }> };

export type PublicOutfittersIdsOnlyQueryVariables = Exact<{ [key: string]: never; }>;


export type PublicOutfittersIdsOnlyQuery = { __typename?: 'Query', publicOutfitters: Array<{ __typename?: 'PublicOutfitter', id: string }> };

export type SearchOutfittersForSportsmenQueryVariables = Exact<{
  searchParams: SearchOutfittersForSportsmenInput;
  options: SearchOptions;
}>;


export type SearchOutfittersForSportsmenQuery = { __typename?: 'Query', searchOutfittersForSportsmen: { __typename?: 'PublicOutfitterSearchResults', total: number, results: Array<{ __typename?: 'PublicOutfitter', id: string, slug: string, created_at: number, name: string, about: string, listings_count: number, avatar?: { __typename?: 'Media', url: string, description?: string | null } | null, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, video?: { __typename?: 'Video', hosted?: { __typename?: 'Media', url: string, description?: string | null } | null, social?: { __typename?: 'Media', url: string, description?: string | null } | null } | null, owner: { __typename?: 'PublicUser', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, bio: string, years_of_experience?: number | null, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null }, guides: Array<{ __typename?: 'PublicTeamMember', id: string, name: string, avatar?: string | null, role: TeamMemberRole, user?: { __typename?: 'PublicUser', avatar_url?: string | null, bio: string, years_of_experience?: number | null, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null } | null }>, lodgings: Array<{ __typename?: 'PublicLodging', id: string, name: string, description: string, type: LodgingType, type_name: string, capacity: number, cover_image: string, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, images?: Array<{ __typename?: 'Media', url: string, description?: string | null }> | null }> }> } };

export type PaymentRequestBookingFieldsFragment = { __typename?: 'Booking', id: string, sub_total: number, listing: { __typename?: 'Listing', title?: string | null, type?: ListingType | null, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }> }, add_ons?: Array<{ __typename?: 'QuoteAddOn', id: string, name: string, category: string, note?: string | null, unit_price: number, deposit_amount?: number | null, deposit_percentage?: number | null, offer_period: AddOnOfferPeriod, quantity: number, package_id?: string | null }> | null };

export type PaymentRequestFieldsFragment = { __typename?: 'PaymentRequest', id: string, intent_id?: string | null, invoice_id?: string | null, status: PaymentRequestStatus, subtotal?: number | null, sales_tax?: number | null, processing_fee?: number | null, value: number, should_include_taxes?: boolean | null, created_at: number, updated_at: number, add_ons?: Array<{ __typename?: 'PaymentRequestAddOn', id: string, total: number, quantity: number, number_of_days?: number | null, number_of_guests?: number | null }> | null, booking: { __typename?: 'Booking', id: string, sub_total: number, listing: { __typename?: 'Listing', title?: string | null, type?: ListingType | null, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }> }, add_ons?: Array<{ __typename?: 'QuoteAddOn', id: string, name: string, category: string, note?: string | null, unit_price: number, deposit_amount?: number | null, deposit_percentage?: number | null, offer_period: AddOnOfferPeriod, quantity: number, package_id?: string | null }> | null }, items: Array<{ __typename?: 'PaymentItemRequest', currency?: string | null, amount: number, description: string, add_on_id?: string | null }> };

export type PaymentRequestSummaryFieldsFragment = { __typename?: 'AdditionalPaymentSummary', total: number, line_items: Array<{ __typename?: 'LineItem', details_label?: string | null, display_value: string, label: string, details_value?: string | null, total: number }>, prices: Array<{ __typename?: 'QuotePrice', category?: QuotePriceCategory | null, currency?: string | null, name: string, value: number, note?: string | null, subsections: Array<{ __typename?: 'PriceSubsection', category?: QuotePriceCategory | null, currency?: string | null, name: string, value: number }> }> };

export type PaymentRequestQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  isAchPaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
  shouldCalculateFees?: InputMaybe<Scalars['Boolean']['input']>;
  tipAmount?: InputMaybe<Scalars['NonNegativeInt']['input']>;
}>;


export type PaymentRequestQuery = { __typename?: 'Query', paymentRequest: { __typename?: 'PaymentRequest', id: string, intent_id?: string | null, invoice_id?: string | null, status: PaymentRequestStatus, subtotal?: number | null, sales_tax?: number | null, processing_fee?: number | null, value: number, should_include_taxes?: boolean | null, created_at: number, updated_at: number, add_ons?: Array<{ __typename?: 'PaymentRequestAddOn', id: string, total: number, quantity: number, number_of_days?: number | null, number_of_guests?: number | null }> | null, booking: { __typename?: 'Booking', id: string, sub_total: number, listing: { __typename?: 'Listing', title?: string | null, type?: ListingType | null, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }> }, add_ons?: Array<{ __typename?: 'QuoteAddOn', id: string, name: string, category: string, note?: string | null, unit_price: number, deposit_amount?: number | null, deposit_percentage?: number | null, offer_period: AddOnOfferPeriod, quantity: number, package_id?: string | null }> | null }, items: Array<{ __typename?: 'PaymentItemRequest', currency?: string | null, amount: number, description: string, add_on_id?: string | null }> } };

export type AdditionalPaymentSummaryQueryVariables = Exact<{
  bookingId: Scalars['ID']['input'];
  data: AdditionalPaymentSummaryInput;
}>;


export type AdditionalPaymentSummaryQuery = { __typename?: 'Query', additionalPaymentSummary: { __typename?: 'AdditionalPaymentSummary', total: number, line_items: Array<{ __typename?: 'LineItem', details_label?: string | null, display_value: string, label: string, details_value?: string | null, total: number }>, prices: Array<{ __typename?: 'QuotePrice', category?: QuotePriceCategory | null, currency?: string | null, name: string, value: number, note?: string | null, subsections: Array<{ __typename?: 'PriceSubsection', category?: QuotePriceCategory | null, currency?: string | null, name: string, value: number }> }> } };

export type AcceptPaymentRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: AcceptPaymentRequestInput;
}>;


export type AcceptPaymentRequestMutation = { __typename?: 'Mutation', acceptPaymentRequest: { __typename?: 'PaymentRequest', id: string, intent_id?: string | null, invoice_id?: string | null, status: PaymentRequestStatus, subtotal?: number | null, sales_tax?: number | null, processing_fee?: number | null, value: number, should_include_taxes?: boolean | null, created_at: number, updated_at: number, add_ons?: Array<{ __typename?: 'PaymentRequestAddOn', id: string, total: number, quantity: number, number_of_days?: number | null, number_of_guests?: number | null }> | null, booking: { __typename?: 'Booking', id: string, sub_total: number, listing: { __typename?: 'Listing', title?: string | null, type?: ListingType | null, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }> }, add_ons?: Array<{ __typename?: 'QuoteAddOn', id: string, name: string, category: string, note?: string | null, unit_price: number, deposit_amount?: number | null, deposit_percentage?: number | null, offer_period: AddOnOfferPeriod, quantity: number, package_id?: string | null }> | null }, items: Array<{ __typename?: 'PaymentItemRequest', currency?: string | null, amount: number, description: string, add_on_id?: string | null }> } };

export type PaymentFieldsFragment = { __typename?: 'Payment', id: string, value: number, total?: number | null, sales_tax: number, processing_fee: number, status: PaymentStatus, outfitter: { __typename?: 'Outfitter', name: string } };

export type PaymentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  invitationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PaymentQuery = { __typename?: 'Query', payment: { __typename?: 'Payment', id: string, value: number, total?: number | null, sales_tax: number, processing_fee: number, status: PaymentStatus, outfitter: { __typename?: 'Outfitter', name: string } } };

export type RetryPaymentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: RetryPaymentInput;
}>;


export type RetryPaymentMutation = { __typename?: 'Mutation', retryPayment: { __typename?: 'Payment', receipt_hosted_url?: string | null, total?: number | null, intent_id?: string | null, note?: string | null, payment_method_id?: string | null, id: string, date: number, value: number, status: PaymentStatus, is_payment_method_unverified?: boolean | null, user?: { __typename?: 'User', id: string } | null, group_pay_member?: { __typename?: 'GroupPayMember', id: string } | null, errors: Array<{ __typename?: 'PaymentError', code?: string | null, message: string }>, refunds: Array<{ __typename?: 'Refund', id: string, amount: number, payment_id: string, status: RefundStatus, approved_by_name: string, user_reason: string, stripe_reason?: StripeRefundReason | null, created_at: number, cancelled_at?: number | null, error?: { __typename?: 'PaymentError', message: string } | null, created_by: { __typename?: 'User', first_name?: string | null, last_name?: string | null }, cancelled_by?: { __typename?: 'User', first_name?: string | null, last_name?: string | null } | null }> } };

export type PricingPackageFieldsFragment = { __typename?: 'PricingPackage', id: string, name: string, price: number, price_by_guest: PriceByGuest, price_by_day: PriceByDay, guests_included: number, min_guests?: number | null, max_guests?: number | null, days_included: number, lodging_included: boolean, included_lodging_id?: string | null, is_active: boolean, is_available?: boolean | null, not_available_reason?: string | null, included_resource_ids?: Array<string | null> | null, trophies: Array<{ __typename?: 'AddOn', id: string, name: string, category: string, species?: { __typename?: 'Species', id: string, type: SpeciesType, name: string } | null }>, gear_rentals: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, meal_upgrades: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, other_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, included_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, listing: { __typename?: 'Listing', id: string } };

export type MinimalPricingPackageFieldsFragment = { __typename?: 'PricingPackage', name: string, price: number };

export type PublicPricingPackageFieldsFragment = { __typename?: 'PublicPricingPackage', price: number };

export type GetPricingPackageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPricingPackageQuery = { __typename?: 'Query', pricingPackage: { __typename?: 'PricingPackage', id: string, name: string, price: number, price_by_guest: PriceByGuest, price_by_day: PriceByDay, guests_included: number, min_guests?: number | null, max_guests?: number | null, days_included: number, lodging_included: boolean, included_lodging_id?: string | null, is_active: boolean, is_available?: boolean | null, not_available_reason?: string | null, included_resource_ids?: Array<string | null> | null, trophies: Array<{ __typename?: 'AddOn', id: string, name: string, category: string, species?: { __typename?: 'Species', id: string, type: SpeciesType, name: string } | null }>, gear_rentals: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, meal_upgrades: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, other_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, included_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, listing: { __typename?: 'Listing', id: string } } };

export type PricingPackagesByListingQueryVariables = Exact<{
  listingId: Scalars['ID']['input'];
  dates?: InputMaybe<Array<Scalars['Timestamp']['input']> | Scalars['Timestamp']['input']>;
  numberOfGuests?: InputMaybe<Scalars['PositiveInt']['input']>;
}>;


export type PricingPackagesByListingQuery = { __typename?: 'Query', pricingPackagesByListing: Array<{ __typename?: 'PricingPackage', id: string, name: string, price: number, price_by_guest: PriceByGuest, price_by_day: PriceByDay, guests_included: number, min_guests?: number | null, max_guests?: number | null, days_included: number, lodging_included: boolean, included_lodging_id?: string | null, is_active: boolean, is_available?: boolean | null, not_available_reason?: string | null, included_resource_ids?: Array<string | null> | null, trophies: Array<{ __typename?: 'AddOn', id: string, name: string, category: string, species?: { __typename?: 'Species', id: string, type: SpeciesType, name: string } | null }>, gear_rentals: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, meal_upgrades: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, other_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, included_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, listing: { __typename?: 'Listing', id: string } }> };

export type QuoteRequestFieldsFragment = { __typename?: 'QuoteRequest', id: string, created_at: number, updated_at: number, dates: Array<number>, trip_details: string, is_archived: boolean, contact: { __typename?: 'QuoteRequestContact', first_name: string, last_name: string, email: string, phone?: string | null, preferred_method: QuoteRequestPreferredMethod }, listing?: { __typename?: 'Listing', id: string, type?: ListingType | null, published?: boolean | null, title?: string | null, description?: string | null, rule?: string | null, booking_instructions?: string | null, min_guest?: number | null, max_guest?: number | null, duration?: ListingDuration | null, admin_note?: string | null, featured?: boolean | null, created_at: number, updated_at: number, is_unavailable?: boolean | null, cover_image?: string | null, license_required?: boolean | null, should_allow_quote_requests?: boolean | null, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, description: string, category: AmenityCategory, icon_url: string }>, species: Array<{ __typename?: 'Species', id: string, type: SpeciesType, name: string, image?: { __typename?: 'Media', url: string, description?: string | null } | null }>, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, lodging?: { __typename?: 'Lodging', id: string } | null, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, license_info?: { __typename?: 'LicenseInfo', general_info_url?: string | null, hunting_info_url?: string | null, fishing_info_url?: string | null, online_portal_url?: string | null } | null, outfitter: { __typename?: 'Outfitter', id: string, slug: string, created_at: number, name: string, about: string, cancellation_policy: { __typename?: 'OutfitterCancellationPolicy', policy_id: string, description: string }, avatar?: { __typename?: 'Media', url: string, description?: string | null } | null, location?: { __typename?: 'Address', city: string, state: string } | null, owner: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, bio: string, years_of_experience?: number | null, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null } }, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null, lowest_pricing_package?: { __typename?: 'PricingPackage', name: string, price: number } | null, next_availability?: { __typename?: 'GenericAvailabilityEntry', id: string, resource_type: string, resource_id: string, date: number, is_available: boolean, total_slots: number, booked_slots: number, available_slots: number, created_at: number, updated_at: number } | null } | null, booking_invite?: { __typename?: 'BookingInvite', id: string } | null };

export type CreateQuoteRequestMutationVariables = Exact<{
  data: QuoteRequestInput;
}>;


export type CreateQuoteRequestMutation = { __typename?: 'Mutation', createQuoteRequest: { __typename?: 'QuoteRequest', id: string, created_at: number, updated_at: number, dates: Array<number>, trip_details: string, is_archived: boolean, contact: { __typename?: 'QuoteRequestContact', first_name: string, last_name: string, email: string, phone?: string | null, preferred_method: QuoteRequestPreferredMethod }, listing?: { __typename?: 'Listing', id: string, type?: ListingType | null, published?: boolean | null, title?: string | null, description?: string | null, rule?: string | null, booking_instructions?: string | null, min_guest?: number | null, max_guest?: number | null, duration?: ListingDuration | null, admin_note?: string | null, featured?: boolean | null, created_at: number, updated_at: number, is_unavailable?: boolean | null, cover_image?: string | null, license_required?: boolean | null, should_allow_quote_requests?: boolean | null, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, description: string, category: AmenityCategory, icon_url: string }>, species: Array<{ __typename?: 'Species', id: string, type: SpeciesType, name: string, image?: { __typename?: 'Media', url: string, description?: string | null } | null }>, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, lodging?: { __typename?: 'Lodging', id: string } | null, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, license_info?: { __typename?: 'LicenseInfo', general_info_url?: string | null, hunting_info_url?: string | null, fishing_info_url?: string | null, online_portal_url?: string | null } | null, outfitter: { __typename?: 'Outfitter', id: string, slug: string, created_at: number, name: string, about: string, cancellation_policy: { __typename?: 'OutfitterCancellationPolicy', policy_id: string, description: string }, avatar?: { __typename?: 'Media', url: string, description?: string | null } | null, location?: { __typename?: 'Address', city: string, state: string } | null, owner: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, bio: string, years_of_experience?: number | null, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null } }, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null, lowest_pricing_package?: { __typename?: 'PricingPackage', name: string, price: number } | null, next_availability?: { __typename?: 'GenericAvailabilityEntry', id: string, resource_type: string, resource_id: string, date: number, is_available: boolean, total_slots: number, booked_slots: number, available_slots: number, created_at: number, updated_at: number } | null } | null, booking_invite?: { __typename?: 'BookingInvite', id: string } | null } };

export type AddOnQuoteFieldsFragment = { __typename?: 'QuoteAddOn', id: string, category: string, name: string, unit_price: number, quantity: number, deposit_amount?: number | null, deposit_percentage?: number | null, price_by_day?: PriceByDay | null, price_by_guest?: PriceByGuest | null, package_id?: string | null };

export type BookingQuoteTripInsuranceQuoteFieldsFragment = { __typename?: 'BookingQuoteTripInsuranceQuote', quote_id: string, is_accepted?: boolean | null, zip_code?: string | null, cost: number, policy_attributes?: { __typename?: 'TripInsurancePolicyAttribute', insurable_amount: number, insurable_amount_currency: string, event_start_date: number, event_end_date: number } | null, taxes_and_fees?: Array<{ __typename?: 'TripInsuranceTaxesAndFees', amount: number, description: string, type?: string | null }> | null, product: { __typename?: 'TripInsuranceProduct', description: string, promotional_header?: string | null, promotional_description?: string | null, accept_action_text?: string | null, decline_action_text?: string | null, legal_disclaimer?: string | null, privacy_policy_url?: string | null, terms_conditions_url?: string | null, additional_policy_purchase_email_message?: string | null, carrier_logo_url?: string | null, descriptors?: Array<string | null> | null, perils?: Array<string | null> | null, peril_heading?: string | null } };

export type PaymentSummaryFieldsFragment = { __typename?: 'PaymentSummary', total: number, line_items: Array<{ __typename?: 'LineItem', total: number, label: string, display_value: string, details_label?: string | null, details_value?: string | null, key?: string | null, section_key?: string | null, sub_items?: Array<{ __typename?: 'SubItem', label: string }> | null }>, prices: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }>, totals: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }> };

export type LineItemFieldsFragment = { __typename?: 'LineItem', total: number, label: string, display_value: string, details_label?: string | null, details_value?: string | null, key?: string | null, section_key?: string | null, sub_items?: Array<{ __typename?: 'SubItem', label: string }> | null };

export type SubItemFieldsFragment = { __typename?: 'SubItem', label: string };

export type QuoteItemFieldsFragment = { __typename?: 'QuoteItem', name: string, option_id: string, rate: number, quantity: number, price: number };

export type QuoteListingFieldsFragment = { __typename?: 'Listing', id: string, title?: string | null, type?: ListingType | null, cover_image?: string | null, check_out_minutes?: number | null, time_zone?: string | null, location?: { __typename?: 'Address', zip?: string | null, city: string, state: string } | null, lodging?: { __typename?: 'Lodging', id: string } | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, outfitter: { __typename?: 'Outfitter', id: string, time_zone?: string | null, is_ach_enabled?: boolean | null, is_processing_fee_payed_by_sportsman?: boolean | null, cancellation_policy: { __typename?: 'OutfitterCancellationPolicy', policy_id: string, description: string } } };

export type QuotePaymentPlanFieldsFragment = { __typename?: 'QuotePaymentPlan', id: string, name?: string | null, note?: string | null, type: PaymentPlanType, payments: Array<{ __typename?: 'QuotePayment', id: string, date: number, value: number }> };

export type QuotePaymentGroupMemberFieldsFragment = { __typename?: 'QuotePaymentGroupMember', id: string, name: string, email: string, slots: number, amount: number, payment_plans: Array<{ __typename?: 'QuotePaymentPlan', id: string, name?: string | null, note?: string | null, type: PaymentPlanType, payments: Array<{ __typename?: 'QuotePayment', id: string, date: number, value: number }> }> };

export type QuotePaymentGroupFieldsFragment = { __typename?: 'QuotePaymentGroup', remaining_slots: number, last_payment_due_date: number, host: { __typename?: 'QuotePaymentGroupMember', id: string, name: string, email: string, slots: number, amount: number, payment_plans: Array<{ __typename?: 'QuotePaymentPlan', id: string, name?: string | null, note?: string | null, type: PaymentPlanType, payments: Array<{ __typename?: 'QuotePayment', id: string, date: number, value: number }> }> }, members: Array<{ __typename?: 'QuotePaymentGroupMember', id: string, name: string, email: string, slots: number, amount: number, payment_plans: Array<{ __typename?: 'QuotePaymentPlan', id: string, name?: string | null, note?: string | null, type: PaymentPlanType, payments: Array<{ __typename?: 'QuotePayment', id: string, date: number, value: number }> }> }> };

export type QuotePackageFieldsFragment = { __typename?: 'QuotePackage', id: string, line_item_key?: string | null, number_of_guests: number, pricing_package: { __typename?: 'PricingPackage', id: string, name: string, price: number, price_by_guest: PriceByGuest, price_by_day: PriceByDay, guests_included: number, min_guests?: number | null, max_guests?: number | null, days_included: number, lodging_included: boolean, included_lodging_id?: string | null, is_active: boolean, is_available?: boolean | null, not_available_reason?: string | null, included_resource_ids?: Array<string | null> | null, trophies: Array<{ __typename?: 'AddOn', id: string, name: string, category: string, species?: { __typename?: 'Species', id: string, type: SpeciesType, name: string } | null }>, gear_rentals: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, meal_upgrades: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, other_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, included_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, listing: { __typename?: 'Listing', id: string } }, items: Array<{ __typename?: 'QuoteItem', name: string, option_id: string, rate: number, quantity: number, price: number }>, add_ons: Array<{ __typename?: 'QuoteAddOn', id: string, category: string, name: string, unit_price: number, quantity: number, deposit_amount?: number | null, deposit_percentage?: number | null, price_by_day?: PriceByDay | null, price_by_guest?: PriceByGuest | null, package_id?: string | null }> };

type QuoteInterfaceFields_DraftQuote_Fragment = { __typename?: 'DraftQuote', dates: Array<number>, lodging_included?: boolean | null, discount?: number | null, total: number, listing: { __typename?: 'Listing', id: string, title?: string | null, type?: ListingType | null, cover_image?: string | null, check_out_minutes?: number | null, time_zone?: string | null, location?: { __typename?: 'Address', zip?: string | null, city: string, state: string } | null, lodging?: { __typename?: 'Lodging', id: string } | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, outfitter: { __typename?: 'Outfitter', id: string, time_zone?: string | null, is_ach_enabled?: boolean | null, is_processing_fee_payed_by_sportsman?: boolean | null, cancellation_policy: { __typename?: 'OutfitterCancellationPolicy', policy_id: string, description: string } } }, items: Array<{ __typename?: 'QuoteItem', name: string, option_id: string, rate: number, quantity: number, price: number }>, prices: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }>, packages: Array<{ __typename?: 'QuotePackage', id: string, line_item_key?: string | null, number_of_guests: number, pricing_package: { __typename?: 'PricingPackage', id: string, name: string, price: number, price_by_guest: PriceByGuest, price_by_day: PriceByDay, guests_included: number, min_guests?: number | null, max_guests?: number | null, days_included: number, lodging_included: boolean, included_lodging_id?: string | null, is_active: boolean, is_available?: boolean | null, not_available_reason?: string | null, included_resource_ids?: Array<string | null> | null, trophies: Array<{ __typename?: 'AddOn', id: string, name: string, category: string, species?: { __typename?: 'Species', id: string, type: SpeciesType, name: string } | null }>, gear_rentals: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, meal_upgrades: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, other_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, included_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, listing: { __typename?: 'Listing', id: string } }, items: Array<{ __typename?: 'QuoteItem', name: string, option_id: string, rate: number, quantity: number, price: number }>, add_ons: Array<{ __typename?: 'QuoteAddOn', id: string, category: string, name: string, unit_price: number, quantity: number, deposit_amount?: number | null, deposit_percentage?: number | null, price_by_day?: PriceByDay | null, price_by_guest?: PriceByGuest | null, package_id?: string | null }> }>, payment_plans: Array<{ __typename?: 'QuotePaymentPlan', id: string, name?: string | null, note?: string | null, type: PaymentPlanType, payments: Array<{ __typename?: 'QuotePayment', id: string, date: number, value: number }> }>, coupon?: { __typename?: 'Coupon', id: string, custom_code: string, amount_off?: number | null, percent_off?: number | null } | null, add_ons?: Array<{ __typename?: 'QuoteAddOn', id: string, category: string, name: string, unit_price: number, quantity: number, deposit_amount?: number | null, deposit_percentage?: number | null, price_by_day?: PriceByDay | null, price_by_guest?: PriceByGuest | null, package_id?: string | null }> | null, payment_summary?: { __typename?: 'PaymentSummary', total: number, line_items: Array<{ __typename?: 'LineItem', total: number, label: string, display_value: string, details_label?: string | null, details_value?: string | null, key?: string | null, section_key?: string | null, sub_items?: Array<{ __typename?: 'SubItem', label: string }> | null }>, prices: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }>, totals: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }> } | null, itinerary?: { __typename?: 'TripItinerary', title?: string | null, label?: string | null, items: Array<{ __typename?: 'TripItineraryItem', title: string, label: string, helper_text?: string | null, timestamp: number, type: TripItineraryItemType }> } | null, attribution?: { __typename?: 'Attribution', internal_source?: BookingInternalSource | null, internal_source_entity_id?: string | null, internal_source_entity_type?: BookingInternalSourceEntityType | null } | null };

type QuoteInterfaceFields_Quote_Fragment = { __typename?: 'Quote', dates: Array<number>, lodging_included?: boolean | null, discount?: number | null, total: number, listing: { __typename?: 'Listing', id: string, title?: string | null, type?: ListingType | null, cover_image?: string | null, check_out_minutes?: number | null, time_zone?: string | null, location?: { __typename?: 'Address', zip?: string | null, city: string, state: string } | null, lodging?: { __typename?: 'Lodging', id: string } | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, outfitter: { __typename?: 'Outfitter', id: string, time_zone?: string | null, is_ach_enabled?: boolean | null, is_processing_fee_payed_by_sportsman?: boolean | null, cancellation_policy: { __typename?: 'OutfitterCancellationPolicy', policy_id: string, description: string } } }, items: Array<{ __typename?: 'QuoteItem', name: string, option_id: string, rate: number, quantity: number, price: number }>, prices: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }>, packages: Array<{ __typename?: 'QuotePackage', id: string, line_item_key?: string | null, number_of_guests: number, pricing_package: { __typename?: 'PricingPackage', id: string, name: string, price: number, price_by_guest: PriceByGuest, price_by_day: PriceByDay, guests_included: number, min_guests?: number | null, max_guests?: number | null, days_included: number, lodging_included: boolean, included_lodging_id?: string | null, is_active: boolean, is_available?: boolean | null, not_available_reason?: string | null, included_resource_ids?: Array<string | null> | null, trophies: Array<{ __typename?: 'AddOn', id: string, name: string, category: string, species?: { __typename?: 'Species', id: string, type: SpeciesType, name: string } | null }>, gear_rentals: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, meal_upgrades: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, other_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, included_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, listing: { __typename?: 'Listing', id: string } }, items: Array<{ __typename?: 'QuoteItem', name: string, option_id: string, rate: number, quantity: number, price: number }>, add_ons: Array<{ __typename?: 'QuoteAddOn', id: string, category: string, name: string, unit_price: number, quantity: number, deposit_amount?: number | null, deposit_percentage?: number | null, price_by_day?: PriceByDay | null, price_by_guest?: PriceByGuest | null, package_id?: string | null }> }>, payment_plans: Array<{ __typename?: 'QuotePaymentPlan', id: string, name?: string | null, note?: string | null, type: PaymentPlanType, payments: Array<{ __typename?: 'QuotePayment', id: string, date: number, value: number }> }>, coupon?: { __typename?: 'Coupon', id: string, custom_code: string, amount_off?: number | null, percent_off?: number | null } | null, add_ons?: Array<{ __typename?: 'QuoteAddOn', id: string, category: string, name: string, unit_price: number, quantity: number, deposit_amount?: number | null, deposit_percentage?: number | null, price_by_day?: PriceByDay | null, price_by_guest?: PriceByGuest | null, package_id?: string | null }> | null, payment_summary?: { __typename?: 'PaymentSummary', total: number, line_items: Array<{ __typename?: 'LineItem', total: number, label: string, display_value: string, details_label?: string | null, details_value?: string | null, key?: string | null, section_key?: string | null, sub_items?: Array<{ __typename?: 'SubItem', label: string }> | null }>, prices: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }>, totals: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }> } | null, itinerary?: { __typename?: 'TripItinerary', title?: string | null, label?: string | null, items: Array<{ __typename?: 'TripItineraryItem', title: string, label: string, helper_text?: string | null, timestamp: number, type: TripItineraryItemType }> } | null, attribution?: { __typename?: 'Attribution', internal_source?: BookingInternalSource | null, internal_source_entity_id?: string | null, internal_source_entity_type?: BookingInternalSourceEntityType | null } | null };

export type QuoteInterfaceFieldsFragment = QuoteInterfaceFields_DraftQuote_Fragment | QuoteInterfaceFields_Quote_Fragment;

export type QuoteFieldsFragment = { __typename?: 'Quote', id: string, dates: Array<number>, lodging_included?: boolean | null, discount?: number | null, total: number, should_allow_external_payment?: boolean | null, payment_group?: { __typename?: 'QuotePaymentGroup', remaining_slots: number, last_payment_due_date: number, host: { __typename?: 'QuotePaymentGroupMember', id: string, name: string, email: string, slots: number, amount: number, payment_plans: Array<{ __typename?: 'QuotePaymentPlan', id: string, name?: string | null, note?: string | null, type: PaymentPlanType, payments: Array<{ __typename?: 'QuotePayment', id: string, date: number, value: number }> }> }, members: Array<{ __typename?: 'QuotePaymentGroupMember', id: string, name: string, email: string, slots: number, amount: number, payment_plans: Array<{ __typename?: 'QuotePaymentPlan', id: string, name?: string | null, note?: string | null, type: PaymentPlanType, payments: Array<{ __typename?: 'QuotePayment', id: string, date: number, value: number }> }> }> } | null, packages: Array<{ __typename?: 'QuotePackage', id: string, line_item_key?: string | null, number_of_guests: number, pricing_package: { __typename?: 'PricingPackage', id: string, name: string, price: number, price_by_guest: PriceByGuest, price_by_day: PriceByDay, guests_included: number, min_guests?: number | null, max_guests?: number | null, days_included: number, lodging_included: boolean, included_lodging_id?: string | null, is_active: boolean, is_available?: boolean | null, not_available_reason?: string | null, included_resource_ids?: Array<string | null> | null, trophies: Array<{ __typename?: 'AddOn', id: string, name: string, category: string, species?: { __typename?: 'Species', id: string, type: SpeciesType, name: string } | null }>, gear_rentals: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, meal_upgrades: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, other_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, included_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, listing: { __typename?: 'Listing', id: string } }, items: Array<{ __typename?: 'QuoteItem', name: string, option_id: string, rate: number, quantity: number, price: number }>, add_ons: Array<{ __typename?: 'QuoteAddOn', id: string, category: string, name: string, unit_price: number, quantity: number, deposit_amount?: number | null, deposit_percentage?: number | null, price_by_day?: PriceByDay | null, price_by_guest?: PriceByGuest | null, package_id?: string | null }> }>, listing: { __typename?: 'Listing', id: string, title?: string | null, type?: ListingType | null, cover_image?: string | null, check_out_minutes?: number | null, time_zone?: string | null, location?: { __typename?: 'Address', zip?: string | null, city: string, state: string } | null, lodging?: { __typename?: 'Lodging', id: string } | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, outfitter: { __typename?: 'Outfitter', id: string, time_zone?: string | null, is_ach_enabled?: boolean | null, is_processing_fee_payed_by_sportsman?: boolean | null, cancellation_policy: { __typename?: 'OutfitterCancellationPolicy', policy_id: string, description: string } } }, items: Array<{ __typename?: 'QuoteItem', name: string, option_id: string, rate: number, quantity: number, price: number }>, prices: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }>, payment_plans: Array<{ __typename?: 'QuotePaymentPlan', id: string, name?: string | null, note?: string | null, type: PaymentPlanType, payments: Array<{ __typename?: 'QuotePayment', id: string, date: number, value: number }> }>, coupon?: { __typename?: 'Coupon', id: string, custom_code: string, amount_off?: number | null, percent_off?: number | null } | null, add_ons?: Array<{ __typename?: 'QuoteAddOn', id: string, category: string, name: string, unit_price: number, quantity: number, deposit_amount?: number | null, deposit_percentage?: number | null, price_by_day?: PriceByDay | null, price_by_guest?: PriceByGuest | null, package_id?: string | null }> | null, booking_invite?: { __typename?: 'BookingInvite', id: string } | null, payment_summary?: { __typename?: 'PaymentSummary', total: number, line_items: Array<{ __typename?: 'LineItem', total: number, label: string, display_value: string, details_label?: string | null, details_value?: string | null, key?: string | null, section_key?: string | null, sub_items?: Array<{ __typename?: 'SubItem', label: string }> | null }>, prices: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }>, totals: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }> } | null, itinerary?: { __typename?: 'TripItinerary', title?: string | null, label?: string | null, items: Array<{ __typename?: 'TripItineraryItem', title: string, label: string, helper_text?: string | null, timestamp: number, type: TripItineraryItemType }> } | null, attribution?: { __typename?: 'Attribution', internal_source?: BookingInternalSource | null, internal_source_entity_id?: string | null, internal_source_entity_type?: BookingInternalSourceEntityType | null } | null, trip_insurance?: { __typename?: 'BookingQuoteTripInsuranceQuote', quote_id: string, is_accepted?: boolean | null, zip_code?: string | null, cost: number, policy_attributes?: { __typename?: 'TripInsurancePolicyAttribute', insurable_amount: number, insurable_amount_currency: string, event_start_date: number, event_end_date: number } | null, taxes_and_fees?: Array<{ __typename?: 'TripInsuranceTaxesAndFees', amount: number, description: string, type?: string | null }> | null, product: { __typename?: 'TripInsuranceProduct', description: string, promotional_header?: string | null, promotional_description?: string | null, accept_action_text?: string | null, decline_action_text?: string | null, legal_disclaimer?: string | null, privacy_policy_url?: string | null, terms_conditions_url?: string | null, additional_policy_purchase_email_message?: string | null, carrier_logo_url?: string | null, descriptors?: Array<string | null> | null, perils?: Array<string | null> | null, peril_heading?: string | null } } | null };

export type QuotePriceFieldsFragment = { __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> };

export type QuoteCouponFieldsFragment = { __typename?: 'Coupon', id: string, custom_code: string, amount_off?: number | null, percent_off?: number | null };

export type QuoteQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  isAchPaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
  isExternalPaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
  paymentPlanType?: InputMaybe<PaymentPlanType>;
  sportmanZipCode?: InputMaybe<Scalars['String']['input']>;
  shouldAcceptTripInsurance?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type QuoteQuery = { __typename?: 'Query', quote: { __typename?: 'Quote', id: string, dates: Array<number>, lodging_included?: boolean | null, discount?: number | null, total: number, should_allow_external_payment?: boolean | null, payment_group?: { __typename?: 'QuotePaymentGroup', remaining_slots: number, last_payment_due_date: number, host: { __typename?: 'QuotePaymentGroupMember', id: string, name: string, email: string, slots: number, amount: number, payment_plans: Array<{ __typename?: 'QuotePaymentPlan', id: string, name?: string | null, note?: string | null, type: PaymentPlanType, payments: Array<{ __typename?: 'QuotePayment', id: string, date: number, value: number }> }> }, members: Array<{ __typename?: 'QuotePaymentGroupMember', id: string, name: string, email: string, slots: number, amount: number, payment_plans: Array<{ __typename?: 'QuotePaymentPlan', id: string, name?: string | null, note?: string | null, type: PaymentPlanType, payments: Array<{ __typename?: 'QuotePayment', id: string, date: number, value: number }> }> }> } | null, packages: Array<{ __typename?: 'QuotePackage', id: string, line_item_key?: string | null, number_of_guests: number, pricing_package: { __typename?: 'PricingPackage', id: string, name: string, price: number, price_by_guest: PriceByGuest, price_by_day: PriceByDay, guests_included: number, min_guests?: number | null, max_guests?: number | null, days_included: number, lodging_included: boolean, included_lodging_id?: string | null, is_active: boolean, is_available?: boolean | null, not_available_reason?: string | null, included_resource_ids?: Array<string | null> | null, trophies: Array<{ __typename?: 'AddOn', id: string, name: string, category: string, species?: { __typename?: 'Species', id: string, type: SpeciesType, name: string } | null }>, gear_rentals: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, meal_upgrades: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, other_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, included_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, listing: { __typename?: 'Listing', id: string } }, items: Array<{ __typename?: 'QuoteItem', name: string, option_id: string, rate: number, quantity: number, price: number }>, add_ons: Array<{ __typename?: 'QuoteAddOn', id: string, category: string, name: string, unit_price: number, quantity: number, deposit_amount?: number | null, deposit_percentage?: number | null, price_by_day?: PriceByDay | null, price_by_guest?: PriceByGuest | null, package_id?: string | null }> }>, listing: { __typename?: 'Listing', id: string, title?: string | null, type?: ListingType | null, cover_image?: string | null, check_out_minutes?: number | null, time_zone?: string | null, location?: { __typename?: 'Address', zip?: string | null, city: string, state: string } | null, lodging?: { __typename?: 'Lodging', id: string } | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, outfitter: { __typename?: 'Outfitter', id: string, time_zone?: string | null, is_ach_enabled?: boolean | null, is_processing_fee_payed_by_sportsman?: boolean | null, cancellation_policy: { __typename?: 'OutfitterCancellationPolicy', policy_id: string, description: string } } }, items: Array<{ __typename?: 'QuoteItem', name: string, option_id: string, rate: number, quantity: number, price: number }>, prices: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }>, payment_plans: Array<{ __typename?: 'QuotePaymentPlan', id: string, name?: string | null, note?: string | null, type: PaymentPlanType, payments: Array<{ __typename?: 'QuotePayment', id: string, date: number, value: number }> }>, coupon?: { __typename?: 'Coupon', id: string, custom_code: string, amount_off?: number | null, percent_off?: number | null } | null, add_ons?: Array<{ __typename?: 'QuoteAddOn', id: string, category: string, name: string, unit_price: number, quantity: number, deposit_amount?: number | null, deposit_percentage?: number | null, price_by_day?: PriceByDay | null, price_by_guest?: PriceByGuest | null, package_id?: string | null }> | null, booking_invite?: { __typename?: 'BookingInvite', id: string } | null, payment_summary?: { __typename?: 'PaymentSummary', total: number, line_items: Array<{ __typename?: 'LineItem', total: number, label: string, display_value: string, details_label?: string | null, details_value?: string | null, key?: string | null, section_key?: string | null, sub_items?: Array<{ __typename?: 'SubItem', label: string }> | null }>, prices: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }>, totals: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }> } | null, itinerary?: { __typename?: 'TripItinerary', title?: string | null, label?: string | null, items: Array<{ __typename?: 'TripItineraryItem', title: string, label: string, helper_text?: string | null, timestamp: number, type: TripItineraryItemType }> } | null, attribution?: { __typename?: 'Attribution', internal_source?: BookingInternalSource | null, internal_source_entity_id?: string | null, internal_source_entity_type?: BookingInternalSourceEntityType | null } | null, trip_insurance?: { __typename?: 'BookingQuoteTripInsuranceQuote', quote_id: string, is_accepted?: boolean | null, zip_code?: string | null, cost: number, policy_attributes?: { __typename?: 'TripInsurancePolicyAttribute', insurable_amount: number, insurable_amount_currency: string, event_start_date: number, event_end_date: number } | null, taxes_and_fees?: Array<{ __typename?: 'TripInsuranceTaxesAndFees', amount: number, description: string, type?: string | null }> | null, product: { __typename?: 'TripInsuranceProduct', description: string, promotional_header?: string | null, promotional_description?: string | null, accept_action_text?: string | null, decline_action_text?: string | null, legal_disclaimer?: string | null, privacy_policy_url?: string | null, terms_conditions_url?: string | null, additional_policy_purchase_email_message?: string | null, carrier_logo_url?: string | null, descriptors?: Array<string | null> | null, perils?: Array<string | null> | null, peril_heading?: string | null } } | null } };

export type DraftQuoteQueryVariables = Exact<{
  data: CreateQuoteInput;
}>;


export type DraftQuoteQuery = { __typename?: 'Query', draftQuote: { __typename?: 'DraftQuote', dates: Array<number>, lodging_included?: boolean | null, discount?: number | null, total: number, listing: { __typename?: 'Listing', id: string, title?: string | null, type?: ListingType | null, cover_image?: string | null, check_out_minutes?: number | null, time_zone?: string | null, location?: { __typename?: 'Address', zip?: string | null, city: string, state: string } | null, lodging?: { __typename?: 'Lodging', id: string } | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, outfitter: { __typename?: 'Outfitter', id: string, time_zone?: string | null, is_ach_enabled?: boolean | null, is_processing_fee_payed_by_sportsman?: boolean | null, cancellation_policy: { __typename?: 'OutfitterCancellationPolicy', policy_id: string, description: string } } }, items: Array<{ __typename?: 'QuoteItem', name: string, option_id: string, rate: number, quantity: number, price: number }>, prices: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }>, packages: Array<{ __typename?: 'QuotePackage', id: string, line_item_key?: string | null, number_of_guests: number, pricing_package: { __typename?: 'PricingPackage', id: string, name: string, price: number, price_by_guest: PriceByGuest, price_by_day: PriceByDay, guests_included: number, min_guests?: number | null, max_guests?: number | null, days_included: number, lodging_included: boolean, included_lodging_id?: string | null, is_active: boolean, is_available?: boolean | null, not_available_reason?: string | null, included_resource_ids?: Array<string | null> | null, trophies: Array<{ __typename?: 'AddOn', id: string, name: string, category: string, species?: { __typename?: 'Species', id: string, type: SpeciesType, name: string } | null }>, gear_rentals: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, meal_upgrades: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, other_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, included_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, listing: { __typename?: 'Listing', id: string } }, items: Array<{ __typename?: 'QuoteItem', name: string, option_id: string, rate: number, quantity: number, price: number }>, add_ons: Array<{ __typename?: 'QuoteAddOn', id: string, category: string, name: string, unit_price: number, quantity: number, deposit_amount?: number | null, deposit_percentage?: number | null, price_by_day?: PriceByDay | null, price_by_guest?: PriceByGuest | null, package_id?: string | null }> }>, payment_plans: Array<{ __typename?: 'QuotePaymentPlan', id: string, name?: string | null, note?: string | null, type: PaymentPlanType, payments: Array<{ __typename?: 'QuotePayment', id: string, date: number, value: number }> }>, coupon?: { __typename?: 'Coupon', id: string, custom_code: string, amount_off?: number | null, percent_off?: number | null } | null, add_ons?: Array<{ __typename?: 'QuoteAddOn', id: string, category: string, name: string, unit_price: number, quantity: number, deposit_amount?: number | null, deposit_percentage?: number | null, price_by_day?: PriceByDay | null, price_by_guest?: PriceByGuest | null, package_id?: string | null }> | null, payment_summary?: { __typename?: 'PaymentSummary', total: number, line_items: Array<{ __typename?: 'LineItem', total: number, label: string, display_value: string, details_label?: string | null, details_value?: string | null, key?: string | null, section_key?: string | null, sub_items?: Array<{ __typename?: 'SubItem', label: string }> | null }>, prices: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }>, totals: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }> } | null, itinerary?: { __typename?: 'TripItinerary', title?: string | null, label?: string | null, items: Array<{ __typename?: 'TripItineraryItem', title: string, label: string, helper_text?: string | null, timestamp: number, type: TripItineraryItemType }> } | null, attribution?: { __typename?: 'Attribution', internal_source?: BookingInternalSource | null, internal_source_entity_id?: string | null, internal_source_entity_type?: BookingInternalSourceEntityType | null } | null } };

export type CreateQuoteMutationVariables = Exact<{
  data: CreateQuoteInput;
}>;


export type CreateQuoteMutation = { __typename?: 'Mutation', createQuote: { __typename?: 'Quote', id: string } };

export type ApplyQuoteCouponMutationVariables = Exact<{
  quoteId: Scalars['ID']['input'];
  couponCode: Scalars['String']['input'];
}>;


export type ApplyQuoteCouponMutation = { __typename?: 'Mutation', applyQuoteCoupon: { __typename?: 'Quote', id: string, dates: Array<number>, lodging_included?: boolean | null, discount?: number | null, total: number, should_allow_external_payment?: boolean | null, payment_group?: { __typename?: 'QuotePaymentGroup', remaining_slots: number, last_payment_due_date: number, host: { __typename?: 'QuotePaymentGroupMember', id: string, name: string, email: string, slots: number, amount: number, payment_plans: Array<{ __typename?: 'QuotePaymentPlan', id: string, name?: string | null, note?: string | null, type: PaymentPlanType, payments: Array<{ __typename?: 'QuotePayment', id: string, date: number, value: number }> }> }, members: Array<{ __typename?: 'QuotePaymentGroupMember', id: string, name: string, email: string, slots: number, amount: number, payment_plans: Array<{ __typename?: 'QuotePaymentPlan', id: string, name?: string | null, note?: string | null, type: PaymentPlanType, payments: Array<{ __typename?: 'QuotePayment', id: string, date: number, value: number }> }> }> } | null, packages: Array<{ __typename?: 'QuotePackage', id: string, line_item_key?: string | null, number_of_guests: number, pricing_package: { __typename?: 'PricingPackage', id: string, name: string, price: number, price_by_guest: PriceByGuest, price_by_day: PriceByDay, guests_included: number, min_guests?: number | null, max_guests?: number | null, days_included: number, lodging_included: boolean, included_lodging_id?: string | null, is_active: boolean, is_available?: boolean | null, not_available_reason?: string | null, included_resource_ids?: Array<string | null> | null, trophies: Array<{ __typename?: 'AddOn', id: string, name: string, category: string, species?: { __typename?: 'Species', id: string, type: SpeciesType, name: string } | null }>, gear_rentals: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, meal_upgrades: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, other_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, included_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, listing: { __typename?: 'Listing', id: string } }, items: Array<{ __typename?: 'QuoteItem', name: string, option_id: string, rate: number, quantity: number, price: number }>, add_ons: Array<{ __typename?: 'QuoteAddOn', id: string, category: string, name: string, unit_price: number, quantity: number, deposit_amount?: number | null, deposit_percentage?: number | null, price_by_day?: PriceByDay | null, price_by_guest?: PriceByGuest | null, package_id?: string | null }> }>, listing: { __typename?: 'Listing', id: string, title?: string | null, type?: ListingType | null, cover_image?: string | null, check_out_minutes?: number | null, time_zone?: string | null, location?: { __typename?: 'Address', zip?: string | null, city: string, state: string } | null, lodging?: { __typename?: 'Lodging', id: string } | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, outfitter: { __typename?: 'Outfitter', id: string, time_zone?: string | null, is_ach_enabled?: boolean | null, is_processing_fee_payed_by_sportsman?: boolean | null, cancellation_policy: { __typename?: 'OutfitterCancellationPolicy', policy_id: string, description: string } } }, items: Array<{ __typename?: 'QuoteItem', name: string, option_id: string, rate: number, quantity: number, price: number }>, prices: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }>, payment_plans: Array<{ __typename?: 'QuotePaymentPlan', id: string, name?: string | null, note?: string | null, type: PaymentPlanType, payments: Array<{ __typename?: 'QuotePayment', id: string, date: number, value: number }> }>, coupon?: { __typename?: 'Coupon', id: string, custom_code: string, amount_off?: number | null, percent_off?: number | null } | null, add_ons?: Array<{ __typename?: 'QuoteAddOn', id: string, category: string, name: string, unit_price: number, quantity: number, deposit_amount?: number | null, deposit_percentage?: number | null, price_by_day?: PriceByDay | null, price_by_guest?: PriceByGuest | null, package_id?: string | null }> | null, booking_invite?: { __typename?: 'BookingInvite', id: string } | null, payment_summary?: { __typename?: 'PaymentSummary', total: number, line_items: Array<{ __typename?: 'LineItem', total: number, label: string, display_value: string, details_label?: string | null, details_value?: string | null, key?: string | null, section_key?: string | null, sub_items?: Array<{ __typename?: 'SubItem', label: string }> | null }>, prices: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }>, totals: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }> } | null, itinerary?: { __typename?: 'TripItinerary', title?: string | null, label?: string | null, items: Array<{ __typename?: 'TripItineraryItem', title: string, label: string, helper_text?: string | null, timestamp: number, type: TripItineraryItemType }> } | null, attribution?: { __typename?: 'Attribution', internal_source?: BookingInternalSource | null, internal_source_entity_id?: string | null, internal_source_entity_type?: BookingInternalSourceEntityType | null } | null, trip_insurance?: { __typename?: 'BookingQuoteTripInsuranceQuote', quote_id: string, is_accepted?: boolean | null, zip_code?: string | null, cost: number, policy_attributes?: { __typename?: 'TripInsurancePolicyAttribute', insurable_amount: number, insurable_amount_currency: string, event_start_date: number, event_end_date: number } | null, taxes_and_fees?: Array<{ __typename?: 'TripInsuranceTaxesAndFees', amount: number, description: string, type?: string | null }> | null, product: { __typename?: 'TripInsuranceProduct', description: string, promotional_header?: string | null, promotional_description?: string | null, accept_action_text?: string | null, decline_action_text?: string | null, legal_disclaimer?: string | null, privacy_policy_url?: string | null, terms_conditions_url?: string | null, additional_policy_purchase_email_message?: string | null, carrier_logo_url?: string | null, descriptors?: Array<string | null> | null, perils?: Array<string | null> | null, peril_heading?: string | null } } | null } };

export type RemoveQuoteCouponMutationVariables = Exact<{
  quoteId: Scalars['ID']['input'];
}>;


export type RemoveQuoteCouponMutation = { __typename?: 'Mutation', removeQuoteCoupon: { __typename?: 'Quote', id: string, dates: Array<number>, lodging_included?: boolean | null, discount?: number | null, total: number, should_allow_external_payment?: boolean | null, payment_group?: { __typename?: 'QuotePaymentGroup', remaining_slots: number, last_payment_due_date: number, host: { __typename?: 'QuotePaymentGroupMember', id: string, name: string, email: string, slots: number, amount: number, payment_plans: Array<{ __typename?: 'QuotePaymentPlan', id: string, name?: string | null, note?: string | null, type: PaymentPlanType, payments: Array<{ __typename?: 'QuotePayment', id: string, date: number, value: number }> }> }, members: Array<{ __typename?: 'QuotePaymentGroupMember', id: string, name: string, email: string, slots: number, amount: number, payment_plans: Array<{ __typename?: 'QuotePaymentPlan', id: string, name?: string | null, note?: string | null, type: PaymentPlanType, payments: Array<{ __typename?: 'QuotePayment', id: string, date: number, value: number }> }> }> } | null, packages: Array<{ __typename?: 'QuotePackage', id: string, line_item_key?: string | null, number_of_guests: number, pricing_package: { __typename?: 'PricingPackage', id: string, name: string, price: number, price_by_guest: PriceByGuest, price_by_day: PriceByDay, guests_included: number, min_guests?: number | null, max_guests?: number | null, days_included: number, lodging_included: boolean, included_lodging_id?: string | null, is_active: boolean, is_available?: boolean | null, not_available_reason?: string | null, included_resource_ids?: Array<string | null> | null, trophies: Array<{ __typename?: 'AddOn', id: string, name: string, category: string, species?: { __typename?: 'Species', id: string, type: SpeciesType, name: string } | null }>, gear_rentals: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, meal_upgrades: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, other_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, included_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, listing: { __typename?: 'Listing', id: string } }, items: Array<{ __typename?: 'QuoteItem', name: string, option_id: string, rate: number, quantity: number, price: number }>, add_ons: Array<{ __typename?: 'QuoteAddOn', id: string, category: string, name: string, unit_price: number, quantity: number, deposit_amount?: number | null, deposit_percentage?: number | null, price_by_day?: PriceByDay | null, price_by_guest?: PriceByGuest | null, package_id?: string | null }> }>, listing: { __typename?: 'Listing', id: string, title?: string | null, type?: ListingType | null, cover_image?: string | null, check_out_minutes?: number | null, time_zone?: string | null, location?: { __typename?: 'Address', zip?: string | null, city: string, state: string } | null, lodging?: { __typename?: 'Lodging', id: string } | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, outfitter: { __typename?: 'Outfitter', id: string, time_zone?: string | null, is_ach_enabled?: boolean | null, is_processing_fee_payed_by_sportsman?: boolean | null, cancellation_policy: { __typename?: 'OutfitterCancellationPolicy', policy_id: string, description: string } } }, items: Array<{ __typename?: 'QuoteItem', name: string, option_id: string, rate: number, quantity: number, price: number }>, prices: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }>, payment_plans: Array<{ __typename?: 'QuotePaymentPlan', id: string, name?: string | null, note?: string | null, type: PaymentPlanType, payments: Array<{ __typename?: 'QuotePayment', id: string, date: number, value: number }> }>, coupon?: { __typename?: 'Coupon', id: string, custom_code: string, amount_off?: number | null, percent_off?: number | null } | null, add_ons?: Array<{ __typename?: 'QuoteAddOn', id: string, category: string, name: string, unit_price: number, quantity: number, deposit_amount?: number | null, deposit_percentage?: number | null, price_by_day?: PriceByDay | null, price_by_guest?: PriceByGuest | null, package_id?: string | null }> | null, booking_invite?: { __typename?: 'BookingInvite', id: string } | null, payment_summary?: { __typename?: 'PaymentSummary', total: number, line_items: Array<{ __typename?: 'LineItem', total: number, label: string, display_value: string, details_label?: string | null, details_value?: string | null, key?: string | null, section_key?: string | null, sub_items?: Array<{ __typename?: 'SubItem', label: string }> | null }>, prices: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }>, totals: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }> } | null, itinerary?: { __typename?: 'TripItinerary', title?: string | null, label?: string | null, items: Array<{ __typename?: 'TripItineraryItem', title: string, label: string, helper_text?: string | null, timestamp: number, type: TripItineraryItemType }> } | null, attribution?: { __typename?: 'Attribution', internal_source?: BookingInternalSource | null, internal_source_entity_id?: string | null, internal_source_entity_type?: BookingInternalSourceEntityType | null } | null, trip_insurance?: { __typename?: 'BookingQuoteTripInsuranceQuote', quote_id: string, is_accepted?: boolean | null, zip_code?: string | null, cost: number, policy_attributes?: { __typename?: 'TripInsurancePolicyAttribute', insurable_amount: number, insurable_amount_currency: string, event_start_date: number, event_end_date: number } | null, taxes_and_fees?: Array<{ __typename?: 'TripInsuranceTaxesAndFees', amount: number, description: string, type?: string | null }> | null, product: { __typename?: 'TripInsuranceProduct', description: string, promotional_header?: string | null, promotional_description?: string | null, accept_action_text?: string | null, decline_action_text?: string | null, legal_disclaimer?: string | null, privacy_policy_url?: string | null, terms_conditions_url?: string | null, additional_policy_purchase_email_message?: string | null, carrier_logo_url?: string | null, descriptors?: Array<string | null> | null, perils?: Array<string | null> | null, peril_heading?: string | null } } | null } };

export type EnableQuotePaymentGroupMutationVariables = Exact<{
  quoteId: Scalars['ID']['input'];
  hostSlots: Scalars['PositiveInt']['input'];
}>;


export type EnableQuotePaymentGroupMutation = { __typename?: 'Mutation', enableQuotePaymentGroup: { __typename?: 'Quote', id: string, dates: Array<number>, lodging_included?: boolean | null, discount?: number | null, total: number, should_allow_external_payment?: boolean | null, payment_group?: { __typename?: 'QuotePaymentGroup', remaining_slots: number, last_payment_due_date: number, host: { __typename?: 'QuotePaymentGroupMember', id: string, name: string, email: string, slots: number, amount: number, payment_plans: Array<{ __typename?: 'QuotePaymentPlan', id: string, name?: string | null, note?: string | null, type: PaymentPlanType, payments: Array<{ __typename?: 'QuotePayment', id: string, date: number, value: number }> }> }, members: Array<{ __typename?: 'QuotePaymentGroupMember', id: string, name: string, email: string, slots: number, amount: number, payment_plans: Array<{ __typename?: 'QuotePaymentPlan', id: string, name?: string | null, note?: string | null, type: PaymentPlanType, payments: Array<{ __typename?: 'QuotePayment', id: string, date: number, value: number }> }> }> } | null, packages: Array<{ __typename?: 'QuotePackage', id: string, line_item_key?: string | null, number_of_guests: number, pricing_package: { __typename?: 'PricingPackage', id: string, name: string, price: number, price_by_guest: PriceByGuest, price_by_day: PriceByDay, guests_included: number, min_guests?: number | null, max_guests?: number | null, days_included: number, lodging_included: boolean, included_lodging_id?: string | null, is_active: boolean, is_available?: boolean | null, not_available_reason?: string | null, included_resource_ids?: Array<string | null> | null, trophies: Array<{ __typename?: 'AddOn', id: string, name: string, category: string, species?: { __typename?: 'Species', id: string, type: SpeciesType, name: string } | null }>, gear_rentals: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, meal_upgrades: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, other_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, included_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, listing: { __typename?: 'Listing', id: string } }, items: Array<{ __typename?: 'QuoteItem', name: string, option_id: string, rate: number, quantity: number, price: number }>, add_ons: Array<{ __typename?: 'QuoteAddOn', id: string, category: string, name: string, unit_price: number, quantity: number, deposit_amount?: number | null, deposit_percentage?: number | null, price_by_day?: PriceByDay | null, price_by_guest?: PriceByGuest | null, package_id?: string | null }> }>, listing: { __typename?: 'Listing', id: string, title?: string | null, type?: ListingType | null, cover_image?: string | null, check_out_minutes?: number | null, time_zone?: string | null, location?: { __typename?: 'Address', zip?: string | null, city: string, state: string } | null, lodging?: { __typename?: 'Lodging', id: string } | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, outfitter: { __typename?: 'Outfitter', id: string, time_zone?: string | null, is_ach_enabled?: boolean | null, is_processing_fee_payed_by_sportsman?: boolean | null, cancellation_policy: { __typename?: 'OutfitterCancellationPolicy', policy_id: string, description: string } } }, items: Array<{ __typename?: 'QuoteItem', name: string, option_id: string, rate: number, quantity: number, price: number }>, prices: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }>, payment_plans: Array<{ __typename?: 'QuotePaymentPlan', id: string, name?: string | null, note?: string | null, type: PaymentPlanType, payments: Array<{ __typename?: 'QuotePayment', id: string, date: number, value: number }> }>, coupon?: { __typename?: 'Coupon', id: string, custom_code: string, amount_off?: number | null, percent_off?: number | null } | null, add_ons?: Array<{ __typename?: 'QuoteAddOn', id: string, category: string, name: string, unit_price: number, quantity: number, deposit_amount?: number | null, deposit_percentage?: number | null, price_by_day?: PriceByDay | null, price_by_guest?: PriceByGuest | null, package_id?: string | null }> | null, booking_invite?: { __typename?: 'BookingInvite', id: string } | null, payment_summary?: { __typename?: 'PaymentSummary', total: number, line_items: Array<{ __typename?: 'LineItem', total: number, label: string, display_value: string, details_label?: string | null, details_value?: string | null, key?: string | null, section_key?: string | null, sub_items?: Array<{ __typename?: 'SubItem', label: string }> | null }>, prices: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }>, totals: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }> } | null, itinerary?: { __typename?: 'TripItinerary', title?: string | null, label?: string | null, items: Array<{ __typename?: 'TripItineraryItem', title: string, label: string, helper_text?: string | null, timestamp: number, type: TripItineraryItemType }> } | null, attribution?: { __typename?: 'Attribution', internal_source?: BookingInternalSource | null, internal_source_entity_id?: string | null, internal_source_entity_type?: BookingInternalSourceEntityType | null } | null, trip_insurance?: { __typename?: 'BookingQuoteTripInsuranceQuote', quote_id: string, is_accepted?: boolean | null, zip_code?: string | null, cost: number, policy_attributes?: { __typename?: 'TripInsurancePolicyAttribute', insurable_amount: number, insurable_amount_currency: string, event_start_date: number, event_end_date: number } | null, taxes_and_fees?: Array<{ __typename?: 'TripInsuranceTaxesAndFees', amount: number, description: string, type?: string | null }> | null, product: { __typename?: 'TripInsuranceProduct', description: string, promotional_header?: string | null, promotional_description?: string | null, accept_action_text?: string | null, decline_action_text?: string | null, legal_disclaimer?: string | null, privacy_policy_url?: string | null, terms_conditions_url?: string | null, additional_policy_purchase_email_message?: string | null, carrier_logo_url?: string | null, descriptors?: Array<string | null> | null, perils?: Array<string | null> | null, peril_heading?: string | null } } | null } };

export type DisableQuotePaymentGroupMutationVariables = Exact<{
  quoteId: Scalars['ID']['input'];
}>;


export type DisableQuotePaymentGroupMutation = { __typename?: 'Mutation', disableQuotePaymentGroup: { __typename?: 'Quote', id: string, dates: Array<number>, lodging_included?: boolean | null, discount?: number | null, total: number, should_allow_external_payment?: boolean | null, payment_group?: { __typename?: 'QuotePaymentGroup', remaining_slots: number, last_payment_due_date: number, host: { __typename?: 'QuotePaymentGroupMember', id: string, name: string, email: string, slots: number, amount: number, payment_plans: Array<{ __typename?: 'QuotePaymentPlan', id: string, name?: string | null, note?: string | null, type: PaymentPlanType, payments: Array<{ __typename?: 'QuotePayment', id: string, date: number, value: number }> }> }, members: Array<{ __typename?: 'QuotePaymentGroupMember', id: string, name: string, email: string, slots: number, amount: number, payment_plans: Array<{ __typename?: 'QuotePaymentPlan', id: string, name?: string | null, note?: string | null, type: PaymentPlanType, payments: Array<{ __typename?: 'QuotePayment', id: string, date: number, value: number }> }> }> } | null, packages: Array<{ __typename?: 'QuotePackage', id: string, line_item_key?: string | null, number_of_guests: number, pricing_package: { __typename?: 'PricingPackage', id: string, name: string, price: number, price_by_guest: PriceByGuest, price_by_day: PriceByDay, guests_included: number, min_guests?: number | null, max_guests?: number | null, days_included: number, lodging_included: boolean, included_lodging_id?: string | null, is_active: boolean, is_available?: boolean | null, not_available_reason?: string | null, included_resource_ids?: Array<string | null> | null, trophies: Array<{ __typename?: 'AddOn', id: string, name: string, category: string, species?: { __typename?: 'Species', id: string, type: SpeciesType, name: string } | null }>, gear_rentals: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, meal_upgrades: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, other_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, included_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, listing: { __typename?: 'Listing', id: string } }, items: Array<{ __typename?: 'QuoteItem', name: string, option_id: string, rate: number, quantity: number, price: number }>, add_ons: Array<{ __typename?: 'QuoteAddOn', id: string, category: string, name: string, unit_price: number, quantity: number, deposit_amount?: number | null, deposit_percentage?: number | null, price_by_day?: PriceByDay | null, price_by_guest?: PriceByGuest | null, package_id?: string | null }> }>, listing: { __typename?: 'Listing', id: string, title?: string | null, type?: ListingType | null, cover_image?: string | null, check_out_minutes?: number | null, time_zone?: string | null, location?: { __typename?: 'Address', zip?: string | null, city: string, state: string } | null, lodging?: { __typename?: 'Lodging', id: string } | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, outfitter: { __typename?: 'Outfitter', id: string, time_zone?: string | null, is_ach_enabled?: boolean | null, is_processing_fee_payed_by_sportsman?: boolean | null, cancellation_policy: { __typename?: 'OutfitterCancellationPolicy', policy_id: string, description: string } } }, items: Array<{ __typename?: 'QuoteItem', name: string, option_id: string, rate: number, quantity: number, price: number }>, prices: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }>, payment_plans: Array<{ __typename?: 'QuotePaymentPlan', id: string, name?: string | null, note?: string | null, type: PaymentPlanType, payments: Array<{ __typename?: 'QuotePayment', id: string, date: number, value: number }> }>, coupon?: { __typename?: 'Coupon', id: string, custom_code: string, amount_off?: number | null, percent_off?: number | null } | null, add_ons?: Array<{ __typename?: 'QuoteAddOn', id: string, category: string, name: string, unit_price: number, quantity: number, deposit_amount?: number | null, deposit_percentage?: number | null, price_by_day?: PriceByDay | null, price_by_guest?: PriceByGuest | null, package_id?: string | null }> | null, booking_invite?: { __typename?: 'BookingInvite', id: string } | null, payment_summary?: { __typename?: 'PaymentSummary', total: number, line_items: Array<{ __typename?: 'LineItem', total: number, label: string, display_value: string, details_label?: string | null, details_value?: string | null, key?: string | null, section_key?: string | null, sub_items?: Array<{ __typename?: 'SubItem', label: string }> | null }>, prices: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }>, totals: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }> } | null, itinerary?: { __typename?: 'TripItinerary', title?: string | null, label?: string | null, items: Array<{ __typename?: 'TripItineraryItem', title: string, label: string, helper_text?: string | null, timestamp: number, type: TripItineraryItemType }> } | null, attribution?: { __typename?: 'Attribution', internal_source?: BookingInternalSource | null, internal_source_entity_id?: string | null, internal_source_entity_type?: BookingInternalSourceEntityType | null } | null, trip_insurance?: { __typename?: 'BookingQuoteTripInsuranceQuote', quote_id: string, is_accepted?: boolean | null, zip_code?: string | null, cost: number, policy_attributes?: { __typename?: 'TripInsurancePolicyAttribute', insurable_amount: number, insurable_amount_currency: string, event_start_date: number, event_end_date: number } | null, taxes_and_fees?: Array<{ __typename?: 'TripInsuranceTaxesAndFees', amount: number, description: string, type?: string | null }> | null, product: { __typename?: 'TripInsuranceProduct', description: string, promotional_header?: string | null, promotional_description?: string | null, accept_action_text?: string | null, decline_action_text?: string | null, legal_disclaimer?: string | null, privacy_policy_url?: string | null, terms_conditions_url?: string | null, additional_policy_purchase_email_message?: string | null, carrier_logo_url?: string | null, descriptors?: Array<string | null> | null, perils?: Array<string | null> | null, peril_heading?: string | null } } | null } };

export type AddPackageToQuoteMutationVariables = Exact<{
  quoteId: Scalars['ID']['input'];
  data: AddPackageToQuoteInput;
}>;


export type AddPackageToQuoteMutation = { __typename?: 'Mutation', addPackageToQuote: { __typename?: 'Quote', id: string, dates: Array<number>, lodging_included?: boolean | null, discount?: number | null, total: number, should_allow_external_payment?: boolean | null, payment_group?: { __typename?: 'QuotePaymentGroup', remaining_slots: number, last_payment_due_date: number, host: { __typename?: 'QuotePaymentGroupMember', id: string, name: string, email: string, slots: number, amount: number, payment_plans: Array<{ __typename?: 'QuotePaymentPlan', id: string, name?: string | null, note?: string | null, type: PaymentPlanType, payments: Array<{ __typename?: 'QuotePayment', id: string, date: number, value: number }> }> }, members: Array<{ __typename?: 'QuotePaymentGroupMember', id: string, name: string, email: string, slots: number, amount: number, payment_plans: Array<{ __typename?: 'QuotePaymentPlan', id: string, name?: string | null, note?: string | null, type: PaymentPlanType, payments: Array<{ __typename?: 'QuotePayment', id: string, date: number, value: number }> }> }> } | null, packages: Array<{ __typename?: 'QuotePackage', id: string, line_item_key?: string | null, number_of_guests: number, pricing_package: { __typename?: 'PricingPackage', id: string, name: string, price: number, price_by_guest: PriceByGuest, price_by_day: PriceByDay, guests_included: number, min_guests?: number | null, max_guests?: number | null, days_included: number, lodging_included: boolean, included_lodging_id?: string | null, is_active: boolean, is_available?: boolean | null, not_available_reason?: string | null, included_resource_ids?: Array<string | null> | null, trophies: Array<{ __typename?: 'AddOn', id: string, name: string, category: string, species?: { __typename?: 'Species', id: string, type: SpeciesType, name: string } | null }>, gear_rentals: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, meal_upgrades: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, other_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, included_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, listing: { __typename?: 'Listing', id: string } }, items: Array<{ __typename?: 'QuoteItem', name: string, option_id: string, rate: number, quantity: number, price: number }>, add_ons: Array<{ __typename?: 'QuoteAddOn', id: string, category: string, name: string, unit_price: number, quantity: number, deposit_amount?: number | null, deposit_percentage?: number | null, price_by_day?: PriceByDay | null, price_by_guest?: PriceByGuest | null, package_id?: string | null }> }>, listing: { __typename?: 'Listing', id: string, title?: string | null, type?: ListingType | null, cover_image?: string | null, check_out_minutes?: number | null, time_zone?: string | null, location?: { __typename?: 'Address', zip?: string | null, city: string, state: string } | null, lodging?: { __typename?: 'Lodging', id: string } | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, outfitter: { __typename?: 'Outfitter', id: string, time_zone?: string | null, is_ach_enabled?: boolean | null, is_processing_fee_payed_by_sportsman?: boolean | null, cancellation_policy: { __typename?: 'OutfitterCancellationPolicy', policy_id: string, description: string } } }, items: Array<{ __typename?: 'QuoteItem', name: string, option_id: string, rate: number, quantity: number, price: number }>, prices: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }>, payment_plans: Array<{ __typename?: 'QuotePaymentPlan', id: string, name?: string | null, note?: string | null, type: PaymentPlanType, payments: Array<{ __typename?: 'QuotePayment', id: string, date: number, value: number }> }>, coupon?: { __typename?: 'Coupon', id: string, custom_code: string, amount_off?: number | null, percent_off?: number | null } | null, add_ons?: Array<{ __typename?: 'QuoteAddOn', id: string, category: string, name: string, unit_price: number, quantity: number, deposit_amount?: number | null, deposit_percentage?: number | null, price_by_day?: PriceByDay | null, price_by_guest?: PriceByGuest | null, package_id?: string | null }> | null, booking_invite?: { __typename?: 'BookingInvite', id: string } | null, payment_summary?: { __typename?: 'PaymentSummary', total: number, line_items: Array<{ __typename?: 'LineItem', total: number, label: string, display_value: string, details_label?: string | null, details_value?: string | null, key?: string | null, section_key?: string | null, sub_items?: Array<{ __typename?: 'SubItem', label: string }> | null }>, prices: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }>, totals: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }> } | null, itinerary?: { __typename?: 'TripItinerary', title?: string | null, label?: string | null, items: Array<{ __typename?: 'TripItineraryItem', title: string, label: string, helper_text?: string | null, timestamp: number, type: TripItineraryItemType }> } | null, attribution?: { __typename?: 'Attribution', internal_source?: BookingInternalSource | null, internal_source_entity_id?: string | null, internal_source_entity_type?: BookingInternalSourceEntityType | null } | null, trip_insurance?: { __typename?: 'BookingQuoteTripInsuranceQuote', quote_id: string, is_accepted?: boolean | null, zip_code?: string | null, cost: number, policy_attributes?: { __typename?: 'TripInsurancePolicyAttribute', insurable_amount: number, insurable_amount_currency: string, event_start_date: number, event_end_date: number } | null, taxes_and_fees?: Array<{ __typename?: 'TripInsuranceTaxesAndFees', amount: number, description: string, type?: string | null }> | null, product: { __typename?: 'TripInsuranceProduct', description: string, promotional_header?: string | null, promotional_description?: string | null, accept_action_text?: string | null, decline_action_text?: string | null, legal_disclaimer?: string | null, privacy_policy_url?: string | null, terms_conditions_url?: string | null, additional_policy_purchase_email_message?: string | null, carrier_logo_url?: string | null, descriptors?: Array<string | null> | null, perils?: Array<string | null> | null, peril_heading?: string | null } } | null } };

export type UpdatePackageOnQuoteMutationVariables = Exact<{
  quoteId: Scalars['ID']['input'];
  packageId: Scalars['ID']['input'];
  data: UpdatePackageOnQuoteInput;
}>;


export type UpdatePackageOnQuoteMutation = { __typename?: 'Mutation', updatePackageOnQuote: { __typename?: 'Quote', id: string, dates: Array<number>, lodging_included?: boolean | null, discount?: number | null, total: number, should_allow_external_payment?: boolean | null, payment_group?: { __typename?: 'QuotePaymentGroup', remaining_slots: number, last_payment_due_date: number, host: { __typename?: 'QuotePaymentGroupMember', id: string, name: string, email: string, slots: number, amount: number, payment_plans: Array<{ __typename?: 'QuotePaymentPlan', id: string, name?: string | null, note?: string | null, type: PaymentPlanType, payments: Array<{ __typename?: 'QuotePayment', id: string, date: number, value: number }> }> }, members: Array<{ __typename?: 'QuotePaymentGroupMember', id: string, name: string, email: string, slots: number, amount: number, payment_plans: Array<{ __typename?: 'QuotePaymentPlan', id: string, name?: string | null, note?: string | null, type: PaymentPlanType, payments: Array<{ __typename?: 'QuotePayment', id: string, date: number, value: number }> }> }> } | null, packages: Array<{ __typename?: 'QuotePackage', id: string, line_item_key?: string | null, number_of_guests: number, pricing_package: { __typename?: 'PricingPackage', id: string, name: string, price: number, price_by_guest: PriceByGuest, price_by_day: PriceByDay, guests_included: number, min_guests?: number | null, max_guests?: number | null, days_included: number, lodging_included: boolean, included_lodging_id?: string | null, is_active: boolean, is_available?: boolean | null, not_available_reason?: string | null, included_resource_ids?: Array<string | null> | null, trophies: Array<{ __typename?: 'AddOn', id: string, name: string, category: string, species?: { __typename?: 'Species', id: string, type: SpeciesType, name: string } | null }>, gear_rentals: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, meal_upgrades: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, other_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, included_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, listing: { __typename?: 'Listing', id: string } }, items: Array<{ __typename?: 'QuoteItem', name: string, option_id: string, rate: number, quantity: number, price: number }>, add_ons: Array<{ __typename?: 'QuoteAddOn', id: string, category: string, name: string, unit_price: number, quantity: number, deposit_amount?: number | null, deposit_percentage?: number | null, price_by_day?: PriceByDay | null, price_by_guest?: PriceByGuest | null, package_id?: string | null }> }>, listing: { __typename?: 'Listing', id: string, title?: string | null, type?: ListingType | null, cover_image?: string | null, check_out_minutes?: number | null, time_zone?: string | null, location?: { __typename?: 'Address', zip?: string | null, city: string, state: string } | null, lodging?: { __typename?: 'Lodging', id: string } | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, outfitter: { __typename?: 'Outfitter', id: string, time_zone?: string | null, is_ach_enabled?: boolean | null, is_processing_fee_payed_by_sportsman?: boolean | null, cancellation_policy: { __typename?: 'OutfitterCancellationPolicy', policy_id: string, description: string } } }, items: Array<{ __typename?: 'QuoteItem', name: string, option_id: string, rate: number, quantity: number, price: number }>, prices: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }>, payment_plans: Array<{ __typename?: 'QuotePaymentPlan', id: string, name?: string | null, note?: string | null, type: PaymentPlanType, payments: Array<{ __typename?: 'QuotePayment', id: string, date: number, value: number }> }>, coupon?: { __typename?: 'Coupon', id: string, custom_code: string, amount_off?: number | null, percent_off?: number | null } | null, add_ons?: Array<{ __typename?: 'QuoteAddOn', id: string, category: string, name: string, unit_price: number, quantity: number, deposit_amount?: number | null, deposit_percentage?: number | null, price_by_day?: PriceByDay | null, price_by_guest?: PriceByGuest | null, package_id?: string | null }> | null, booking_invite?: { __typename?: 'BookingInvite', id: string } | null, payment_summary?: { __typename?: 'PaymentSummary', total: number, line_items: Array<{ __typename?: 'LineItem', total: number, label: string, display_value: string, details_label?: string | null, details_value?: string | null, key?: string | null, section_key?: string | null, sub_items?: Array<{ __typename?: 'SubItem', label: string }> | null }>, prices: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }>, totals: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }> } | null, itinerary?: { __typename?: 'TripItinerary', title?: string | null, label?: string | null, items: Array<{ __typename?: 'TripItineraryItem', title: string, label: string, helper_text?: string | null, timestamp: number, type: TripItineraryItemType }> } | null, attribution?: { __typename?: 'Attribution', internal_source?: BookingInternalSource | null, internal_source_entity_id?: string | null, internal_source_entity_type?: BookingInternalSourceEntityType | null } | null, trip_insurance?: { __typename?: 'BookingQuoteTripInsuranceQuote', quote_id: string, is_accepted?: boolean | null, zip_code?: string | null, cost: number, policy_attributes?: { __typename?: 'TripInsurancePolicyAttribute', insurable_amount: number, insurable_amount_currency: string, event_start_date: number, event_end_date: number } | null, taxes_and_fees?: Array<{ __typename?: 'TripInsuranceTaxesAndFees', amount: number, description: string, type?: string | null }> | null, product: { __typename?: 'TripInsuranceProduct', description: string, promotional_header?: string | null, promotional_description?: string | null, accept_action_text?: string | null, decline_action_text?: string | null, legal_disclaimer?: string | null, privacy_policy_url?: string | null, terms_conditions_url?: string | null, additional_policy_purchase_email_message?: string | null, carrier_logo_url?: string | null, descriptors?: Array<string | null> | null, perils?: Array<string | null> | null, peril_heading?: string | null } } | null } };

export type RemovePackageFromQuoteMutationVariables = Exact<{
  quoteId: Scalars['ID']['input'];
  packageId: Scalars['ID']['input'];
}>;


export type RemovePackageFromQuoteMutation = { __typename?: 'Mutation', removePackageFromQuote: { __typename?: 'Quote', id: string, dates: Array<number>, lodging_included?: boolean | null, discount?: number | null, total: number, should_allow_external_payment?: boolean | null, payment_group?: { __typename?: 'QuotePaymentGroup', remaining_slots: number, last_payment_due_date: number, host: { __typename?: 'QuotePaymentGroupMember', id: string, name: string, email: string, slots: number, amount: number, payment_plans: Array<{ __typename?: 'QuotePaymentPlan', id: string, name?: string | null, note?: string | null, type: PaymentPlanType, payments: Array<{ __typename?: 'QuotePayment', id: string, date: number, value: number }> }> }, members: Array<{ __typename?: 'QuotePaymentGroupMember', id: string, name: string, email: string, slots: number, amount: number, payment_plans: Array<{ __typename?: 'QuotePaymentPlan', id: string, name?: string | null, note?: string | null, type: PaymentPlanType, payments: Array<{ __typename?: 'QuotePayment', id: string, date: number, value: number }> }> }> } | null, packages: Array<{ __typename?: 'QuotePackage', id: string, line_item_key?: string | null, number_of_guests: number, pricing_package: { __typename?: 'PricingPackage', id: string, name: string, price: number, price_by_guest: PriceByGuest, price_by_day: PriceByDay, guests_included: number, min_guests?: number | null, max_guests?: number | null, days_included: number, lodging_included: boolean, included_lodging_id?: string | null, is_active: boolean, is_available?: boolean | null, not_available_reason?: string | null, included_resource_ids?: Array<string | null> | null, trophies: Array<{ __typename?: 'AddOn', id: string, name: string, category: string, species?: { __typename?: 'Species', id: string, type: SpeciesType, name: string } | null }>, gear_rentals: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, meal_upgrades: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, other_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, included_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, listing: { __typename?: 'Listing', id: string } }, items: Array<{ __typename?: 'QuoteItem', name: string, option_id: string, rate: number, quantity: number, price: number }>, add_ons: Array<{ __typename?: 'QuoteAddOn', id: string, category: string, name: string, unit_price: number, quantity: number, deposit_amount?: number | null, deposit_percentage?: number | null, price_by_day?: PriceByDay | null, price_by_guest?: PriceByGuest | null, package_id?: string | null }> }>, listing: { __typename?: 'Listing', id: string, title?: string | null, type?: ListingType | null, cover_image?: string | null, check_out_minutes?: number | null, time_zone?: string | null, location?: { __typename?: 'Address', zip?: string | null, city: string, state: string } | null, lodging?: { __typename?: 'Lodging', id: string } | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, outfitter: { __typename?: 'Outfitter', id: string, time_zone?: string | null, is_ach_enabled?: boolean | null, is_processing_fee_payed_by_sportsman?: boolean | null, cancellation_policy: { __typename?: 'OutfitterCancellationPolicy', policy_id: string, description: string } } }, items: Array<{ __typename?: 'QuoteItem', name: string, option_id: string, rate: number, quantity: number, price: number }>, prices: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }>, payment_plans: Array<{ __typename?: 'QuotePaymentPlan', id: string, name?: string | null, note?: string | null, type: PaymentPlanType, payments: Array<{ __typename?: 'QuotePayment', id: string, date: number, value: number }> }>, coupon?: { __typename?: 'Coupon', id: string, custom_code: string, amount_off?: number | null, percent_off?: number | null } | null, add_ons?: Array<{ __typename?: 'QuoteAddOn', id: string, category: string, name: string, unit_price: number, quantity: number, deposit_amount?: number | null, deposit_percentage?: number | null, price_by_day?: PriceByDay | null, price_by_guest?: PriceByGuest | null, package_id?: string | null }> | null, booking_invite?: { __typename?: 'BookingInvite', id: string } | null, payment_summary?: { __typename?: 'PaymentSummary', total: number, line_items: Array<{ __typename?: 'LineItem', total: number, label: string, display_value: string, details_label?: string | null, details_value?: string | null, key?: string | null, section_key?: string | null, sub_items?: Array<{ __typename?: 'SubItem', label: string }> | null }>, prices: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }>, totals: Array<{ __typename?: 'QuotePrice', name: string, value: number, note?: string | null, category?: QuotePriceCategory | null, subsections: Array<{ __typename?: 'PriceSubsection', name: string, value: number }> }> } | null, itinerary?: { __typename?: 'TripItinerary', title?: string | null, label?: string | null, items: Array<{ __typename?: 'TripItineraryItem', title: string, label: string, helper_text?: string | null, timestamp: number, type: TripItineraryItemType }> } | null, attribution?: { __typename?: 'Attribution', internal_source?: BookingInternalSource | null, internal_source_entity_id?: string | null, internal_source_entity_type?: BookingInternalSourceEntityType | null } | null, trip_insurance?: { __typename?: 'BookingQuoteTripInsuranceQuote', quote_id: string, is_accepted?: boolean | null, zip_code?: string | null, cost: number, policy_attributes?: { __typename?: 'TripInsurancePolicyAttribute', insurable_amount: number, insurable_amount_currency: string, event_start_date: number, event_end_date: number } | null, taxes_and_fees?: Array<{ __typename?: 'TripInsuranceTaxesAndFees', amount: number, description: string, type?: string | null }> | null, product: { __typename?: 'TripInsuranceProduct', description: string, promotional_header?: string | null, promotional_description?: string | null, accept_action_text?: string | null, decline_action_text?: string | null, legal_disclaimer?: string | null, privacy_policy_url?: string | null, terms_conditions_url?: string | null, additional_policy_purchase_email_message?: string | null, carrier_logo_url?: string | null, descriptors?: Array<string | null> | null, perils?: Array<string | null> | null, peril_heading?: string | null } } | null } };

export type RefundFieldsFragment = { __typename?: 'Refund', id: string, amount: number, payment_id: string, status: RefundStatus, approved_by_name: string, user_reason: string, stripe_reason?: StripeRefundReason | null, created_at: number, cancelled_at?: number | null, error?: { __typename?: 'PaymentError', message: string } | null, created_by: { __typename?: 'User', first_name?: string | null, last_name?: string | null }, cancelled_by?: { __typename?: 'User', first_name?: string | null, last_name?: string | null } | null };

export type ResourceFieldsFragment = { __typename?: 'Resource', id: string, outfitter_id: string, type: ResourceType, name: string, capacity?: number | null, year?: number | null, cover_image: string, description?: string | null, created_at: number, updated_at: number, images?: Array<{ __typename?: 'Media', url: string }> | null, vehicle_props?: { __typename?: 'VehicleProps', category: VehicleCategory, make?: string | null, model?: string | null } | null, boat_props?: { __typename?: 'BoatProps', category: BoatCategory, length?: number | null, boat_manufacturer?: string | null, boat_type?: string | null } | null, blind_props?: { __typename?: 'BlindProps', category: BlindCategory } | null, atv_props?: { __typename?: 'AtvProps', category: AtvCategory, manufacturer?: string | null } | null, gear_props?: { __typename?: 'GearProps', other?: string | null } | null };

export type ResourceQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ResourceQuery = { __typename?: 'Query', resource: { __typename?: 'Resource', id: string, outfitter_id: string, type: ResourceType, name: string, capacity?: number | null, year?: number | null, cover_image: string, description?: string | null, created_at: number, updated_at: number, images?: Array<{ __typename?: 'Media', url: string }> | null, vehicle_props?: { __typename?: 'VehicleProps', category: VehicleCategory, make?: string | null, model?: string | null } | null, boat_props?: { __typename?: 'BoatProps', category: BoatCategory, length?: number | null, boat_manufacturer?: string | null, boat_type?: string | null } | null, blind_props?: { __typename?: 'BlindProps', category: BlindCategory } | null, atv_props?: { __typename?: 'AtvProps', category: AtvCategory, manufacturer?: string | null } | null, gear_props?: { __typename?: 'GearProps', other?: string | null } | null } };

export type ReviewFormFieldsFragment = { __typename?: 'ReviewForm', id: string, name: string, title: string, subtitle?: string | null, main_subject_type: ReviewSubjectType, questions: Array<{ __typename?: 'ReviewFormQuestion', id: string, subject_type: ReviewSubjectType, is_question_required: boolean, should_collect_content: boolean, should_collect_photos: boolean, title_for_rating: string, title_for_content: string, title_for_photos: string, subtitle_for_rating?: string | null, subtitle_for_content?: string | null, subtitle_for_photos?: string | null }> };

export type ReviewFormQuestionFieldsFragment = { __typename?: 'ReviewFormQuestion', id: string, subject_type: ReviewSubjectType, is_question_required: boolean, should_collect_content: boolean, should_collect_photos: boolean, title_for_rating: string, title_for_content: string, title_for_photos: string, subtitle_for_rating?: string | null, subtitle_for_content?: string | null, subtitle_for_photos?: string | null };

export type ReviewFormQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ReviewFormQuery = { __typename?: 'Query', reviewForm: { __typename?: 'ReviewForm', id: string, name: string, title: string, subtitle?: string | null, main_subject_type: ReviewSubjectType, questions: Array<{ __typename?: 'ReviewFormQuestion', id: string, subject_type: ReviewSubjectType, is_question_required: boolean, should_collect_content: boolean, should_collect_photos: boolean, title_for_rating: string, title_for_content: string, title_for_photos: string, subtitle_for_rating?: string | null, subtitle_for_content?: string | null, subtitle_for_photos?: string | null }> } };

export type SubmitReviewFormMutationVariables = Exact<{
  data: SubmitReviewFormInput;
}>;


export type SubmitReviewFormMutation = { __typename?: 'Mutation', submitReviewForm?: any | null };

export type SpeciesFieldsFragment = { __typename?: 'Species', id: string, type: SpeciesType, name: string, image?: { __typename?: 'Media', url: string, description?: string | null } | null };

export type SpeciesMinimalFieldsFragment = { __typename?: 'Species', id: string, type: SpeciesType, name: string };

export type AllSpeciesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllSpeciesQuery = { __typename?: 'Query', allSpecies: Array<{ __typename?: 'Species', id: string, type: SpeciesType, name: string }> };

export type SearchSpeciesQueryVariables = Exact<{
  data: SearchSpeciesInput;
}>;


export type SearchSpeciesQuery = { __typename?: 'Query', searchSpecies: Array<{ __typename?: 'Species', id: string, type: SpeciesType, name: string }> };

export type ReactionFieldsFragment = { __typename?: 'Reaction', id: string, activity_id: string, user_id: string };

export type ActivityFieldsFragment = { __typename?: 'Activity', id: string, time: string, content: string, verb: string, object: string, foreign_id: string, foreign_entity_type: EntityType, attachments: Array<{ __typename?: 'Attachment', url: string, type: MediaType }>, reaction_counts?: { __typename?: 'ReactionCounts', like?: number | null } | null, own_reactions?: { __typename?: 'OwnReactions', like?: Array<{ __typename?: 'Reaction', id: string, activity_id: string, user_id: string }> | null } | null };

export type FeedActivitiesQueryVariables = Exact<{
  feedGroup: FeedGroup;
  feedId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FeedActivitiesQuery = { __typename?: 'Query', feedActivities: { __typename?: 'ActivitiesQueryResponse', canFetchMore: boolean, results: Array<{ __typename?: 'Activity', id: string, time: string, content: string, verb: string, object: string, foreign_id: string, foreign_entity_type: EntityType, attachments: Array<{ __typename?: 'Attachment', url: string, type: MediaType }>, reaction_counts?: { __typename?: 'ReactionCounts', like?: number | null } | null, own_reactions?: { __typename?: 'OwnReactions', like?: Array<{ __typename?: 'Reaction', id: string, activity_id: string, user_id: string }> | null } | null }> } };

export type StreamActivitiesByIdsQueryVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type StreamActivitiesByIdsQuery = { __typename?: 'Query', streamActivitiesByIds: Array<{ __typename?: 'Activity', id: string, time: string, content: string, verb: string, object: string, foreign_id: string, foreign_entity_type: EntityType, attachments: Array<{ __typename?: 'Attachment', url: string, type: MediaType }>, reaction_counts?: { __typename?: 'ReactionCounts', like?: number | null } | null, own_reactions?: { __typename?: 'OwnReactions', like?: Array<{ __typename?: 'Reaction', id: string, activity_id: string, user_id: string }> | null } | null }> };

export type ReactToActivityMutationVariables = Exact<{
  activityId: Scalars['String']['input'];
  reactionType: ReactionType;
}>;


export type ReactToActivityMutation = { __typename?: 'Mutation', reactToActivity: { __typename?: 'Activity', id: string, time: string, content: string, verb: string, object: string, foreign_id: string, foreign_entity_type: EntityType, attachments: Array<{ __typename?: 'Attachment', url: string, type: MediaType }>, reaction_counts?: { __typename?: 'ReactionCounts', like?: number | null } | null, own_reactions?: { __typename?: 'OwnReactions', like?: Array<{ __typename?: 'Reaction', id: string, activity_id: string, user_id: string }> | null } | null } };

export type RemoveReactionMutationVariables = Exact<{
  reactionId: Scalars['String']['input'];
}>;


export type RemoveReactionMutation = { __typename?: 'Mutation', removeReaction: { __typename?: 'Activity', id: string, time: string, content: string, verb: string, object: string, foreign_id: string, foreign_entity_type: EntityType, attachments: Array<{ __typename?: 'Attachment', url: string, type: MediaType }>, reaction_counts?: { __typename?: 'ReactionCounts', like?: number | null } | null, own_reactions?: { __typename?: 'OwnReactions', like?: Array<{ __typename?: 'Reaction', id: string, activity_id: string, user_id: string }> | null } | null } };

export type PaymentBlockFieldsFragment = { __typename?: 'PaymentBlock', id: string, title: string, subtitle?: string | null, subtitle2?: string | null, payment_gateway: PaymentGateway, type?: PaymentBlockType | null, brand?: string | null, is_default?: boolean | null, is_pending?: boolean | null, setup_intent_id?: string | null };

export type StripeSetupIntentFieldsFragment = { __typename?: 'StripeSetupIntent', id: string, client_secret: string };

export type StripePaymentIntentFieldsFragment = { __typename?: 'StripePaymentIntent', id: string, client_secret: string };

export type PreCheckoutDataFieldsFragment = { __typename?: 'PreCheckoutData', is_ach_available: boolean };

export type SportsmanPaymentBlocksQueryVariables = Exact<{
  sportsmanId: Scalars['ID']['input'];
}>;


export type SportsmanPaymentBlocksQuery = { __typename?: 'Query', sportsmanPaymentBlocks: Array<{ __typename?: 'PaymentBlock', id: string, title: string, subtitle?: string | null, subtitle2?: string | null, payment_gateway: PaymentGateway, type?: PaymentBlockType | null, brand?: string | null, is_default?: boolean | null, is_pending?: boolean | null, setup_intent_id?: string | null }> };

export type GroupPayMemberPaymentBlocksQueryVariables = Exact<{
  groupPayMemberId: Scalars['ID']['input'];
}>;


export type GroupPayMemberPaymentBlocksQuery = { __typename?: 'Query', groupPayMemberPaymentBlocks: Array<{ __typename?: 'PaymentBlock', id: string, title: string, subtitle?: string | null, subtitle2?: string | null, payment_gateway: PaymentGateway, type?: PaymentBlockType | null, brand?: string | null, is_default?: boolean | null, is_pending?: boolean | null, setup_intent_id?: string | null }> };

export type PreCheckoutDataQueryVariables = Exact<{
  outfitterId: Scalars['ID']['input'];
}>;


export type PreCheckoutDataQuery = { __typename?: 'Query', preCheckoutData: { __typename?: 'PreCheckoutData', is_ach_available: boolean } };

export type CreateSetupIntentMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateSetupIntentMutation = { __typename?: 'Mutation', createSetupIntent: { __typename?: 'StripeSetupIntent', id: string, client_secret: string } };

export type CreateGroupPayMemberSetupIntentMutationVariables = Exact<{
  memberId: Scalars['ID']['input'];
}>;


export type CreateGroupPayMemberSetupIntentMutation = { __typename?: 'Mutation', createGroupPayMemberSetupIntent: { __typename?: 'StripeSetupIntent', id: string, client_secret: string } };

export type SetDefaultPaymentMethodMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SetDefaultPaymentMethodMutation = { __typename?: 'Mutation', setDefaultPaymentMethod: Array<{ __typename?: 'PaymentBlock', id: string, title: string, subtitle?: string | null, subtitle2?: string | null, payment_gateway: PaymentGateway, type?: PaymentBlockType | null, brand?: string | null, is_default?: boolean | null, is_pending?: boolean | null, setup_intent_id?: string | null }> };

export type DeletePaymentMethodMutationVariables = Exact<{
  id: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
  groupPayMemberId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DeletePaymentMethodMutation = { __typename?: 'Mutation', deletePaymentMethod: Array<{ __typename?: 'PaymentBlock', id: string, title: string, subtitle?: string | null, subtitle2?: string | null, payment_gateway: PaymentGateway, type?: PaymentBlockType | null, brand?: string | null, is_default?: boolean | null, is_pending?: boolean | null, setup_intent_id?: string | null }> };

export type CreatePaymentIntentForQuickPayMutationVariables = Exact<{
  paymentId: Scalars['ID']['input'];
}>;


export type CreatePaymentIntentForQuickPayMutation = { __typename?: 'Mutation', createPaymentIntentForQuickPay: { __typename?: 'StripePaymentIntent', id: string, client_secret: string } };

export type VerifyMicroDepositsMutationVariables = Exact<{
  setupIntentId?: InputMaybe<Scalars['String']['input']>;
  paymentId?: InputMaybe<Scalars['ID']['input']>;
  amount1?: InputMaybe<Scalars['Float']['input']>;
  amount2?: InputMaybe<Scalars['Float']['input']>;
  descriptorCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type VerifyMicroDepositsMutation = { __typename?: 'Mutation', verifyMicroDeposits: boolean };

export type TeamMemberFieldsFragment = { __typename?: 'TeamMember', id: string, name: string, user?: { __typename?: 'User', avatar_url?: string | null } | null };

export type PublicTeamMemberFieldsFragment = { __typename?: 'PublicTeamMember', id: string, name: string, avatar?: string | null, role: TeamMemberRole, user?: { __typename?: 'PublicUser', avatar_url?: string | null, bio: string, years_of_experience?: number | null, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null } | null };

export type FullTeamMemberFieldsFragment = { __typename?: 'TeamMember', id: string, role: TeamMemberRole, years_of_experience?: number | null, user?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, avatar_url?: string | null, bio: string, years_of_experience?: number | null, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null } | null };

export type TeamMembersQueryVariables = Exact<{
  outfitterId: Scalars['ID']['input'];
  role?: InputMaybe<TeamMemberRole>;
}>;


export type TeamMembersQuery = { __typename?: 'Query', teamMembers: Array<{ __typename?: 'TeamMember', id: string, role: TeamMemberRole, years_of_experience?: number | null, user?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, avatar_url?: string | null, bio: string, years_of_experience?: number | null, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null } | null }> };

export type PublicTeamMembersQueryVariables = Exact<{
  outfitterId: Scalars['ID']['input'];
  role?: InputMaybe<TeamMemberRole>;
}>;


export type PublicTeamMembersQuery = { __typename?: 'Query', publicTeamMembers: { __typename?: 'PublicTeamMemberResults', data: Array<{ __typename?: 'PublicTeamMember', id: string, name: string, avatar?: string | null, role: TeamMemberRole, user?: { __typename?: 'PublicUser', avatar_url?: string | null, bio: string, years_of_experience?: number | null, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null } | null }> } };

export type TripInsuranceProductFieldsFragment = { __typename?: 'TripInsuranceProduct', description: string, promotional_header?: string | null, promotional_description?: string | null, accept_action_text?: string | null, decline_action_text?: string | null, legal_disclaimer?: string | null, privacy_policy_url?: string | null, terms_conditions_url?: string | null, additional_policy_purchase_email_message?: string | null, carrier_logo_url?: string | null, descriptors?: Array<string | null> | null, perils?: Array<string | null> | null, peril_heading?: string | null };

export type TripInsuranceQuoteFieldsFragment = { __typename?: 'BookingQuoteTripInsuranceQuote', quote_id: string, is_accepted?: boolean | null, zip_code?: string | null, cost: number, policy_attributes?: { __typename?: 'TripInsurancePolicyAttribute', insurable_amount: number, insurable_amount_currency: string, event_start_date: number, event_end_date: number } | null, taxes_and_fees?: Array<{ __typename?: 'TripInsuranceTaxesAndFees', amount: number, description: string, type?: string | null }> | null, product: { __typename?: 'TripInsuranceProduct', description: string, promotional_header?: string | null, promotional_description?: string | null, accept_action_text?: string | null, decline_action_text?: string | null, legal_disclaimer?: string | null, privacy_policy_url?: string | null, terms_conditions_url?: string | null, additional_policy_purchase_email_message?: string | null, carrier_logo_url?: string | null, descriptors?: Array<string | null> | null, perils?: Array<string | null> | null, peril_heading?: string | null } };

export type TripInsuranceProductQueryVariables = Exact<{
  zipCode: Scalars['String']['input'];
  insurableAmount: Scalars['PositiveInt']['input'];
}>;


export type TripInsuranceProductQuery = { __typename?: 'Query', tripInsuranceProduct?: { __typename?: 'TripInsuranceProduct', description: string, promotional_header?: string | null, promotional_description?: string | null, accept_action_text?: string | null, decline_action_text?: string | null, legal_disclaimer?: string | null, privacy_policy_url?: string | null, terms_conditions_url?: string | null, additional_policy_purchase_email_message?: string | null, carrier_logo_url?: string | null, descriptors?: Array<string | null> | null, perils?: Array<string | null> | null, peril_heading?: string | null } | null };

export type TripInsuranceQuoteQueryVariables = Exact<{
  zipCode: Scalars['String']['input'];
  bookingId: Scalars['String']['input'];
}>;


export type TripInsuranceQuoteQuery = { __typename?: 'Query', tripInsuranceQuote: { __typename?: 'BookingQuoteTripInsuranceQuote', quote_id: string, is_accepted?: boolean | null, zip_code?: string | null, cost: number, policy_attributes?: { __typename?: 'TripInsurancePolicyAttribute', insurable_amount: number, insurable_amount_currency: string, event_start_date: number, event_end_date: number } | null, taxes_and_fees?: Array<{ __typename?: 'TripInsuranceTaxesAndFees', amount: number, description: string, type?: string | null }> | null, product: { __typename?: 'TripInsuranceProduct', description: string, promotional_header?: string | null, promotional_description?: string | null, accept_action_text?: string | null, decline_action_text?: string | null, legal_disclaimer?: string | null, privacy_policy_url?: string | null, terms_conditions_url?: string | null, additional_policy_purchase_email_message?: string | null, carrier_logo_url?: string | null, descriptors?: Array<string | null> | null, perils?: Array<string | null> | null, peril_heading?: string | null } } };

export type CreateBookingTripInsurancePolicyMutationVariables = Exact<{
  data: TripInsurancePolicyInput;
}>;


export type CreateBookingTripInsurancePolicyMutation = { __typename?: 'Mutation', createBookingTripInsurancePolicy: { __typename?: 'Booking', id: string, dates: Array<number>, start_date: number, end_date: number, status: BookingStatus, sub_total: number, service_fee: number, state_tax: number, total: number, notes?: string | null, discount?: number | null, check_in_time: number, check_out_time: number, should_allow_external_payment?: boolean | null, created_at: number, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, is_guest_conversion_disabled?: boolean | null }, listing: { __typename?: 'Listing', time_zone?: string | null, id: string, type?: ListingType | null, title?: string | null, description?: string | null, published?: boolean | null, license_required?: boolean | null, cover_image?: string | null, species: Array<{ __typename?: 'Species', id: string, type: SpeciesType, name: string, image?: { __typename?: 'Media', url: string, description?: string | null } | null }>, lodging?: { __typename?: 'Lodging', id: string } | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null, lowest_pricing_package?: { __typename?: 'PricingPackage', name: string, price: number } | null }, outfitter: { __typename?: 'Outfitter', id: string, slug: string, name: string, status: OutfitterStatus, time_zone?: string | null, avatar?: { __typename?: 'Media', url: string, description?: string | null } | null, owner: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email: string, phone?: string | null, bio: string, location: string, avatar_url?: string | null, favorite_game: Array<string>, years_of_experience?: number | null, is_admin?: boolean | null, is_team_member?: boolean | null, created_at: number, updated_at: number, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null, impersonation_details?: { __typename?: 'ImpersonationDetails', is_impersonated: boolean } | null }, cancellation_policy: { __typename?: 'OutfitterCancellationPolicy', policy_id: string, description: string } }, payments: Array<{ __typename?: 'Payment', id: string, date: number, value: number, status: PaymentStatus, is_payment_method_unverified?: boolean | null, errors: Array<{ __typename?: 'PaymentError', code?: string | null, message: string }>, refunds: Array<{ __typename?: 'Refund', id: string, amount: number, payment_id: string, status: RefundStatus, approved_by_name: string, user_reason: string, stripe_reason?: StripeRefundReason | null, created_at: number, cancelled_at?: number | null, error?: { __typename?: 'PaymentError', message: string } | null, created_by: { __typename?: 'User', first_name?: string | null, last_name?: string | null }, cancelled_by?: { __typename?: 'User', first_name?: string | null, last_name?: string | null } | null }> }>, paymentRequests: Array<{ __typename?: 'PaymentRequest', id: string, value: number, status: PaymentRequestStatus, paid_offline?: boolean | null, created_at: number, errors: Array<{ __typename?: 'PaymentError', code?: string | null, message: string }>, add_ons?: Array<{ __typename?: 'PaymentRequestAddOn', id: string, total: number, quantity: number, number_of_days?: number | null, number_of_guests?: number | null }> | null, items: Array<{ __typename?: 'PaymentItemRequest', amount: number, description: string, add_on_id?: string | null }> }>, coupon?: { __typename?: 'Coupon', id: string, custom_code: string, amount_off?: number | null, percent_off?: number | null } | null, items: Array<{ __typename?: 'QuoteItem', name: string, option_id: string, rate: number, quantity: number, price: number }>, group_pay_share?: { __typename?: 'GroupPayShare', id: string, remaining_slots?: number | null, last_payment_due_date?: number | null, join_url?: string | null, shares: Array<{ __typename?: 'SlotShare', slots: number, total: number, is_invitation_accepted: boolean, is_host: boolean, member: { __typename?: 'GroupPayMember', id: string, name: string, email: string }, payments: Array<{ __typename?: 'Payment', id: string, date: number, value: number, status: PaymentStatus, errors: Array<{ __typename?: 'PaymentError', code?: string | null, message: string }>, refunds: Array<{ __typename?: 'Refund', id: string, amount: number, payment_id: string, status: RefundStatus, approved_by_name: string, user_reason: string, stripe_reason?: StripeRefundReason | null, created_at: number, cancelled_at?: number | null, error?: { __typename?: 'PaymentError', message: string } | null, created_by: { __typename?: 'User', first_name?: string | null, last_name?: string | null }, cancelled_by?: { __typename?: 'User', first_name?: string | null, last_name?: string | null } | null }> }> }> } | null, packages: Array<{ __typename?: 'QuotePackage', id: string, line_item_key?: string | null, pricing_package: { __typename?: 'PricingPackage', id: string, name: string, price: number, price_by_guest: PriceByGuest, price_by_day: PriceByDay, guests_included: number, min_guests?: number | null, max_guests?: number | null, days_included: number, lodging_included: boolean, included_lodging_id?: string | null, is_active: boolean, is_available?: boolean | null, not_available_reason?: string | null, included_resource_ids?: Array<string | null> | null, trophies: Array<{ __typename?: 'AddOn', id: string, name: string, category: string, species?: { __typename?: 'Species', id: string, type: SpeciesType, name: string } | null }>, gear_rentals: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, meal_upgrades: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, other_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, included_add_ons: Array<{ __typename?: 'AddOn', id: string, name: string, category: string }>, listing: { __typename?: 'Listing', id: string } } }>, add_ons?: Array<{ __typename?: 'QuoteAddOn', id: string, name: string, package_id?: string | null }> | null, attribution?: { __typename?: 'Attribution', deal_attribution?: string | null } | null, itinerary?: { __typename?: 'TripItinerary', title?: string | null, label?: string | null, items: Array<{ __typename?: 'TripItineraryItem', title: string, label: string, helper_text?: string | null, timestamp: number, type: TripItineraryItemType }> } | null, liability_waivers?: Array<{ __typename?: 'OutfitterDocument', id: string, name: string, external_url?: string | null }> | null, what_to_expect_documents?: Array<{ __typename?: 'OutfitterDocument', id: string, name: string, external_url?: string | null }> | null, trip_insurance?: { __typename?: 'BookingTripInsurance', insurance_quote_id: string, insurance_policy_number?: string | null, zip_code: string, status: BookingTripInsuranceStatus, is_accepted?: boolean | null } | null, quote?: { __typename?: 'Quote', id: string } | null } };

export type GetUserTrackingDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserTrackingDataQuery = { __typename?: 'Query', userTrackingData: { __typename?: 'UserTrackingData', props: Array<{ __typename?: 'UserTrackingProp', prop: string, boolean_value?: boolean | null, string_value?: string | null, number_value?: number | null, value_prop_name: string }> } };

export type UserFieldsFragment = { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email: string, phone?: string | null, bio: string, location: string, avatar_url?: string | null, favorite_game: Array<string>, years_of_experience?: number | null, is_admin?: boolean | null, is_team_member?: boolean | null, created_at: number, updated_at: number, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null, impersonation_details?: { __typename?: 'ImpersonationDetails', is_impersonated: boolean } | null };

export type PublicUserFieldsFragment = { __typename?: 'PublicUser', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, bio: string, years_of_experience?: number | null, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null };

export type UserMinimalFieldsFragment = { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, is_guest_conversion_disabled?: boolean | null };

export type OutfitterOwnerFieldsFragment = { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, bio: string, years_of_experience?: number | null, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null };

export type UserSocialsFieldsFragment = { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string };

export type UserPaymentsHistoryFieldsFragment = { __typename?: 'Payment', id: string, date: number, value: number, status: PaymentStatus, booking?: { __typename?: 'Booking', id: string } | null };

export type MinimalUserFieldsFragment = { __typename?: 'User', first_name?: string | null, last_name?: string | null, avatar_url?: string | null };

export type UserQueryVariables = Exact<{ [key: string]: never; }>;


export type UserQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email: string, phone?: string | null, bio: string, location: string, avatar_url?: string | null, favorite_game: Array<string>, years_of_experience?: number | null, is_admin?: boolean | null, is_team_member?: boolean | null, created_at: number, updated_at: number, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null, impersonation_details?: { __typename?: 'ImpersonationDetails', is_impersonated: boolean } | null } };

export type UserPaymentsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserPaymentsQuery = { __typename?: 'Query', userPaymentsHistory: Array<{ __typename?: 'Payment', id: string, date: number, value: number, status: PaymentStatus, booking?: { __typename?: 'Booking', id: string } | null }> };

export type IsUserUsingPasswordLoginQueryVariables = Exact<{ [key: string]: never; }>;


export type IsUserUsingPasswordLoginQuery = { __typename?: 'Query', isUserUsingPasswordLogin: boolean };

export type UpdateUserMutationVariables = Exact<{
  data: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email: string, phone?: string | null, bio: string, location: string, avatar_url?: string | null, favorite_game: Array<string>, years_of_experience?: number | null, is_admin?: boolean | null, is_team_member?: boolean | null, created_at: number, updated_at: number, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null, impersonation_details?: { __typename?: 'ImpersonationDetails', is_impersonated: boolean } | null } };

export type ChangeUserPasswordMutationVariables = Exact<{
  newPassword: Scalars['String']['input'];
}>;


export type ChangeUserPasswordMutation = { __typename?: 'Mutation', changeUserPassword: boolean };

export type WidgetFieldsFragment = { __typename?: 'Widget', id: string, listing_ids?: Array<string> | null, widget_name: string, trigger_type: WidgetTriggerType, button_color?: string | null, button_text?: string | null, text_color?: string | null, is_external: boolean, is_active: boolean, source?: string | null, created_at: number, updated_at: number, outfitter: { __typename?: 'Outfitter', listings_count: number, id: string, slug: string, name: string, about: string, status: OutfitterStatus, cover_image?: string | null, is_demo?: boolean | null, listings: Array<{ __typename?: 'Listing', min_guest?: number | null, max_guest?: number | null, id: string, type?: ListingType | null, title?: string | null, description?: string | null, published?: boolean | null, license_required?: boolean | null, cover_image?: string | null, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null, next_availability?: { __typename?: 'GenericAvailabilityEntry', date: number } | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, lowest_pricing_package?: { __typename?: 'PricingPackage', name: string, price: number } | null }>, owner: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, bio: string, years_of_experience?: number | null, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null }, lodgings: Array<{ __typename?: 'Lodging', id: string, name: string, description: string, type: LodgingType, type_name: string, capacity: number, cover_image: string, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, images?: Array<{ __typename?: 'Media', url: string, description?: string | null }> | null }>, guides: Array<{ __typename?: 'TeamMember', id: string, name: string, user?: { __typename?: 'User', avatar_url?: string | null } | null }>, resources: Array<{ __typename?: 'Resource', id: string, outfitter_id: string, type: ResourceType, name: string, capacity?: number | null, year?: number | null, cover_image: string, description?: string | null, created_at: number, updated_at: number, images?: Array<{ __typename?: 'Media', url: string }> | null, vehicle_props?: { __typename?: 'VehicleProps', category: VehicleCategory, make?: string | null, model?: string | null } | null, boat_props?: { __typename?: 'BoatProps', category: BoatCategory, length?: number | null, boat_manufacturer?: string | null, boat_type?: string | null } | null, blind_props?: { __typename?: 'BlindProps', category: BlindCategory } | null, atv_props?: { __typename?: 'AtvProps', category: AtvCategory, manufacturer?: string | null } | null, gear_props?: { __typename?: 'GearProps', other?: string | null } | null }>, avatar?: { __typename?: 'Media', url: string, description?: string | null } | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, video?: { __typename?: 'Video', hosted?: { __typename?: 'Media', url: string, description?: string | null } | null, social?: { __typename?: 'Media', url: string, description?: string | null } | null } | null, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null } };

export type WidgetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type WidgetQuery = { __typename?: 'Query', widget: { __typename?: 'Widget', id: string, listing_ids?: Array<string> | null, widget_name: string, trigger_type: WidgetTriggerType, button_color?: string | null, button_text?: string | null, text_color?: string | null, is_external: boolean, is_active: boolean, source?: string | null, created_at: number, updated_at: number, outfitter: { __typename?: 'Outfitter', listings_count: number, id: string, slug: string, name: string, about: string, status: OutfitterStatus, cover_image?: string | null, is_demo?: boolean | null, listings: Array<{ __typename?: 'Listing', min_guest?: number | null, max_guest?: number | null, id: string, type?: ListingType | null, title?: string | null, description?: string | null, published?: boolean | null, license_required?: boolean | null, cover_image?: string | null, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null, next_availability?: { __typename?: 'GenericAvailabilityEntry', date: number } | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, lowest_pricing_package?: { __typename?: 'PricingPackage', name: string, price: number } | null }>, owner: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, bio: string, years_of_experience?: number | null, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null }, lodgings: Array<{ __typename?: 'Lodging', id: string, name: string, description: string, type: LodgingType, type_name: string, capacity: number, cover_image: string, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, images?: Array<{ __typename?: 'Media', url: string, description?: string | null }> | null }>, guides: Array<{ __typename?: 'TeamMember', id: string, name: string, user?: { __typename?: 'User', avatar_url?: string | null } | null }>, resources: Array<{ __typename?: 'Resource', id: string, outfitter_id: string, type: ResourceType, name: string, capacity?: number | null, year?: number | null, cover_image: string, description?: string | null, created_at: number, updated_at: number, images?: Array<{ __typename?: 'Media', url: string }> | null, vehicle_props?: { __typename?: 'VehicleProps', category: VehicleCategory, make?: string | null, model?: string | null } | null, boat_props?: { __typename?: 'BoatProps', category: BoatCategory, length?: number | null, boat_manufacturer?: string | null, boat_type?: string | null } | null, blind_props?: { __typename?: 'BlindProps', category: BlindCategory } | null, atv_props?: { __typename?: 'AtvProps', category: AtvCategory, manufacturer?: string | null } | null, gear_props?: { __typename?: 'GearProps', other?: string | null } | null }>, avatar?: { __typename?: 'Media', url: string, description?: string | null } | null, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, video?: { __typename?: 'Video', hosted?: { __typename?: 'Media', url: string, description?: string | null } | null, social?: { __typename?: 'Media', url: string, description?: string | null } | null } | null, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null } } };

export type WishlistFieldsFragment = { __typename?: 'Wishlist', id: string, name: string, user: { __typename?: 'User', id: string }, listings: Array<{ __typename?: 'Listing', id: string, type?: ListingType | null, published?: boolean | null, title?: string | null, description?: string | null, rule?: string | null, booking_instructions?: string | null, min_guest?: number | null, max_guest?: number | null, duration?: ListingDuration | null, admin_note?: string | null, featured?: boolean | null, created_at: number, updated_at: number, is_unavailable?: boolean | null, cover_image?: string | null, license_required?: boolean | null, should_allow_quote_requests?: boolean | null, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, description: string, category: AmenityCategory, icon_url: string }>, species: Array<{ __typename?: 'Species', id: string, type: SpeciesType, name: string, image?: { __typename?: 'Media', url: string, description?: string | null } | null }>, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, lodging?: { __typename?: 'Lodging', id: string } | null, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, license_info?: { __typename?: 'LicenseInfo', general_info_url?: string | null, hunting_info_url?: string | null, fishing_info_url?: string | null, online_portal_url?: string | null } | null, outfitter: { __typename?: 'Outfitter', id: string, slug: string, created_at: number, name: string, about: string, cancellation_policy: { __typename?: 'OutfitterCancellationPolicy', policy_id: string, description: string }, avatar?: { __typename?: 'Media', url: string, description?: string | null } | null, location?: { __typename?: 'Address', city: string, state: string } | null, owner: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, bio: string, years_of_experience?: number | null, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null } }, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null, lowest_pricing_package?: { __typename?: 'PricingPackage', name: string, price: number } | null, next_availability?: { __typename?: 'GenericAvailabilityEntry', id: string, resource_type: string, resource_id: string, date: number, is_available: boolean, total_slots: number, booked_slots: number, available_slots: number, created_at: number, updated_at: number } | null }> };

export type WishlistQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type WishlistQuery = { __typename?: 'Query', wishlist: { __typename?: 'Wishlist', id: string, name: string, user: { __typename?: 'User', id: string }, listings: Array<{ __typename?: 'Listing', id: string, type?: ListingType | null, published?: boolean | null, title?: string | null, description?: string | null, rule?: string | null, booking_instructions?: string | null, min_guest?: number | null, max_guest?: number | null, duration?: ListingDuration | null, admin_note?: string | null, featured?: boolean | null, created_at: number, updated_at: number, is_unavailable?: boolean | null, cover_image?: string | null, license_required?: boolean | null, should_allow_quote_requests?: boolean | null, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, description: string, category: AmenityCategory, icon_url: string }>, species: Array<{ __typename?: 'Species', id: string, type: SpeciesType, name: string, image?: { __typename?: 'Media', url: string, description?: string | null } | null }>, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, lodging?: { __typename?: 'Lodging', id: string } | null, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, license_info?: { __typename?: 'LicenseInfo', general_info_url?: string | null, hunting_info_url?: string | null, fishing_info_url?: string | null, online_portal_url?: string | null } | null, outfitter: { __typename?: 'Outfitter', id: string, slug: string, created_at: number, name: string, about: string, cancellation_policy: { __typename?: 'OutfitterCancellationPolicy', policy_id: string, description: string }, avatar?: { __typename?: 'Media', url: string, description?: string | null } | null, location?: { __typename?: 'Address', city: string, state: string } | null, owner: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, bio: string, years_of_experience?: number | null, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null } }, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null, lowest_pricing_package?: { __typename?: 'PricingPackage', name: string, price: number } | null, next_availability?: { __typename?: 'GenericAvailabilityEntry', id: string, resource_type: string, resource_id: string, date: number, is_available: boolean, total_slots: number, booked_slots: number, available_slots: number, created_at: number, updated_at: number } | null }> } };

export type WishlistsByUserQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type WishlistsByUserQuery = { __typename?: 'Query', wishlistsByUser: Array<{ __typename?: 'Wishlist', id: string, name: string, user: { __typename?: 'User', id: string }, listings: Array<{ __typename?: 'Listing', id: string, type?: ListingType | null, published?: boolean | null, title?: string | null, description?: string | null, rule?: string | null, booking_instructions?: string | null, min_guest?: number | null, max_guest?: number | null, duration?: ListingDuration | null, admin_note?: string | null, featured?: boolean | null, created_at: number, updated_at: number, is_unavailable?: boolean | null, cover_image?: string | null, license_required?: boolean | null, should_allow_quote_requests?: boolean | null, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, description: string, category: AmenityCategory, icon_url: string }>, species: Array<{ __typename?: 'Species', id: string, type: SpeciesType, name: string, image?: { __typename?: 'Media', url: string, description?: string | null } | null }>, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, lodging?: { __typename?: 'Lodging', id: string } | null, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, license_info?: { __typename?: 'LicenseInfo', general_info_url?: string | null, hunting_info_url?: string | null, fishing_info_url?: string | null, online_portal_url?: string | null } | null, outfitter: { __typename?: 'Outfitter', id: string, slug: string, created_at: number, name: string, about: string, cancellation_policy: { __typename?: 'OutfitterCancellationPolicy', policy_id: string, description: string }, avatar?: { __typename?: 'Media', url: string, description?: string | null } | null, location?: { __typename?: 'Address', city: string, state: string } | null, owner: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, bio: string, years_of_experience?: number | null, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null } }, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null, lowest_pricing_package?: { __typename?: 'PricingPackage', name: string, price: number } | null, next_availability?: { __typename?: 'GenericAvailabilityEntry', id: string, resource_type: string, resource_id: string, date: number, is_available: boolean, total_slots: number, booked_slots: number, available_slots: number, created_at: number, updated_at: number } | null }> }> };

export type UpdateWishlistMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdateWishlistInput;
}>;


export type UpdateWishlistMutation = { __typename?: 'Mutation', updateWishlist: { __typename?: 'Wishlist', id: string, name: string, user: { __typename?: 'User', id: string }, listings: Array<{ __typename?: 'Listing', id: string, type?: ListingType | null, published?: boolean | null, title?: string | null, description?: string | null, rule?: string | null, booking_instructions?: string | null, min_guest?: number | null, max_guest?: number | null, duration?: ListingDuration | null, admin_note?: string | null, featured?: boolean | null, created_at: number, updated_at: number, is_unavailable?: boolean | null, cover_image?: string | null, license_required?: boolean | null, should_allow_quote_requests?: boolean | null, amenities: Array<{ __typename?: 'Amenity', id: string, name: string, description: string, category: AmenityCategory, icon_url: string }>, species: Array<{ __typename?: 'Species', id: string, type: SpeciesType, name: string, image?: { __typename?: 'Media', url: string, description?: string | null } | null }>, photos: Array<{ __typename?: 'Media', url: string, description?: string | null }>, lodging?: { __typename?: 'Lodging', id: string } | null, location?: { __typename?: 'Address', street_a: string, street_b?: string | null, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null, city: string, state: string } | null, license_info?: { __typename?: 'LicenseInfo', general_info_url?: string | null, hunting_info_url?: string | null, fishing_info_url?: string | null, online_portal_url?: string | null } | null, outfitter: { __typename?: 'Outfitter', id: string, slug: string, created_at: number, name: string, about: string, cancellation_policy: { __typename?: 'OutfitterCancellationPolicy', policy_id: string, description: string }, avatar?: { __typename?: 'Media', url: string, description?: string | null } | null, location?: { __typename?: 'Address', city: string, state: string } | null, owner: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null, bio: string, years_of_experience?: number | null, socials?: { __typename?: 'UserSocials', facebook: string, instagram: string, twitter: string } | null } }, booking_reviews_aggregation?: { __typename?: 'ReviewAggregation', average_rating: number, number_of_reviews: number } | null, lowest_pricing_package?: { __typename?: 'PricingPackage', name: string, price: number } | null, next_availability?: { __typename?: 'GenericAvailabilityEntry', id: string, resource_type: string, resource_id: string, date: number, is_available: boolean, total_slots: number, booked_slots: number, available_slots: number, created_at: number, updated_at: number } | null }> } };

export type CreateWishlistMutationVariables = Exact<{
  data: CreateWishlistInput;
}>;


export type CreateWishlistMutation = { __typename?: 'Mutation', createWishlist: { __typename?: 'Wishlist', id: string } };

export type RemoveWishlistMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveWishlistMutation = { __typename?: 'Mutation', removeWishlist?: any | null };

export const SpeciesMinimalFieldsFragmentDoc = gql`
    fragment SpeciesMinimalFields on Species {
  id
  type
  name
}
    `;
export const AddOnFormFieldsFragmentDoc = gql`
    fragment AddOnFormFields on AddOn {
  id
  name
  listings
  category
  species {
    ...SpeciesMinimalFields
  }
  unit_price
  deposit_amount
  deposit_percentage
  offer_period
  is_enabled
  created_at
  updated_at
  description
  images
  price_by_day
  price_by_guest
}
    ${SpeciesMinimalFieldsFragmentDoc}`;
export const BookingInviteEditableFieldsFragmentDoc = gql`
    fragment BookingInviteEditableFields on BookingInviteEditableFields {
  dates
  pricing_package
  total_guests
  add_ons
  coupon
}
    `;
export const PricingPackageFieldsFragmentDoc = gql`
    fragment PricingPackageFields on PricingPackage {
  id
  name
  price
  price_by_guest
  price_by_day
  guests_included
  min_guests
  max_guests
  days_included
  lodging_included
  included_lodging_id
  is_active
  trophies {
    id
    name
    category
    species {
      ...SpeciesMinimalFields
    }
  }
  gear_rentals {
    id
    name
    category
  }
  meal_upgrades {
    id
    name
    category
  }
  other_add_ons {
    id
    name
    category
  }
  included_add_ons {
    id
    name
    category
  }
  listing {
    id
  }
  is_available
  not_available_reason
  included_resource_ids
}
    ${SpeciesMinimalFieldsFragmentDoc}`;
export const BookingAddOnFieldsFragmentDoc = gql`
    fragment BookingAddOnFields on QuoteAddOn {
  id
  name
  category
  note
  unit_price
  deposit_amount
  deposit_percentage
  offer_period
  quantity
  package_id
}
    `;
export const BookingInvitePackageFieldsFragmentDoc = gql`
    fragment BookingInvitePackageFields on BookingInvitePackage {
  id
  pricing_package {
    ...PricingPackageFields
  }
  total_guests
  add_ons {
    ...BookingAddOnFields
  }
  editable_fields {
    ...BookingInviteEditableFields
  }
}
    ${PricingPackageFieldsFragmentDoc}
${BookingAddOnFieldsFragmentDoc}
${BookingInviteEditableFieldsFragmentDoc}`;
export const CityAndStateFieldsFragmentDoc = gql`
    fragment CityAndStateFields on Address {
  city
  state
}
    `;
export const AddressFieldsFragmentDoc = gql`
    fragment AddressFields on Address {
  street_a
  street_b
  ...CityAndStateFields
  zip
  country
  lat
  lng
  note
}
    ${CityAndStateFieldsFragmentDoc}`;
export const CouponFieldsFragmentDoc = gql`
    fragment CouponFields on Coupon {
  id
  outfitter {
    id
    name
    location {
      ...AddressFields
    }
  }
  name
  percent_off
  amount_off
  currency
  duration
  duration_in_months
  max_redemptions
  redeem_by
  created_at
  updated_at
}
    ${AddressFieldsFragmentDoc}`;
export const TripItineraryItemFieldsFragmentDoc = gql`
    fragment TripItineraryItemFields on TripItineraryItem {
  title
  label
  helper_text
  timestamp
  type
}
    `;
export const TripItineraryFieldsFragmentDoc = gql`
    fragment TripItineraryFields on TripItinerary {
  title
  label
  items {
    ...TripItineraryItemFields
  }
}
    ${TripItineraryItemFieldsFragmentDoc}`;
export const BookingInviteFieldsFragmentDoc = gql`
    fragment BookingInviteFields on BookingInvite {
  id
  listing {
    id
    title
    type
  }
  outfitter {
    id
    name
  }
  editable_fields {
    ...BookingInviteEditableFields
  }
  is_active
  dates
  packages {
    ...BookingInvitePackageFields
  }
  coupon {
    ...CouponFields
  }
  booked_redirect_url
  itinerary {
    ...TripItineraryFields
  }
  created_at
  updated_at
}
    ${BookingInviteEditableFieldsFragmentDoc}
${BookingInvitePackageFieldsFragmentDoc}
${CouponFieldsFragmentDoc}
${TripItineraryFieldsFragmentDoc}`;
export const MediaFieldsFragmentDoc = gql`
    fragment MediaFields on Media {
  url
  description
}
    `;
export const ReviewAggregationFieldsFragmentDoc = gql`
    fragment ReviewAggregationFields on ReviewAggregation {
  average_rating
  number_of_reviews
}
    `;
export const MinimalPricingPackageFieldsFragmentDoc = gql`
    fragment MinimalPricingPackageFields on PricingPackage {
  name
  price
}
    `;
export const ListingMinimalFieldsWithoutOutfitterFragmentDoc = gql`
    fragment ListingMinimalFieldsWithoutOutfitter on Listing {
  id
  type
  title
  description
  published
  license_required
  cover_image
  photos {
    ...MediaFields
  }
  location {
    ...AddressFields
  }
  booking_reviews_aggregation {
    ...ReviewAggregationFields
  }
  lowest_pricing_package {
    ...MinimalPricingPackageFields
  }
}
    ${MediaFieldsFragmentDoc}
${AddressFieldsFragmentDoc}
${ReviewAggregationFieldsFragmentDoc}
${MinimalPricingPackageFieldsFragmentDoc}`;
export const BookingMinimalFieldsFragmentDoc = gql`
    fragment BookingMinimalFields on Booking {
  id
  listing {
    ...ListingMinimalFieldsWithoutOutfitter
  }
  outfitter {
    name
    status
  }
  dates
  start_date
  end_date
  check_in_time
  check_out_time
  status
  can_be_reviewed
  review_form_url
}
    ${ListingMinimalFieldsWithoutOutfitterFragmentDoc}`;
export const PublicPricingPackageFieldsFragmentDoc = gql`
    fragment PublicPricingPackageFields on PublicPricingPackage {
  price
}
    `;
export const PublicListingFieldsWithoutOutfitterFragmentDoc = gql`
    fragment PublicListingFieldsWithoutOutfitter on PublicListing {
  id
  type
  title
  published
  min_guest
  max_guest
  license_required
  cover_image
  photos {
    ...MediaFields
  }
  location {
    ...AddressFields
  }
  booking_reviews_aggregation {
    ...ReviewAggregationFields
  }
  lowest_pricing_package {
    ...PublicPricingPackageFields
  }
}
    ${MediaFieldsFragmentDoc}
${AddressFieldsFragmentDoc}
${ReviewAggregationFieldsFragmentDoc}
${PublicPricingPackageFieldsFragmentDoc}`;
export const RecentPublicBookingsFieldsFragmentDoc = gql`
    fragment RecentPublicBookingsFields on PublicBooking {
  id
  listing {
    ...PublicListingFieldsWithoutOutfitter
  }
  created_at
}
    ${PublicListingFieldsWithoutOutfitterFragmentDoc}`;
export const UserMinimalFieldsFragmentDoc = gql`
    fragment UserMinimalFields on User {
  id
  first_name
  last_name
  avatar_url
  is_guest_conversion_disabled
}
    `;
export const SpeciesFieldsFragmentDoc = gql`
    fragment SpeciesFields on Species {
  id
  type
  name
  image {
    ...MediaFields
  }
}
    ${MediaFieldsFragmentDoc}`;
export const BookingListingFieldsFragmentDoc = gql`
    fragment BookingListingFields on Listing {
  ...ListingMinimalFieldsWithoutOutfitter
  species {
    ...SpeciesFields
  }
  lodging {
    id
  }
  time_zone
}
    ${ListingMinimalFieldsWithoutOutfitterFragmentDoc}
${SpeciesFieldsFragmentDoc}`;
export const UserSocialsFieldsFragmentDoc = gql`
    fragment UserSocialsFields on UserSocials {
  facebook
  instagram
  twitter
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on User {
  id
  first_name
  last_name
  email
  phone
  bio
  location
  avatar_url
  socials {
    ...UserSocialsFields
  }
  favorite_game
  years_of_experience
  is_admin
  is_team_member
  created_at
  updated_at
  impersonation_details {
    is_impersonated
  }
}
    ${UserSocialsFieldsFragmentDoc}`;
export const OutfitterCancellationPolicyFieldsFragmentDoc = gql`
    fragment OutfitterCancellationPolicyFields on OutfitterCancellationPolicy {
  policy_id
  description
}
    `;
export const BookingOutfitterFieldsFragmentDoc = gql`
    fragment BookingOutfitterFields on Outfitter {
  id
  slug
  name
  avatar {
    ...MediaFields
  }
  owner {
    ...UserFields
  }
  status
  time_zone
  cancellation_policy {
    ...OutfitterCancellationPolicyFields
  }
}
    ${MediaFieldsFragmentDoc}
${UserFieldsFragmentDoc}
${OutfitterCancellationPolicyFieldsFragmentDoc}`;
export const RefundFieldsFragmentDoc = gql`
    fragment RefundFields on Refund {
  id
  amount
  payment_id
  status
  approved_by_name
  user_reason
  stripe_reason
  error {
    message
  }
  created_by {
    first_name
    last_name
  }
  cancelled_by {
    first_name
    last_name
  }
  created_at
  cancelled_at
}
    `;
export const BookingPaymentFieldsFragmentDoc = gql`
    fragment BookingPaymentFields on Payment {
  id
  date
  value
  status
  is_payment_method_unverified
  errors {
    code
    message
  }
  refunds {
    ...RefundFields
  }
}
    ${RefundFieldsFragmentDoc}`;
export const BookingPaymentRequestFieldsFragmentDoc = gql`
    fragment BookingPaymentRequestFields on PaymentRequest {
  id
  value
  status
  paid_offline
  errors {
    code
    message
  }
  add_ons {
    id
    total
    quantity
    number_of_days
    number_of_guests
  }
  items {
    amount
    description
    add_on_id
  }
  created_at
}
    `;
export const QuoteItemFieldsFragmentDoc = gql`
    fragment QuoteItemFields on QuoteItem {
  name
  option_id
  rate
  quantity
  price
}
    `;
export const GroupPayMemberFieldsFragmentDoc = gql`
    fragment GroupPayMemberFields on GroupPayMember {
  id
  name
  email
}
    `;
export const SlotSharePaymentFieldsFragmentDoc = gql`
    fragment SlotSharePaymentFields on Payment {
  id
  date
  value
  status
  errors {
    code
    message
  }
  refunds {
    ...RefundFields
  }
}
    ${RefundFieldsFragmentDoc}`;
export const SlotShareFieldsFragmentDoc = gql`
    fragment SlotShareFields on SlotShare {
  member {
    ...GroupPayMemberFields
  }
  slots
  total
  is_invitation_accepted
  is_host
  payments {
    ...SlotSharePaymentFields
  }
}
    ${GroupPayMemberFieldsFragmentDoc}
${SlotSharePaymentFieldsFragmentDoc}`;
export const GroupPayShareFieldsFragmentDoc = gql`
    fragment GroupPayShareFields on GroupPayShare {
  id
  shares {
    ...SlotShareFields
  }
  remaining_slots
  last_payment_due_date
  join_url
}
    ${SlotShareFieldsFragmentDoc}`;
export const BookingPackageFieldsFragmentDoc = gql`
    fragment BookingPackageFields on QuotePackage {
  id
  pricing_package {
    ...PricingPackageFields
  }
  line_item_key
}
    ${PricingPackageFieldsFragmentDoc}`;
export const OutfitterDocumentFieldsFragmentDoc = gql`
    fragment OutfitterDocumentFields on OutfitterDocument {
  id
  name
  external_url
}
    `;
export const BookingFieldsFragmentDoc = gql`
    fragment BookingFields on Booking {
  id
  user {
    ...UserMinimalFields
  }
  listing {
    ...BookingListingFields
  }
  outfitter {
    ...BookingOutfitterFields
  }
  dates
  start_date
  end_date
  status
  sub_total
  service_fee
  state_tax
  total
  sub_total
  payments {
    ...BookingPaymentFields
  }
  paymentRequests {
    ...BookingPaymentRequestFields
  }
  coupon {
    id
    custom_code
    amount_off
    percent_off
  }
  items {
    ...QuoteItemFields
  }
  group_pay_share {
    ...GroupPayShareFields
  }
  packages {
    ...BookingPackageFields
  }
  add_ons {
    id
    name
    package_id
  }
  notes
  discount
  check_in_time
  check_out_time
  should_allow_external_payment
  created_at
  attribution {
    deal_attribution
  }
  itinerary {
    ...TripItineraryFields
  }
  liability_waivers {
    ...OutfitterDocumentFields
  }
  what_to_expect_documents {
    ...OutfitterDocumentFields
  }
  trip_insurance {
    insurance_quote_id
    insurance_policy_number
    zip_code
    status
    is_accepted
  }
  quote {
    id
  }
}
    ${UserMinimalFieldsFragmentDoc}
${BookingListingFieldsFragmentDoc}
${BookingOutfitterFieldsFragmentDoc}
${BookingPaymentFieldsFragmentDoc}
${BookingPaymentRequestFieldsFragmentDoc}
${QuoteItemFieldsFragmentDoc}
${GroupPayShareFieldsFragmentDoc}
${BookingPackageFieldsFragmentDoc}
${TripItineraryFieldsFragmentDoc}
${OutfitterDocumentFieldsFragmentDoc}`;
export const SubItemFieldsFragmentDoc = gql`
    fragment SubItemFields on SubItem {
  label
}
    `;
export const LineItemFieldsFragmentDoc = gql`
    fragment LineItemFields on LineItem {
  total
  label
  display_value
  details_label
  details_value
  key
  section_key
  sub_items {
    ...SubItemFields
  }
}
    ${SubItemFieldsFragmentDoc}`;
export const QuotePriceFieldsFragmentDoc = gql`
    fragment QuotePriceFields on QuotePrice {
  name
  value
  note
  subsections {
    name
    value
  }
  category
}
    `;
export const MemberPaymentSummaryFieldsFragmentDoc = gql`
    fragment MemberPaymentSummaryFields on MemberPaymentSummary {
  member_id
  member_name
  prices {
    ...QuotePriceFields
  }
  totals {
    ...QuotePriceFields
  }
}
    ${QuotePriceFieldsFragmentDoc}`;
export const BookingPaymentSummaryFieldsFragmentDoc = gql`
    fragment BookingPaymentSummaryFields on BookingPaymentSummary {
  line_items {
    ...LineItemFields
  }
  totals {
    ...QuotePriceFields
  }
  member_summaries {
    ...MemberPaymentSummaryFields
  }
  member_total
}
    ${LineItemFieldsFragmentDoc}
${QuotePriceFieldsFragmentDoc}
${MemberPaymentSummaryFieldsFragmentDoc}`;
export const BookingPaymentWithStripeUrlFieldsFragmentDoc = gql`
    fragment BookingPaymentWithStripeUrlFields on Payment {
  ...BookingPaymentFields
  receipt_hosted_url
  total
  intent_id
  note
  payment_method_id
  user {
    id
  }
  group_pay_member {
    id
  }
}
    ${BookingPaymentFieldsFragmentDoc}`;
export const BookingWithPaymentSummaryFieldsFragmentDoc = gql`
    fragment BookingWithPaymentSummaryFields on Booking {
  ...BookingFields
  can_be_reviewed
  review_form_url
  payment_summary {
    ...BookingPaymentSummaryFields
  }
  payments {
    ...BookingPaymentWithStripeUrlFields
  }
}
    ${BookingFieldsFragmentDoc}
${BookingPaymentSummaryFieldsFragmentDoc}
${BookingPaymentWithStripeUrlFieldsFragmentDoc}`;
export const QuotePaymentPlanFieldsFragmentDoc = gql`
    fragment QuotePaymentPlanFields on QuotePaymentPlan {
  id
  name
  note
  type
  payments {
    id
    date
    value
  }
}
    `;
export const BookingQuoteTripInsuranceQuoteFieldsFragmentDoc = gql`
    fragment BookingQuoteTripInsuranceQuoteFields on BookingQuoteTripInsuranceQuote {
  quote_id
  policy_attributes {
    insurable_amount
    insurable_amount_currency
    event_start_date
    event_end_date
  }
  taxes_and_fees {
    amount
    description
    type
  }
  product {
    description
    promotional_header
    promotional_description
    accept_action_text
    decline_action_text
    legal_disclaimer
    privacy_policy_url
    terms_conditions_url
    additional_policy_purchase_email_message
    carrier_logo_url
    descriptors
    perils
    peril_heading
  }
  is_accepted
  zip_code
  cost
}
    `;
export const SlotPaymentPlanFieldsFragmentDoc = gql`
    fragment SlotPaymentPlanFields on SlotPaymentPlan {
  slots
  total
  payment_plan {
    ...QuotePaymentPlanFields
  }
  trip_insurance {
    ...BookingQuoteTripInsuranceQuoteFields
  }
  totals {
    ...QuotePriceFields
  }
}
    ${QuotePaymentPlanFieldsFragmentDoc}
${BookingQuoteTripInsuranceQuoteFieldsFragmentDoc}
${QuotePriceFieldsFragmentDoc}`;
export const PageSubsectionItemFieldsFragmentDoc = gql`
    fragment PageSubsectionItemFields on PageSubsectionItem {
  label
  sub_label
  cta_url
}
    `;
export const PageSubsectionFieldsFragmentDoc = gql`
    fragment PageSubsectionFields on PageSubsection {
  label
  sub_label
  items {
    ...PageSubsectionItemFields
  }
}
    ${PageSubsectionItemFieldsFragmentDoc}`;
export const RegionFieldsFragmentDoc = gql`
    fragment RegionFields on Region {
  label
  sub_label
  states_subsection {
    ...PageSubsectionFields
  }
  countries_subsection {
    ...PageSubsectionFields
  }
}
    ${PageSubsectionFieldsFragmentDoc}`;
export const AmenityFieldsFragmentDoc = gql`
    fragment AmenityFields on Amenity {
  id
  name
  description
  category
  icon_url
}
    `;
export const LicenseInfoFieldsFragmentDoc = gql`
    fragment LicenseInfoFields on LicenseInfo {
  general_info_url
  hunting_info_url
  fishing_info_url
  online_portal_url
}
    `;
export const OutfitterOwnerFieldsFragmentDoc = gql`
    fragment OutfitterOwnerFields on User {
  id
  first_name
  last_name
  avatar_url
  bio
  years_of_experience
  socials {
    ...UserSocialsFields
  }
}
    ${UserSocialsFieldsFragmentDoc}`;
export const ListingOutfitterFieldsFragmentDoc = gql`
    fragment ListingOutfitterFields on Outfitter {
  id
  slug
  created_at
  name
  about
  created_at
  avatar {
    ...MediaFields
  }
  location {
    ...CityAndStateFields
  }
  owner {
    ...OutfitterOwnerFields
  }
}
    ${MediaFieldsFragmentDoc}
${CityAndStateFieldsFragmentDoc}
${OutfitterOwnerFieldsFragmentDoc}`;
export const ListingsFieldsFragmentDoc = gql`
    fragment ListingsFields on Listing {
  id
  type
  published
  title
  description
  min_guest
  max_guest
  amenities {
    ...AmenityFields
  }
  cover_image
  photos {
    ...MediaFields
  }
  location {
    ...AddressFields
  }
  license_required
  license_info {
    ...LicenseInfoFields
  }
  outfitter {
    ...ListingOutfitterFields
  }
  booking_reviews_aggregation {
    ...ReviewAggregationFields
  }
  lowest_pricing_package {
    ...MinimalPricingPackageFields
  }
  should_allow_quote_requests
}
    ${AmenityFieldsFragmentDoc}
${MediaFieldsFragmentDoc}
${AddressFieldsFragmentDoc}
${LicenseInfoFieldsFragmentDoc}
${ListingOutfitterFieldsFragmentDoc}
${ReviewAggregationFieldsFragmentDoc}
${MinimalPricingPackageFieldsFragmentDoc}`;
export const PublicUserFieldsFragmentDoc = gql`
    fragment PublicUserFields on PublicUser {
  id
  first_name
  last_name
  avatar_url
  bio
  years_of_experience
  socials {
    ...UserSocialsFields
  }
}
    ${UserSocialsFieldsFragmentDoc}`;
export const ListingPublicOutfitterFieldsFragmentDoc = gql`
    fragment ListingPublicOutfitterFields on PublicOutfitter {
  id
  slug
  created_at
  name
  about
  created_at
  avatar {
    ...MediaFields
  }
  location {
    ...CityAndStateFields
  }
  owner {
    ...PublicUserFields
  }
}
    ${MediaFieldsFragmentDoc}
${CityAndStateFieldsFragmentDoc}
${PublicUserFieldsFragmentDoc}`;
export const PublicListingFieldsFragmentDoc = gql`
    fragment PublicListingFields on PublicListing {
  ...PublicListingFieldsWithoutOutfitter
  description
  rule
  is_unavailable
  amenities {
    ...AmenityFields
  }
  species {
    ...SpeciesFields
  }
  next_availability {
    date
  }
  license_info {
    ...LicenseInfoFields
  }
  outfitter {
    ...ListingPublicOutfitterFields
  }
  should_allow_quote_requests
}
    ${PublicListingFieldsWithoutOutfitterFragmentDoc}
${AmenityFieldsFragmentDoc}
${SpeciesFieldsFragmentDoc}
${LicenseInfoFieldsFragmentDoc}
${ListingPublicOutfitterFieldsFragmentDoc}`;
export const SearchListingFieldsFragmentDoc = gql`
    fragment SearchListingFields on Listing {
  id
  type
  title
  published
  min_guest
  max_guest
  cover_image
  photos {
    ...MediaFields
  }
  location {
    ...AddressFields
  }
  outfitter {
    ...ListingOutfitterFields
  }
  booking_reviews_aggregation {
    ...ReviewAggregationFields
  }
  lowest_pricing_package {
    ...MinimalPricingPackageFields
  }
}
    ${MediaFieldsFragmentDoc}
${AddressFieldsFragmentDoc}
${ListingOutfitterFieldsFragmentDoc}
${ReviewAggregationFieldsFragmentDoc}
${MinimalPricingPackageFieldsFragmentDoc}`;
export const PublicSearchListingFieldsFragmentDoc = gql`
    fragment PublicSearchListingFields on PublicListing {
  id
  type
  title
  published
  min_guest
  max_guest
  cover_image
  is_unavailable
  photos {
    ...MediaFields
  }
  location {
    ...AddressFields
  }
  outfitter {
    ...ListingPublicOutfitterFields
  }
  booking_reviews_aggregation {
    ...ReviewAggregationFields
  }
  lowest_pricing_package {
    price
  }
  next_availability {
    date
  }
}
    ${MediaFieldsFragmentDoc}
${AddressFieldsFragmentDoc}
${ListingPublicOutfitterFieldsFragmentDoc}
${ReviewAggregationFieldsFragmentDoc}`;
export const ListingMinimalFieldsFragmentDoc = gql`
    fragment ListingMinimalFields on Listing {
  ...ListingMinimalFieldsWithoutOutfitter
  outfitter {
    ...ListingOutfitterFields
  }
}
    ${ListingMinimalFieldsWithoutOutfitterFragmentDoc}
${ListingOutfitterFieldsFragmentDoc}`;
export const ListingPricingOptionFieldsFragmentDoc = gql`
    fragment ListingPricingOptionFields on PricingOption {
  id
  name
  day_rate
  min
  max
  note
}
    `;
export const ListingPricingFieldsFragmentDoc = gql`
    fragment ListingPricingFields on Pricing {
  type
  options {
    ...ListingPricingOptionFields
  }
}
    ${ListingPricingOptionFieldsFragmentDoc}`;
export const LodgingFieldsFragmentDoc = gql`
    fragment LodgingFields on Lodging {
  id
  name
  description
  type
  capacity
  location {
    ...AddressFields
  }
  outfitter {
    id
    slug
    name
  }
  images {
    url
  }
  created_at
  updated_at
}
    ${AddressFieldsFragmentDoc}`;
export const GenericSearchSuggestionItemFieldsFragmentDoc = gql`
    fragment GenericSearchSuggestionItemFields on GenericSearchSuggestionItem {
  type
  label
  value
  image_url
  icon_url
  cta_url
}
    `;
export const GenericSearchSuggestionGroupFieldsFragmentDoc = gql`
    fragment GenericSearchSuggestionGroupFields on GenericSearchSuggestionGroup {
  title
  type
  items {
    ...GenericSearchSuggestionItemFields
  }
}
    ${GenericSearchSuggestionItemFieldsFragmentDoc}`;
export const OnboardingFieldsFragmentDoc = gql`
    fragment OnboardingFields on Onboarding {
  id
}
    `;
export const OnboardingStatusInfoFieldsFragmentDoc = gql`
    fragment OnboardingStatusInfoFields on OnboardingStatusInfo {
  status
}
    `;
export const PublicTeamMemberFieldsFragmentDoc = gql`
    fragment PublicTeamMemberFields on PublicTeamMember {
  id
  user {
    avatar_url
    socials {
      facebook
      instagram
      twitter
    }
    bio
    years_of_experience
  }
  name
  avatar
  role
}
    `;
export const PublicLodgingFieldsFragmentDoc = gql`
    fragment PublicLodgingFields on PublicLodging {
  id
  name
  description
  type
  type_name
  capacity
  location {
    ...AddressFields
  }
  images {
    url
    description
  }
  cover_image
}
    ${AddressFieldsFragmentDoc}`;
export const PublicOutfitterFieldsFragmentDoc = gql`
    fragment PublicOutfitterFields on PublicOutfitter {
  id
  slug
  created_at
  name
  about
  created_at
  avatar {
    ...MediaFields
  }
  location {
    ...AddressFields
  }
  booking_reviews_aggregation {
    ...ReviewAggregationFields
  }
  listings_count
  photos {
    ...MediaFields
  }
  video {
    hosted {
      ...MediaFields
    }
    social {
      ...MediaFields
    }
  }
  owner {
    ...PublicUserFields
  }
  guides {
    ...PublicTeamMemberFields
  }
  lodgings {
    ...PublicLodgingFields
  }
}
    ${MediaFieldsFragmentDoc}
${AddressFieldsFragmentDoc}
${ReviewAggregationFieldsFragmentDoc}
${PublicUserFieldsFragmentDoc}
${PublicTeamMemberFieldsFragmentDoc}
${PublicLodgingFieldsFragmentDoc}`;
export const MinimalUserFieldsFragmentDoc = gql`
    fragment MinimalUserFields on User {
  first_name
  last_name
  avatar_url
}
    `;
export const OutfitterMinimalFieldsFragmentDoc = gql`
    fragment OutfitterMinimalFields on Outfitter {
  id
  slug
  name
  avatar {
    ...MediaFields
  }
  owner {
    ...MinimalUserFields
  }
  status
  time_zone
}
    ${MediaFieldsFragmentDoc}
${MinimalUserFieldsFragmentDoc}`;
export const PaymentRequestBookingFieldsFragmentDoc = gql`
    fragment PaymentRequestBookingFields on Booking {
  id
  listing {
    title
    type
    location {
      ...AddressFields
    }
    photos {
      ...MediaFields
    }
  }
  sub_total
  add_ons {
    ...BookingAddOnFields
  }
}
    ${AddressFieldsFragmentDoc}
${MediaFieldsFragmentDoc}
${BookingAddOnFieldsFragmentDoc}`;
export const PaymentRequestFieldsFragmentDoc = gql`
    fragment PaymentRequestFields on PaymentRequest {
  id
  add_ons {
    id
    total
    quantity
    number_of_days
    number_of_guests
  }
  booking {
    ...PaymentRequestBookingFields
  }
  items {
    currency
    amount
    description
    add_on_id
  }
  intent_id
  invoice_id
  status
  subtotal
  sales_tax
  processing_fee
  value
  should_include_taxes
  created_at
  updated_at
}
    ${PaymentRequestBookingFieldsFragmentDoc}`;
export const PaymentRequestSummaryFieldsFragmentDoc = gql`
    fragment PaymentRequestSummaryFields on AdditionalPaymentSummary {
  line_items {
    details_label
    display_value
    label
    details_value
    total
  }
  prices {
    category
    currency
    name
    value
    note
    subsections {
      category
      currency
      name
      value
    }
  }
  total
}
    `;
export const PaymentFieldsFragmentDoc = gql`
    fragment PaymentFields on Payment {
  id
  value
  total
  sales_tax
  processing_fee
  status
  outfitter {
    name
  }
}
    `;
export const ListingOutfitterWithCancellationPolicyFieldsFragmentDoc = gql`
    fragment ListingOutfitterWithCancellationPolicyFields on Outfitter {
  ...ListingOutfitterFields
  cancellation_policy {
    ...OutfitterCancellationPolicyFields
  }
}
    ${ListingOutfitterFieldsFragmentDoc}
${OutfitterCancellationPolicyFieldsFragmentDoc}`;
export const GenericAvailabilityFieldsFragmentDoc = gql`
    fragment GenericAvailabilityFields on GenericAvailabilityEntry {
  id
  resource_type
  resource_id
  date
  is_available
  total_slots
  booked_slots
  available_slots
  created_at
  updated_at
}
    `;
export const ListingFieldsFragmentDoc = gql`
    fragment ListingFields on Listing {
  id
  type
  published
  title
  description
  rule
  booking_instructions
  min_guest
  max_guest
  duration
  admin_note
  featured
  created_at
  updated_at
  is_unavailable
  amenities {
    ...AmenityFields
  }
  species {
    ...SpeciesFields
  }
  cover_image
  photos {
    ...MediaFields
  }
  lodging {
    id
  }
  location {
    ...AddressFields
  }
  license_required
  license_info {
    ...LicenseInfoFields
  }
  outfitter {
    ...ListingOutfitterWithCancellationPolicyFields
  }
  booking_reviews_aggregation {
    ...ReviewAggregationFields
  }
  lowest_pricing_package {
    ...MinimalPricingPackageFields
  }
  next_availability {
    ...GenericAvailabilityFields
  }
  should_allow_quote_requests
}
    ${AmenityFieldsFragmentDoc}
${SpeciesFieldsFragmentDoc}
${MediaFieldsFragmentDoc}
${AddressFieldsFragmentDoc}
${LicenseInfoFieldsFragmentDoc}
${ListingOutfitterWithCancellationPolicyFieldsFragmentDoc}
${ReviewAggregationFieldsFragmentDoc}
${MinimalPricingPackageFieldsFragmentDoc}
${GenericAvailabilityFieldsFragmentDoc}`;
export const QuoteRequestFieldsFragmentDoc = gql`
    fragment QuoteRequestFields on QuoteRequest {
  id
  contact {
    first_name
    last_name
    email
    phone
    preferred_method
  }
  created_at
  updated_at
  dates
  trip_details
  is_archived
  listing {
    ...ListingFields
  }
  booking_invite {
    id
  }
}
    ${ListingFieldsFragmentDoc}`;
export const QuoteListingFieldsFragmentDoc = gql`
    fragment QuoteListingFields on Listing {
  id
  title
  type
  location {
    ...CityAndStateFields
    zip
  }
  lodging {
    id
  }
  cover_image
  photos {
    ...MediaFields
  }
  check_out_minutes
  time_zone
  outfitter {
    id
    time_zone
    is_ach_enabled
    is_processing_fee_payed_by_sportsman
    cancellation_policy {
      ...OutfitterCancellationPolicyFields
    }
  }
}
    ${CityAndStateFieldsFragmentDoc}
${MediaFieldsFragmentDoc}
${OutfitterCancellationPolicyFieldsFragmentDoc}`;
export const AddOnQuoteFieldsFragmentDoc = gql`
    fragment AddOnQuoteFields on QuoteAddOn {
  id
  category
  name
  unit_price
  quantity
  deposit_amount
  deposit_percentage
  price_by_day
  price_by_guest
  package_id
}
    `;
export const QuotePackageFieldsFragmentDoc = gql`
    fragment QuotePackageFields on QuotePackage {
  id
  line_item_key
  pricing_package {
    ...PricingPackageFields
  }
  number_of_guests
  items {
    ...QuoteItemFields
  }
  add_ons {
    ...AddOnQuoteFields
  }
}
    ${PricingPackageFieldsFragmentDoc}
${QuoteItemFieldsFragmentDoc}
${AddOnQuoteFieldsFragmentDoc}`;
export const QuoteCouponFieldsFragmentDoc = gql`
    fragment QuoteCouponFields on Coupon {
  id
  custom_code
  amount_off
  percent_off
}
    `;
export const PaymentSummaryFieldsFragmentDoc = gql`
    fragment PaymentSummaryFields on PaymentSummary {
  line_items {
    ...LineItemFields
  }
  prices {
    ...QuotePriceFields
  }
  totals {
    ...QuotePriceFields
  }
  total
}
    ${LineItemFieldsFragmentDoc}
${QuotePriceFieldsFragmentDoc}`;
export const AttributionFieldsFragmentDoc = gql`
    fragment AttributionFields on Attribution {
  internal_source
  internal_source_entity_id
  internal_source_entity_type
}
    `;
export const QuoteInterfaceFieldsFragmentDoc = gql`
    fragment QuoteInterfaceFields on QuoteInterface {
  dates
  listing {
    ...QuoteListingFields
  }
  items {
    ...QuoteItemFields
  }
  prices {
    ...QuotePriceFields
  }
  packages {
    ...QuotePackageFields
  }
  lodging_included
  payment_plans {
    ...QuotePaymentPlanFields
  }
  coupon {
    ...QuoteCouponFields
  }
  add_ons {
    ...AddOnQuoteFields
  }
  discount
  total
  payment_summary {
    ...PaymentSummaryFields
  }
  itinerary {
    ...TripItineraryFields
  }
  attribution {
    ...AttributionFields
  }
}
    ${QuoteListingFieldsFragmentDoc}
${QuoteItemFieldsFragmentDoc}
${QuotePriceFieldsFragmentDoc}
${QuotePackageFieldsFragmentDoc}
${QuotePaymentPlanFieldsFragmentDoc}
${QuoteCouponFieldsFragmentDoc}
${AddOnQuoteFieldsFragmentDoc}
${PaymentSummaryFieldsFragmentDoc}
${TripItineraryFieldsFragmentDoc}
${AttributionFieldsFragmentDoc}`;
export const QuotePaymentGroupMemberFieldsFragmentDoc = gql`
    fragment QuotePaymentGroupMemberFields on QuotePaymentGroupMember {
  id
  name
  email
  slots
  amount
  payment_plans {
    ...QuotePaymentPlanFields
  }
}
    ${QuotePaymentPlanFieldsFragmentDoc}`;
export const QuotePaymentGroupFieldsFragmentDoc = gql`
    fragment QuotePaymentGroupFields on QuotePaymentGroup {
  host {
    ...QuotePaymentGroupMemberFields
  }
  members {
    ...QuotePaymentGroupMemberFields
  }
  remaining_slots
  last_payment_due_date
}
    ${QuotePaymentGroupMemberFieldsFragmentDoc}`;
export const QuoteFieldsFragmentDoc = gql`
    fragment QuoteFields on Quote {
  id
  payment_group {
    ...QuotePaymentGroupFields
  }
  packages {
    ...QuotePackageFields
  }
  dates
  listing {
    ...QuoteListingFields
  }
  items {
    ...QuoteItemFields
  }
  prices {
    ...QuotePriceFields
  }
  lodging_included
  payment_plans {
    ...QuotePaymentPlanFields
  }
  coupon {
    ...QuoteCouponFields
  }
  add_ons {
    ...AddOnQuoteFields
  }
  discount
  total
  booking_invite {
    id
  }
  should_allow_external_payment
  payment_summary {
    ...PaymentSummaryFields
  }
  itinerary {
    ...TripItineraryFields
  }
  attribution {
    ...AttributionFields
  }
  trip_insurance {
    ...BookingQuoteTripInsuranceQuoteFields
  }
}
    ${QuotePaymentGroupFieldsFragmentDoc}
${QuotePackageFieldsFragmentDoc}
${QuoteListingFieldsFragmentDoc}
${QuoteItemFieldsFragmentDoc}
${QuotePriceFieldsFragmentDoc}
${QuotePaymentPlanFieldsFragmentDoc}
${QuoteCouponFieldsFragmentDoc}
${AddOnQuoteFieldsFragmentDoc}
${PaymentSummaryFieldsFragmentDoc}
${TripItineraryFieldsFragmentDoc}
${AttributionFieldsFragmentDoc}
${BookingQuoteTripInsuranceQuoteFieldsFragmentDoc}`;
export const ReviewFormQuestionFieldsFragmentDoc = gql`
    fragment ReviewFormQuestionFields on ReviewFormQuestion {
  id
  subject_type
  is_question_required
  should_collect_content
  should_collect_photos
  title_for_rating
  title_for_content
  title_for_photos
  subtitle_for_rating
  subtitle_for_content
  subtitle_for_photos
}
    `;
export const ReviewFormFieldsFragmentDoc = gql`
    fragment ReviewFormFields on ReviewForm {
  id
  name
  title
  subtitle
  main_subject_type
  questions {
    ...ReviewFormQuestionFields
  }
}
    ${ReviewFormQuestionFieldsFragmentDoc}`;
export const ReactionFieldsFragmentDoc = gql`
    fragment ReactionFields on Reaction {
  id
  activity_id
  user_id
}
    `;
export const ActivityFieldsFragmentDoc = gql`
    fragment ActivityFields on Activity {
  id
  time
  content
  attachments {
    url
    type
  }
  verb
  object
  foreign_id
  foreign_entity_type
  reaction_counts {
    like
  }
  own_reactions {
    like {
      ...ReactionFields
    }
  }
}
    ${ReactionFieldsFragmentDoc}`;
export const PaymentBlockFieldsFragmentDoc = gql`
    fragment PaymentBlockFields on PaymentBlock {
  id
  title
  subtitle
  subtitle2
  payment_gateway
  type
  brand
  is_default
  is_pending
  setup_intent_id
}
    `;
export const StripeSetupIntentFieldsFragmentDoc = gql`
    fragment StripeSetupIntentFields on StripeSetupIntent {
  id
  client_secret
}
    `;
export const StripePaymentIntentFieldsFragmentDoc = gql`
    fragment StripePaymentIntentFields on StripePaymentIntent {
  id
  client_secret
}
    `;
export const PreCheckoutDataFieldsFragmentDoc = gql`
    fragment PreCheckoutDataFields on PreCheckoutData {
  is_ach_available
}
    `;
export const FullTeamMemberFieldsFragmentDoc = gql`
    fragment FullTeamMemberFields on TeamMember {
  id
  user {
    first_name
    last_name
    avatar_url
    bio
    years_of_experience
    socials {
      facebook
      instagram
      twitter
    }
  }
  role
  years_of_experience
}
    `;
export const TripInsuranceProductFieldsFragmentDoc = gql`
    fragment TripInsuranceProductFields on TripInsuranceProduct {
  description
  promotional_header
  promotional_description
  accept_action_text
  decline_action_text
  legal_disclaimer
  privacy_policy_url
  terms_conditions_url
  additional_policy_purchase_email_message
  carrier_logo_url
  descriptors
  perils
  peril_heading
}
    `;
export const TripInsuranceQuoteFieldsFragmentDoc = gql`
    fragment TripInsuranceQuoteFields on BookingQuoteTripInsuranceQuote {
  ...BookingQuoteTripInsuranceQuoteFields
}
    ${BookingQuoteTripInsuranceQuoteFieldsFragmentDoc}`;
export const UserPaymentsHistoryFieldsFragmentDoc = gql`
    fragment UserPaymentsHistoryFields on Payment {
  id
  date
  value
  status
  booking {
    id
  }
}
    `;
export const AllOutfittersFieldsFragmentDoc = gql`
    fragment AllOutfittersFields on Outfitter {
  id
  slug
  name
  about
  status
  cover_image
  is_demo
  avatar {
    ...MediaFields
  }
  photos {
    ...MediaFields
  }
  video {
    hosted {
      ...MediaFields
    }
    social {
      ...MediaFields
    }
  }
  location {
    ...AddressFields
  }
  listings_count
  avatar {
    ...MediaFields
  }
  booking_reviews_aggregation {
    ...ReviewAggregationFields
  }
}
    ${MediaFieldsFragmentDoc}
${AddressFieldsFragmentDoc}
${ReviewAggregationFieldsFragmentDoc}`;
export const OutfitterListingFieldsFragmentDoc = gql`
    fragment OutfitterListingFields on Listing {
  ...ListingMinimalFieldsWithoutOutfitter
  min_guest
  max_guest
  booking_reviews_aggregation {
    ...ReviewAggregationFields
  }
  next_availability {
    date
  }
}
    ${ListingMinimalFieldsWithoutOutfitterFragmentDoc}
${ReviewAggregationFieldsFragmentDoc}`;
export const OutfitterLodgingFieldsFragmentDoc = gql`
    fragment OutfitterLodgingFields on Lodging {
  id
  name
  description
  type
  type_name
  capacity
  location {
    ...AddressFields
  }
  images {
    url
    description
  }
  cover_image
}
    ${AddressFieldsFragmentDoc}`;
export const TeamMemberFieldsFragmentDoc = gql`
    fragment TeamMemberFields on TeamMember {
  id
  name
  user {
    avatar_url
  }
}
    `;
export const ResourceFieldsFragmentDoc = gql`
    fragment ResourceFields on Resource {
  id
  outfitter_id
  type
  name
  images {
    url
  }
  capacity
  year
  vehicle_props {
    category
    make
    model
  }
  boat_props {
    category
    length
    boat_manufacturer
    boat_type
  }
  blind_props {
    category
  }
  atv_props {
    category
    manufacturer
  }
  gear_props {
    other
  }
  cover_image
  description
  created_at
  updated_at
}
    `;
export const OutfitterFieldsFragmentDoc = gql`
    fragment OutfitterFields on Outfitter {
  ...AllOutfittersFields
  listings {
    ...OutfitterListingFields
  }
  listings_count
  owner {
    ...OutfitterOwnerFields
  }
  lodgings {
    ...OutfitterLodgingFields
  }
  guides {
    ...TeamMemberFields
  }
  resources {
    ...ResourceFields
  }
}
    ${AllOutfittersFieldsFragmentDoc}
${OutfitterListingFieldsFragmentDoc}
${OutfitterOwnerFieldsFragmentDoc}
${OutfitterLodgingFieldsFragmentDoc}
${TeamMemberFieldsFragmentDoc}
${ResourceFieldsFragmentDoc}`;
export const WidgetFieldsFragmentDoc = gql`
    fragment WidgetFields on Widget {
  id
  outfitter {
    ...OutfitterFields
  }
  listing_ids
  widget_name
  trigger_type
  button_color
  button_text
  text_color
  is_external
  is_active
  source
  created_at
  updated_at
}
    ${OutfitterFieldsFragmentDoc}`;
export const WishlistFieldsFragmentDoc = gql`
    fragment WishlistFields on Wishlist {
  id
  name
  user {
    id
  }
  listings {
    ...ListingFields
  }
}
    ${ListingFieldsFragmentDoc}`;
export const GetExtraAddOnsForListingAndPricingPackageDocument = gql`
    query getExtraAddOnsForListingAndPricingPackage($listingId: ID!, $pricingPackageId: ID!) {
  getExtraAddOnsForListingAndPricingPackage(
    listingId: $listingId
    pricingPackageId: $pricingPackageId
  ) {
    ...AddOnFormFields
  }
}
    ${AddOnFormFieldsFragmentDoc}`;

/**
 * __useGetExtraAddOnsForListingAndPricingPackageQuery__
 *
 * To run a query within a React component, call `useGetExtraAddOnsForListingAndPricingPackageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExtraAddOnsForListingAndPricingPackageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExtraAddOnsForListingAndPricingPackageQuery({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      pricingPackageId: // value for 'pricingPackageId'
 *   },
 * });
 */
export function useGetExtraAddOnsForListingAndPricingPackageQuery(baseOptions: Apollo.QueryHookOptions<GetExtraAddOnsForListingAndPricingPackageQuery, GetExtraAddOnsForListingAndPricingPackageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExtraAddOnsForListingAndPricingPackageQuery, GetExtraAddOnsForListingAndPricingPackageQueryVariables>(GetExtraAddOnsForListingAndPricingPackageDocument, options);
      }
export function useGetExtraAddOnsForListingAndPricingPackageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExtraAddOnsForListingAndPricingPackageQuery, GetExtraAddOnsForListingAndPricingPackageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExtraAddOnsForListingAndPricingPackageQuery, GetExtraAddOnsForListingAndPricingPackageQueryVariables>(GetExtraAddOnsForListingAndPricingPackageDocument, options);
        }
export type GetExtraAddOnsForListingAndPricingPackageQueryHookResult = ReturnType<typeof useGetExtraAddOnsForListingAndPricingPackageQuery>;
export type GetExtraAddOnsForListingAndPricingPackageLazyQueryHookResult = ReturnType<typeof useGetExtraAddOnsForListingAndPricingPackageLazyQuery>;
export type GetExtraAddOnsForListingAndPricingPackageQueryResult = Apollo.QueryResult<GetExtraAddOnsForListingAndPricingPackageQuery, GetExtraAddOnsForListingAndPricingPackageQueryVariables>;
export const AllAmenitiesDocument = gql`
    query allAmenities {
  allAmenities {
    ...AmenityFields
  }
}
    ${AmenityFieldsFragmentDoc}`;

/**
 * __useAllAmenitiesQuery__
 *
 * To run a query within a React component, call `useAllAmenitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAmenitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAmenitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllAmenitiesQuery(baseOptions?: Apollo.QueryHookOptions<AllAmenitiesQuery, AllAmenitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllAmenitiesQuery, AllAmenitiesQueryVariables>(AllAmenitiesDocument, options);
      }
export function useAllAmenitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllAmenitiesQuery, AllAmenitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllAmenitiesQuery, AllAmenitiesQueryVariables>(AllAmenitiesDocument, options);
        }
export type AllAmenitiesQueryHookResult = ReturnType<typeof useAllAmenitiesQuery>;
export type AllAmenitiesLazyQueryHookResult = ReturnType<typeof useAllAmenitiesLazyQuery>;
export type AllAmenitiesQueryResult = Apollo.QueryResult<AllAmenitiesQuery, AllAmenitiesQueryVariables>;
export const CanConvertGuestToUserDocument = gql`
    query canConvertGuestToUser($code: String) {
  canConvertGuestToUser(code: $code)
}
    `;

/**
 * __useCanConvertGuestToUserQuery__
 *
 * To run a query within a React component, call `useCanConvertGuestToUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanConvertGuestToUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanConvertGuestToUserQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useCanConvertGuestToUserQuery(baseOptions?: Apollo.QueryHookOptions<CanConvertGuestToUserQuery, CanConvertGuestToUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CanConvertGuestToUserQuery, CanConvertGuestToUserQueryVariables>(CanConvertGuestToUserDocument, options);
      }
export function useCanConvertGuestToUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CanConvertGuestToUserQuery, CanConvertGuestToUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CanConvertGuestToUserQuery, CanConvertGuestToUserQueryVariables>(CanConvertGuestToUserDocument, options);
        }
export type CanConvertGuestToUserQueryHookResult = ReturnType<typeof useCanConvertGuestToUserQuery>;
export type CanConvertGuestToUserLazyQueryHookResult = ReturnType<typeof useCanConvertGuestToUserLazyQuery>;
export type CanConvertGuestToUserQueryResult = Apollo.QueryResult<CanConvertGuestToUserQuery, CanConvertGuestToUserQueryVariables>;
export const LogInAsGuestUserDocument = gql`
    mutation logInAsGuestUser($data: GuestUserInput!) {
  logInAsGuestUser(data: $data)
}
    `;
export type LogInAsGuestUserMutationFn = Apollo.MutationFunction<LogInAsGuestUserMutation, LogInAsGuestUserMutationVariables>;

/**
 * __useLogInAsGuestUserMutation__
 *
 * To run a mutation, you first call `useLogInAsGuestUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogInAsGuestUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logInAsGuestUserMutation, { data, loading, error }] = useLogInAsGuestUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useLogInAsGuestUserMutation(baseOptions?: Apollo.MutationHookOptions<LogInAsGuestUserMutation, LogInAsGuestUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogInAsGuestUserMutation, LogInAsGuestUserMutationVariables>(LogInAsGuestUserDocument, options);
      }
export type LogInAsGuestUserMutationHookResult = ReturnType<typeof useLogInAsGuestUserMutation>;
export type LogInAsGuestUserMutationResult = Apollo.MutationResult<LogInAsGuestUserMutation>;
export type LogInAsGuestUserMutationOptions = Apollo.BaseMutationOptions<LogInAsGuestUserMutation, LogInAsGuestUserMutationVariables>;
export const ConvertGuestToUserDocument = gql`
    mutation convertGuestToUser($password: String!, $code: String) {
  convertGuestToUser(password: $password, code: $code)
}
    `;
export type ConvertGuestToUserMutationFn = Apollo.MutationFunction<ConvertGuestToUserMutation, ConvertGuestToUserMutationVariables>;

/**
 * __useConvertGuestToUserMutation__
 *
 * To run a mutation, you first call `useConvertGuestToUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConvertGuestToUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [convertGuestToUserMutation, { data, loading, error }] = useConvertGuestToUserMutation({
 *   variables: {
 *      password: // value for 'password'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useConvertGuestToUserMutation(baseOptions?: Apollo.MutationHookOptions<ConvertGuestToUserMutation, ConvertGuestToUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConvertGuestToUserMutation, ConvertGuestToUserMutationVariables>(ConvertGuestToUserDocument, options);
      }
export type ConvertGuestToUserMutationHookResult = ReturnType<typeof useConvertGuestToUserMutation>;
export type ConvertGuestToUserMutationResult = Apollo.MutationResult<ConvertGuestToUserMutation>;
export type ConvertGuestToUserMutationOptions = Apollo.BaseMutationOptions<ConvertGuestToUserMutation, ConvertGuestToUserMutationVariables>;
export const AvailabilityDocument = gql`
    query availability($data: GetGenericAvailabilityInput!) {
  availability(data: $data) {
    ...GenericAvailabilityFields
  }
}
    ${GenericAvailabilityFieldsFragmentDoc}`;

/**
 * __useAvailabilityQuery__
 *
 * To run a query within a React component, call `useAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailabilityQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<AvailabilityQuery, AvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailabilityQuery, AvailabilityQueryVariables>(AvailabilityDocument, options);
      }
export function useAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailabilityQuery, AvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailabilityQuery, AvailabilityQueryVariables>(AvailabilityDocument, options);
        }
export type AvailabilityQueryHookResult = ReturnType<typeof useAvailabilityQuery>;
export type AvailabilityLazyQueryHookResult = ReturnType<typeof useAvailabilityLazyQuery>;
export type AvailabilityQueryResult = Apollo.QueryResult<AvailabilityQuery, AvailabilityQueryVariables>;
export const BookingInviteDocument = gql`
    query bookingInvite($id: ID!) {
  bookingInvite(id: $id) {
    ...BookingInviteFields
  }
}
    ${BookingInviteFieldsFragmentDoc}`;

/**
 * __useBookingInviteQuery__
 *
 * To run a query within a React component, call `useBookingInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingInviteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBookingInviteQuery(baseOptions: Apollo.QueryHookOptions<BookingInviteQuery, BookingInviteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingInviteQuery, BookingInviteQueryVariables>(BookingInviteDocument, options);
      }
export function useBookingInviteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingInviteQuery, BookingInviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingInviteQuery, BookingInviteQueryVariables>(BookingInviteDocument, options);
        }
export type BookingInviteQueryHookResult = ReturnType<typeof useBookingInviteQuery>;
export type BookingInviteLazyQueryHookResult = ReturnType<typeof useBookingInviteLazyQuery>;
export type BookingInviteQueryResult = Apollo.QueryResult<BookingInviteQuery, BookingInviteQueryVariables>;
export const BookingDocument = gql`
    query booking($id: ID!, $invitationId: ID) {
  booking(id: $id, invitationId: $invitationId) {
    ...BookingFields
  }
}
    ${BookingFieldsFragmentDoc}`;

/**
 * __useBookingQuery__
 *
 * To run a query within a React component, call `useBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingQuery({
 *   variables: {
 *      id: // value for 'id'
 *      invitationId: // value for 'invitationId'
 *   },
 * });
 */
export function useBookingQuery(baseOptions: Apollo.QueryHookOptions<BookingQuery, BookingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingQuery, BookingQueryVariables>(BookingDocument, options);
      }
export function useBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingQuery, BookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingQuery, BookingQueryVariables>(BookingDocument, options);
        }
export type BookingQueryHookResult = ReturnType<typeof useBookingQuery>;
export type BookingLazyQueryHookResult = ReturnType<typeof useBookingLazyQuery>;
export type BookingQueryResult = Apollo.QueryResult<BookingQuery, BookingQueryVariables>;
export const BookingWithPaymentSummaryDocument = gql`
    query bookingWithPaymentSummary($id: ID!, $invitationId: ID) {
  booking(id: $id, invitationId: $invitationId) {
    ...BookingWithPaymentSummaryFields
  }
}
    ${BookingWithPaymentSummaryFieldsFragmentDoc}`;

/**
 * __useBookingWithPaymentSummaryQuery__
 *
 * To run a query within a React component, call `useBookingWithPaymentSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingWithPaymentSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingWithPaymentSummaryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      invitationId: // value for 'invitationId'
 *   },
 * });
 */
export function useBookingWithPaymentSummaryQuery(baseOptions: Apollo.QueryHookOptions<BookingWithPaymentSummaryQuery, BookingWithPaymentSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingWithPaymentSummaryQuery, BookingWithPaymentSummaryQueryVariables>(BookingWithPaymentSummaryDocument, options);
      }
export function useBookingWithPaymentSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingWithPaymentSummaryQuery, BookingWithPaymentSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingWithPaymentSummaryQuery, BookingWithPaymentSummaryQueryVariables>(BookingWithPaymentSummaryDocument, options);
        }
export type BookingWithPaymentSummaryQueryHookResult = ReturnType<typeof useBookingWithPaymentSummaryQuery>;
export type BookingWithPaymentSummaryLazyQueryHookResult = ReturnType<typeof useBookingWithPaymentSummaryLazyQuery>;
export type BookingWithPaymentSummaryQueryResult = Apollo.QueryResult<BookingWithPaymentSummaryQuery, BookingWithPaymentSummaryQueryVariables>;
export const BookingsDocument = gql`
    query bookings {
  bookings {
    ...BookingMinimalFields
  }
}
    ${BookingMinimalFieldsFragmentDoc}`;

/**
 * __useBookingsQuery__
 *
 * To run a query within a React component, call `useBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBookingsQuery(baseOptions?: Apollo.QueryHookOptions<BookingsQuery, BookingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingsQuery, BookingsQueryVariables>(BookingsDocument, options);
      }
export function useBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingsQuery, BookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingsQuery, BookingsQueryVariables>(BookingsDocument, options);
        }
export type BookingsQueryHookResult = ReturnType<typeof useBookingsQuery>;
export type BookingsLazyQueryHookResult = ReturnType<typeof useBookingsLazyQuery>;
export type BookingsQueryResult = Apollo.QueryResult<BookingsQuery, BookingsQueryVariables>;
export const RecentPublicBookingsDocument = gql`
    query recentPublicBookings($size: PositiveInt) {
  recentPublicBookings(size: $size) {
    ...RecentPublicBookingsFields
  }
}
    ${RecentPublicBookingsFieldsFragmentDoc}`;

/**
 * __useRecentPublicBookingsQuery__
 *
 * To run a query within a React component, call `useRecentPublicBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentPublicBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentPublicBookingsQuery({
 *   variables: {
 *      size: // value for 'size'
 *   },
 * });
 */
export function useRecentPublicBookingsQuery(baseOptions?: Apollo.QueryHookOptions<RecentPublicBookingsQuery, RecentPublicBookingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecentPublicBookingsQuery, RecentPublicBookingsQueryVariables>(RecentPublicBookingsDocument, options);
      }
export function useRecentPublicBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentPublicBookingsQuery, RecentPublicBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecentPublicBookingsQuery, RecentPublicBookingsQueryVariables>(RecentPublicBookingsDocument, options);
        }
export type RecentPublicBookingsQueryHookResult = ReturnType<typeof useRecentPublicBookingsQuery>;
export type RecentPublicBookingsLazyQueryHookResult = ReturnType<typeof useRecentPublicBookingsLazyQuery>;
export type RecentPublicBookingsQueryResult = Apollo.QueryResult<RecentPublicBookingsQuery, RecentPublicBookingsQueryVariables>;
export const GetBookingDealAttributionOptionsDocument = gql`
    query getBookingDealAttributionOptions {
  bookingDealAttributionOptions {
    id
    title
  }
}
    `;

/**
 * __useGetBookingDealAttributionOptionsQuery__
 *
 * To run a query within a React component, call `useGetBookingDealAttributionOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingDealAttributionOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingDealAttributionOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBookingDealAttributionOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetBookingDealAttributionOptionsQuery, GetBookingDealAttributionOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingDealAttributionOptionsQuery, GetBookingDealAttributionOptionsQueryVariables>(GetBookingDealAttributionOptionsDocument, options);
      }
export function useGetBookingDealAttributionOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingDealAttributionOptionsQuery, GetBookingDealAttributionOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingDealAttributionOptionsQuery, GetBookingDealAttributionOptionsQueryVariables>(GetBookingDealAttributionOptionsDocument, options);
        }
export type GetBookingDealAttributionOptionsQueryHookResult = ReturnType<typeof useGetBookingDealAttributionOptionsQuery>;
export type GetBookingDealAttributionOptionsLazyQueryHookResult = ReturnType<typeof useGetBookingDealAttributionOptionsLazyQuery>;
export type GetBookingDealAttributionOptionsQueryResult = Apollo.QueryResult<GetBookingDealAttributionOptionsQuery, GetBookingDealAttributionOptionsQueryVariables>;
export const CreateBookingDocument = gql`
    mutation createBooking($data: CreateBookingInput!) {
  createBooking(data: $data) {
    id
  }
}
    `;
export type CreateBookingMutationFn = Apollo.MutationFunction<CreateBookingMutation, CreateBookingMutationVariables>;

/**
 * __useCreateBookingMutation__
 *
 * To run a mutation, you first call `useCreateBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookingMutation, { data, loading, error }] = useCreateBookingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateBookingMutation(baseOptions?: Apollo.MutationHookOptions<CreateBookingMutation, CreateBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBookingMutation, CreateBookingMutationVariables>(CreateBookingDocument, options);
      }
export type CreateBookingMutationHookResult = ReturnType<typeof useCreateBookingMutation>;
export type CreateBookingMutationResult = Apollo.MutationResult<CreateBookingMutation>;
export type CreateBookingMutationOptions = Apollo.BaseMutationOptions<CreateBookingMutation, CreateBookingMutationVariables>;
export const UpdateBookingDocument = gql`
    mutation updateBooking($updateBookingId: ID!, $data: UpdateBookingInput!) {
  updateBooking(id: $updateBookingId, data: $data) {
    ...BookingFields
  }
}
    ${BookingFieldsFragmentDoc}`;
export type UpdateBookingMutationFn = Apollo.MutationFunction<UpdateBookingMutation, UpdateBookingMutationVariables>;

/**
 * __useUpdateBookingMutation__
 *
 * To run a mutation, you first call `useUpdateBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookingMutation, { data, loading, error }] = useUpdateBookingMutation({
 *   variables: {
 *      updateBookingId: // value for 'updateBookingId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateBookingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBookingMutation, UpdateBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBookingMutation, UpdateBookingMutationVariables>(UpdateBookingDocument, options);
      }
export type UpdateBookingMutationHookResult = ReturnType<typeof useUpdateBookingMutation>;
export type UpdateBookingMutationResult = Apollo.MutationResult<UpdateBookingMutation>;
export type UpdateBookingMutationOptions = Apollo.BaseMutationOptions<UpdateBookingMutation, UpdateBookingMutationVariables>;
export const UpdateBookingAttributionDocument = gql`
    mutation updateBookingAttribution($id: ID!, $data: AttributionInput!) {
  updateBookingAttribution(id: $id, data: $data) {
    ...BookingFields
  }
}
    ${BookingFieldsFragmentDoc}`;
export type UpdateBookingAttributionMutationFn = Apollo.MutationFunction<UpdateBookingAttributionMutation, UpdateBookingAttributionMutationVariables>;

/**
 * __useUpdateBookingAttributionMutation__
 *
 * To run a mutation, you first call `useUpdateBookingAttributionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookingAttributionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookingAttributionMutation, { data, loading, error }] = useUpdateBookingAttributionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateBookingAttributionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBookingAttributionMutation, UpdateBookingAttributionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBookingAttributionMutation, UpdateBookingAttributionMutationVariables>(UpdateBookingAttributionDocument, options);
      }
export type UpdateBookingAttributionMutationHookResult = ReturnType<typeof useUpdateBookingAttributionMutation>;
export type UpdateBookingAttributionMutationResult = Apollo.MutationResult<UpdateBookingAttributionMutation>;
export type UpdateBookingAttributionMutationOptions = Apollo.BaseMutationOptions<UpdateBookingAttributionMutation, UpdateBookingAttributionMutationVariables>;
export const GetSportsmanChatTokenDocument = gql`
    query getSportsmanChatToken {
  getSportsmanChatToken
}
    `;

/**
 * __useGetSportsmanChatTokenQuery__
 *
 * To run a query within a React component, call `useGetSportsmanChatTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSportsmanChatTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSportsmanChatTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSportsmanChatTokenQuery(baseOptions?: Apollo.QueryHookOptions<GetSportsmanChatTokenQuery, GetSportsmanChatTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSportsmanChatTokenQuery, GetSportsmanChatTokenQueryVariables>(GetSportsmanChatTokenDocument, options);
      }
export function useGetSportsmanChatTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSportsmanChatTokenQuery, GetSportsmanChatTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSportsmanChatTokenQuery, GetSportsmanChatTokenQueryVariables>(GetSportsmanChatTokenDocument, options);
        }
export type GetSportsmanChatTokenQueryHookResult = ReturnType<typeof useGetSportsmanChatTokenQuery>;
export type GetSportsmanChatTokenLazyQueryHookResult = ReturnType<typeof useGetSportsmanChatTokenLazyQuery>;
export type GetSportsmanChatTokenQueryResult = Apollo.QueryResult<GetSportsmanChatTokenQuery, GetSportsmanChatTokenQueryVariables>;
export const CreateChatChannelWithOutfitterDocument = gql`
    mutation createChatChannelWithOutfitter($outfitterId: ID!) {
  createChatChannelWithOutfitter(outfitterId: $outfitterId)
}
    `;
export type CreateChatChannelWithOutfitterMutationFn = Apollo.MutationFunction<CreateChatChannelWithOutfitterMutation, CreateChatChannelWithOutfitterMutationVariables>;

/**
 * __useCreateChatChannelWithOutfitterMutation__
 *
 * To run a mutation, you first call `useCreateChatChannelWithOutfitterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChatChannelWithOutfitterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChatChannelWithOutfitterMutation, { data, loading, error }] = useCreateChatChannelWithOutfitterMutation({
 *   variables: {
 *      outfitterId: // value for 'outfitterId'
 *   },
 * });
 */
export function useCreateChatChannelWithOutfitterMutation(baseOptions?: Apollo.MutationHookOptions<CreateChatChannelWithOutfitterMutation, CreateChatChannelWithOutfitterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChatChannelWithOutfitterMutation, CreateChatChannelWithOutfitterMutationVariables>(CreateChatChannelWithOutfitterDocument, options);
      }
export type CreateChatChannelWithOutfitterMutationHookResult = ReturnType<typeof useCreateChatChannelWithOutfitterMutation>;
export type CreateChatChannelWithOutfitterMutationResult = Apollo.MutationResult<CreateChatChannelWithOutfitterMutation>;
export type CreateChatChannelWithOutfitterMutationOptions = Apollo.BaseMutationOptions<CreateChatChannelWithOutfitterMutation, CreateChatChannelWithOutfitterMutationVariables>;
export const GetCourierInboxAuthTokenDocument = gql`
    query getCourierInboxAuthToken {
  getCourierInboxAuthToken
}
    `;

/**
 * __useGetCourierInboxAuthTokenQuery__
 *
 * To run a query within a React component, call `useGetCourierInboxAuthTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourierInboxAuthTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourierInboxAuthTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCourierInboxAuthTokenQuery(baseOptions?: Apollo.QueryHookOptions<GetCourierInboxAuthTokenQuery, GetCourierInboxAuthTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourierInboxAuthTokenQuery, GetCourierInboxAuthTokenQueryVariables>(GetCourierInboxAuthTokenDocument, options);
      }
export function useGetCourierInboxAuthTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourierInboxAuthTokenQuery, GetCourierInboxAuthTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourierInboxAuthTokenQuery, GetCourierInboxAuthTokenQueryVariables>(GetCourierInboxAuthTokenDocument, options);
        }
export type GetCourierInboxAuthTokenQueryHookResult = ReturnType<typeof useGetCourierInboxAuthTokenQuery>;
export type GetCourierInboxAuthTokenLazyQueryHookResult = ReturnType<typeof useGetCourierInboxAuthTokenLazyQuery>;
export type GetCourierInboxAuthTokenQueryResult = Apollo.QueryResult<GetCourierInboxAuthTokenQuery, GetCourierInboxAuthTokenQueryVariables>;
export const CreateListingVisitedEventDocument = gql`
    mutation createListingVisitedEvent($data: CreateListingVisitedEventInput!) {
  createListingVisitedEvent(data: $data) {
    id
  }
}
    `;
export type CreateListingVisitedEventMutationFn = Apollo.MutationFunction<CreateListingVisitedEventMutation, CreateListingVisitedEventMutationVariables>;

/**
 * __useCreateListingVisitedEventMutation__
 *
 * To run a mutation, you first call `useCreateListingVisitedEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateListingVisitedEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createListingVisitedEventMutation, { data, loading, error }] = useCreateListingVisitedEventMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateListingVisitedEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateListingVisitedEventMutation, CreateListingVisitedEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateListingVisitedEventMutation, CreateListingVisitedEventMutationVariables>(CreateListingVisitedEventDocument, options);
      }
export type CreateListingVisitedEventMutationHookResult = ReturnType<typeof useCreateListingVisitedEventMutation>;
export type CreateListingVisitedEventMutationResult = Apollo.MutationResult<CreateListingVisitedEventMutation>;
export type CreateListingVisitedEventMutationOptions = Apollo.BaseMutationOptions<CreateListingVisitedEventMutation, CreateListingVisitedEventMutationVariables>;
export const CreateBookingStartedEventDocument = gql`
    mutation createBookingStartedEvent($data: CreateBookingStartedEventInput!) {
  createBookingStartedEvent(data: $data) {
    id
  }
}
    `;
export type CreateBookingStartedEventMutationFn = Apollo.MutationFunction<CreateBookingStartedEventMutation, CreateBookingStartedEventMutationVariables>;

/**
 * __useCreateBookingStartedEventMutation__
 *
 * To run a mutation, you first call `useCreateBookingStartedEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookingStartedEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookingStartedEventMutation, { data, loading, error }] = useCreateBookingStartedEventMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateBookingStartedEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateBookingStartedEventMutation, CreateBookingStartedEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBookingStartedEventMutation, CreateBookingStartedEventMutationVariables>(CreateBookingStartedEventDocument, options);
      }
export type CreateBookingStartedEventMutationHookResult = ReturnType<typeof useCreateBookingStartedEventMutation>;
export type CreateBookingStartedEventMutationResult = Apollo.MutationResult<CreateBookingStartedEventMutation>;
export type CreateBookingStartedEventMutationOptions = Apollo.BaseMutationOptions<CreateBookingStartedEventMutation, CreateBookingStartedEventMutationVariables>;
export const CreateNewsfeedPostInteractedWithEventDocument = gql`
    mutation createNewsfeedPostInteractedWithEvent($data: CreateNewsfeedEventInput!) {
  createNewsfeedPostInteractedWithEvent(data: $data) {
    id
  }
}
    `;
export type CreateNewsfeedPostInteractedWithEventMutationFn = Apollo.MutationFunction<CreateNewsfeedPostInteractedWithEventMutation, CreateNewsfeedPostInteractedWithEventMutationVariables>;

/**
 * __useCreateNewsfeedPostInteractedWithEventMutation__
 *
 * To run a mutation, you first call `useCreateNewsfeedPostInteractedWithEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewsfeedPostInteractedWithEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewsfeedPostInteractedWithEventMutation, { data, loading, error }] = useCreateNewsfeedPostInteractedWithEventMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateNewsfeedPostInteractedWithEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewsfeedPostInteractedWithEventMutation, CreateNewsfeedPostInteractedWithEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewsfeedPostInteractedWithEventMutation, CreateNewsfeedPostInteractedWithEventMutationVariables>(CreateNewsfeedPostInteractedWithEventDocument, options);
      }
export type CreateNewsfeedPostInteractedWithEventMutationHookResult = ReturnType<typeof useCreateNewsfeedPostInteractedWithEventMutation>;
export type CreateNewsfeedPostInteractedWithEventMutationResult = Apollo.MutationResult<CreateNewsfeedPostInteractedWithEventMutation>;
export type CreateNewsfeedPostInteractedWithEventMutationOptions = Apollo.BaseMutationOptions<CreateNewsfeedPostInteractedWithEventMutation, CreateNewsfeedPostInteractedWithEventMutationVariables>;
export const CreateNewsfeedPostOpenedEventDocument = gql`
    mutation createNewsfeedPostOpenedEvent($data: CreateNewsfeedEventInput!) {
  createNewsfeedPostOpenedEvent(data: $data) {
    id
  }
}
    `;
export type CreateNewsfeedPostOpenedEventMutationFn = Apollo.MutationFunction<CreateNewsfeedPostOpenedEventMutation, CreateNewsfeedPostOpenedEventMutationVariables>;

/**
 * __useCreateNewsfeedPostOpenedEventMutation__
 *
 * To run a mutation, you first call `useCreateNewsfeedPostOpenedEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewsfeedPostOpenedEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewsfeedPostOpenedEventMutation, { data, loading, error }] = useCreateNewsfeedPostOpenedEventMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateNewsfeedPostOpenedEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewsfeedPostOpenedEventMutation, CreateNewsfeedPostOpenedEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewsfeedPostOpenedEventMutation, CreateNewsfeedPostOpenedEventMutationVariables>(CreateNewsfeedPostOpenedEventDocument, options);
      }
export type CreateNewsfeedPostOpenedEventMutationHookResult = ReturnType<typeof useCreateNewsfeedPostOpenedEventMutation>;
export type CreateNewsfeedPostOpenedEventMutationResult = Apollo.MutationResult<CreateNewsfeedPostOpenedEventMutation>;
export type CreateNewsfeedPostOpenedEventMutationOptions = Apollo.BaseMutationOptions<CreateNewsfeedPostOpenedEventMutation, CreateNewsfeedPostOpenedEventMutationVariables>;
export const CreateGenericEventDocument = gql`
    mutation createGenericEvent($data: CreateGenericEventInput!) {
  createGenericEvent(data: $data) {
    id
  }
}
    `;
export type CreateGenericEventMutationFn = Apollo.MutationFunction<CreateGenericEventMutation, CreateGenericEventMutationVariables>;

/**
 * __useCreateGenericEventMutation__
 *
 * To run a mutation, you first call `useCreateGenericEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGenericEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGenericEventMutation, { data, loading, error }] = useCreateGenericEventMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateGenericEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateGenericEventMutation, CreateGenericEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGenericEventMutation, CreateGenericEventMutationVariables>(CreateGenericEventDocument, options);
      }
export type CreateGenericEventMutationHookResult = ReturnType<typeof useCreateGenericEventMutation>;
export type CreateGenericEventMutationResult = Apollo.MutationResult<CreateGenericEventMutation>;
export type CreateGenericEventMutationOptions = Apollo.BaseMutationOptions<CreateGenericEventMutation, CreateGenericEventMutationVariables>;
export const JoinGroupPayDocument = gql`
    mutation joinGroupPay($input: JoinGroupPayInput!) {
  joinGroupPay(input: $input) {
    ...GroupPayShareFields
  }
}
    ${GroupPayShareFieldsFragmentDoc}`;
export type JoinGroupPayMutationFn = Apollo.MutationFunction<JoinGroupPayMutation, JoinGroupPayMutationVariables>;

/**
 * __useJoinGroupPayMutation__
 *
 * To run a mutation, you first call `useJoinGroupPayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinGroupPayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinGroupPayMutation, { data, loading, error }] = useJoinGroupPayMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJoinGroupPayMutation(baseOptions?: Apollo.MutationHookOptions<JoinGroupPayMutation, JoinGroupPayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinGroupPayMutation, JoinGroupPayMutationVariables>(JoinGroupPayDocument, options);
      }
export type JoinGroupPayMutationHookResult = ReturnType<typeof useJoinGroupPayMutation>;
export type JoinGroupPayMutationResult = Apollo.MutationResult<JoinGroupPayMutation>;
export type JoinGroupPayMutationOptions = Apollo.BaseMutationOptions<JoinGroupPayMutation, JoinGroupPayMutationVariables>;
export const GroupPaySharePaymentPlanBySlotsDocument = gql`
    query groupPaySharePaymentPlanBySlots($bookingId: ID!, $slots: PositiveInt!, $isAchPaymentMethod: Boolean, $isExternalPaymentMethod: Boolean, $sportsmanZipCode: String, $shouldAcceptTripInsurance: Boolean) {
  groupPaySharePaymentPlanBySlots(
    bookingId: $bookingId
    slots: $slots
    isAchPaymentMethod: $isAchPaymentMethod
    isExternalPaymentMethod: $isExternalPaymentMethod
    sportsmanZipCode: $sportsmanZipCode
    shouldAcceptTripInsurance: $shouldAcceptTripInsurance
  ) {
    ...SlotPaymentPlanFields
  }
}
    ${SlotPaymentPlanFieldsFragmentDoc}`;

/**
 * __useGroupPaySharePaymentPlanBySlotsQuery__
 *
 * To run a query within a React component, call `useGroupPaySharePaymentPlanBySlotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupPaySharePaymentPlanBySlotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupPaySharePaymentPlanBySlotsQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      slots: // value for 'slots'
 *      isAchPaymentMethod: // value for 'isAchPaymentMethod'
 *      isExternalPaymentMethod: // value for 'isExternalPaymentMethod'
 *      sportsmanZipCode: // value for 'sportsmanZipCode'
 *      shouldAcceptTripInsurance: // value for 'shouldAcceptTripInsurance'
 *   },
 * });
 */
export function useGroupPaySharePaymentPlanBySlotsQuery(baseOptions: Apollo.QueryHookOptions<GroupPaySharePaymentPlanBySlotsQuery, GroupPaySharePaymentPlanBySlotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupPaySharePaymentPlanBySlotsQuery, GroupPaySharePaymentPlanBySlotsQueryVariables>(GroupPaySharePaymentPlanBySlotsDocument, options);
      }
export function useGroupPaySharePaymentPlanBySlotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupPaySharePaymentPlanBySlotsQuery, GroupPaySharePaymentPlanBySlotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupPaySharePaymentPlanBySlotsQuery, GroupPaySharePaymentPlanBySlotsQueryVariables>(GroupPaySharePaymentPlanBySlotsDocument, options);
        }
export type GroupPaySharePaymentPlanBySlotsQueryHookResult = ReturnType<typeof useGroupPaySharePaymentPlanBySlotsQuery>;
export type GroupPaySharePaymentPlanBySlotsLazyQueryHookResult = ReturnType<typeof useGroupPaySharePaymentPlanBySlotsLazyQuery>;
export type GroupPaySharePaymentPlanBySlotsQueryResult = Apollo.QueryResult<GroupPaySharePaymentPlanBySlotsQuery, GroupPaySharePaymentPlanBySlotsQueryVariables>;
export const GetInvoicePdfDocument = gql`
    query getInvoicePdf($entityType: EntityType!, $entityId: ID!, $accessCodeId: String) {
  getInvoicePdf(
    entityType: $entityType
    entityId: $entityId
    accessCodeId: $accessCodeId
  )
}
    `;

/**
 * __useGetInvoicePdfQuery__
 *
 * To run a query within a React component, call `useGetInvoicePdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicePdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicePdfQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      entityId: // value for 'entityId'
 *      accessCodeId: // value for 'accessCodeId'
 *   },
 * });
 */
export function useGetInvoicePdfQuery(baseOptions: Apollo.QueryHookOptions<GetInvoicePdfQuery, GetInvoicePdfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoicePdfQuery, GetInvoicePdfQueryVariables>(GetInvoicePdfDocument, options);
      }
export function useGetInvoicePdfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicePdfQuery, GetInvoicePdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoicePdfQuery, GetInvoicePdfQueryVariables>(GetInvoicePdfDocument, options);
        }
export type GetInvoicePdfQueryHookResult = ReturnType<typeof useGetInvoicePdfQuery>;
export type GetInvoicePdfLazyQueryHookResult = ReturnType<typeof useGetInvoicePdfLazyQuery>;
export type GetInvoicePdfQueryResult = Apollo.QueryResult<GetInvoicePdfQuery, GetInvoicePdfQueryVariables>;
export const ListingRegionAggregationsDocument = gql`
    query listingRegionAggregations {
  listingRegionAggregations {
    ...RegionFields
  }
}
    ${RegionFieldsFragmentDoc}`;

/**
 * __useListingRegionAggregationsQuery__
 *
 * To run a query within a React component, call `useListingRegionAggregationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingRegionAggregationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingRegionAggregationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListingRegionAggregationsQuery(baseOptions?: Apollo.QueryHookOptions<ListingRegionAggregationsQuery, ListingRegionAggregationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingRegionAggregationsQuery, ListingRegionAggregationsQueryVariables>(ListingRegionAggregationsDocument, options);
      }
export function useListingRegionAggregationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingRegionAggregationsQuery, ListingRegionAggregationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingRegionAggregationsQuery, ListingRegionAggregationsQueryVariables>(ListingRegionAggregationsDocument, options);
        }
export type ListingRegionAggregationsQueryHookResult = ReturnType<typeof useListingRegionAggregationsQuery>;
export type ListingRegionAggregationsLazyQueryHookResult = ReturnType<typeof useListingRegionAggregationsLazyQuery>;
export type ListingRegionAggregationsQueryResult = Apollo.QueryResult<ListingRegionAggregationsQuery, ListingRegionAggregationsQueryVariables>;
export const ListingDocument = gql`
    query listing($id: ID!) {
  listing(id: $id) {
    ...ListingFields
  }
}
    ${ListingFieldsFragmentDoc}`;

/**
 * __useListingQuery__
 *
 * To run a query within a React component, call `useListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useListingQuery(baseOptions: Apollo.QueryHookOptions<ListingQuery, ListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingQuery, ListingQueryVariables>(ListingDocument, options);
      }
export function useListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingQuery, ListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingQuery, ListingQueryVariables>(ListingDocument, options);
        }
export type ListingQueryHookResult = ReturnType<typeof useListingQuery>;
export type ListingLazyQueryHookResult = ReturnType<typeof useListingLazyQuery>;
export type ListingQueryResult = Apollo.QueryResult<ListingQuery, ListingQueryVariables>;
export const PublicListingsDocument = gql`
    query publicListings($ids: [ID!]) {
  publicListings(ids: $ids) {
    ...PublicListingFields
  }
}
    ${PublicListingFieldsFragmentDoc}`;

/**
 * __usePublicListingsQuery__
 *
 * To run a query within a React component, call `usePublicListingsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicListingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicListingsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function usePublicListingsQuery(baseOptions?: Apollo.QueryHookOptions<PublicListingsQuery, PublicListingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicListingsQuery, PublicListingsQueryVariables>(PublicListingsDocument, options);
      }
export function usePublicListingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicListingsQuery, PublicListingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicListingsQuery, PublicListingsQueryVariables>(PublicListingsDocument, options);
        }
export type PublicListingsQueryHookResult = ReturnType<typeof usePublicListingsQuery>;
export type PublicListingsLazyQueryHookResult = ReturnType<typeof usePublicListingsLazyQuery>;
export type PublicListingsQueryResult = Apollo.QueryResult<PublicListingsQuery, PublicListingsQueryVariables>;
export const PublicListingsIdsOnlyDocument = gql`
    query publicListingsIdsOnly {
  publicListings {
    id
  }
}
    `;

/**
 * __usePublicListingsIdsOnlyQuery__
 *
 * To run a query within a React component, call `usePublicListingsIdsOnlyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicListingsIdsOnlyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicListingsIdsOnlyQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublicListingsIdsOnlyQuery(baseOptions?: Apollo.QueryHookOptions<PublicListingsIdsOnlyQuery, PublicListingsIdsOnlyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicListingsIdsOnlyQuery, PublicListingsIdsOnlyQueryVariables>(PublicListingsIdsOnlyDocument, options);
      }
export function usePublicListingsIdsOnlyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicListingsIdsOnlyQuery, PublicListingsIdsOnlyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicListingsIdsOnlyQuery, PublicListingsIdsOnlyQueryVariables>(PublicListingsIdsOnlyDocument, options);
        }
export type PublicListingsIdsOnlyQueryHookResult = ReturnType<typeof usePublicListingsIdsOnlyQuery>;
export type PublicListingsIdsOnlyLazyQueryHookResult = ReturnType<typeof usePublicListingsIdsOnlyLazyQuery>;
export type PublicListingsIdsOnlyQueryResult = Apollo.QueryResult<PublicListingsIdsOnlyQuery, PublicListingsIdsOnlyQueryVariables>;
export const SearchListingsForSportsmenDocument = gql`
    query searchListingsForSportsmen($searchParams: SearchListingsForSportsmenInput!, $options: SearchOptions!) {
  searchListingsForSportsmen(searchParams: $searchParams, options: $options) {
    results {
      ...PublicSearchListingFields
    }
    total
  }
}
    ${PublicSearchListingFieldsFragmentDoc}`;

/**
 * __useSearchListingsForSportsmenQuery__
 *
 * To run a query within a React component, call `useSearchListingsForSportsmenQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchListingsForSportsmenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchListingsForSportsmenQuery({
 *   variables: {
 *      searchParams: // value for 'searchParams'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useSearchListingsForSportsmenQuery(baseOptions: Apollo.QueryHookOptions<SearchListingsForSportsmenQuery, SearchListingsForSportsmenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchListingsForSportsmenQuery, SearchListingsForSportsmenQueryVariables>(SearchListingsForSportsmenDocument, options);
      }
export function useSearchListingsForSportsmenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchListingsForSportsmenQuery, SearchListingsForSportsmenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchListingsForSportsmenQuery, SearchListingsForSportsmenQueryVariables>(SearchListingsForSportsmenDocument, options);
        }
export type SearchListingsForSportsmenQueryHookResult = ReturnType<typeof useSearchListingsForSportsmenQuery>;
export type SearchListingsForSportsmenLazyQueryHookResult = ReturnType<typeof useSearchListingsForSportsmenLazyQuery>;
export type SearchListingsForSportsmenQueryResult = Apollo.QueryResult<SearchListingsForSportsmenQuery, SearchListingsForSportsmenQueryVariables>;
export const LodgingDocument = gql`
    query lodging($id: ID!) {
  lodging(id: $id) {
    ...OutfitterLodgingFields
  }
}
    ${OutfitterLodgingFieldsFragmentDoc}`;

/**
 * __useLodgingQuery__
 *
 * To run a query within a React component, call `useLodgingQuery` and pass it any options that fit your needs.
 * When your component renders, `useLodgingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLodgingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLodgingQuery(baseOptions: Apollo.QueryHookOptions<LodgingQuery, LodgingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LodgingQuery, LodgingQueryVariables>(LodgingDocument, options);
      }
export function useLodgingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LodgingQuery, LodgingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LodgingQuery, LodgingQueryVariables>(LodgingDocument, options);
        }
export type LodgingQueryHookResult = ReturnType<typeof useLodgingQuery>;
export type LodgingLazyQueryHookResult = ReturnType<typeof useLodgingLazyQuery>;
export type LodgingQueryResult = Apollo.QueryResult<LodgingQuery, LodgingQueryVariables>;
export const PublicLodgingsByListingDocument = gql`
    query publicLodgingsByListing($listingId: ID!) {
  publicLodgingsByListing(listingId: $listingId) {
    ...PublicLodgingFields
  }
}
    ${PublicLodgingFieldsFragmentDoc}`;

/**
 * __usePublicLodgingsByListingQuery__
 *
 * To run a query within a React component, call `usePublicLodgingsByListingQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicLodgingsByListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicLodgingsByListingQuery({
 *   variables: {
 *      listingId: // value for 'listingId'
 *   },
 * });
 */
export function usePublicLodgingsByListingQuery(baseOptions: Apollo.QueryHookOptions<PublicLodgingsByListingQuery, PublicLodgingsByListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicLodgingsByListingQuery, PublicLodgingsByListingQueryVariables>(PublicLodgingsByListingDocument, options);
      }
export function usePublicLodgingsByListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicLodgingsByListingQuery, PublicLodgingsByListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicLodgingsByListingQuery, PublicLodgingsByListingQueryVariables>(PublicLodgingsByListingDocument, options);
        }
export type PublicLodgingsByListingQueryHookResult = ReturnType<typeof usePublicLodgingsByListingQuery>;
export type PublicLodgingsByListingLazyQueryHookResult = ReturnType<typeof usePublicLodgingsByListingLazyQuery>;
export type PublicLodgingsByListingQueryResult = Apollo.QueryResult<PublicLodgingsByListingQuery, PublicLodgingsByListingQueryVariables>;
export const GetSearchSuggestionsForTripDocument = gql`
    query getSearchSuggestionsForTrip($searchParams: SearchListingsForSportsmenInput!) {
  getSearchSuggestionsForTrip(searchParams: $searchParams) {
    ...GenericSearchSuggestionGroupFields
  }
}
    ${GenericSearchSuggestionGroupFieldsFragmentDoc}`;

/**
 * __useGetSearchSuggestionsForTripQuery__
 *
 * To run a query within a React component, call `useGetSearchSuggestionsForTripQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchSuggestionsForTripQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchSuggestionsForTripQuery({
 *   variables: {
 *      searchParams: // value for 'searchParams'
 *   },
 * });
 */
export function useGetSearchSuggestionsForTripQuery(baseOptions: Apollo.QueryHookOptions<GetSearchSuggestionsForTripQuery, GetSearchSuggestionsForTripQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchSuggestionsForTripQuery, GetSearchSuggestionsForTripQueryVariables>(GetSearchSuggestionsForTripDocument, options);
      }
export function useGetSearchSuggestionsForTripLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchSuggestionsForTripQuery, GetSearchSuggestionsForTripQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchSuggestionsForTripQuery, GetSearchSuggestionsForTripQueryVariables>(GetSearchSuggestionsForTripDocument, options);
        }
export type GetSearchSuggestionsForTripQueryHookResult = ReturnType<typeof useGetSearchSuggestionsForTripQuery>;
export type GetSearchSuggestionsForTripLazyQueryHookResult = ReturnType<typeof useGetSearchSuggestionsForTripLazyQuery>;
export type GetSearchSuggestionsForTripQueryResult = Apollo.QueryResult<GetSearchSuggestionsForTripQuery, GetSearchSuggestionsForTripQueryVariables>;
export const OnboardingStatusInfoDocument = gql`
    query onboardingStatusInfo($id: ID!) {
  onboardingStatusInfo(id: $id) {
    ...OnboardingStatusInfoFields
  }
}
    ${OnboardingStatusInfoFieldsFragmentDoc}`;

/**
 * __useOnboardingStatusInfoQuery__
 *
 * To run a query within a React component, call `useOnboardingStatusInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingStatusInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingStatusInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOnboardingStatusInfoQuery(baseOptions: Apollo.QueryHookOptions<OnboardingStatusInfoQuery, OnboardingStatusInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnboardingStatusInfoQuery, OnboardingStatusInfoQueryVariables>(OnboardingStatusInfoDocument, options);
      }
export function useOnboardingStatusInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardingStatusInfoQuery, OnboardingStatusInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnboardingStatusInfoQuery, OnboardingStatusInfoQueryVariables>(OnboardingStatusInfoDocument, options);
        }
export type OnboardingStatusInfoQueryHookResult = ReturnType<typeof useOnboardingStatusInfoQuery>;
export type OnboardingStatusInfoLazyQueryHookResult = ReturnType<typeof useOnboardingStatusInfoLazyQuery>;
export type OnboardingStatusInfoQueryResult = Apollo.QueryResult<OnboardingStatusInfoQuery, OnboardingStatusInfoQueryVariables>;
export const CreateDraftOnboardingDocument = gql`
    mutation createDraftOnboarding {
  createDraftOnboarding {
    ...OnboardingFields
  }
}
    ${OnboardingFieldsFragmentDoc}`;
export type CreateDraftOnboardingMutationFn = Apollo.MutationFunction<CreateDraftOnboardingMutation, CreateDraftOnboardingMutationVariables>;

/**
 * __useCreateDraftOnboardingMutation__
 *
 * To run a mutation, you first call `useCreateDraftOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDraftOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDraftOnboardingMutation, { data, loading, error }] = useCreateDraftOnboardingMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateDraftOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<CreateDraftOnboardingMutation, CreateDraftOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDraftOnboardingMutation, CreateDraftOnboardingMutationVariables>(CreateDraftOnboardingDocument, options);
      }
export type CreateDraftOnboardingMutationHookResult = ReturnType<typeof useCreateDraftOnboardingMutation>;
export type CreateDraftOnboardingMutationResult = Apollo.MutationResult<CreateDraftOnboardingMutation>;
export type CreateDraftOnboardingMutationOptions = Apollo.BaseMutationOptions<CreateDraftOnboardingMutation, CreateDraftOnboardingMutationVariables>;
export const OutfitterDocument = gql`
    query outfitter($id: ID!) {
  outfitter(id: $id) {
    ...OutfitterFields
  }
}
    ${OutfitterFieldsFragmentDoc}`;

/**
 * __useOutfitterQuery__
 *
 * To run a query within a React component, call `useOutfitterQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutfitterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutfitterQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOutfitterQuery(baseOptions: Apollo.QueryHookOptions<OutfitterQuery, OutfitterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OutfitterQuery, OutfitterQueryVariables>(OutfitterDocument, options);
      }
export function useOutfitterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OutfitterQuery, OutfitterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OutfitterQuery, OutfitterQueryVariables>(OutfitterDocument, options);
        }
export type OutfitterQueryHookResult = ReturnType<typeof useOutfitterQuery>;
export type OutfitterLazyQueryHookResult = ReturnType<typeof useOutfitterLazyQuery>;
export type OutfitterQueryResult = Apollo.QueryResult<OutfitterQuery, OutfitterQueryVariables>;
export const OutfitterListingsDocument = gql`
    query outfitterListings($id: ID!) {
  outfitter(id: $id) {
    listings {
      ...ListingMinimalFields
    }
  }
}
    ${ListingMinimalFieldsFragmentDoc}`;

/**
 * __useOutfitterListingsQuery__
 *
 * To run a query within a React component, call `useOutfitterListingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutfitterListingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutfitterListingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOutfitterListingsQuery(baseOptions: Apollo.QueryHookOptions<OutfitterListingsQuery, OutfitterListingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OutfitterListingsQuery, OutfitterListingsQueryVariables>(OutfitterListingsDocument, options);
      }
export function useOutfitterListingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OutfitterListingsQuery, OutfitterListingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OutfitterListingsQuery, OutfitterListingsQueryVariables>(OutfitterListingsDocument, options);
        }
export type OutfitterListingsQueryHookResult = ReturnType<typeof useOutfitterListingsQuery>;
export type OutfitterListingsLazyQueryHookResult = ReturnType<typeof useOutfitterListingsLazyQuery>;
export type OutfitterListingsQueryResult = Apollo.QueryResult<OutfitterListingsQuery, OutfitterListingsQueryVariables>;
export const PublicOutfittersDocument = gql`
    query publicOutfitters($ids: [ID!]) {
  publicOutfitters(ids: $ids) {
    ...PublicOutfitterFields
  }
}
    ${PublicOutfitterFieldsFragmentDoc}`;

/**
 * __usePublicOutfittersQuery__
 *
 * To run a query within a React component, call `usePublicOutfittersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicOutfittersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicOutfittersQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function usePublicOutfittersQuery(baseOptions?: Apollo.QueryHookOptions<PublicOutfittersQuery, PublicOutfittersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicOutfittersQuery, PublicOutfittersQueryVariables>(PublicOutfittersDocument, options);
      }
export function usePublicOutfittersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicOutfittersQuery, PublicOutfittersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicOutfittersQuery, PublicOutfittersQueryVariables>(PublicOutfittersDocument, options);
        }
export type PublicOutfittersQueryHookResult = ReturnType<typeof usePublicOutfittersQuery>;
export type PublicOutfittersLazyQueryHookResult = ReturnType<typeof usePublicOutfittersLazyQuery>;
export type PublicOutfittersQueryResult = Apollo.QueryResult<PublicOutfittersQuery, PublicOutfittersQueryVariables>;
export const PublicOutfittersIdsOnlyDocument = gql`
    query publicOutfittersIdsOnly {
  publicOutfitters {
    id
  }
}
    `;

/**
 * __usePublicOutfittersIdsOnlyQuery__
 *
 * To run a query within a React component, call `usePublicOutfittersIdsOnlyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicOutfittersIdsOnlyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicOutfittersIdsOnlyQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublicOutfittersIdsOnlyQuery(baseOptions?: Apollo.QueryHookOptions<PublicOutfittersIdsOnlyQuery, PublicOutfittersIdsOnlyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicOutfittersIdsOnlyQuery, PublicOutfittersIdsOnlyQueryVariables>(PublicOutfittersIdsOnlyDocument, options);
      }
export function usePublicOutfittersIdsOnlyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicOutfittersIdsOnlyQuery, PublicOutfittersIdsOnlyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicOutfittersIdsOnlyQuery, PublicOutfittersIdsOnlyQueryVariables>(PublicOutfittersIdsOnlyDocument, options);
        }
export type PublicOutfittersIdsOnlyQueryHookResult = ReturnType<typeof usePublicOutfittersIdsOnlyQuery>;
export type PublicOutfittersIdsOnlyLazyQueryHookResult = ReturnType<typeof usePublicOutfittersIdsOnlyLazyQuery>;
export type PublicOutfittersIdsOnlyQueryResult = Apollo.QueryResult<PublicOutfittersIdsOnlyQuery, PublicOutfittersIdsOnlyQueryVariables>;
export const SearchOutfittersForSportsmenDocument = gql`
    query searchOutfittersForSportsmen($searchParams: SearchOutfittersForSportsmenInput!, $options: SearchOptions!) {
  searchOutfittersForSportsmen(searchParams: $searchParams, options: $options) {
    results {
      ...PublicOutfitterFields
    }
    total
  }
}
    ${PublicOutfitterFieldsFragmentDoc}`;

/**
 * __useSearchOutfittersForSportsmenQuery__
 *
 * To run a query within a React component, call `useSearchOutfittersForSportsmenQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchOutfittersForSportsmenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchOutfittersForSportsmenQuery({
 *   variables: {
 *      searchParams: // value for 'searchParams'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useSearchOutfittersForSportsmenQuery(baseOptions: Apollo.QueryHookOptions<SearchOutfittersForSportsmenQuery, SearchOutfittersForSportsmenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchOutfittersForSportsmenQuery, SearchOutfittersForSportsmenQueryVariables>(SearchOutfittersForSportsmenDocument, options);
      }
export function useSearchOutfittersForSportsmenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchOutfittersForSportsmenQuery, SearchOutfittersForSportsmenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchOutfittersForSportsmenQuery, SearchOutfittersForSportsmenQueryVariables>(SearchOutfittersForSportsmenDocument, options);
        }
export type SearchOutfittersForSportsmenQueryHookResult = ReturnType<typeof useSearchOutfittersForSportsmenQuery>;
export type SearchOutfittersForSportsmenLazyQueryHookResult = ReturnType<typeof useSearchOutfittersForSportsmenLazyQuery>;
export type SearchOutfittersForSportsmenQueryResult = Apollo.QueryResult<SearchOutfittersForSportsmenQuery, SearchOutfittersForSportsmenQueryVariables>;
export const PaymentRequestDocument = gql`
    query paymentRequest($id: ID!, $isAchPaymentMethod: Boolean, $shouldCalculateFees: Boolean, $tipAmount: NonNegativeInt) {
  paymentRequest(
    id: $id
    isAchPaymentMethod: $isAchPaymentMethod
    shouldCalculateFees: $shouldCalculateFees
    tipAmount: $tipAmount
  ) {
    ...PaymentRequestFields
  }
}
    ${PaymentRequestFieldsFragmentDoc}`;

/**
 * __usePaymentRequestQuery__
 *
 * To run a query within a React component, call `usePaymentRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentRequestQuery({
 *   variables: {
 *      id: // value for 'id'
 *      isAchPaymentMethod: // value for 'isAchPaymentMethod'
 *      shouldCalculateFees: // value for 'shouldCalculateFees'
 *      tipAmount: // value for 'tipAmount'
 *   },
 * });
 */
export function usePaymentRequestQuery(baseOptions: Apollo.QueryHookOptions<PaymentRequestQuery, PaymentRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentRequestQuery, PaymentRequestQueryVariables>(PaymentRequestDocument, options);
      }
export function usePaymentRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentRequestQuery, PaymentRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentRequestQuery, PaymentRequestQueryVariables>(PaymentRequestDocument, options);
        }
export type PaymentRequestQueryHookResult = ReturnType<typeof usePaymentRequestQuery>;
export type PaymentRequestLazyQueryHookResult = ReturnType<typeof usePaymentRequestLazyQuery>;
export type PaymentRequestQueryResult = Apollo.QueryResult<PaymentRequestQuery, PaymentRequestQueryVariables>;
export const AdditionalPaymentSummaryDocument = gql`
    query additionalPaymentSummary($bookingId: ID!, $data: AdditionalPaymentSummaryInput!) {
  additionalPaymentSummary(bookingId: $bookingId, data: $data) {
    ...PaymentRequestSummaryFields
  }
}
    ${PaymentRequestSummaryFieldsFragmentDoc}`;

/**
 * __useAdditionalPaymentSummaryQuery__
 *
 * To run a query within a React component, call `useAdditionalPaymentSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdditionalPaymentSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdditionalPaymentSummaryQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAdditionalPaymentSummaryQuery(baseOptions: Apollo.QueryHookOptions<AdditionalPaymentSummaryQuery, AdditionalPaymentSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdditionalPaymentSummaryQuery, AdditionalPaymentSummaryQueryVariables>(AdditionalPaymentSummaryDocument, options);
      }
export function useAdditionalPaymentSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdditionalPaymentSummaryQuery, AdditionalPaymentSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdditionalPaymentSummaryQuery, AdditionalPaymentSummaryQueryVariables>(AdditionalPaymentSummaryDocument, options);
        }
export type AdditionalPaymentSummaryQueryHookResult = ReturnType<typeof useAdditionalPaymentSummaryQuery>;
export type AdditionalPaymentSummaryLazyQueryHookResult = ReturnType<typeof useAdditionalPaymentSummaryLazyQuery>;
export type AdditionalPaymentSummaryQueryResult = Apollo.QueryResult<AdditionalPaymentSummaryQuery, AdditionalPaymentSummaryQueryVariables>;
export const AcceptPaymentRequestDocument = gql`
    mutation acceptPaymentRequest($id: ID!, $data: AcceptPaymentRequestInput!) {
  acceptPaymentRequest(id: $id, data: $data) {
    ...PaymentRequestFields
  }
}
    ${PaymentRequestFieldsFragmentDoc}`;
export type AcceptPaymentRequestMutationFn = Apollo.MutationFunction<AcceptPaymentRequestMutation, AcceptPaymentRequestMutationVariables>;

/**
 * __useAcceptPaymentRequestMutation__
 *
 * To run a mutation, you first call `useAcceptPaymentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptPaymentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptPaymentRequestMutation, { data, loading, error }] = useAcceptPaymentRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAcceptPaymentRequestMutation(baseOptions?: Apollo.MutationHookOptions<AcceptPaymentRequestMutation, AcceptPaymentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptPaymentRequestMutation, AcceptPaymentRequestMutationVariables>(AcceptPaymentRequestDocument, options);
      }
export type AcceptPaymentRequestMutationHookResult = ReturnType<typeof useAcceptPaymentRequestMutation>;
export type AcceptPaymentRequestMutationResult = Apollo.MutationResult<AcceptPaymentRequestMutation>;
export type AcceptPaymentRequestMutationOptions = Apollo.BaseMutationOptions<AcceptPaymentRequestMutation, AcceptPaymentRequestMutationVariables>;
export const PaymentDocument = gql`
    query payment($id: ID!, $invitationId: ID) {
  payment(id: $id, invitationId: $invitationId) {
    ...PaymentFields
  }
}
    ${PaymentFieldsFragmentDoc}`;

/**
 * __usePaymentQuery__
 *
 * To run a query within a React component, call `usePaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      invitationId: // value for 'invitationId'
 *   },
 * });
 */
export function usePaymentQuery(baseOptions: Apollo.QueryHookOptions<PaymentQuery, PaymentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentQuery, PaymentQueryVariables>(PaymentDocument, options);
      }
export function usePaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentQuery, PaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentQuery, PaymentQueryVariables>(PaymentDocument, options);
        }
export type PaymentQueryHookResult = ReturnType<typeof usePaymentQuery>;
export type PaymentLazyQueryHookResult = ReturnType<typeof usePaymentLazyQuery>;
export type PaymentQueryResult = Apollo.QueryResult<PaymentQuery, PaymentQueryVariables>;
export const RetryPaymentDocument = gql`
    mutation retryPayment($id: ID!, $data: RetryPaymentInput!) {
  retryPayment(id: $id, data: $data) {
    ...BookingPaymentWithStripeUrlFields
  }
}
    ${BookingPaymentWithStripeUrlFieldsFragmentDoc}`;
export type RetryPaymentMutationFn = Apollo.MutationFunction<RetryPaymentMutation, RetryPaymentMutationVariables>;

/**
 * __useRetryPaymentMutation__
 *
 * To run a mutation, you first call `useRetryPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryPaymentMutation, { data, loading, error }] = useRetryPaymentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRetryPaymentMutation(baseOptions?: Apollo.MutationHookOptions<RetryPaymentMutation, RetryPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryPaymentMutation, RetryPaymentMutationVariables>(RetryPaymentDocument, options);
      }
export type RetryPaymentMutationHookResult = ReturnType<typeof useRetryPaymentMutation>;
export type RetryPaymentMutationResult = Apollo.MutationResult<RetryPaymentMutation>;
export type RetryPaymentMutationOptions = Apollo.BaseMutationOptions<RetryPaymentMutation, RetryPaymentMutationVariables>;
export const GetPricingPackageDocument = gql`
    query getPricingPackage($id: ID!) {
  pricingPackage(id: $id) {
    ...PricingPackageFields
  }
}
    ${PricingPackageFieldsFragmentDoc}`;

/**
 * __useGetPricingPackageQuery__
 *
 * To run a query within a React component, call `useGetPricingPackageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPricingPackageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPricingPackageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPricingPackageQuery(baseOptions: Apollo.QueryHookOptions<GetPricingPackageQuery, GetPricingPackageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPricingPackageQuery, GetPricingPackageQueryVariables>(GetPricingPackageDocument, options);
      }
export function useGetPricingPackageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPricingPackageQuery, GetPricingPackageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPricingPackageQuery, GetPricingPackageQueryVariables>(GetPricingPackageDocument, options);
        }
export type GetPricingPackageQueryHookResult = ReturnType<typeof useGetPricingPackageQuery>;
export type GetPricingPackageLazyQueryHookResult = ReturnType<typeof useGetPricingPackageLazyQuery>;
export type GetPricingPackageQueryResult = Apollo.QueryResult<GetPricingPackageQuery, GetPricingPackageQueryVariables>;
export const PricingPackagesByListingDocument = gql`
    query pricingPackagesByListing($listingId: ID!, $dates: [Timestamp!], $numberOfGuests: PositiveInt) {
  pricingPackagesByListing(
    listing: $listingId
    dates: $dates
    numberOfGuests: $numberOfGuests
  ) {
    ...PricingPackageFields
  }
}
    ${PricingPackageFieldsFragmentDoc}`;

/**
 * __usePricingPackagesByListingQuery__
 *
 * To run a query within a React component, call `usePricingPackagesByListingQuery` and pass it any options that fit your needs.
 * When your component renders, `usePricingPackagesByListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePricingPackagesByListingQuery({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      dates: // value for 'dates'
 *      numberOfGuests: // value for 'numberOfGuests'
 *   },
 * });
 */
export function usePricingPackagesByListingQuery(baseOptions: Apollo.QueryHookOptions<PricingPackagesByListingQuery, PricingPackagesByListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PricingPackagesByListingQuery, PricingPackagesByListingQueryVariables>(PricingPackagesByListingDocument, options);
      }
export function usePricingPackagesByListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PricingPackagesByListingQuery, PricingPackagesByListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PricingPackagesByListingQuery, PricingPackagesByListingQueryVariables>(PricingPackagesByListingDocument, options);
        }
export type PricingPackagesByListingQueryHookResult = ReturnType<typeof usePricingPackagesByListingQuery>;
export type PricingPackagesByListingLazyQueryHookResult = ReturnType<typeof usePricingPackagesByListingLazyQuery>;
export type PricingPackagesByListingQueryResult = Apollo.QueryResult<PricingPackagesByListingQuery, PricingPackagesByListingQueryVariables>;
export const CreateQuoteRequestDocument = gql`
    mutation createQuoteRequest($data: QuoteRequestInput!) {
  createQuoteRequest(data: $data) {
    ...QuoteRequestFields
  }
}
    ${QuoteRequestFieldsFragmentDoc}`;
export type CreateQuoteRequestMutationFn = Apollo.MutationFunction<CreateQuoteRequestMutation, CreateQuoteRequestMutationVariables>;

/**
 * __useCreateQuoteRequestMutation__
 *
 * To run a mutation, you first call `useCreateQuoteRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuoteRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuoteRequestMutation, { data, loading, error }] = useCreateQuoteRequestMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateQuoteRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuoteRequestMutation, CreateQuoteRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuoteRequestMutation, CreateQuoteRequestMutationVariables>(CreateQuoteRequestDocument, options);
      }
export type CreateQuoteRequestMutationHookResult = ReturnType<typeof useCreateQuoteRequestMutation>;
export type CreateQuoteRequestMutationResult = Apollo.MutationResult<CreateQuoteRequestMutation>;
export type CreateQuoteRequestMutationOptions = Apollo.BaseMutationOptions<CreateQuoteRequestMutation, CreateQuoteRequestMutationVariables>;
export const QuoteDocument = gql`
    query quote($id: ID!, $isAchPaymentMethod: Boolean, $isExternalPaymentMethod: Boolean, $paymentPlanType: PaymentPlanType, $sportmanZipCode: String, $shouldAcceptTripInsurance: Boolean) {
  quote(
    id: $id
    isAchPaymentMethod: $isAchPaymentMethod
    isExternalPaymentMethod: $isExternalPaymentMethod
    paymentPlanType: $paymentPlanType
    sportmanZipCode: $sportmanZipCode
    shouldAcceptTripInsurance: $shouldAcceptTripInsurance
  ) {
    ...QuoteFields
  }
}
    ${QuoteFieldsFragmentDoc}`;

/**
 * __useQuoteQuery__
 *
 * To run a query within a React component, call `useQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteQuery({
 *   variables: {
 *      id: // value for 'id'
 *      isAchPaymentMethod: // value for 'isAchPaymentMethod'
 *      isExternalPaymentMethod: // value for 'isExternalPaymentMethod'
 *      paymentPlanType: // value for 'paymentPlanType'
 *      sportmanZipCode: // value for 'sportmanZipCode'
 *      shouldAcceptTripInsurance: // value for 'shouldAcceptTripInsurance'
 *   },
 * });
 */
export function useQuoteQuery(baseOptions: Apollo.QueryHookOptions<QuoteQuery, QuoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteQuery, QuoteQueryVariables>(QuoteDocument, options);
      }
export function useQuoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteQuery, QuoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteQuery, QuoteQueryVariables>(QuoteDocument, options);
        }
export type QuoteQueryHookResult = ReturnType<typeof useQuoteQuery>;
export type QuoteLazyQueryHookResult = ReturnType<typeof useQuoteLazyQuery>;
export type QuoteQueryResult = Apollo.QueryResult<QuoteQuery, QuoteQueryVariables>;
export const DraftQuoteDocument = gql`
    query draftQuote($data: CreateQuoteInput!) {
  draftQuote(data: $data) {
    ...QuoteInterfaceFields
  }
}
    ${QuoteInterfaceFieldsFragmentDoc}`;

/**
 * __useDraftQuoteQuery__
 *
 * To run a query within a React component, call `useDraftQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useDraftQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDraftQuoteQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDraftQuoteQuery(baseOptions: Apollo.QueryHookOptions<DraftQuoteQuery, DraftQuoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DraftQuoteQuery, DraftQuoteQueryVariables>(DraftQuoteDocument, options);
      }
export function useDraftQuoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DraftQuoteQuery, DraftQuoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DraftQuoteQuery, DraftQuoteQueryVariables>(DraftQuoteDocument, options);
        }
export type DraftQuoteQueryHookResult = ReturnType<typeof useDraftQuoteQuery>;
export type DraftQuoteLazyQueryHookResult = ReturnType<typeof useDraftQuoteLazyQuery>;
export type DraftQuoteQueryResult = Apollo.QueryResult<DraftQuoteQuery, DraftQuoteQueryVariables>;
export const CreateQuoteDocument = gql`
    mutation createQuote($data: CreateQuoteInput!) {
  createQuote(data: $data) {
    id
  }
}
    `;
export type CreateQuoteMutationFn = Apollo.MutationFunction<CreateQuoteMutation, CreateQuoteMutationVariables>;

/**
 * __useCreateQuoteMutation__
 *
 * To run a mutation, you first call `useCreateQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuoteMutation, { data, loading, error }] = useCreateQuoteMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateQuoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuoteMutation, CreateQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuoteMutation, CreateQuoteMutationVariables>(CreateQuoteDocument, options);
      }
export type CreateQuoteMutationHookResult = ReturnType<typeof useCreateQuoteMutation>;
export type CreateQuoteMutationResult = Apollo.MutationResult<CreateQuoteMutation>;
export type CreateQuoteMutationOptions = Apollo.BaseMutationOptions<CreateQuoteMutation, CreateQuoteMutationVariables>;
export const ApplyQuoteCouponDocument = gql`
    mutation applyQuoteCoupon($quoteId: ID!, $couponCode: String!) {
  applyQuoteCoupon(quoteId: $quoteId, couponCode: $couponCode) {
    ...QuoteFields
  }
}
    ${QuoteFieldsFragmentDoc}`;
export type ApplyQuoteCouponMutationFn = Apollo.MutationFunction<ApplyQuoteCouponMutation, ApplyQuoteCouponMutationVariables>;

/**
 * __useApplyQuoteCouponMutation__
 *
 * To run a mutation, you first call `useApplyQuoteCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyQuoteCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyQuoteCouponMutation, { data, loading, error }] = useApplyQuoteCouponMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      couponCode: // value for 'couponCode'
 *   },
 * });
 */
export function useApplyQuoteCouponMutation(baseOptions?: Apollo.MutationHookOptions<ApplyQuoteCouponMutation, ApplyQuoteCouponMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyQuoteCouponMutation, ApplyQuoteCouponMutationVariables>(ApplyQuoteCouponDocument, options);
      }
export type ApplyQuoteCouponMutationHookResult = ReturnType<typeof useApplyQuoteCouponMutation>;
export type ApplyQuoteCouponMutationResult = Apollo.MutationResult<ApplyQuoteCouponMutation>;
export type ApplyQuoteCouponMutationOptions = Apollo.BaseMutationOptions<ApplyQuoteCouponMutation, ApplyQuoteCouponMutationVariables>;
export const RemoveQuoteCouponDocument = gql`
    mutation removeQuoteCoupon($quoteId: ID!) {
  removeQuoteCoupon(quoteId: $quoteId) {
    ...QuoteFields
  }
}
    ${QuoteFieldsFragmentDoc}`;
export type RemoveQuoteCouponMutationFn = Apollo.MutationFunction<RemoveQuoteCouponMutation, RemoveQuoteCouponMutationVariables>;

/**
 * __useRemoveQuoteCouponMutation__
 *
 * To run a mutation, you first call `useRemoveQuoteCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveQuoteCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeQuoteCouponMutation, { data, loading, error }] = useRemoveQuoteCouponMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useRemoveQuoteCouponMutation(baseOptions?: Apollo.MutationHookOptions<RemoveQuoteCouponMutation, RemoveQuoteCouponMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveQuoteCouponMutation, RemoveQuoteCouponMutationVariables>(RemoveQuoteCouponDocument, options);
      }
export type RemoveQuoteCouponMutationHookResult = ReturnType<typeof useRemoveQuoteCouponMutation>;
export type RemoveQuoteCouponMutationResult = Apollo.MutationResult<RemoveQuoteCouponMutation>;
export type RemoveQuoteCouponMutationOptions = Apollo.BaseMutationOptions<RemoveQuoteCouponMutation, RemoveQuoteCouponMutationVariables>;
export const EnableQuotePaymentGroupDocument = gql`
    mutation enableQuotePaymentGroup($quoteId: ID!, $hostSlots: PositiveInt!) {
  enableQuotePaymentGroup(quoteId: $quoteId, hostSlots: $hostSlots) {
    ...QuoteFields
  }
}
    ${QuoteFieldsFragmentDoc}`;
export type EnableQuotePaymentGroupMutationFn = Apollo.MutationFunction<EnableQuotePaymentGroupMutation, EnableQuotePaymentGroupMutationVariables>;

/**
 * __useEnableQuotePaymentGroupMutation__
 *
 * To run a mutation, you first call `useEnableQuotePaymentGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableQuotePaymentGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableQuotePaymentGroupMutation, { data, loading, error }] = useEnableQuotePaymentGroupMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      hostSlots: // value for 'hostSlots'
 *   },
 * });
 */
export function useEnableQuotePaymentGroupMutation(baseOptions?: Apollo.MutationHookOptions<EnableQuotePaymentGroupMutation, EnableQuotePaymentGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableQuotePaymentGroupMutation, EnableQuotePaymentGroupMutationVariables>(EnableQuotePaymentGroupDocument, options);
      }
export type EnableQuotePaymentGroupMutationHookResult = ReturnType<typeof useEnableQuotePaymentGroupMutation>;
export type EnableQuotePaymentGroupMutationResult = Apollo.MutationResult<EnableQuotePaymentGroupMutation>;
export type EnableQuotePaymentGroupMutationOptions = Apollo.BaseMutationOptions<EnableQuotePaymentGroupMutation, EnableQuotePaymentGroupMutationVariables>;
export const DisableQuotePaymentGroupDocument = gql`
    mutation disableQuotePaymentGroup($quoteId: ID!) {
  disableQuotePaymentGroup(quoteId: $quoteId) {
    ...QuoteFields
  }
}
    ${QuoteFieldsFragmentDoc}`;
export type DisableQuotePaymentGroupMutationFn = Apollo.MutationFunction<DisableQuotePaymentGroupMutation, DisableQuotePaymentGroupMutationVariables>;

/**
 * __useDisableQuotePaymentGroupMutation__
 *
 * To run a mutation, you first call `useDisableQuotePaymentGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableQuotePaymentGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableQuotePaymentGroupMutation, { data, loading, error }] = useDisableQuotePaymentGroupMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useDisableQuotePaymentGroupMutation(baseOptions?: Apollo.MutationHookOptions<DisableQuotePaymentGroupMutation, DisableQuotePaymentGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableQuotePaymentGroupMutation, DisableQuotePaymentGroupMutationVariables>(DisableQuotePaymentGroupDocument, options);
      }
export type DisableQuotePaymentGroupMutationHookResult = ReturnType<typeof useDisableQuotePaymentGroupMutation>;
export type DisableQuotePaymentGroupMutationResult = Apollo.MutationResult<DisableQuotePaymentGroupMutation>;
export type DisableQuotePaymentGroupMutationOptions = Apollo.BaseMutationOptions<DisableQuotePaymentGroupMutation, DisableQuotePaymentGroupMutationVariables>;
export const AddPackageToQuoteDocument = gql`
    mutation addPackageToQuote($quoteId: ID!, $data: AddPackageToQuoteInput!) {
  addPackageToQuote(quoteId: $quoteId, data: $data) {
    ...QuoteFields
  }
}
    ${QuoteFieldsFragmentDoc}`;
export type AddPackageToQuoteMutationFn = Apollo.MutationFunction<AddPackageToQuoteMutation, AddPackageToQuoteMutationVariables>;

/**
 * __useAddPackageToQuoteMutation__
 *
 * To run a mutation, you first call `useAddPackageToQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPackageToQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPackageToQuoteMutation, { data, loading, error }] = useAddPackageToQuoteMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddPackageToQuoteMutation(baseOptions?: Apollo.MutationHookOptions<AddPackageToQuoteMutation, AddPackageToQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPackageToQuoteMutation, AddPackageToQuoteMutationVariables>(AddPackageToQuoteDocument, options);
      }
export type AddPackageToQuoteMutationHookResult = ReturnType<typeof useAddPackageToQuoteMutation>;
export type AddPackageToQuoteMutationResult = Apollo.MutationResult<AddPackageToQuoteMutation>;
export type AddPackageToQuoteMutationOptions = Apollo.BaseMutationOptions<AddPackageToQuoteMutation, AddPackageToQuoteMutationVariables>;
export const UpdatePackageOnQuoteDocument = gql`
    mutation updatePackageOnQuote($quoteId: ID!, $packageId: ID!, $data: UpdatePackageOnQuoteInput!) {
  updatePackageOnQuote(quoteId: $quoteId, packageId: $packageId, data: $data) {
    ...QuoteFields
  }
}
    ${QuoteFieldsFragmentDoc}`;
export type UpdatePackageOnQuoteMutationFn = Apollo.MutationFunction<UpdatePackageOnQuoteMutation, UpdatePackageOnQuoteMutationVariables>;

/**
 * __useUpdatePackageOnQuoteMutation__
 *
 * To run a mutation, you first call `useUpdatePackageOnQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePackageOnQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePackageOnQuoteMutation, { data, loading, error }] = useUpdatePackageOnQuoteMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      packageId: // value for 'packageId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePackageOnQuoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePackageOnQuoteMutation, UpdatePackageOnQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePackageOnQuoteMutation, UpdatePackageOnQuoteMutationVariables>(UpdatePackageOnQuoteDocument, options);
      }
export type UpdatePackageOnQuoteMutationHookResult = ReturnType<typeof useUpdatePackageOnQuoteMutation>;
export type UpdatePackageOnQuoteMutationResult = Apollo.MutationResult<UpdatePackageOnQuoteMutation>;
export type UpdatePackageOnQuoteMutationOptions = Apollo.BaseMutationOptions<UpdatePackageOnQuoteMutation, UpdatePackageOnQuoteMutationVariables>;
export const RemovePackageFromQuoteDocument = gql`
    mutation removePackageFromQuote($quoteId: ID!, $packageId: ID!) {
  removePackageFromQuote(quoteId: $quoteId, packageId: $packageId) {
    ...QuoteFields
  }
}
    ${QuoteFieldsFragmentDoc}`;
export type RemovePackageFromQuoteMutationFn = Apollo.MutationFunction<RemovePackageFromQuoteMutation, RemovePackageFromQuoteMutationVariables>;

/**
 * __useRemovePackageFromQuoteMutation__
 *
 * To run a mutation, you first call `useRemovePackageFromQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePackageFromQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePackageFromQuoteMutation, { data, loading, error }] = useRemovePackageFromQuoteMutation({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      packageId: // value for 'packageId'
 *   },
 * });
 */
export function useRemovePackageFromQuoteMutation(baseOptions?: Apollo.MutationHookOptions<RemovePackageFromQuoteMutation, RemovePackageFromQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePackageFromQuoteMutation, RemovePackageFromQuoteMutationVariables>(RemovePackageFromQuoteDocument, options);
      }
export type RemovePackageFromQuoteMutationHookResult = ReturnType<typeof useRemovePackageFromQuoteMutation>;
export type RemovePackageFromQuoteMutationResult = Apollo.MutationResult<RemovePackageFromQuoteMutation>;
export type RemovePackageFromQuoteMutationOptions = Apollo.BaseMutationOptions<RemovePackageFromQuoteMutation, RemovePackageFromQuoteMutationVariables>;
export const ResourceDocument = gql`
    query resource($id: String!) {
  resource(id: $id) {
    ...ResourceFields
  }
}
    ${ResourceFieldsFragmentDoc}`;

/**
 * __useResourceQuery__
 *
 * To run a query within a React component, call `useResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResourceQuery(baseOptions: Apollo.QueryHookOptions<ResourceQuery, ResourceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourceQuery, ResourceQueryVariables>(ResourceDocument, options);
      }
export function useResourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourceQuery, ResourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourceQuery, ResourceQueryVariables>(ResourceDocument, options);
        }
export type ResourceQueryHookResult = ReturnType<typeof useResourceQuery>;
export type ResourceLazyQueryHookResult = ReturnType<typeof useResourceLazyQuery>;
export type ResourceQueryResult = Apollo.QueryResult<ResourceQuery, ResourceQueryVariables>;
export const ReviewFormDocument = gql`
    query reviewForm($id: ID!) {
  reviewForm(id: $id) {
    ...ReviewFormFields
  }
}
    ${ReviewFormFieldsFragmentDoc}`;

/**
 * __useReviewFormQuery__
 *
 * To run a query within a React component, call `useReviewFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReviewFormQuery(baseOptions: Apollo.QueryHookOptions<ReviewFormQuery, ReviewFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReviewFormQuery, ReviewFormQueryVariables>(ReviewFormDocument, options);
      }
export function useReviewFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReviewFormQuery, ReviewFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReviewFormQuery, ReviewFormQueryVariables>(ReviewFormDocument, options);
        }
export type ReviewFormQueryHookResult = ReturnType<typeof useReviewFormQuery>;
export type ReviewFormLazyQueryHookResult = ReturnType<typeof useReviewFormLazyQuery>;
export type ReviewFormQueryResult = Apollo.QueryResult<ReviewFormQuery, ReviewFormQueryVariables>;
export const SubmitReviewFormDocument = gql`
    mutation submitReviewForm($data: SubmitReviewFormInput!) {
  submitReviewForm(data: $data)
}
    `;
export type SubmitReviewFormMutationFn = Apollo.MutationFunction<SubmitReviewFormMutation, SubmitReviewFormMutationVariables>;

/**
 * __useSubmitReviewFormMutation__
 *
 * To run a mutation, you first call `useSubmitReviewFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitReviewFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitReviewFormMutation, { data, loading, error }] = useSubmitReviewFormMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSubmitReviewFormMutation(baseOptions?: Apollo.MutationHookOptions<SubmitReviewFormMutation, SubmitReviewFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitReviewFormMutation, SubmitReviewFormMutationVariables>(SubmitReviewFormDocument, options);
      }
export type SubmitReviewFormMutationHookResult = ReturnType<typeof useSubmitReviewFormMutation>;
export type SubmitReviewFormMutationResult = Apollo.MutationResult<SubmitReviewFormMutation>;
export type SubmitReviewFormMutationOptions = Apollo.BaseMutationOptions<SubmitReviewFormMutation, SubmitReviewFormMutationVariables>;
export const AllSpeciesDocument = gql`
    query allSpecies {
  allSpecies {
    ...SpeciesMinimalFields
  }
}
    ${SpeciesMinimalFieldsFragmentDoc}`;

/**
 * __useAllSpeciesQuery__
 *
 * To run a query within a React component, call `useAllSpeciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSpeciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSpeciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllSpeciesQuery(baseOptions?: Apollo.QueryHookOptions<AllSpeciesQuery, AllSpeciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllSpeciesQuery, AllSpeciesQueryVariables>(AllSpeciesDocument, options);
      }
export function useAllSpeciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllSpeciesQuery, AllSpeciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllSpeciesQuery, AllSpeciesQueryVariables>(AllSpeciesDocument, options);
        }
export type AllSpeciesQueryHookResult = ReturnType<typeof useAllSpeciesQuery>;
export type AllSpeciesLazyQueryHookResult = ReturnType<typeof useAllSpeciesLazyQuery>;
export type AllSpeciesQueryResult = Apollo.QueryResult<AllSpeciesQuery, AllSpeciesQueryVariables>;
export const SearchSpeciesDocument = gql`
    query searchSpecies($data: SearchSpeciesInput!) {
  searchSpecies(data: $data) {
    ...SpeciesMinimalFields
  }
}
    ${SpeciesMinimalFieldsFragmentDoc}`;

/**
 * __useSearchSpeciesQuery__
 *
 * To run a query within a React component, call `useSearchSpeciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSpeciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSpeciesQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSearchSpeciesQuery(baseOptions: Apollo.QueryHookOptions<SearchSpeciesQuery, SearchSpeciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchSpeciesQuery, SearchSpeciesQueryVariables>(SearchSpeciesDocument, options);
      }
export function useSearchSpeciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchSpeciesQuery, SearchSpeciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchSpeciesQuery, SearchSpeciesQueryVariables>(SearchSpeciesDocument, options);
        }
export type SearchSpeciesQueryHookResult = ReturnType<typeof useSearchSpeciesQuery>;
export type SearchSpeciesLazyQueryHookResult = ReturnType<typeof useSearchSpeciesLazyQuery>;
export type SearchSpeciesQueryResult = Apollo.QueryResult<SearchSpeciesQuery, SearchSpeciesQueryVariables>;
export const FeedActivitiesDocument = gql`
    query feedActivities($feedGroup: FeedGroup!, $feedId: String!, $limit: Int, $offset: Int) {
  feedActivities(
    feedGroup: $feedGroup
    feedId: $feedId
    limit: $limit
    offset: $offset
  ) {
    results {
      ...ActivityFields
    }
    canFetchMore
  }
}
    ${ActivityFieldsFragmentDoc}`;

/**
 * __useFeedActivitiesQuery__
 *
 * To run a query within a React component, call `useFeedActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedActivitiesQuery({
 *   variables: {
 *      feedGroup: // value for 'feedGroup'
 *      feedId: // value for 'feedId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useFeedActivitiesQuery(baseOptions: Apollo.QueryHookOptions<FeedActivitiesQuery, FeedActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedActivitiesQuery, FeedActivitiesQueryVariables>(FeedActivitiesDocument, options);
      }
export function useFeedActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedActivitiesQuery, FeedActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedActivitiesQuery, FeedActivitiesQueryVariables>(FeedActivitiesDocument, options);
        }
export type FeedActivitiesQueryHookResult = ReturnType<typeof useFeedActivitiesQuery>;
export type FeedActivitiesLazyQueryHookResult = ReturnType<typeof useFeedActivitiesLazyQuery>;
export type FeedActivitiesQueryResult = Apollo.QueryResult<FeedActivitiesQuery, FeedActivitiesQueryVariables>;
export const StreamActivitiesByIdsDocument = gql`
    query streamActivitiesByIds($ids: [String!]!) {
  streamActivitiesByIds(ids: $ids) {
    ...ActivityFields
  }
}
    ${ActivityFieldsFragmentDoc}`;

/**
 * __useStreamActivitiesByIdsQuery__
 *
 * To run a query within a React component, call `useStreamActivitiesByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStreamActivitiesByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStreamActivitiesByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useStreamActivitiesByIdsQuery(baseOptions: Apollo.QueryHookOptions<StreamActivitiesByIdsQuery, StreamActivitiesByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StreamActivitiesByIdsQuery, StreamActivitiesByIdsQueryVariables>(StreamActivitiesByIdsDocument, options);
      }
export function useStreamActivitiesByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StreamActivitiesByIdsQuery, StreamActivitiesByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StreamActivitiesByIdsQuery, StreamActivitiesByIdsQueryVariables>(StreamActivitiesByIdsDocument, options);
        }
export type StreamActivitiesByIdsQueryHookResult = ReturnType<typeof useStreamActivitiesByIdsQuery>;
export type StreamActivitiesByIdsLazyQueryHookResult = ReturnType<typeof useStreamActivitiesByIdsLazyQuery>;
export type StreamActivitiesByIdsQueryResult = Apollo.QueryResult<StreamActivitiesByIdsQuery, StreamActivitiesByIdsQueryVariables>;
export const ReactToActivityDocument = gql`
    mutation reactToActivity($activityId: String!, $reactionType: ReactionType!) {
  reactToActivity(activityId: $activityId, reactionType: $reactionType) {
    ...ActivityFields
  }
}
    ${ActivityFieldsFragmentDoc}`;
export type ReactToActivityMutationFn = Apollo.MutationFunction<ReactToActivityMutation, ReactToActivityMutationVariables>;

/**
 * __useReactToActivityMutation__
 *
 * To run a mutation, you first call `useReactToActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactToActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactToActivityMutation, { data, loading, error }] = useReactToActivityMutation({
 *   variables: {
 *      activityId: // value for 'activityId'
 *      reactionType: // value for 'reactionType'
 *   },
 * });
 */
export function useReactToActivityMutation(baseOptions?: Apollo.MutationHookOptions<ReactToActivityMutation, ReactToActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactToActivityMutation, ReactToActivityMutationVariables>(ReactToActivityDocument, options);
      }
export type ReactToActivityMutationHookResult = ReturnType<typeof useReactToActivityMutation>;
export type ReactToActivityMutationResult = Apollo.MutationResult<ReactToActivityMutation>;
export type ReactToActivityMutationOptions = Apollo.BaseMutationOptions<ReactToActivityMutation, ReactToActivityMutationVariables>;
export const RemoveReactionDocument = gql`
    mutation removeReaction($reactionId: String!) {
  removeReaction(reactionId: $reactionId) {
    ...ActivityFields
  }
}
    ${ActivityFieldsFragmentDoc}`;
export type RemoveReactionMutationFn = Apollo.MutationFunction<RemoveReactionMutation, RemoveReactionMutationVariables>;

/**
 * __useRemoveReactionMutation__
 *
 * To run a mutation, you first call `useRemoveReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeReactionMutation, { data, loading, error }] = useRemoveReactionMutation({
 *   variables: {
 *      reactionId: // value for 'reactionId'
 *   },
 * });
 */
export function useRemoveReactionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveReactionMutation, RemoveReactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveReactionMutation, RemoveReactionMutationVariables>(RemoveReactionDocument, options);
      }
export type RemoveReactionMutationHookResult = ReturnType<typeof useRemoveReactionMutation>;
export type RemoveReactionMutationResult = Apollo.MutationResult<RemoveReactionMutation>;
export type RemoveReactionMutationOptions = Apollo.BaseMutationOptions<RemoveReactionMutation, RemoveReactionMutationVariables>;
export const SportsmanPaymentBlocksDocument = gql`
    query sportsmanPaymentBlocks($sportsmanId: ID!) {
  sportsmanPaymentBlocks(sportsmanId: $sportsmanId) {
    ...PaymentBlockFields
  }
}
    ${PaymentBlockFieldsFragmentDoc}`;

/**
 * __useSportsmanPaymentBlocksQuery__
 *
 * To run a query within a React component, call `useSportsmanPaymentBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useSportsmanPaymentBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSportsmanPaymentBlocksQuery({
 *   variables: {
 *      sportsmanId: // value for 'sportsmanId'
 *   },
 * });
 */
export function useSportsmanPaymentBlocksQuery(baseOptions: Apollo.QueryHookOptions<SportsmanPaymentBlocksQuery, SportsmanPaymentBlocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SportsmanPaymentBlocksQuery, SportsmanPaymentBlocksQueryVariables>(SportsmanPaymentBlocksDocument, options);
      }
export function useSportsmanPaymentBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SportsmanPaymentBlocksQuery, SportsmanPaymentBlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SportsmanPaymentBlocksQuery, SportsmanPaymentBlocksQueryVariables>(SportsmanPaymentBlocksDocument, options);
        }
export type SportsmanPaymentBlocksQueryHookResult = ReturnType<typeof useSportsmanPaymentBlocksQuery>;
export type SportsmanPaymentBlocksLazyQueryHookResult = ReturnType<typeof useSportsmanPaymentBlocksLazyQuery>;
export type SportsmanPaymentBlocksQueryResult = Apollo.QueryResult<SportsmanPaymentBlocksQuery, SportsmanPaymentBlocksQueryVariables>;
export const GroupPayMemberPaymentBlocksDocument = gql`
    query groupPayMemberPaymentBlocks($groupPayMemberId: ID!) {
  groupPayMemberPaymentBlocks(groupPayMemberId: $groupPayMemberId) {
    ...PaymentBlockFields
  }
}
    ${PaymentBlockFieldsFragmentDoc}`;

/**
 * __useGroupPayMemberPaymentBlocksQuery__
 *
 * To run a query within a React component, call `useGroupPayMemberPaymentBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupPayMemberPaymentBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupPayMemberPaymentBlocksQuery({
 *   variables: {
 *      groupPayMemberId: // value for 'groupPayMemberId'
 *   },
 * });
 */
export function useGroupPayMemberPaymentBlocksQuery(baseOptions: Apollo.QueryHookOptions<GroupPayMemberPaymentBlocksQuery, GroupPayMemberPaymentBlocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupPayMemberPaymentBlocksQuery, GroupPayMemberPaymentBlocksQueryVariables>(GroupPayMemberPaymentBlocksDocument, options);
      }
export function useGroupPayMemberPaymentBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupPayMemberPaymentBlocksQuery, GroupPayMemberPaymentBlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupPayMemberPaymentBlocksQuery, GroupPayMemberPaymentBlocksQueryVariables>(GroupPayMemberPaymentBlocksDocument, options);
        }
export type GroupPayMemberPaymentBlocksQueryHookResult = ReturnType<typeof useGroupPayMemberPaymentBlocksQuery>;
export type GroupPayMemberPaymentBlocksLazyQueryHookResult = ReturnType<typeof useGroupPayMemberPaymentBlocksLazyQuery>;
export type GroupPayMemberPaymentBlocksQueryResult = Apollo.QueryResult<GroupPayMemberPaymentBlocksQuery, GroupPayMemberPaymentBlocksQueryVariables>;
export const PreCheckoutDataDocument = gql`
    query preCheckoutData($outfitterId: ID!) {
  preCheckoutData(outfitterId: $outfitterId) {
    ...PreCheckoutDataFields
  }
}
    ${PreCheckoutDataFieldsFragmentDoc}`;

/**
 * __usePreCheckoutDataQuery__
 *
 * To run a query within a React component, call `usePreCheckoutDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreCheckoutDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreCheckoutDataQuery({
 *   variables: {
 *      outfitterId: // value for 'outfitterId'
 *   },
 * });
 */
export function usePreCheckoutDataQuery(baseOptions: Apollo.QueryHookOptions<PreCheckoutDataQuery, PreCheckoutDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreCheckoutDataQuery, PreCheckoutDataQueryVariables>(PreCheckoutDataDocument, options);
      }
export function usePreCheckoutDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreCheckoutDataQuery, PreCheckoutDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreCheckoutDataQuery, PreCheckoutDataQueryVariables>(PreCheckoutDataDocument, options);
        }
export type PreCheckoutDataQueryHookResult = ReturnType<typeof usePreCheckoutDataQuery>;
export type PreCheckoutDataLazyQueryHookResult = ReturnType<typeof usePreCheckoutDataLazyQuery>;
export type PreCheckoutDataQueryResult = Apollo.QueryResult<PreCheckoutDataQuery, PreCheckoutDataQueryVariables>;
export const CreateSetupIntentDocument = gql`
    mutation createSetupIntent($userId: ID) {
  createSetupIntent(userId: $userId) {
    ...StripeSetupIntentFields
  }
}
    ${StripeSetupIntentFieldsFragmentDoc}`;
export type CreateSetupIntentMutationFn = Apollo.MutationFunction<CreateSetupIntentMutation, CreateSetupIntentMutationVariables>;

/**
 * __useCreateSetupIntentMutation__
 *
 * To run a mutation, you first call `useCreateSetupIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSetupIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSetupIntentMutation, { data, loading, error }] = useCreateSetupIntentMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCreateSetupIntentMutation(baseOptions?: Apollo.MutationHookOptions<CreateSetupIntentMutation, CreateSetupIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSetupIntentMutation, CreateSetupIntentMutationVariables>(CreateSetupIntentDocument, options);
      }
export type CreateSetupIntentMutationHookResult = ReturnType<typeof useCreateSetupIntentMutation>;
export type CreateSetupIntentMutationResult = Apollo.MutationResult<CreateSetupIntentMutation>;
export type CreateSetupIntentMutationOptions = Apollo.BaseMutationOptions<CreateSetupIntentMutation, CreateSetupIntentMutationVariables>;
export const CreateGroupPayMemberSetupIntentDocument = gql`
    mutation createGroupPayMemberSetupIntent($memberId: ID!) {
  createGroupPayMemberSetupIntent(memberId: $memberId) {
    ...StripeSetupIntentFields
  }
}
    ${StripeSetupIntentFieldsFragmentDoc}`;
export type CreateGroupPayMemberSetupIntentMutationFn = Apollo.MutationFunction<CreateGroupPayMemberSetupIntentMutation, CreateGroupPayMemberSetupIntentMutationVariables>;

/**
 * __useCreateGroupPayMemberSetupIntentMutation__
 *
 * To run a mutation, you first call `useCreateGroupPayMemberSetupIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupPayMemberSetupIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupPayMemberSetupIntentMutation, { data, loading, error }] = useCreateGroupPayMemberSetupIntentMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useCreateGroupPayMemberSetupIntentMutation(baseOptions?: Apollo.MutationHookOptions<CreateGroupPayMemberSetupIntentMutation, CreateGroupPayMemberSetupIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGroupPayMemberSetupIntentMutation, CreateGroupPayMemberSetupIntentMutationVariables>(CreateGroupPayMemberSetupIntentDocument, options);
      }
export type CreateGroupPayMemberSetupIntentMutationHookResult = ReturnType<typeof useCreateGroupPayMemberSetupIntentMutation>;
export type CreateGroupPayMemberSetupIntentMutationResult = Apollo.MutationResult<CreateGroupPayMemberSetupIntentMutation>;
export type CreateGroupPayMemberSetupIntentMutationOptions = Apollo.BaseMutationOptions<CreateGroupPayMemberSetupIntentMutation, CreateGroupPayMemberSetupIntentMutationVariables>;
export const SetDefaultPaymentMethodDocument = gql`
    mutation setDefaultPaymentMethod($id: String!) {
  setDefaultPaymentMethod(id: $id) {
    ...PaymentBlockFields
  }
}
    ${PaymentBlockFieldsFragmentDoc}`;
export type SetDefaultPaymentMethodMutationFn = Apollo.MutationFunction<SetDefaultPaymentMethodMutation, SetDefaultPaymentMethodMutationVariables>;

/**
 * __useSetDefaultPaymentMethodMutation__
 *
 * To run a mutation, you first call `useSetDefaultPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultPaymentMethodMutation, { data, loading, error }] = useSetDefaultPaymentMethodMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetDefaultPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultPaymentMethodMutation, SetDefaultPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultPaymentMethodMutation, SetDefaultPaymentMethodMutationVariables>(SetDefaultPaymentMethodDocument, options);
      }
export type SetDefaultPaymentMethodMutationHookResult = ReturnType<typeof useSetDefaultPaymentMethodMutation>;
export type SetDefaultPaymentMethodMutationResult = Apollo.MutationResult<SetDefaultPaymentMethodMutation>;
export type SetDefaultPaymentMethodMutationOptions = Apollo.BaseMutationOptions<SetDefaultPaymentMethodMutation, SetDefaultPaymentMethodMutationVariables>;
export const DeletePaymentMethodDocument = gql`
    mutation deletePaymentMethod($id: String!, $userId: ID, $groupPayMemberId: ID) {
  deletePaymentMethod(
    id: $id
    userId: $userId
    groupPayMemberId: $groupPayMemberId
  ) {
    ...PaymentBlockFields
  }
}
    ${PaymentBlockFieldsFragmentDoc}`;
export type DeletePaymentMethodMutationFn = Apollo.MutationFunction<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>;

/**
 * __useDeletePaymentMethodMutation__
 *
 * To run a mutation, you first call `useDeletePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaymentMethodMutation, { data, loading, error }] = useDeletePaymentMethodMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *      groupPayMemberId: // value for 'groupPayMemberId'
 *   },
 * });
 */
export function useDeletePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>(DeletePaymentMethodDocument, options);
      }
export type DeletePaymentMethodMutationHookResult = ReturnType<typeof useDeletePaymentMethodMutation>;
export type DeletePaymentMethodMutationResult = Apollo.MutationResult<DeletePaymentMethodMutation>;
export type DeletePaymentMethodMutationOptions = Apollo.BaseMutationOptions<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>;
export const CreatePaymentIntentForQuickPayDocument = gql`
    mutation createPaymentIntentForQuickPay($paymentId: ID!) {
  createPaymentIntentForQuickPay(paymentId: $paymentId) {
    ...StripePaymentIntentFields
  }
}
    ${StripePaymentIntentFieldsFragmentDoc}`;
export type CreatePaymentIntentForQuickPayMutationFn = Apollo.MutationFunction<CreatePaymentIntentForQuickPayMutation, CreatePaymentIntentForQuickPayMutationVariables>;

/**
 * __useCreatePaymentIntentForQuickPayMutation__
 *
 * To run a mutation, you first call `useCreatePaymentIntentForQuickPayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentIntentForQuickPayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentIntentForQuickPayMutation, { data, loading, error }] = useCreatePaymentIntentForQuickPayMutation({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function useCreatePaymentIntentForQuickPayMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentIntentForQuickPayMutation, CreatePaymentIntentForQuickPayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentIntentForQuickPayMutation, CreatePaymentIntentForQuickPayMutationVariables>(CreatePaymentIntentForQuickPayDocument, options);
      }
export type CreatePaymentIntentForQuickPayMutationHookResult = ReturnType<typeof useCreatePaymentIntentForQuickPayMutation>;
export type CreatePaymentIntentForQuickPayMutationResult = Apollo.MutationResult<CreatePaymentIntentForQuickPayMutation>;
export type CreatePaymentIntentForQuickPayMutationOptions = Apollo.BaseMutationOptions<CreatePaymentIntentForQuickPayMutation, CreatePaymentIntentForQuickPayMutationVariables>;
export const VerifyMicroDepositsDocument = gql`
    mutation verifyMicroDeposits($setupIntentId: String, $paymentId: ID, $amount1: Float, $amount2: Float, $descriptorCode: String) {
  verifyMicroDeposits(
    setupIntentId: $setupIntentId
    paymentId: $paymentId
    amount1: $amount1
    amount2: $amount2
    descriptorCode: $descriptorCode
  )
}
    `;
export type VerifyMicroDepositsMutationFn = Apollo.MutationFunction<VerifyMicroDepositsMutation, VerifyMicroDepositsMutationVariables>;

/**
 * __useVerifyMicroDepositsMutation__
 *
 * To run a mutation, you first call `useVerifyMicroDepositsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyMicroDepositsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyMicroDepositsMutation, { data, loading, error }] = useVerifyMicroDepositsMutation({
 *   variables: {
 *      setupIntentId: // value for 'setupIntentId'
 *      paymentId: // value for 'paymentId'
 *      amount1: // value for 'amount1'
 *      amount2: // value for 'amount2'
 *      descriptorCode: // value for 'descriptorCode'
 *   },
 * });
 */
export function useVerifyMicroDepositsMutation(baseOptions?: Apollo.MutationHookOptions<VerifyMicroDepositsMutation, VerifyMicroDepositsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyMicroDepositsMutation, VerifyMicroDepositsMutationVariables>(VerifyMicroDepositsDocument, options);
      }
export type VerifyMicroDepositsMutationHookResult = ReturnType<typeof useVerifyMicroDepositsMutation>;
export type VerifyMicroDepositsMutationResult = Apollo.MutationResult<VerifyMicroDepositsMutation>;
export type VerifyMicroDepositsMutationOptions = Apollo.BaseMutationOptions<VerifyMicroDepositsMutation, VerifyMicroDepositsMutationVariables>;
export const TeamMembersDocument = gql`
    query teamMembers($outfitterId: ID!, $role: TeamMemberRole) {
  teamMembers(outfitterId: $outfitterId, role: $role) {
    ...FullTeamMemberFields
  }
}
    ${FullTeamMemberFieldsFragmentDoc}`;

/**
 * __useTeamMembersQuery__
 *
 * To run a query within a React component, call `useTeamMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamMembersQuery({
 *   variables: {
 *      outfitterId: // value for 'outfitterId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useTeamMembersQuery(baseOptions: Apollo.QueryHookOptions<TeamMembersQuery, TeamMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamMembersQuery, TeamMembersQueryVariables>(TeamMembersDocument, options);
      }
export function useTeamMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamMembersQuery, TeamMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamMembersQuery, TeamMembersQueryVariables>(TeamMembersDocument, options);
        }
export type TeamMembersQueryHookResult = ReturnType<typeof useTeamMembersQuery>;
export type TeamMembersLazyQueryHookResult = ReturnType<typeof useTeamMembersLazyQuery>;
export type TeamMembersQueryResult = Apollo.QueryResult<TeamMembersQuery, TeamMembersQueryVariables>;
export const PublicTeamMembersDocument = gql`
    query publicTeamMembers($outfitterId: ID!, $role: TeamMemberRole) {
  publicTeamMembers(outfitterId: $outfitterId, role: $role) {
    data {
      ...PublicTeamMemberFields
    }
  }
}
    ${PublicTeamMemberFieldsFragmentDoc}`;

/**
 * __usePublicTeamMembersQuery__
 *
 * To run a query within a React component, call `usePublicTeamMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicTeamMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicTeamMembersQuery({
 *   variables: {
 *      outfitterId: // value for 'outfitterId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function usePublicTeamMembersQuery(baseOptions: Apollo.QueryHookOptions<PublicTeamMembersQuery, PublicTeamMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicTeamMembersQuery, PublicTeamMembersQueryVariables>(PublicTeamMembersDocument, options);
      }
export function usePublicTeamMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicTeamMembersQuery, PublicTeamMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicTeamMembersQuery, PublicTeamMembersQueryVariables>(PublicTeamMembersDocument, options);
        }
export type PublicTeamMembersQueryHookResult = ReturnType<typeof usePublicTeamMembersQuery>;
export type PublicTeamMembersLazyQueryHookResult = ReturnType<typeof usePublicTeamMembersLazyQuery>;
export type PublicTeamMembersQueryResult = Apollo.QueryResult<PublicTeamMembersQuery, PublicTeamMembersQueryVariables>;
export const TripInsuranceProductDocument = gql`
    query tripInsuranceProduct($zipCode: String!, $insurableAmount: PositiveInt!) {
  tripInsuranceProduct(zipCode: $zipCode, insurableAmount: $insurableAmount) {
    ...TripInsuranceProductFields
  }
}
    ${TripInsuranceProductFieldsFragmentDoc}`;

/**
 * __useTripInsuranceProductQuery__
 *
 * To run a query within a React component, call `useTripInsuranceProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useTripInsuranceProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTripInsuranceProductQuery({
 *   variables: {
 *      zipCode: // value for 'zipCode'
 *      insurableAmount: // value for 'insurableAmount'
 *   },
 * });
 */
export function useTripInsuranceProductQuery(baseOptions: Apollo.QueryHookOptions<TripInsuranceProductQuery, TripInsuranceProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TripInsuranceProductQuery, TripInsuranceProductQueryVariables>(TripInsuranceProductDocument, options);
      }
export function useTripInsuranceProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TripInsuranceProductQuery, TripInsuranceProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TripInsuranceProductQuery, TripInsuranceProductQueryVariables>(TripInsuranceProductDocument, options);
        }
export type TripInsuranceProductQueryHookResult = ReturnType<typeof useTripInsuranceProductQuery>;
export type TripInsuranceProductLazyQueryHookResult = ReturnType<typeof useTripInsuranceProductLazyQuery>;
export type TripInsuranceProductQueryResult = Apollo.QueryResult<TripInsuranceProductQuery, TripInsuranceProductQueryVariables>;
export const TripInsuranceQuoteDocument = gql`
    query tripInsuranceQuote($zipCode: String!, $bookingId: String!) {
  tripInsuranceQuote(zipCode: $zipCode, bookingId: $bookingId) {
    ...TripInsuranceQuoteFields
  }
}
    ${TripInsuranceQuoteFieldsFragmentDoc}`;

/**
 * __useTripInsuranceQuoteQuery__
 *
 * To run a query within a React component, call `useTripInsuranceQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useTripInsuranceQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTripInsuranceQuoteQuery({
 *   variables: {
 *      zipCode: // value for 'zipCode'
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useTripInsuranceQuoteQuery(baseOptions: Apollo.QueryHookOptions<TripInsuranceQuoteQuery, TripInsuranceQuoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TripInsuranceQuoteQuery, TripInsuranceQuoteQueryVariables>(TripInsuranceQuoteDocument, options);
      }
export function useTripInsuranceQuoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TripInsuranceQuoteQuery, TripInsuranceQuoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TripInsuranceQuoteQuery, TripInsuranceQuoteQueryVariables>(TripInsuranceQuoteDocument, options);
        }
export type TripInsuranceQuoteQueryHookResult = ReturnType<typeof useTripInsuranceQuoteQuery>;
export type TripInsuranceQuoteLazyQueryHookResult = ReturnType<typeof useTripInsuranceQuoteLazyQuery>;
export type TripInsuranceQuoteQueryResult = Apollo.QueryResult<TripInsuranceQuoteQuery, TripInsuranceQuoteQueryVariables>;
export const CreateBookingTripInsurancePolicyDocument = gql`
    mutation createBookingTripInsurancePolicy($data: TripInsurancePolicyInput!) {
  createBookingTripInsurancePolicy(data: $data) {
    ...BookingFields
  }
}
    ${BookingFieldsFragmentDoc}`;
export type CreateBookingTripInsurancePolicyMutationFn = Apollo.MutationFunction<CreateBookingTripInsurancePolicyMutation, CreateBookingTripInsurancePolicyMutationVariables>;

/**
 * __useCreateBookingTripInsurancePolicyMutation__
 *
 * To run a mutation, you first call `useCreateBookingTripInsurancePolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookingTripInsurancePolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookingTripInsurancePolicyMutation, { data, loading, error }] = useCreateBookingTripInsurancePolicyMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateBookingTripInsurancePolicyMutation(baseOptions?: Apollo.MutationHookOptions<CreateBookingTripInsurancePolicyMutation, CreateBookingTripInsurancePolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBookingTripInsurancePolicyMutation, CreateBookingTripInsurancePolicyMutationVariables>(CreateBookingTripInsurancePolicyDocument, options);
      }
export type CreateBookingTripInsurancePolicyMutationHookResult = ReturnType<typeof useCreateBookingTripInsurancePolicyMutation>;
export type CreateBookingTripInsurancePolicyMutationResult = Apollo.MutationResult<CreateBookingTripInsurancePolicyMutation>;
export type CreateBookingTripInsurancePolicyMutationOptions = Apollo.BaseMutationOptions<CreateBookingTripInsurancePolicyMutation, CreateBookingTripInsurancePolicyMutationVariables>;
export const GetUserTrackingDataDocument = gql`
    query getUserTrackingData {
  userTrackingData {
    props {
      prop
      boolean_value
      string_value
      number_value
      value_prop_name
    }
  }
}
    `;

/**
 * __useGetUserTrackingDataQuery__
 *
 * To run a query within a React component, call `useGetUserTrackingDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTrackingDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserTrackingDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserTrackingDataQuery(baseOptions?: Apollo.QueryHookOptions<GetUserTrackingDataQuery, GetUserTrackingDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserTrackingDataQuery, GetUserTrackingDataQueryVariables>(GetUserTrackingDataDocument, options);
      }
export function useGetUserTrackingDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserTrackingDataQuery, GetUserTrackingDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserTrackingDataQuery, GetUserTrackingDataQueryVariables>(GetUserTrackingDataDocument, options);
        }
export type GetUserTrackingDataQueryHookResult = ReturnType<typeof useGetUserTrackingDataQuery>;
export type GetUserTrackingDataLazyQueryHookResult = ReturnType<typeof useGetUserTrackingDataLazyQuery>;
export type GetUserTrackingDataQueryResult = Apollo.QueryResult<GetUserTrackingDataQuery, GetUserTrackingDataQueryVariables>;
export const UserDocument = gql`
    query user {
  user {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserQuery(baseOptions?: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const UserPaymentsDocument = gql`
    query userPayments {
  userPaymentsHistory {
    ...UserPaymentsHistoryFields
  }
}
    ${UserPaymentsHistoryFieldsFragmentDoc}`;

/**
 * __useUserPaymentsQuery__
 *
 * To run a query within a React component, call `useUserPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPaymentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserPaymentsQuery(baseOptions?: Apollo.QueryHookOptions<UserPaymentsQuery, UserPaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserPaymentsQuery, UserPaymentsQueryVariables>(UserPaymentsDocument, options);
      }
export function useUserPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserPaymentsQuery, UserPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserPaymentsQuery, UserPaymentsQueryVariables>(UserPaymentsDocument, options);
        }
export type UserPaymentsQueryHookResult = ReturnType<typeof useUserPaymentsQuery>;
export type UserPaymentsLazyQueryHookResult = ReturnType<typeof useUserPaymentsLazyQuery>;
export type UserPaymentsQueryResult = Apollo.QueryResult<UserPaymentsQuery, UserPaymentsQueryVariables>;
export const IsUserUsingPasswordLoginDocument = gql`
    query isUserUsingPasswordLogin {
  isUserUsingPasswordLogin
}
    `;

/**
 * __useIsUserUsingPasswordLoginQuery__
 *
 * To run a query within a React component, call `useIsUserUsingPasswordLoginQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsUserUsingPasswordLoginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsUserUsingPasswordLoginQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsUserUsingPasswordLoginQuery(baseOptions?: Apollo.QueryHookOptions<IsUserUsingPasswordLoginQuery, IsUserUsingPasswordLoginQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsUserUsingPasswordLoginQuery, IsUserUsingPasswordLoginQueryVariables>(IsUserUsingPasswordLoginDocument, options);
      }
export function useIsUserUsingPasswordLoginLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsUserUsingPasswordLoginQuery, IsUserUsingPasswordLoginQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsUserUsingPasswordLoginQuery, IsUserUsingPasswordLoginQueryVariables>(IsUserUsingPasswordLoginDocument, options);
        }
export type IsUserUsingPasswordLoginQueryHookResult = ReturnType<typeof useIsUserUsingPasswordLoginQuery>;
export type IsUserUsingPasswordLoginLazyQueryHookResult = ReturnType<typeof useIsUserUsingPasswordLoginLazyQuery>;
export type IsUserUsingPasswordLoginQueryResult = Apollo.QueryResult<IsUserUsingPasswordLoginQuery, IsUserUsingPasswordLoginQueryVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($data: UpdateUserInput!) {
  updateUser(data: $data) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const ChangeUserPasswordDocument = gql`
    mutation changeUserPassword($newPassword: String!) {
  changeUserPassword(newPassword: $newPassword)
}
    `;
export type ChangeUserPasswordMutationFn = Apollo.MutationFunction<ChangeUserPasswordMutation, ChangeUserPasswordMutationVariables>;

/**
 * __useChangeUserPasswordMutation__
 *
 * To run a mutation, you first call `useChangeUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeUserPasswordMutation, { data, loading, error }] = useChangeUserPasswordMutation({
 *   variables: {
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useChangeUserPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangeUserPasswordMutation, ChangeUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeUserPasswordMutation, ChangeUserPasswordMutationVariables>(ChangeUserPasswordDocument, options);
      }
export type ChangeUserPasswordMutationHookResult = ReturnType<typeof useChangeUserPasswordMutation>;
export type ChangeUserPasswordMutationResult = Apollo.MutationResult<ChangeUserPasswordMutation>;
export type ChangeUserPasswordMutationOptions = Apollo.BaseMutationOptions<ChangeUserPasswordMutation, ChangeUserPasswordMutationVariables>;
export const WidgetDocument = gql`
    query widget($id: ID!) {
  widget(id: $id) {
    ...WidgetFields
  }
}
    ${WidgetFieldsFragmentDoc}`;

/**
 * __useWidgetQuery__
 *
 * To run a query within a React component, call `useWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWidgetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWidgetQuery(baseOptions: Apollo.QueryHookOptions<WidgetQuery, WidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WidgetQuery, WidgetQueryVariables>(WidgetDocument, options);
      }
export function useWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WidgetQuery, WidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WidgetQuery, WidgetQueryVariables>(WidgetDocument, options);
        }
export type WidgetQueryHookResult = ReturnType<typeof useWidgetQuery>;
export type WidgetLazyQueryHookResult = ReturnType<typeof useWidgetLazyQuery>;
export type WidgetQueryResult = Apollo.QueryResult<WidgetQuery, WidgetQueryVariables>;
export const WishlistDocument = gql`
    query wishlist($id: ID!) {
  wishlist(id: $id) {
    ...WishlistFields
  }
}
    ${WishlistFieldsFragmentDoc}`;

/**
 * __useWishlistQuery__
 *
 * To run a query within a React component, call `useWishlistQuery` and pass it any options that fit your needs.
 * When your component renders, `useWishlistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWishlistQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWishlistQuery(baseOptions: Apollo.QueryHookOptions<WishlistQuery, WishlistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WishlistQuery, WishlistQueryVariables>(WishlistDocument, options);
      }
export function useWishlistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WishlistQuery, WishlistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WishlistQuery, WishlistQueryVariables>(WishlistDocument, options);
        }
export type WishlistQueryHookResult = ReturnType<typeof useWishlistQuery>;
export type WishlistLazyQueryHookResult = ReturnType<typeof useWishlistLazyQuery>;
export type WishlistQueryResult = Apollo.QueryResult<WishlistQuery, WishlistQueryVariables>;
export const WishlistsByUserDocument = gql`
    query wishlistsByUser($userId: ID!) {
  wishlistsByUser(userId: $userId) {
    ...WishlistFields
  }
}
    ${WishlistFieldsFragmentDoc}`;

/**
 * __useWishlistsByUserQuery__
 *
 * To run a query within a React component, call `useWishlistsByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useWishlistsByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWishlistsByUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useWishlistsByUserQuery(baseOptions: Apollo.QueryHookOptions<WishlistsByUserQuery, WishlistsByUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WishlistsByUserQuery, WishlistsByUserQueryVariables>(WishlistsByUserDocument, options);
      }
export function useWishlistsByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WishlistsByUserQuery, WishlistsByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WishlistsByUserQuery, WishlistsByUserQueryVariables>(WishlistsByUserDocument, options);
        }
export type WishlistsByUserQueryHookResult = ReturnType<typeof useWishlistsByUserQuery>;
export type WishlistsByUserLazyQueryHookResult = ReturnType<typeof useWishlistsByUserLazyQuery>;
export type WishlistsByUserQueryResult = Apollo.QueryResult<WishlistsByUserQuery, WishlistsByUserQueryVariables>;
export const UpdateWishlistDocument = gql`
    mutation updateWishlist($id: ID!, $data: UpdateWishlistInput!) {
  updateWishlist(id: $id, data: $data) {
    ...WishlistFields
  }
}
    ${WishlistFieldsFragmentDoc}`;
export type UpdateWishlistMutationFn = Apollo.MutationFunction<UpdateWishlistMutation, UpdateWishlistMutationVariables>;

/**
 * __useUpdateWishlistMutation__
 *
 * To run a mutation, you first call `useUpdateWishlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWishlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWishlistMutation, { data, loading, error }] = useUpdateWishlistMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateWishlistMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWishlistMutation, UpdateWishlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWishlistMutation, UpdateWishlistMutationVariables>(UpdateWishlistDocument, options);
      }
export type UpdateWishlistMutationHookResult = ReturnType<typeof useUpdateWishlistMutation>;
export type UpdateWishlistMutationResult = Apollo.MutationResult<UpdateWishlistMutation>;
export type UpdateWishlistMutationOptions = Apollo.BaseMutationOptions<UpdateWishlistMutation, UpdateWishlistMutationVariables>;
export const CreateWishlistDocument = gql`
    mutation createWishlist($data: CreateWishlistInput!) {
  createWishlist(data: $data) {
    id
  }
}
    `;
export type CreateWishlistMutationFn = Apollo.MutationFunction<CreateWishlistMutation, CreateWishlistMutationVariables>;

/**
 * __useCreateWishlistMutation__
 *
 * To run a mutation, you first call `useCreateWishlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWishlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWishlistMutation, { data, loading, error }] = useCreateWishlistMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateWishlistMutation(baseOptions?: Apollo.MutationHookOptions<CreateWishlistMutation, CreateWishlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWishlistMutation, CreateWishlistMutationVariables>(CreateWishlistDocument, options);
      }
export type CreateWishlistMutationHookResult = ReturnType<typeof useCreateWishlistMutation>;
export type CreateWishlistMutationResult = Apollo.MutationResult<CreateWishlistMutation>;
export type CreateWishlistMutationOptions = Apollo.BaseMutationOptions<CreateWishlistMutation, CreateWishlistMutationVariables>;
export const RemoveWishlistDocument = gql`
    mutation removeWishlist($id: ID!) {
  removeWishlist(id: $id)
}
    `;
export type RemoveWishlistMutationFn = Apollo.MutationFunction<RemoveWishlistMutation, RemoveWishlistMutationVariables>;

/**
 * __useRemoveWishlistMutation__
 *
 * To run a mutation, you first call `useRemoveWishlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveWishlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeWishlistMutation, { data, loading, error }] = useRemoveWishlistMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveWishlistMutation(baseOptions?: Apollo.MutationHookOptions<RemoveWishlistMutation, RemoveWishlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveWishlistMutation, RemoveWishlistMutationVariables>(RemoveWishlistDocument, options);
      }
export type RemoveWishlistMutationHookResult = ReturnType<typeof useRemoveWishlistMutation>;
export type RemoveWishlistMutationResult = Apollo.MutationResult<RemoveWishlistMutation>;
export type RemoveWishlistMutationOptions = Apollo.BaseMutationOptions<RemoveWishlistMutation, RemoveWishlistMutationVariables>;
export const namedOperations = {
  Query: {
    getExtraAddOnsForListingAndPricingPackage: 'getExtraAddOnsForListingAndPricingPackage',
    allAmenities: 'allAmenities',
    canConvertGuestToUser: 'canConvertGuestToUser',
    availability: 'availability',
    bookingInvite: 'bookingInvite',
    booking: 'booking',
    bookingWithPaymentSummary: 'bookingWithPaymentSummary',
    bookings: 'bookings',
    recentPublicBookings: 'recentPublicBookings',
    getBookingDealAttributionOptions: 'getBookingDealAttributionOptions',
    getSportsmanChatToken: 'getSportsmanChatToken',
    getCourierInboxAuthToken: 'getCourierInboxAuthToken',
    groupPaySharePaymentPlanBySlots: 'groupPaySharePaymentPlanBySlots',
    getInvoicePdf: 'getInvoicePdf',
    listingRegionAggregations: 'listingRegionAggregations',
    listing: 'listing',
    publicListings: 'publicListings',
    publicListingsIdsOnly: 'publicListingsIdsOnly',
    searchListingsForSportsmen: 'searchListingsForSportsmen',
    lodging: 'lodging',
    publicLodgingsByListing: 'publicLodgingsByListing',
    getSearchSuggestionsForTrip: 'getSearchSuggestionsForTrip',
    onboardingStatusInfo: 'onboardingStatusInfo',
    outfitter: 'outfitter',
    outfitterListings: 'outfitterListings',
    publicOutfitters: 'publicOutfitters',
    publicOutfittersIdsOnly: 'publicOutfittersIdsOnly',
    searchOutfittersForSportsmen: 'searchOutfittersForSportsmen',
    paymentRequest: 'paymentRequest',
    additionalPaymentSummary: 'additionalPaymentSummary',
    payment: 'payment',
    getPricingPackage: 'getPricingPackage',
    pricingPackagesByListing: 'pricingPackagesByListing',
    quote: 'quote',
    draftQuote: 'draftQuote',
    resource: 'resource',
    reviewForm: 'reviewForm',
    allSpecies: 'allSpecies',
    searchSpecies: 'searchSpecies',
    feedActivities: 'feedActivities',
    streamActivitiesByIds: 'streamActivitiesByIds',
    sportsmanPaymentBlocks: 'sportsmanPaymentBlocks',
    groupPayMemberPaymentBlocks: 'groupPayMemberPaymentBlocks',
    preCheckoutData: 'preCheckoutData',
    teamMembers: 'teamMembers',
    publicTeamMembers: 'publicTeamMembers',
    tripInsuranceProduct: 'tripInsuranceProduct',
    tripInsuranceQuote: 'tripInsuranceQuote',
    getUserTrackingData: 'getUserTrackingData',
    user: 'user',
    userPayments: 'userPayments',
    isUserUsingPasswordLogin: 'isUserUsingPasswordLogin',
    widget: 'widget',
    wishlist: 'wishlist',
    wishlistsByUser: 'wishlistsByUser'
  },
  Mutation: {
    logInAsGuestUser: 'logInAsGuestUser',
    convertGuestToUser: 'convertGuestToUser',
    createBooking: 'createBooking',
    updateBooking: 'updateBooking',
    updateBookingAttribution: 'updateBookingAttribution',
    createChatChannelWithOutfitter: 'createChatChannelWithOutfitter',
    createListingVisitedEvent: 'createListingVisitedEvent',
    createBookingStartedEvent: 'createBookingStartedEvent',
    createNewsfeedPostInteractedWithEvent: 'createNewsfeedPostInteractedWithEvent',
    createNewsfeedPostOpenedEvent: 'createNewsfeedPostOpenedEvent',
    createGenericEvent: 'createGenericEvent',
    joinGroupPay: 'joinGroupPay',
    createDraftOnboarding: 'createDraftOnboarding',
    acceptPaymentRequest: 'acceptPaymentRequest',
    retryPayment: 'retryPayment',
    createQuoteRequest: 'createQuoteRequest',
    createQuote: 'createQuote',
    applyQuoteCoupon: 'applyQuoteCoupon',
    removeQuoteCoupon: 'removeQuoteCoupon',
    enableQuotePaymentGroup: 'enableQuotePaymentGroup',
    disableQuotePaymentGroup: 'disableQuotePaymentGroup',
    addPackageToQuote: 'addPackageToQuote',
    updatePackageOnQuote: 'updatePackageOnQuote',
    removePackageFromQuote: 'removePackageFromQuote',
    submitReviewForm: 'submitReviewForm',
    reactToActivity: 'reactToActivity',
    removeReaction: 'removeReaction',
    createSetupIntent: 'createSetupIntent',
    createGroupPayMemberSetupIntent: 'createGroupPayMemberSetupIntent',
    setDefaultPaymentMethod: 'setDefaultPaymentMethod',
    deletePaymentMethod: 'deletePaymentMethod',
    createPaymentIntentForQuickPay: 'createPaymentIntentForQuickPay',
    verifyMicroDeposits: 'verifyMicroDeposits',
    createBookingTripInsurancePolicy: 'createBookingTripInsurancePolicy',
    updateUser: 'updateUser',
    changeUserPassword: 'changeUserPassword',
    updateWishlist: 'updateWishlist',
    createWishlist: 'createWishlist',
    removeWishlist: 'removeWishlist'
  },
  Fragment: {
    AddOnFormFields: 'AddOnFormFields',
    BookingAddOnFields: 'BookingAddOnFields',
    AddressFields: 'AddressFields',
    CityAndStateFields: 'CityAndStateFields',
    AmenityFields: 'AmenityFields',
    GenericAvailabilityFields: 'GenericAvailabilityFields',
    BookingInviteFields: 'BookingInviteFields',
    BookingInviteEditableFields: 'BookingInviteEditableFields',
    BookingInvitePackageFields: 'BookingInvitePackageFields',
    BookingFields: 'BookingFields',
    OutfitterDocumentFields: 'OutfitterDocumentFields',
    BookingPackageFields: 'BookingPackageFields',
    BookingPaymentFields: 'BookingPaymentFields',
    BookingPaymentWithStripeUrlFields: 'BookingPaymentWithStripeUrlFields',
    BookingPaymentRequestFields: 'BookingPaymentRequestFields',
    BookingMinimalFields: 'BookingMinimalFields',
    BookingListingFields: 'BookingListingFields',
    BookingOutfitterFields: 'BookingOutfitterFields',
    RecentPublicBookingsFields: 'RecentPublicBookingsFields',
    TripItineraryFields: 'TripItineraryFields',
    TripItineraryItemFields: 'TripItineraryItemFields',
    BookingPaymentSummaryFields: 'BookingPaymentSummaryFields',
    MemberPaymentSummaryFields: 'MemberPaymentSummaryFields',
    BookingWithPaymentSummaryFields: 'BookingWithPaymentSummaryFields',
    ReviewAggregationFields: 'ReviewAggregationFields',
    AttributionFields: 'AttributionFields',
    PageSubsectionFields: 'PageSubsectionFields',
    PageSubsectionItemFields: 'PageSubsectionItemFields',
    CouponFields: 'CouponFields',
    GroupPayMemberFields: 'GroupPayMemberFields',
    GroupPayShareFields: 'GroupPayShareFields',
    SlotShareFields: 'SlotShareFields',
    SlotSharePaymentFields: 'SlotSharePaymentFields',
    SlotPaymentPlanFields: 'SlotPaymentPlanFields',
    RegionFields: 'RegionFields',
    ListingFields: 'ListingFields',
    ListingsFields: 'ListingsFields',
    PublicListingFields: 'PublicListingFields',
    PublicListingFieldsWithoutOutfitter: 'PublicListingFieldsWithoutOutfitter',
    SearchListingFields: 'SearchListingFields',
    PublicSearchListingFields: 'PublicSearchListingFields',
    ListingMinimalFields: 'ListingMinimalFields',
    ListingMinimalFieldsWithoutOutfitter: 'ListingMinimalFieldsWithoutOutfitter',
    ListingPricingFields: 'ListingPricingFields',
    ListingPricingOptionFields: 'ListingPricingOptionFields',
    ListingOutfitterFields: 'ListingOutfitterFields',
    ListingPublicOutfitterFields: 'ListingPublicOutfitterFields',
    ListingOutfitterWithCancellationPolicyFields: 'ListingOutfitterWithCancellationPolicyFields',
    LicenseInfoFields: 'LicenseInfoFields',
    LodgingFields: 'LodgingFields',
    PublicLodgingFields: 'PublicLodgingFields',
    MediaFields: 'MediaFields',
    GenericSearchSuggestionGroupFields: 'GenericSearchSuggestionGroupFields',
    GenericSearchSuggestionItemFields: 'GenericSearchSuggestionItemFields',
    OnboardingFields: 'OnboardingFields',
    OnboardingStatusInfoFields: 'OnboardingStatusInfoFields',
    OutfitterFields: 'OutfitterFields',
    PublicOutfitterFields: 'PublicOutfitterFields',
    AllOutfittersFields: 'AllOutfittersFields',
    OutfitterListingFields: 'OutfitterListingFields',
    OutfitterLodgingFields: 'OutfitterLodgingFields',
    OutfitterCancellationPolicyFields: 'OutfitterCancellationPolicyFields',
    OutfitterMinimalFields: 'OutfitterMinimalFields',
    PaymentRequestBookingFields: 'PaymentRequestBookingFields',
    PaymentRequestFields: 'PaymentRequestFields',
    PaymentRequestSummaryFields: 'PaymentRequestSummaryFields',
    PaymentFields: 'PaymentFields',
    PricingPackageFields: 'PricingPackageFields',
    MinimalPricingPackageFields: 'MinimalPricingPackageFields',
    PublicPricingPackageFields: 'PublicPricingPackageFields',
    QuoteRequestFields: 'QuoteRequestFields',
    AddOnQuoteFields: 'AddOnQuoteFields',
    BookingQuoteTripInsuranceQuoteFields: 'BookingQuoteTripInsuranceQuoteFields',
    PaymentSummaryFields: 'PaymentSummaryFields',
    LineItemFields: 'LineItemFields',
    SubItemFields: 'SubItemFields',
    QuoteItemFields: 'QuoteItemFields',
    QuoteListingFields: 'QuoteListingFields',
    QuotePaymentPlanFields: 'QuotePaymentPlanFields',
    QuotePaymentGroupMemberFields: 'QuotePaymentGroupMemberFields',
    QuotePaymentGroupFields: 'QuotePaymentGroupFields',
    QuotePackageFields: 'QuotePackageFields',
    QuoteInterfaceFields: 'QuoteInterfaceFields',
    QuoteFields: 'QuoteFields',
    QuotePriceFields: 'QuotePriceFields',
    QuoteCouponFields: 'QuoteCouponFields',
    RefundFields: 'RefundFields',
    ResourceFields: 'ResourceFields',
    ReviewFormFields: 'ReviewFormFields',
    ReviewFormQuestionFields: 'ReviewFormQuestionFields',
    SpeciesFields: 'SpeciesFields',
    SpeciesMinimalFields: 'SpeciesMinimalFields',
    ReactionFields: 'ReactionFields',
    ActivityFields: 'ActivityFields',
    PaymentBlockFields: 'PaymentBlockFields',
    StripeSetupIntentFields: 'StripeSetupIntentFields',
    StripePaymentIntentFields: 'StripePaymentIntentFields',
    PreCheckoutDataFields: 'PreCheckoutDataFields',
    TeamMemberFields: 'TeamMemberFields',
    PublicTeamMemberFields: 'PublicTeamMemberFields',
    FullTeamMemberFields: 'FullTeamMemberFields',
    TripInsuranceProductFields: 'TripInsuranceProductFields',
    TripInsuranceQuoteFields: 'TripInsuranceQuoteFields',
    UserFields: 'UserFields',
    PublicUserFields: 'PublicUserFields',
    UserMinimalFields: 'UserMinimalFields',
    OutfitterOwnerFields: 'OutfitterOwnerFields',
    UserSocialsFields: 'UserSocialsFields',
    UserPaymentsHistoryFields: 'UserPaymentsHistoryFields',
    MinimalUserFields: 'MinimalUserFields',
    WidgetFields: 'WidgetFields',
    WishlistFields: 'WishlistFields'
  }
}